
/** Please note CSS is currently set up to accept 8 markers **/


/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});   

function openTab(event, tabName) {
    const tabcontents = document.getElementsByClassName('map-choices-wrap');
    const tabs = document.getElementsByClassName('tab');
    for (let i = 0; i < tabcontents.length; i++) {
        tabcontents[i].classList.remove('active');
    }
    for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('active');
    }
    document.getElementById(tabName).classList.add('active');
    event.currentTarget.classList.add('active');
}

const intervalId = setInterval(function() {
    const tabs = document.querySelector('.section-tabs');
    if (tabs) {
      clearInterval(intervalId);
      const productContent = document.querySelector('.product__content');
      const callToAction = document.querySelector('.buy-button-wrap');
      const clonedTabs = tabs.cloneNode(true);
      const clonedCallToAction = callToAction.cloneNode(true);
      productContent.insertAdjacentElement('beforebegin', clonedTabs);
      productContent.insertAdjacentElement('afterend', clonedCallToAction);

      const tabButtons = clonedTabs.querySelectorAll('.section-tabs .tab');
      tabButtons.forEach(button => {
          button.addEventListener('click', function() {
              if (window.innerWidth < 1024) {
                  clonedTabs.scrollIntoView({behavior: 'smooth', block: 'start'});
              }
          });
      });
    }
}, 100);

(function($) {
    $.fn.drags = function(opt) {

        opt = $.extend({handle:"",cursor:"move"}, opt);

        if(opt.handle === "") {
            var $el = this;
        } else {
            var $el = this.find(opt.handle);
        }

        return $el.css('cursor', opt.cursor).on("mousedown", function(e) {
            if(opt.handle === "") {
                var $drag = $(this).addClass('draggable');
            } else {
                var $drag = $(this).addClass('active-handle').parent().addClass('draggable');
            }
            var z_idx = $drag.css('z-index'),
                drg_h = $drag.outerHeight(),
                drg_w = $drag.outerWidth(),
                pos_y = $drag.offset().top + drg_h - e.pageY,
                pos_x = $drag.offset().left + drg_w - e.pageX;
            $drag.css('z-index', 1000).parents().on("mousemove", function(e) {
                $('.draggable').offset({
                    top:e.pageY + pos_y - drg_h,
                    left:e.pageX + pos_x - drg_w
                }).on("mouseup", function() {
                    $(this).removeClass('draggable').css('z-index', z_idx);
                });
            });
            e.preventDefault(); // disable selection
        }).on("mouseup", function() {
            if(opt.handle === "") {
                $(this).removeClass('draggable');
            } else {
                $(this).removeClass('active-handle').parent().removeClass('draggable');
            }
        });

    }
})(jQuery);





(function (root, factory) {
	if (typeof exports === 'object') {
		module.exports = factory(root);
	} else if (typeof define === 'function' && define.amd) {
		define('colors', [], function () {
			return factory(root);
		});
	} else {
		root.Colors = factory(root);
	}
}(this, function(window, undefined) {
	"use strict"

	var _valueRanges = {
			rgb:   {r: [0, 255], g: [0, 255], b: [0, 255]},
			hsv:   {h: [0, 360], s: [0, 100], v: [0, 100]},
			hsl:   {h: [0, 360], s: [0, 100], l: [0, 100]},
			alpha: {alpha: [0, 1]},
			HEX:   {HEX: [0, 16777215]} // maybe we don't need this
		},

		_Math = window.Math,
		_round = _Math.round,

		_instance = {},
		_colors = {},

		grey = {r: 0.298954, g: 0.586434, b: 0.114612}, // CIE-XYZ 1931
		luminance = {r: 0.2126, g: 0.7152, b: 0.0722}, // W3C 2.0

		Colors = function(options) {
			this.colors = {RND: {}};
			this.options = {
				color: 'rgba(0,0,0,0)', // init value(s)...
				grey: grey,
				luminance: luminance,
				valueRanges: _valueRanges
				// customBG: '#808080'
				// convertCallback: undefined,
				// allMixDetails: false
			};
            initInstance(this, options || {});
		},
		initInstance = function(THIS, options) {
			var importColor,
				_options = THIS.options,
				customBG;

			focusInstance(THIS);
			for (var option in options) {
				if (options[option] !== undefined) _options[option] = options[option];
			}
			customBG = _options.customBG;
			_options.customBG = (typeof customBG === 'string') ? ColorConverter.txt2color(customBG).rgb : customBG;
			_colors = setColor(THIS.colors, _options.color, undefined, true); // THIS.colors = _colors = 
		},
		focusInstance = function(THIS) {
			if (_instance !== THIS) {
				_instance = THIS;
				_colors = THIS.colors;
			}
		};

	Colors.prototype.setColor = function(newCol, type, alpha) {
		focusInstance(this);
		if (newCol) {
			return setColor(this.colors, newCol, type, undefined, alpha);
		} else {
			if (alpha !== undefined) {
				this.colors.alpha = limitValue(alpha, 0, 1);
			}
			return convertColors(type);
		}
	};

	Colors.prototype.setCustomBackground = function(col) { // wild gues,... check again...
		focusInstance(this); // needed???
		this.options.customBG = (typeof col === 'string') ? ColorConverter.txt2color(col).rgb : col;
		// return setColor(this.colors, this.options.customBG, 'rgb', true); // !!!!RGB
		return setColor(this.colors, undefined, 'rgb'); // just recalculate existing
	};

	Colors.prototype.saveAsBackground = function() { // alpha
		focusInstance(this); // needed???
		// return setColor(this.colors, this.colors.RND.rgb, 'rgb', true);
		return setColor(this.colors, undefined, 'rgb', true);
	};

	Colors.prototype.toString = function(colorMode, forceAlpha) {
		return ColorConverter.color2text((colorMode || 'rgb').toLowerCase(), this.colors, forceAlpha);
	};

	// ------------------------------------------------------ //
	// ---------- Color calculation related stuff  ---------- //
	// -------------------------------------------------------//

	function setColor(colors, color, type, save, alpha) { // color only full range
		if (typeof color === 'string') {
			var color = ColorConverter.txt2color(color); // new object
			type = color.type;
			_colors[type] = color[type];
			alpha = alpha !== undefined ? alpha : color.alpha;
		} else if (color) {
			for (var n in color) {
				colors[type][n] = limitValue(color[n] / _valueRanges[type][n][1], 0 , 1);
			}
		}
		if (alpha !== undefined) {
			colors.alpha = limitValue(+alpha, 0, 1);
		}
		return convertColors(type, save ? colors : undefined);
	}

	function saveAsBackground(RGB, rgb, alpha) {
		var grey = _instance.options.grey,
			color = {};

		color.RGB = {r: RGB.r, g: RGB.g, b: RGB.b};
		color.rgb = {r: rgb.r, g: rgb.g, b: rgb.b};
		color.alpha = alpha;
		// color.RGBLuminance = getLuminance(RGB);
		color.equivalentGrey = _round(grey.r * RGB.r + grey.g * RGB.g + grey.b * RGB.b);

		color.rgbaMixBlack = mixColors(rgb, {r: 0, g: 0, b: 0}, alpha, 1);
		color.rgbaMixWhite = mixColors(rgb, {r: 1, g: 1, b: 1}, alpha, 1);
		color.rgbaMixBlack.luminance = getLuminance(color.rgbaMixBlack, true);
		color.rgbaMixWhite.luminance = getLuminance(color.rgbaMixWhite, true);

		if (_instance.options.customBG) {
			color.rgbaMixCustom = mixColors(rgb, _instance.options.customBG, alpha, 1);
			color.rgbaMixCustom.luminance = getLuminance(color.rgbaMixCustom, true);
			_instance.options.customBG.luminance = getLuminance(_instance.options.customBG, true);
		}

		return color;
	}

	function convertColors(type, colorObj) {
		// console.time('convertColors');
		var colors = colorObj || _colors,
			convert = ColorConverter,
			options = _instance.options,
			ranges = _valueRanges,
			RND = colors.RND,
			// type = colorType, // || _mode.type,
			modes, mode = '', from = '', // value = '',
			exceptions = {hsl: 'hsv', rgb: type},
			RGB = RND.rgb, SAVE, SMART;

		if (type !== 'alpha') {
			for (var typ in ranges) {
				if (!ranges[typ][typ]) { // no alpha|HEX
					if (type !== typ) {
						from = exceptions[typ] || 'rgb';
						colors[typ] = convert[from + '2' + typ](colors[from]);
					}

					if (!RND[typ]) RND[typ] = {};
					modes = colors[typ];
					for(mode in modes) {
						RND[typ][mode] = _round(modes[mode] * ranges[typ][mode][1]);
					}
				}
			}

			RGB = RND.rgb;
			colors.HEX = convert.RGB2HEX(RGB);
			colors.equivalentGrey =
				options.grey.r * colors.rgb.r +
				options.grey.g * colors.rgb.g +
				options.grey.b * colors.rgb.b;
			colors.webSave = SAVE = getClosestWebColor(RGB, 51);
			// colors.webSave.HEX = convert.RGB2HEX(colors.webSave);
			colors.webSmart = SMART = getClosestWebColor(RGB, 17);
			// colors.webSmart.HEX = convert.RGB2HEX(colors.webSmart);
			colors.saveColor =
				RGB.r === SAVE.r && RGB.g === SAVE.g && RGB.b === SAVE.b  ? 'web save' :
				RGB.r === SMART.r && RGB.g === SMART.g && RGB.b === SMART.b  ? 'web smart' : '';
			colors.hueRGB = ColorConverter.hue2RGB(colors.hsv.h);

			if (colorObj) {
				colors.background = saveAsBackground(RGB, colors.rgb, colors.alpha);
			}
		} // else RGB = RND.rgb;

		var rgb = colors.rgb, // for better minification...
			alpha = colors.alpha,
			luminance = 'luminance',
			background = colors.background,
			rgbaMixBlack, rgbaMixWhite, rgbaMixCustom, 
			rgbaMixBG, rgbaMixBGMixBlack, rgbaMixBGMixWhite, rgbaMixBGMixCustom;

		rgbaMixBlack = mixColors(rgb, {r: 0, g: 0, b: 0}, alpha, 1);
		rgbaMixBlack[luminance] = getLuminance(rgbaMixBlack, true);
		colors.rgbaMixBlack = rgbaMixBlack;

		rgbaMixWhite = mixColors(rgb, {r: 1, g: 1, b: 1}, alpha, 1);
		rgbaMixWhite[luminance] = getLuminance(rgbaMixWhite, true);
		colors.rgbaMixWhite = rgbaMixWhite;

		if (options.customBG) {
			rgbaMixBGMixCustom = mixColors(rgb, background.rgbaMixCustom, alpha, 1);
			rgbaMixBGMixCustom[luminance] = getLuminance(rgbaMixBGMixCustom, true);
			rgbaMixBGMixCustom.WCAG2Ratio = getWCAG2Ratio(rgbaMixBGMixCustom[luminance],
				background.rgbaMixCustom[luminance]);
			colors.rgbaMixBGMixCustom = rgbaMixBGMixCustom;
			/* ------ */
			rgbaMixBGMixCustom.luminanceDelta = _Math.abs(
				rgbaMixBGMixCustom[luminance] - background.rgbaMixCustom[luminance]);
			rgbaMixBGMixCustom.hueDelta = getHueDelta(background.rgbaMixCustom, rgbaMixBGMixCustom, true);
			/* ------ */
		}

		colors.RGBLuminance = getLuminance(RGB);
		colors.HUELuminance = getLuminance(colors.hueRGB);

		// renderVars.readyToRender = true;
		if (options.convertCallback) {
			options.convertCallback(colors, type); //, convert); //, _mode);
		}

		// console.timeEnd('convertColors')
		// if (colorObj)
		return colors;
	}


	// ------------------------------------------------------ //
	// ------------------ color conversion ------------------ //
	// -------------------------------------------------------//

	var ColorConverter = {
		txt2color: function(txt) {
			var color = {},
				parts = txt.replace(/(?:#|\)|%)/g, '').split('('),
				values = (parts[1] || '').split(/,\s*/),
				type = parts[1] ? parts[0].substr(0, 3) : 'rgb',
				m = '';

			color.type = type;
			color[type] = {};
			if (parts[1]) {
				for (var n = 3; n--; ) {
					m = type[n] || type.charAt(n); // IE7
					color[type][m] = +values[n] / _valueRanges[type][m][1];
				}
			} else {
				color.rgb = ColorConverter.HEX2rgb(parts[0]);
			}
			// color.color = color[type];
			color.alpha = values[3] ? +values[3] : 1;

			return color;
		},

		color2text: function(colorMode, colors, forceAlpha) {
			var alpha = forceAlpha !== false && _round(colors.alpha * 100) / 100,
				hasAlpha = typeof alpha === 'number' &&
					forceAlpha !== false && (forceAlpha || alpha !== 1),
				RGB = colors.RND.rgb,
				HSL = colors.RND.hsl,
				shouldBeHex = colorMode === 'hex' && hasAlpha,
				isHex = colorMode === 'hex' && !shouldBeHex,
				isRgb = colorMode === 'rgb' || shouldBeHex,
				innerText = isRgb ? RGB.r + ', ' + RGB.g + ', ' + RGB.b :
					!isHex ? HSL.h + ', ' + HSL.s + '%, ' + HSL.l + '%' :
					'#' + colors.HEX;

			return isHex ? innerText : (shouldBeHex ? 'rgb' : colorMode) + 
				(hasAlpha ? 'a' : '') + '(' + innerText +
				(hasAlpha ? ', ' + alpha : '') + ')';
		},

		RGB2HEX: function(RGB) {
			return (
				(RGB.r < 16 ? '0' : '') + RGB.r.toString(16) +
				(RGB.g < 16 ? '0' : '') + RGB.g.toString(16) +
				(RGB.b < 16 ? '0' : '') + RGB.b.toString(16)
			).toUpperCase();
		},

		HEX2rgb: function(HEX) {
			HEX = HEX.split(''); // IE7
			return {
				r: +('0x' + HEX[0] + HEX[HEX[3] ? 1 : 0]) / 255,
				g: +('0x' + HEX[HEX[3] ? 2 : 1] + (HEX[3] || HEX[1])) / 255,
				b: +('0x' + (HEX[4] || HEX[2]) + (HEX[5] || HEX[2])) / 255
			};
		},

		hue2RGB: function(hue) {
			var h = hue * 6,
				mod = ~~h % 6, // _Math.floor(h) -> faster in most browsers
				i = h === 6 ? 0 : (h - mod);

			return {
				r: _round([1, 1 - i, 0, 0, i, 1][mod] * 255),
				g: _round([i, 1, 1, 1 - i, 0, 0][mod] * 255),
				b: _round([0, 0, i, 1, 1, 1 - i][mod] * 255)
			};
		},

		// ------------------------ HSV ------------------------ //

		rgb2hsv: function(rgb) { // faster
			var r = rgb.r,
				g = rgb.g,
				b = rgb.b,
				k = 0, chroma, min, s;

			if (g < b) {
				g = b + (b = g, 0);
				k = -1;
			}
			min = b;
			if (r < g) {
				r = g + (g = r, 0);
				k = -2 / 6 - k;
				min = _Math.min(g, b); // g < b ? g : b; ???
			}
			chroma = r - min;
			s = r ? (chroma / r) : 0;
			return {
				h: s < 1e-15 ? ((_colors && _colors.hsl && _colors.hsl.h) || 0) :
					chroma ? _Math.abs(k + (g - b) / (6 * chroma)) : 0,
				s: r ? (chroma / r) : ((_colors && _colors.hsv && _colors.hsv.s) || 0), // ??_colors.hsv.s || 0
				v: r
			};
		},

		hsv2rgb: function(hsv) {
			var h = hsv.h * 6,
				s = hsv.s,
				v = hsv.v,
				i = ~~h, // _Math.floor(h) -> faster in most browsers
				f = h - i,
				p = v * (1 - s),
				q = v * (1 - f * s),
				t = v * (1 - (1 - f) * s),
				mod = i % 6;

			return {
				r: [v, q, p, p, t, v][mod],
				g: [t, v, v, q, p, p][mod],
				b: [p, p, t, v, v, q][mod]
			};
		},

		// ------------------------ HSL ------------------------ //

		hsv2hsl: function(hsv) {
			var l = (2 - hsv.s) * hsv.v,
				s = hsv.s * hsv.v;

			s = !hsv.s ? 0 : l < 1 ? (l ? s / l : 0) : s / (2 - l);

			return {
				h: hsv.h,
				s: !hsv.v && !s ? ((_colors && _colors.hsl && _colors.hsl.s) || 0) : s, // ???
				l: l / 2
			};
		},

		rgb2hsl: function(rgb, dependent) { // not used in Color
			var hsv = ColorConverter.rgb2hsv(rgb);

			return ColorConverter.hsv2hsl(dependent ? hsv : (_colors.hsv = hsv));
		},

		hsl2rgb: function(hsl) {
			var h = hsl.h * 6,
				s = hsl.s,
				l = hsl.l,
				v = l < 0.5 ? l * (1 + s) : (l + s) - (s * l),
				m = l + l - v,
				sv = v ? ((v - m) / v) : 0,
				sextant = ~~h, // _Math.floor(h) -> faster in most browsers
				fract = h - sextant,
				vsf = v * sv * fract,
				t = m + vsf,
				q = v - vsf,
				mod = sextant % 6;

			return {
				r: [v, q, m, m, t, v][mod],
				g: [t, v, v, q, m, m][mod],
				b: [m, m, t, v, v, q][mod]
			};
		}
	};

	// ------------------------------------------------------ //
	// ------------------ helper functions ------------------ //
	// -------------------------------------------------------//

	function getClosestWebColor(RGB, val) {
		var out = {},
			tmp = 0,
			half = val / 2;

		for (var n in RGB) {
			tmp = RGB[n] % val; // 51 = 'web save', 17 = 'web smart'
			out[n] = RGB[n] + (tmp > half ? val - tmp : -tmp);
		}
		return out;
	}

	function getHueDelta(rgb1, rgb2, nominal) {
		return (_Math.max(rgb1.r - rgb2.r, rgb2.r - rgb1.r) +
				_Math.max(rgb1.g - rgb2.g, rgb2.g - rgb1.g) +
				_Math.max(rgb1.b - rgb2.b, rgb2.b - rgb1.b)) * (nominal ? 255 : 1) / 765;
	}

	function getLuminance(rgb, normalized) {
		var div = normalized ? 1 : 255,
			RGB = [rgb.r / div, rgb.g / div, rgb.b / div],
			luminance = _instance.options.luminance;

		for (var i = RGB.length; i--; ) {
			RGB[i] = RGB[i] <= 0.03928 ? RGB[i] / 12.92 : _Math.pow(((RGB[i] + 0.055) / 1.055), 2.4);
		}
		return ((luminance.r * RGB[0]) + (luminance.g * RGB[1]) + (luminance.b * RGB[2]));
	}

	function mixColors(topColor, bottomColor, topAlpha, bottomAlpha) {
		var newColor = {},
			alphaTop = (topAlpha !== undefined ? topAlpha : 1),
			alphaBottom = (bottomAlpha !== undefined ? bottomAlpha : 1),
			alpha = alphaTop + alphaBottom * (1 - alphaTop); // 1 - (1 - alphaTop) * (1 - alphaBottom);

		for(var n in topColor) {
			newColor[n] = (topColor[n] * alphaTop + bottomColor[n] * alphaBottom * (1 - alphaTop)) / alpha;
		}
		newColor.a = alpha;
		return newColor;
	}

	function getWCAG2Ratio(lum1, lum2) {
		var ratio = 1;

		if (lum1 >= lum2) {
			ratio = (lum1 + 0.05) / (lum2 + 0.05);
		} else {
			ratio = (lum2 + 0.05) / (lum1 + 0.05);
		}
		return _round(ratio * 100) / 100;
	}

	function limitValue(value, min, max) {
		// return _Math.max(min, _Math.min(max, value)); // faster??
		return (value > max ? max : value < min ? min : value);
	}

	return Colors;
}));


(function (root, factory) {
    if (typeof exports === 'object') {
        module.exports = factory(root, require('jquery'), require('colors'));
    } else if (typeof define === 'function' && define.amd) {
        define(['jquery', 'colors'], function (jQuery, Colors) {
            return factory(root, jQuery, Colors);
        });
    } else {
        factory(root, root.jQuery, root.Colors);
    }
}(this, function(window, $, Colors, undefined){
    'use strict';

    var $document = $(document),
        _instance = $(),
        _colorPicker,
        _color,
        _options,

        _$trigger, _$UI,
        _$z_slider, _$xy_slider,
        _$xy_cursor, _$z_cursor , _$alpha , _$alpha_cursor,

        _pointermove = 'touchmove.tcp mousemove.tcp pointermove.tcp',
        _pointerdown = 'touchstart.tcp mousedown.tcp pointerdown.tcp',
        _pointerup = 'touchend.tcp mouseup.tcp pointerup.tcp',
        _GPU = false,
        _animate = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame || function(cb){cb()},
        _html = '<div class="cp-color-picker"><div class="cp-z-slider"><div c' +
            'lass="cp-z-cursor"></div></div><div class="cp-xy-slider"><div cl' +
            'ass="cp-white"></div><div class="cp-xy-cursor"></div></div><div ' +
            'class="cp-alpha"><div class="cp-alpha-cursor"></div></div></div>',
            // 'grunt-contrib-uglify' puts all this back to one single string...
        _css = '.cp-color-picker{position:absolute;overflow:hidden;padding:6p' +
            'x 6px 0;background-color:#444;color:#bbb;font-family:Arial,Helve' +
            'tica,sans-serif;font-size:12px;font-weight:400;cursor:default;bo' +
            'rder-radius:5px}.cp-color-picker>div{position:relative;overflow:' +
            'hidden}.cp-xy-slider{float:left;height:128px;width:128px;margin-' +
            'bottom:6px;background:linear-gradient(to right,#FFF,rgba(255,255' +
            ',255,0))}.cp-white{height:100%;width:100%;background:linear-grad' +
            'ient(rgba(0,0,0,0),#000)}.cp-xy-cursor{position:absolute;top:0;w' +
            'idth:10px;height:10px;margin:-5px;border:1px solid #fff;border-r' +
            'adius:100%;box-sizing:border-box}.cp-z-slider{float:right;margin' +
            '-left:6px;height:128px;width:20px;background:linear-gradient(red' +
            ' 0,#f0f 17%,#00f 33%,#0ff 50%,#0f0 67%,#ff0 83%,red 100%)}.cp-z-' +
            'cursor{position:absolute;margin-top:-4px;width:100%;border:4px s' +
            'olid #fff;border-color:transparent #fff;box-sizing:border-box}.c' +
            'p-alpha{clear:both;width:100%;height:16px;margin:6px 0;backgroun' +
            'd:linear-gradient(to right,#444,rgba(0,0,0,0))}.cp-alpha-cursor{' +
            'position:absolute;margin-left:-4px;height:100%;border:4px solid ' +
            '#fff;border-color:#fff transparent;box-sizing:border-box}',

        ColorPicker = function(options) {
            _color = this.color = new Colors(options);
            _options = _color.options;
            _colorPicker = this;
        };

    ColorPicker.prototype = {
        render: preRender,
        toggle: toggle
    };

    function extractValue(elm) {
        return elm.value || elm.getAttribute('value') ||
            $(elm).css('background-color') || '#FFF';
    }

    function resolveEventType(event) {
        event = event.originalEvent && event.originalEvent.touches ?
            event.originalEvent.touches[0] : event;

        return event.originalEvent ? event.originalEvent : event;
    }

    function findElement($elm) {
        return $($elm.find(_options.doRender)[0] || $elm[0]);
    }

    function toggle(event) {
        var $this = $(this),
            position = $this.offset(),
            $window = $(window),
            gap = _options.gap;

        if (event) {
            _$trigger = findElement($this);
            _$trigger._colorMode = _$trigger.data('colorMode');

            _colorPicker.$trigger = $this;

            (_$UI || build()).css(
                _options.positionCallback.call(_colorPicker, $this) ||
                {'left': (_$UI._left = position.left) -
                    ((_$UI._left += _$UI._width -
                    ($window.scrollLeft() + $window.width())) + gap > 0 ?
                    _$UI._left + gap : 0),
                'top': (_$UI._top = position.top + $this.outerHeight()) -
                    ((_$UI._top += _$UI._height -
                    ($window.scrollTop() + $window.height())) + gap > 0 ?
                    _$UI._top + gap : 0)
            }).show(_options.animationSpeed, function() {
                if (event === true) { // resize, scroll
                    return;
                }
                _$alpha.toggle(!!_options.opacity)._width = _$alpha.width();
                _$xy_slider._width = _$xy_slider.width();
                _$xy_slider._height = _$xy_slider.height();
                _$z_slider._height = _$z_slider.height();
                _color.setColor(extractValue(_$trigger[0]));

                preRender(true);
            })
            .off('.tcp').on(_pointerdown,
                '.cp-xy-slider,.cp-z-slider,.cp-alpha', pointerdown);
        } else if (_colorPicker.$trigger) {
            $(_$UI).hide(_options.animationSpeed, function() {
                preRender(false);
                _colorPicker.$trigger = null;
            }).off('.tcp');
        }
    }

    function build() {
        $('head')[_options.cssPrepend ? 'prepend' : 'append']
            ('<style type="text/css" id="tinyColorPickerStyles">' +
                (_options.css || _css) + (_options.cssAddon || '') + '</style>');

        return $(_html).css({'margin': _options.margin})
            .appendTo('body')
            .show(0, function() {
                _colorPicker.$UI = _$UI = $(this);

                _GPU = _options.GPU && _$UI.css('perspective') !== undefined;
                _$z_slider = $('.cp-z-slider', this);
                _$xy_slider = $('.cp-xy-slider', this);
                _$xy_cursor = $('.cp-xy-cursor', this);
                _$z_cursor = $('.cp-z-cursor', this);
                _$alpha = $('.cp-alpha', this);
                _$alpha_cursor = $('.cp-alpha-cursor', this);
                _options.buildCallback.call(_colorPicker, _$UI);
                _$UI.prepend('<div>').children().eq(0).css('width',
                    _$UI.children().eq(0).width()); // stabilizer
                _$UI._width = this.offsetWidth;
                _$UI._height = this.offsetHeight;
            }).hide();
    }

    function pointerdown(e) {
        var action = this.className
                .replace(/cp-(.*?)(?:\s*|$)/, '$1').replace('-', '_');

        if ((e.button || e.which) > 1) return;

        e.preventDefault && e.preventDefault();
        e.returnValue = false;

        _$trigger._offset = $(this).offset();

        (action = action === 'xy_slider' ? xy_slider :
            action === 'z_slider' ? z_slider : alpha)(e);
        preRender();

        $document.on(_pointerup, function(e) {
            $document.off('.tcp');
        }).on(_pointermove, function(e) {
            action(e);
            preRender();
        });
    }

    function xy_slider(event) {
        var e = resolveEventType(event),
            x = e.pageX - _$trigger._offset.left,
            y = e.pageY - _$trigger._offset.top;

        _color.setColor({
            s: x / _$xy_slider._width * 100,
            v: 100 - (y / _$xy_slider._height * 100)
        }, 'hsv');
    }

    function z_slider(event) {
        var z = resolveEventType(event).pageY - _$trigger._offset.top;

        _color.setColor({h: 360 - (z / _$z_slider._height * 360)}, 'hsv');
    }

    function alpha(event) {
        var x = resolveEventType(event).pageX - _$trigger._offset.left,
            alpha = x / _$alpha._width;

        _color.setColor({}, 'rgb', alpha);
    }

    function preRender(toggled) {
        var colors = _color.colors,
            hueRGB = colors.hueRGB,
            RGB = colors.RND.rgb,
            HSL = colors.RND.hsl,
            dark = _options.dark,
            light = _options.light,
            colorText = _color.toString(_$trigger._colorMode, _options.forceAlpha),
            HUEContrast = colors.HUELuminance > 0.22 ? dark : light,
            alphaContrast = colors.rgbaMixBlack.luminance > 0.22 ? dark : light,
            h = (1 - colors.hsv.h) * _$z_slider._height,
            s = colors.hsv.s * _$xy_slider._width,
            v = (1 - colors.hsv.v) * _$xy_slider._height,
            a = colors.alpha * _$alpha._width,
            translate3d = _GPU ? 'translate3d' : '',
            triggerValue = _$trigger[0].value,
            hasNoValue = _$trigger[0].hasAttribute('value') && // question this
                triggerValue === '' && toggled !== undefined;

        _$xy_slider._css = {
            backgroundColor: 'rgb(' +
                hueRGB.r + ',' + hueRGB.g + ',' + hueRGB.b + ')'};
        _$xy_cursor._css = {
            transform: translate3d + '(' + s + 'px, ' + v + 'px, 0)',
            left: !_GPU ? s : '',
            top: !_GPU ? v : '',
            borderColor : colors.RGBLuminance > 0.22 ? dark : light
        };
        _$z_cursor._css = {
            transform: translate3d + '(0, ' + h + 'px, 0)',
            top: !_GPU ? h : '',
            borderColor : 'transparent ' + HUEContrast
        };
        _$alpha._css = {backgroundColor: '#' + colors.HEX};
        _$alpha_cursor._css = {
            transform: translate3d + '(' + a + 'px, 0, 0)',
            left: !_GPU ? a : '',
            borderColor : alphaContrast + ' transparent'
        };
        _$trigger._css = {
            backgroundColor : hasNoValue ? '' : colorText,
            color: hasNoValue ? '' :
                colors.rgbaMixBGMixCustom.luminance > 0.22 ? dark : light
        };
        _$trigger.text = hasNoValue ? '' : triggerValue !== colorText ? colorText : '';

        toggled !== undefined ? render(toggled) : _animate(render);
    }

    // As _animate() is actually requestAnimationFrame(), render() gets called
    // decoupled from any pointer action (whenever the browser decides to do
    // so) as an event. preRender() is coupled to toggle() and all pointermove
    // actions; that's where all the calculations happen. render() can now be
    // called without extra calculations which results in faster rendering.
    function render(toggled) {
        _$xy_slider.css(_$xy_slider._css);
        _$xy_cursor.css(_$xy_cursor._css);
        _$z_cursor.css(_$z_cursor._css);
        _$alpha.css(_$alpha._css);
        _$alpha_cursor.css(_$alpha_cursor._css);

        _options.doRender && _$trigger.css(_$trigger._css);
        _$trigger.text && _$trigger.val(_$trigger.text);

        _options.renderCallback.call(
            _colorPicker,
            _$trigger,
            typeof toggled === 'boolean' ? toggled : undefined
        );
    }

    $.fn.colorPicker = function(options) {
        var _this = this,
            noop = function(){};

        options = $.extend({
            animationSpeed: 150,
            GPU: true,
            doRender: true,
            customBG: '#FFF',
            opacity: true,
            renderCallback: noop,
            buildCallback: noop,
            positionCallback: noop,
            body: document.body,
            scrollResize: true,
            gap: 4,
            dark: '#222',
            light: '#DDD',
            // cssPrepend: true,
            // forceAlpha: undefined,
            // css: '',
            // cssAddon: '',
            // margin: '',
            // preventFocus: false
        }, options);

        !_colorPicker && options.scrollResize && $(window)
        .on('resize.tcp scroll.tcp', function() {
            if (_colorPicker.$trigger) {
                _colorPicker.toggle.call(_colorPicker.$trigger[0], true);
            }
        });
        _instance = _instance.add(this);
        this.colorPicker = _colorPicker || new ColorPicker(options);
        this.options = options;

        $(options.body).off('.tcp').on(_pointerdown, function(e) {
            _instance.add(_$UI).add($(_$UI).find(e.target)).
                index(e.target) === -1 && toggle();
        });

        return this.on('focusin.tcp click.tcp', function(event) {
            _colorPicker.color.options = // swap options to fake new instance
                $.extend(_colorPicker.color.options, _options = _this.options);
            toggle.call(this, event);
        })
        .on('change.tcp', function() {
            _color.setColor(this.value || '#FFF');
            _this.colorPicker.render(true);
        })
        .each(function() {
            var value = extractValue(this),
                mode = value.split('('),
                $elm = findElement($(this));

            $elm.data('colorMode', mode[1] ? mode[0].substr(0, 3) : 'HEX')
                .attr('readonly', _options.preventFocus);
            options.doRender &&
            $elm.css({'background-color': value,
                'color': function() {
                    return _color.setColor(value)
                        .rgbaMixBGMixCustom.luminance > 0.22 ?
                        options.dark : options.light
                }
            });
        });
    };

    $.fn.colorPicker.destroy = function() {
        $('*').off('.tcp'); // slower but saver
        _colorPicker.toggle(false);
        _instance = $();
        // destroy _colorPicker
    };

}));


/*! WOW wow.js - v1.3.0 - 2016-10-04
* https://wowjs.uk
* Copyright (c) 2016 Thomas Grainger; Licensed MIT */!function(a,b){if("function"==typeof define&&define.amd)define(["module","exports"],b);else if("undefined"!=typeof exports)b(module,exports);else{var c={exports:{}};b(c,c.exports),a.WOW=c.exports}}(this,function(a,b){"use strict";function c(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function d(a,b){return b.indexOf(a)>=0}function e(a,b){for(var c in b)if(null==a[c]){var d=b[c];a[c]=d}return a}function f(a){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(a)}function g(a){var b=arguments.length<=1||void 0===arguments[1]?!1:arguments[1],c=arguments.length<=2||void 0===arguments[2]?!1:arguments[2],d=arguments.length<=3||void 0===arguments[3]?null:arguments[3],e=void 0;return null!=document.createEvent?(e=document.createEvent("CustomEvent"),e.initCustomEvent(a,b,c,d)):null!=document.createEventObject?(e=document.createEventObject(),e.eventType=a):e.eventName=a,e}function h(a,b){null!=a.dispatchEvent?a.dispatchEvent(b):b in(null!=a)?a[b]():"on"+b in(null!=a)&&a["on"+b]()}function i(a,b,c){null!=a.addEventListener?a.addEventListener(b,c,!1):null!=a.attachEvent?a.attachEvent("on"+b,c):a[b]=c}function j(a,b,c){null!=a.removeEventListener?a.removeEventListener(b,c,!1):null!=a.detachEvent?a.detachEvent("on"+b,c):delete a[b]}function k(){return"innerHeight"in window?window.innerHeight:document.documentElement.clientHeight}Object.defineProperty(b,"__esModule",{value:!0});var l,m,n=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),o=window.WeakMap||window.MozWeakMap||function(){function a(){c(this,a),this.keys=[],this.values=[]}return n(a,[{key:"get",value:function(a){for(var b=0;b<this.keys.length;b++){var c=this.keys[b];if(c===a)return this.values[b]}}},{key:"set",value:function(a,b){for(var c=0;c<this.keys.length;c++){var d=this.keys[c];if(d===a)return this.values[c]=b,this}return this.keys.push(a),this.values.push(b),this}}]),a}(),p=window.MutationObserver||window.WebkitMutationObserver||window.MozMutationObserver||(m=l=function(){function a(){c(this,a),"undefined"!=typeof console&&null!==console&&(console.warn("MutationObserver is not supported by your browser."),console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content."))}return n(a,[{key:"observe",value:function(){}}]),a}(),l.notSupported=!0,m),q=window.getComputedStyle||function(a){var b=/(\-([a-z]){1})/g;return{getPropertyValue:function(c){"float"===c&&(c="styleFloat"),b.test(c)&&c.replace(b,function(a,b){return b.toUpperCase()});var d=a.currentStyle;return(null!=d?d[c]:void 0)||null}}},r=function(){function a(){var b=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c(this,a),this.defaults={boxClass:"wow",animateClass:"animated",offset:0,mobile:!0,live:!0,callback:null,scrollContainer:null,resetAnimation:!0},this.animate=function(){return"requestAnimationFrame"in window?function(a){return window.requestAnimationFrame(a)}:function(a){return a()}}(),this.vendors=["moz","webkit"],this.start=this.start.bind(this),this.resetAnimation=this.resetAnimation.bind(this),this.scrollHandler=this.scrollHandler.bind(this),this.scrollCallback=this.scrollCallback.bind(this),this.scrolled=!0,this.config=e(b,this.defaults),null!=b.scrollContainer&&(this.config.scrollContainer=document.querySelector(b.scrollContainer)),this.animationNameCache=new o,this.wowEvent=g(this.config.boxClass)}return n(a,[{key:"init",value:function(){this.element=window.document.documentElement,d(document.readyState,["interactive","complete"])?this.start():i(document,"DOMContentLoaded",this.start),this.finished=[]}},{key:"start",value:function(){var a=this;if(this.stopped=!1,this.boxes=[].slice.call(this.element.querySelectorAll("."+this.config.boxClass)),this.all=this.boxes.slice(0),this.boxes.length)if(this.disabled())this.resetStyle();else for(var b=0;b<this.boxes.length;b++){var c=this.boxes[b];this.applyStyle(c,!0)}if(this.disabled()||(i(this.config.scrollContainer||window,"scroll",this.scrollHandler),i(window,"resize",this.scrollHandler),this.interval=setInterval(this.scrollCallback,50)),this.config.live){var d=new p(function(b){for(var c=0;c<b.length;c++)for(var d=b[c],e=0;e<d.addedNodes.length;e++){var f=d.addedNodes[e];a.doSync(f)}});d.observe(document.body,{childList:!0,subtree:!0})}}},{key:"stop",value:function(){this.stopped=!0,j(this.config.scrollContainer||window,"scroll",this.scrollHandler),j(window,"resize",this.scrollHandler),null!=this.interval&&clearInterval(this.interval)}},{key:"sync",value:function(){p.notSupported&&this.doSync(this.element)}},{key:"doSync",value:function(a){if("undefined"!=typeof a&&null!==a||(a=this.element),1===a.nodeType){a=a.parentNode||a;for(var b=a.querySelectorAll("."+this.config.boxClass),c=0;c<b.length;c++){var e=b[c];d(e,this.all)||(this.boxes.push(e),this.all.push(e),this.stopped||this.disabled()?this.resetStyle():this.applyStyle(e,!0),this.scrolled=!0)}}}},{key:"show",value:function(a){return this.applyStyle(a),a.className=a.className+" "+this.config.animateClass,null!=this.config.callback&&this.config.callback(a),h(a,this.wowEvent),this.config.resetAnimation&&(i(a,"animationend",this.resetAnimation),i(a,"oanimationend",this.resetAnimation),i(a,"webkitAnimationEnd",this.resetAnimation),i(a,"MSAnimationEnd",this.resetAnimation)),a}},{key:"applyStyle",value:function(a,b){var c=this,d=a.getAttribute("data-wow-duration"),e=a.getAttribute("data-wow-delay"),f=a.getAttribute("data-wow-iteration");return this.animate(function(){return c.customStyle(a,b,d,e,f)})}},{key:"resetStyle",value:function(){for(var a=0;a<this.boxes.length;a++){var b=this.boxes[a];b.style.visibility="visible"}}},{key:"resetAnimation",value:function(a){if(a.type.toLowerCase().indexOf("animationend")>=0){var b=a.target||a.srcElement;b.className=b.className.replace(this.config.animateClass,"").trim()}}},{key:"customStyle",value:function(a,b,c,d,e){return b&&this.cacheAnimationName(a),a.style.visibility=b?"hidden":"visible",c&&this.vendorSet(a.style,{animationDuration:c}),d&&this.vendorSet(a.style,{animationDelay:d}),e&&this.vendorSet(a.style,{animationIterationCount:e}),this.vendorSet(a.style,{animationName:b?"none":this.cachedAnimationName(a)}),a}},{key:"vendorSet",value:function(a,b){for(var c in b)if(b.hasOwnProperty(c)){var d=b[c];a[""+c]=d;for(var e=0;e<this.vendors.length;e++){var f=this.vendors[e];a[""+f+c.charAt(0).toUpperCase()+c.substr(1)]=d}}}},{key:"vendorCSS",value:function(a,b){for(var c=q(a),d=c.getPropertyCSSValue(b),e=0;e<this.vendors.length;e++){var f=this.vendors[e];d=d||c.getPropertyCSSValue("-"+f+"-"+b)}return d}},{key:"animationName",value:function(a){var b=void 0;try{b=this.vendorCSS(a,"animation-name").cssText}catch(c){b=q(a).getPropertyValue("animation-name")}return"none"===b?"":b}},{key:"cacheAnimationName",value:function(a){return this.animationNameCache.set(a,this.animationName(a))}},{key:"cachedAnimationName",value:function(a){return this.animationNameCache.get(a)}},{key:"scrollHandler",value:function(){this.scrolled=!0}},{key:"scrollCallback",value:function(){if(this.scrolled){this.scrolled=!1;for(var a=[],b=0;b<this.boxes.length;b++){var c=this.boxes[b];if(c){if(this.isVisible(c)){this.show(c);continue}a.push(c)}}this.boxes=a,this.boxes.length||this.config.live||this.stop()}}},{key:"offsetTop",value:function(a){for(;void 0===a.offsetTop;)a=a.parentNode;for(var b=a.offsetTop;a.offsetParent;)a=a.offsetParent,b+=a.offsetTop;return b}},{key:"isVisible",value:function(a){var b=a.getAttribute("data-wow-offset")||this.config.offset,c=this.config.scrollContainer&&this.config.scrollContainer.scrollTop||window.pageYOffset,d=c+Math.min(this.element.clientHeight,k())-b,e=this.offsetTop(a),f=e+a.clientHeight;return d>=e&&f>=c}},{key:"disabled",value:function(){return!this.config.mobile&&f(navigator.userAgent)}}]),a}();b["default"]=r,a.exports=b["default"]});


!function(a){"use strict";function b(b,d){this.$el=a(b),this.opt=a.extend(!0,{},c,d),this.init(this)}var c={};b.prototype={init:function(b){a(document).on("click",function(c){var d=a(c.target);d.closest(b.$el.data("menu-toggle"))[0]?(d=d.closest(b.$el.data("menu-toggle")),b.$el.css(b.calcPosition(d)).toggleClass("show"),c.preventDefault()):d.closest(b.$el)[0]||b.$el.removeClass("show")})},calcPosition:function(b){var c,d,e;return c=a(window).width(),d=b.offset(),e={top:d.top+b.outerHeight()/2},d.left>c/2?(this.$el.addClass("menu--right").removeClass("menu--left"),e.right=c-d.left-b.outerWidth()/2,e.left="auto"):(this.$el.addClass("menu--left").removeClass("menu--right"),e.left=d.left+b.outerWidth()/2,e.right="auto"),e}},a.fn.menu=function(c){return this.each(function(){a.data(this,"menu")||a.data(this,"menu",new b(this,c))})}}(window.jQuery);



/*! jQuery & Zepto Lazy v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function(t,e){"use strict";function r(r,a,i,u,l){function f(){L=t.devicePixelRatio>1,i=c(i),a.delay>=0&&setTimeout(function(){s(!0)},a.delay),(a.delay<0||a.combined)&&(u.e=v(a.throttle,function(t){"resize"===t.type&&(w=B=-1),s(t.all)}),u.a=function(t){t=c(t),i.push.apply(i,t)},u.g=function(){return i=n(i).filter(function(){return!n(this).data(a.loadedName)})},u.f=function(t){for(var e=0;e<t.length;e++){var r=i.filter(function(){return this===t[e]});r.length&&s(!1,r)}},s(),n(a.appendScroll).on("scroll."+l+" resize."+l,u.e))}function c(t){var i=a.defaultImage,o=a.placeholder,u=a.imageBase,l=a.srcsetAttribute,f=a.loaderAttribute,c=a._f||{};t=n(t).filter(function(){var t=n(this),r=m(this);return!t.data(a.handledName)&&(t.attr(a.attribute)||t.attr(l)||t.attr(f)||c[r]!==e)}).data("plugin_"+a.name,r);for(var s=0,d=t.length;s<d;s++){var A=n(t[s]),g=m(t[s]),h=A.attr(a.imageBaseAttribute)||u;g===N&&h&&A.attr(l)&&A.attr(l,b(A.attr(l),h)),c[g]===e||A.attr(f)||A.attr(f,c[g]),g===N&&i&&!A.attr(E)?A.attr(E,i):g===N||!o||A.css(O)&&"none"!==A.css(O)||A.css(O,"url('"+o+"')")}return t}function s(t,e){if(!i.length)return void(a.autoDestroy&&r.destroy());for(var o=e||i,u=!1,l=a.imageBase||"",f=a.srcsetAttribute,c=a.handledName,s=0;s<o.length;s++)if(t||e||A(o[s])){var g=n(o[s]),h=m(o[s]),b=g.attr(a.attribute),v=g.attr(a.imageBaseAttribute)||l,p=g.attr(a.loaderAttribute);g.data(c)||a.visibleOnly&&!g.is(":visible")||!((b||g.attr(f))&&(h===N&&(v+b!==g.attr(E)||g.attr(f)!==g.attr(F))||h!==N&&v+b!==g.css(O))||p)||(u=!0,g.data(c,!0),d(g,h,v,p))}u&&(i=n(i).filter(function(){return!n(this).data(c)}))}function d(t,e,r,i){++z;var o=function(){y("onError",t),p(),o=n.noop};y("beforeLoad",t);var u=a.attribute,l=a.srcsetAttribute,f=a.sizesAttribute,c=a.retinaAttribute,s=a.removeAttribute,d=a.loadedName,A=t.attr(c);if(i){var g=function(){s&&t.removeAttr(a.loaderAttribute),t.data(d,!0),y(T,t),setTimeout(p,1),g=n.noop};t.off(I).one(I,o).one(D,g),y(i,t,function(e){e?(t.off(D),g()):(t.off(I),o())})||t.trigger(I)}else{var h=n(new Image);h.one(I,o).one(D,function(){t.hide(),e===N?t.attr(C,h.attr(C)).attr(F,h.attr(F)).attr(E,h.attr(E)):t.css(O,"url('"+h.attr(E)+"')"),t[a.effect](a.effectTime),s&&(t.removeAttr(u+" "+l+" "+c+" "+a.imageBaseAttribute),f!==C&&t.removeAttr(f)),t.data(d,!0),y(T,t),h.remove(),p()});var m=(L&&A?A:t.attr(u))||"";h.attr(C,t.attr(f)).attr(F,t.attr(l)).attr(E,m?r+m:null),h.complete&&h.trigger(D)}}function A(t){var e=t.getBoundingClientRect(),r=a.scrollDirection,n=a.threshold,i=h()+n>e.top&&-n<e.bottom,o=g()+n>e.left&&-n<e.right;return"vertical"===r?i:"horizontal"===r?o:i&&o}function g(){return w>=0?w:w=n(t).width()}function h(){return B>=0?B:B=n(t).height()}function m(t){return t.tagName.toLowerCase()}function b(t,e){if(e){var r=t.split(",");t="";for(var a=0,n=r.length;a<n;a++)t+=e+r[a].trim()+(a!==n-1?",":"")}return t}function v(t,e){var n,i=0;return function(o,u){function l(){i=+new Date,e.call(r,o)}var f=+new Date-i;n&&clearTimeout(n),f>t||!a.enableThrottle||u?l():n=setTimeout(l,t-f)}}function p(){--z,i.length||z||y("onFinishedAll")}function y(t,e,n){return!!(t=a[t])&&(t.apply(r,[].slice.call(arguments,1)),!0)}var z=0,w=-1,B=-1,L=!1,T="afterLoad",D="load",I="error",N="img",E="src",F="srcset",C="sizes",O="background-image";"event"===a.bind||o?f():n(t).on(D+"."+l,f)}function a(a,o){var u=this,l=n.extend({},u.config,o),f={},c=l.name+"-"+ ++i;return u.config=function(t,r){return r===e?l[t]:(l[t]=r,u)},u.addItems=function(t){return f.a&&f.a("string"===n.type(t)?n(t):t),u},u.getItems=function(){return f.g?f.g():{}},u.update=function(t){return f.e&&f.e({},!t),u},u.force=function(t){return f.f&&f.f("string"===n.type(t)?n(t):t),u},u.loadAll=function(){return f.e&&f.e({all:!0},!0),u},u.destroy=function(){return n(l.appendScroll).off("."+c,f.e),n(t).off("."+c),f={},e},r(u,l,a,f,c),l.chainable?a:u}var n=t.jQuery||t.Zepto,i=0,o=!1;n.fn.Lazy=n.fn.lazy=function(t){return new a(this,t)},n.Lazy=n.lazy=function(t,r,i){if(n.isFunction(r)&&(i=r,r=[]),n.isFunction(i)){t=n.isArray(t)?t:[t],r=n.isArray(r)?r:[r];for(var o=a.prototype.config,u=o._f||(o._f={}),l=0,f=t.length;l<f;l++)(o[t[l]]===e||n.isFunction(o[t[l]]))&&(o[t[l]]=i);for(var c=0,s=r.length;c<s;c++)u[r[c]]=t[0]}},a.prototype.config={name:"lazy",chainable:!0,autoDestroy:!0,bind:"load",threshold:500,visibleOnly:!1,appendScroll:t,scrollDirection:"both",imageBase:null,defaultImage:"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",placeholder:null,delay:-1,combined:!1,attribute:"data-src",srcsetAttribute:"data-srcset",sizesAttribute:"data-sizes",retinaAttribute:"data-retina",loaderAttribute:"data-loader",imageBaseAttribute:"data-imagebase",removeAttribute:!0,handledName:"handled",loadedName:"loaded",effect:"show",effectTime:0,enableThrottle:!0,throttle:250,beforeLoad:e,afterLoad:e,onError:e,onFinishedAll:e},n(t).on("load",function(){o=!0})}(window);



  
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
		target.style.overflow = 'hidden';
		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === target) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target && $(settings.target)[0] || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				var srcElement = source.querySelector('img');
				if (srcElement) {
					settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
				}
				if (!settings.url) {
					return;
				}
			}

			$source.one('zoom.destroy', function(position, overflow){
				$source.off(".zoom");
				target.style.position = position;
				target.style.overflow = overflow;
				img.onload = null;
				$img.remove();
			}.bind(this, target.style.position, target.style.overflow));

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					$source
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							} else {
								touched = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
						});
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.setAttribute('role', 'presentation');
			img.alt = '';
			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));

  







/*
 * arrive.js
 * v2.4.1
 * https://github.com/uzairfarooq/arrive
 * MIT licensed
 *
 * Copyright (c) 2014-2017 Uzair Farooq
 */

var Arrive=function(e,t,n){"use strict";function r(e,t,n){l.addMethod(t,n,e.unbindEvent),l.addMethod(t,n,e.unbindEventWithSelectorOrCallback),l.addMethod(t,n,e.unbindEventWithSelectorAndCallback)}function i(e){e.arrive=f.bindEvent,r(f,e,"unbindArrive"),e.leave=d.bindEvent,r(d,e,"unbindLeave")}if(e.MutationObserver&&"undefined"!=typeof HTMLElement){var o=0,l=function(){var t=HTMLElement.prototype.matches||HTMLElement.prototype.webkitMatchesSelector||HTMLElement.prototype.mozMatchesSelector||HTMLElement.prototype.msMatchesSelector;return{matchesSelector:function(e,n){return e instanceof HTMLElement&&t.call(e,n)},addMethod:function(e,t,r){var i=e[t];e[t]=function(){return r.length==arguments.length?r.apply(this,arguments):"function"==typeof i?i.apply(this,arguments):n}},callCallbacks:function(e,t){t&&t.options.onceOnly&&1==t.firedElems.length&&(e=[e[0]]);for(var n,r=0;n=e[r];r++)n&&n.callback&&n.callback.call(n.elem,n.elem);t&&t.options.onceOnly&&1==t.firedElems.length&&t.me.unbindEventWithSelectorAndCallback.call(t.target,t.selector,t.callback)},checkChildNodesRecursively:function(e,t,n,r){for(var i,o=0;i=e[o];o++)n(i,t,r)&&r.push({callback:t.callback,elem:i}),i.childNodes.length>0&&l.checkChildNodesRecursively(i.childNodes,t,n,r)},mergeArrays:function(e,t){var n,r={};for(n in e)e.hasOwnProperty(n)&&(r[n]=e[n]);for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);return r},toElementsArray:function(t){return n===t||"number"==typeof t.length&&t!==e||(t=[t]),t}}}(),c=function(){var e=function(){this._eventsBucket=[],this._beforeAdding=null,this._beforeRemoving=null};return e.prototype.addEvent=function(e,t,n,r){var i={target:e,selector:t,options:n,callback:r,firedElems:[]};return this._beforeAdding&&this._beforeAdding(i),this._eventsBucket.push(i),i},e.prototype.removeEvent=function(e){for(var t,n=this._eventsBucket.length-1;t=this._eventsBucket[n];n--)if(e(t)){this._beforeRemoving&&this._beforeRemoving(t);var r=this._eventsBucket.splice(n,1);r&&r.length&&(r[0].callback=null)}},e.prototype.beforeAdding=function(e){this._beforeAdding=e},e.prototype.beforeRemoving=function(e){this._beforeRemoving=e},e}(),a=function(t,r){var i=new c,o=this,a={fireOnAttributesModification:!1};return i.beforeAdding(function(n){var i,l=n.target;(l===e.document||l===e)&&(l=document.getElementsByTagName("html")[0]),i=new MutationObserver(function(e){r.call(this,e,n)});var c=t(n.options);i.observe(l,c),n.observer=i,n.me=o}),i.beforeRemoving(function(e){e.observer.disconnect()}),this.bindEvent=function(e,t,n){t=l.mergeArrays(a,t);for(var r=l.toElementsArray(this),o=0;o<r.length;o++)i.addEvent(r[o],e,t,n)},this.unbindEvent=function(){var e=l.toElementsArray(this);i.removeEvent(function(t){for(var r=0;r<e.length;r++)if(this===n||t.target===e[r])return!0;return!1})},this.unbindEventWithSelectorOrCallback=function(e){var t,r=l.toElementsArray(this),o=e;t="function"==typeof e?function(e){for(var t=0;t<r.length;t++)if((this===n||e.target===r[t])&&e.callback===o)return!0;return!1}:function(t){for(var i=0;i<r.length;i++)if((this===n||t.target===r[i])&&t.selector===e)return!0;return!1},i.removeEvent(t)},this.unbindEventWithSelectorAndCallback=function(e,t){var r=l.toElementsArray(this);i.removeEvent(function(i){for(var o=0;o<r.length;o++)if((this===n||i.target===r[o])&&i.selector===e&&i.callback===t)return!0;return!1})},this},s=function(){function e(e){var t={attributes:!1,childList:!0,subtree:!0};return e.fireOnAttributesModification&&(t.attributes=!0),t}function t(e,t){e.forEach(function(e){var n=e.addedNodes,i=e.target,o=[];null!==n&&n.length>0?l.checkChildNodesRecursively(n,t,r,o):"attributes"===e.type&&r(i,t,o)&&o.push({callback:t.callback,elem:i}),l.callCallbacks(o,t)})}function r(e,t){return l.matchesSelector(e,t.selector)&&(e._id===n&&(e._id=o++),-1==t.firedElems.indexOf(e._id))?(t.firedElems.push(e._id),!0):!1}var i={fireOnAttributesModification:!1,onceOnly:!1,existing:!1};f=new a(e,t);var c=f.bindEvent;return f.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t);var o=l.toElementsArray(this);if(t.existing){for(var a=[],s=0;s<o.length;s++)for(var u=o[s].querySelectorAll(e),f=0;f<u.length;f++)a.push({callback:r,elem:u[f]});if(t.onceOnly&&a.length)return r.call(a[0].elem,a[0].elem);setTimeout(l.callCallbacks,1,a)}c.call(this,e,t,r)},f},u=function(){function e(){var e={childList:!0,subtree:!0};return e}function t(e,t){e.forEach(function(e){var n=e.removedNodes,i=[];null!==n&&n.length>0&&l.checkChildNodesRecursively(n,t,r,i),l.callCallbacks(i,t)})}function r(e,t){return l.matchesSelector(e,t.selector)}var i={};d=new a(e,t);var o=d.bindEvent;return d.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t),o.call(this,e,t,r)},d},f=new s,d=new u;t&&i(t.fn),i(HTMLElement.prototype),i(NodeList.prototype),i(HTMLCollection.prototype),i(HTMLDocument.prototype),i(Window.prototype);var h={};return r(f,h,"unbindAllArrive"),r(d,h,"unbindAllLeave"),h}}(window,"undefined"==typeof jQuery?null:jQuery,void 0);


/*
A simple jQuery function that can add listeners on attribute change.
http://meetselva.github.io/attrchange/

About License:
Copyright (C) 2013-2014 Selvakumar Arumugam
You may use attrchange plugin under the terms of the MIT Licese.
https://github.com/meetselva/attrchange/blob/master/MIT-License.txt
 */
(function($) {
	function isDOMAttrModifiedSupported() {
		var p = document.createElement('p');
		var flag = false;

		if (p.addEventListener) {
			p.addEventListener('DOMAttrModified', function() {
				flag = true
			}, false);
		} else if (p.attachEvent) {
			p.attachEvent('onDOMAttrModified', function() {
				flag = true
			});
		} else { return false; }
		p.setAttribute('id', 'target');
		return flag;
	}

	function checkAttributes(chkAttr, e) {
		if (chkAttr) {
			var attributes = this.data('attr-old-value');

			if (e.attributeName.indexOf('style') >= 0) {
				if (!attributes['style'])
					attributes['style'] = {}; //initialize
				var keys = e.attributeName.split('.');
				e.attributeName = keys[0];
				e.oldValue = attributes['style'][keys[1]]; //old value
				e.newValue = keys[1] + ':'
						+ this.prop("style")[$.camelCase(keys[1])]; //new value
				attributes['style'][keys[1]] = e.newValue;
			} else {
				e.oldValue = attributes[e.attributeName];
				e.newValue = this.attr(e.attributeName);
				attributes[e.attributeName] = e.newValue;
			}

			this.data('attr-old-value', attributes); //update the old value object
		}
	}

	//initialize Mutation Observer
	var MutationObserver = window.MutationObserver
			|| window.WebKitMutationObserver;

	$.fn.attrchange = function(a, b) {
		if (typeof a == 'object') {//core
			var cfg = {
				trackValues : false,
				callback : $.noop
			};
			//backward compatibility
			if (typeof a === "function") { cfg.callback = a; } else { $.extend(cfg, a); }

			if (cfg.trackValues) { //get attributes old value
				this.each(function(i, el) {
					var attributes = {};
					for ( var attr, i = 0, attrs = el.attributes, l = attrs.length; i < l; i++) {
						attr = attrs.item(i);
						attributes[attr.nodeName] = attr.value;
					}
					$(this).data('attr-old-value', attributes);
				});
			}

			if (MutationObserver) { //Modern Browsers supporting MutationObserver
				var mOptions = {
					subtree : false,
					attributes : true,
					attributeOldValue : cfg.trackValues
				};
				var observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(e) {
						var _this = e.target;
						//get new value if trackValues is true
						if (cfg.trackValues) {							
							e.newValue = $(_this).attr(e.attributeName);
						}						
						if ($(_this).data('attrchange-status') === 'connected') { //execute if connected
							cfg.callback.call(_this, e);
						}
					});
				});

				return this.data('attrchange-method', 'Mutation Observer').data('attrchange-status', 'connected')
						.data('attrchange-obs', observer).each(function() {
							observer.observe(this, mOptions);
						});
			} else if (isDOMAttrModifiedSupported()) { //Opera
				//Good old Mutation Events
				return this.data('attrchange-method', 'DOMAttrModified').data('attrchange-status', 'connected').on('DOMAttrModified', function(event) {
					if (event.originalEvent) { event = event.originalEvent; }//jQuery normalization is not required 
					event.attributeName = event.attrName; //property names to be consistent with MutationObserver
					event.oldValue = event.prevValue; //property names to be consistent with MutationObserver
					if ($(this).data('attrchange-status') === 'connected') { //disconnected logically
						cfg.callback.call(this, event);
					}
				});
			} else if ('onpropertychange' in document.body) { //works only in IE		
				return this.data('attrchange-method', 'propertychange').data('attrchange-status', 'connected').on('propertychange', function(e) {
					e.attributeName = window.event.propertyName;
					//to set the attr old value
					checkAttributes.call($(this), cfg.trackValues, e);
					if ($(this).data('attrchange-status') === 'connected') { //disconnected logically
						cfg.callback.call(this, e);
					}
				});
			}
			return this;
		} else if (typeof a == 'string' && $.fn.attrchange.hasOwnProperty('extensions') &&
				$.fn.attrchange['extensions'].hasOwnProperty(a)) { //extensions/options
			return $.fn.attrchange['extensions'][a].call(this, b);
		}
	}
})(jQuery);


/*
An extension for attrchange jQuery plugin
http://meetselva.github.io/attrchange/

About License:
Copyright (C) 2013-2014 Selvakumar Arumugam
You may use attrchange ext plugin under the terms of the MIT Licese.
https://github.com/meetselva/attrchange/blob/master/MIT-License.txt
 */
$.fn.attrchange.extensions = { /*attrchange option/extension*/
	disconnect: function (o) {
		if (typeof o !== 'undefined' && o.isPhysicalDisconnect) {
			return this.each(function() {
				var attrchangeMethod = $(this).data('attrchange-method');
				if (attrchangeMethod == 'propertychange' || attrchangeMethod == 'DOMAttrModified') {
					$(this).off(attrchangeMethod);
				} else if (attrchangeMethod == 'Mutation Observer') {
					$(this).data('attrchange-obs').disconnect();
				} else if (attrchangeMethod == 'polling') {
					clearInterval($(this).data('attrchange-polling-timer'));
				}
			}).removeData(['attrchange-method', 'attrchange-status']);
		} else { //logical disconnect
			return this.data('attrchange-status', 'disconnected'); //set a flag that prevents triggering callback onattrchange
		}
	},
	remove: function (o) {
		return  $.fn.attrchange.extensions['disconnect'].call(this, {isPhysicalDisconnect: true});
	},
	getProperties: function (o) {
		var attrchangeMethod = $(this).data('attrchange-method');
		var pollInterval = $(this).data('attrchange-pollInterval');
		return {
			method: attrchangeMethod,
			isPolling: (attrchangeMethod == 'polling'),
			pollingInterval: (typeof pollInterval === 'undefined')?0:parseInt(pollInterval, 10),
			status: (typeof attrchangeMethod === 'undefined')?'removed': $(this).data('attrchange-status')
		}
	},
	reconnect: function (o) {//reconnect possible only when there is a logical disconnect
		return this.data('attrchange-status', 'connected');
	},
	polling: function (o) {
		if (o.hasOwnProperty('isComputedStyle') && o.isComputedStyle == 'true') { /* extensive and slow - polling to check on computed style properties */
			return this.each(function(i, _this) {
				if (!o.hasOwnProperty('properties') ||
						Object.prototype.toString.call(o.properties) !== '[object Array]' ||
							o.properties.length == 0) { return false; } //return if no properties found
				var attributes = {}; //store computed properties
				for (var i = 0; i < o.properties.length; i++) {
					attributes[o.properties[i]] = $(this).css(o.properties[i]);
				}			
				var _this = this;
				$(this).data('attrchange-polling-timer', setInterval(function () {
					var changes = {}, hasChanges = false; // attrName: { oldValue: xxx, newValue: yyy}						
					for (var comuptedVal, i = 0; i < o.properties.length; i++){
						comuptedVal = $(_this).css(o.properties[i]);
						if (attributes[o.properties[i]] !== comuptedVal) {
							hasChanges = true;
							changes[o.properties[i]] = {oldValue: attributes[o.properties[i]], newValue: comuptedVal};
							attributes[o.properties[i]] = comuptedVal //add the attribute to the orig						
						}
					}					
					if (hasChanges && $(_this).data('attrchange-status') === 'connected') { //disconnected logically
						o.callback.call(_this, changes);
					}
				}, (o.pollInterval)?o.pollInterval: 1000)).data('attrchange-method', 'polling').data('attrchange-pollInterval', o.pollInterval).data('attrchange-status', 'connected');
			});
		} else {
			return this.each(function(i, _this) { /* this one is programmatic polling */
				var attributes = {};
				for (var attr, i=0, attrs=_this.attributes, l=attrs.length; i<l; i++){
					attr = attrs.item(i);
					attributes[attr.nodeName] = attr.nodeValue;
				}						
				$(_this).data('attrchange-polling-timer', setInterval(function () {
					var changes = {}, hasChanges = false; // attrName: { oldValue: xxx, newValue: yyy}						
					for (var attr, i=0, attrs=_this.attributes, l=attrs.length; i<l; i++){
						attr = attrs.item(i);							
						if (attributes.hasOwnProperty(attr.nodeName) &&
								attributes[attr.nodeName] != attr.nodeValue) { //check the values
							changes[attr.nodeName] = {oldValue: attributes[attr.nodeName], newValue: attr.nodeValue};
							hasChanges = true;
						} else if (!attributes.hasOwnProperty(attr.nodeName)) { //new attribute
							changes[attr.nodeName] = {oldValue: '', newValue: attr.nodeValue};
							hasChanges = true;
						}
						attributes[attr.nodeName] = attr.nodeValue; //add the attribute to the orig
					}
					if (hasChanges && $(_this).data('attrchange-status') === 'connected') { //disconnected logically
						o.callback.call(_this, changes);
					}
				}, (o.pollInterval)?o.pollInterval: 1000)).data('attrchange-method', 'polling').data('attrchange-pollInterval', o.pollInterval).data('attrchange-status', 'connected');
			});
		}
	}
}


/**
 * Owl carousel
 * @version 2.2.1
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */

!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this.drag=a.extend({},m),this.state=a.extend({},n),this.e=a.extend({},o),this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._invalidated={},this._pipe=[],a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a[0].toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Pipe,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}function f(a){if(a.touches!==d)return{x:a.touches[0].pageX,y:a.touches[0].pageY};if(a.touches===d){if(a.pageX!==d)return{x:a.pageX,y:a.pageY};if(a.pageX===d)return{x:a.clientX,y:a.clientY}}}function g(a){var b,d,e=c.createElement("div"),f=a;for(b in f)if(d=f[b],"undefined"!=typeof e.style[d])return e=null,[d,b];return[!1]}function h(){return g(["transition","WebkitTransition","MozTransition","OTransition"])[1]}function i(){return g(["transform","WebkitTransform","MozTransform","OTransform","msTransform"])[0]}function j(){return g(["perspective","webkitPerspective","MozPerspective","OPerspective","MsPerspective"])[0]}function k(){return"ontouchstart"in b||!!navigator.msMaxTouchPoints}function l(){return b.navigator.msPointerEnabled}var m,n,o;m={start:0,startX:0,startY:0,current:0,currentX:0,currentY:0,offsetX:0,offsetY:0,distance:null,startTime:0,endTime:0,updatedX:0,targetEl:null},n={isTouch:!1,isScrolling:!1,isSwiping:!1,direction:!1,inMotion:!1},o={_onDragStart:null,_onDragMove:null,_onDragEnd:null,_transitionEnd:null,_resizer:null,_responsiveCall:null,_goToLoop:null,_checkVisibile:null},e.Defaults={items:3,loop:!1,center:!1,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,responsiveClass:!1,fallbackEasing:"swing",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",themeClass:"owl-theme",baseClass:"owl-carousel",itemClass:"owl-item",centerClass:"center",activeClass:"active"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Plugins={},e.Pipe=[{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){var a=this._clones,b=this.$stage.children(".cloned");(b.length!==a.length||!this.settings.loop&&a.length>0)&&(this.$stage.children(".cloned").remove(),this._clones=[])}},{filter:["items","settings"],run:function(){var a,b,c=this._clones,d=this._items,e=this.settings.loop?c.length-Math.max(2*this.settings.items,4):0;for(a=0,b=Math.abs(e/2);b>a;a++)e>0?(this.$stage.children().eq(d.length+c.length-1).remove(),c.pop(),this.$stage.children().eq(0).remove(),c.pop()):(c.push(c.length/2),this.$stage.append(d[c[c.length-1]].clone().addClass("cloned")),c.push(d.length-1-(c.length-1)/2),this.$stage.prepend(d[c[c.length-1]].clone().addClass("cloned")))}},{filter:["width","items","settings"],run:function(){var a,b,c,d=this.settings.rtl?1:-1,e=(this.width()/this.settings.items).toFixed(3),f=0;for(this._coordinates=[],b=0,c=this._clones.length+this._items.length;c>b;b++)a=this._mergers[this.relative(b)],a=this.settings.mergeFit&&Math.min(a,this.settings.items)||a,f+=(this.settings.autoWidth?this._items[this.relative(b)].width()+this.settings.margin:e*a)*d,this._coordinates.push(f)}},{filter:["width","items","settings"],run:function(){var b,c,d=(this.width()/this.settings.items).toFixed(3),e={width:Math.abs(this._coordinates[this._coordinates.length-1])+2*this.settings.stagePadding,"padding-left":this.settings.stagePadding||"","padding-right":this.settings.stagePadding||""};if(this.$stage.css(e),e={width:this.settings.autoWidth?"auto":d-this.settings.margin},e[this.settings.rtl?"margin-left":"margin-right"]=this.settings.margin,!this.settings.autoWidth&&a.grep(this._mergers,function(a){return a>1}).length>0)for(b=0,c=this._coordinates.length;c>b;b++)e.width=Math.abs(this._coordinates[b])-Math.abs(this._coordinates[b-1]||0)-this.settings.margin,this.$stage.children().eq(b).css(e);else this.$stage.children().css(e)}},{filter:["width","items","settings"],run:function(a){a.current&&this.reset(this.$stage.children().index(a.current))}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;d>c;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children("."+this.settings.activeClass).removeClass(this.settings.activeClass),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass(this.settings.activeClass),this.settings.center&&(this.$stage.children("."+this.settings.centerClass).removeClass(this.settings.centerClass),this.$stage.children().eq(this.current()).addClass(this.settings.centerClass))}}],e.prototype.initialize=function(){if(this.trigger("initialize"),this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass("owl-rtl",this.settings.rtl),this.browserSupport(),this.settings.autoWidth&&this.state.imagesLoaded!==!0){var b,c,e;if(b=this.$element.find("img"),c=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,e=this.$element.children(c).width(),b.length&&0>=e)return this.preloadAutoWidthImages(b),!1}this.$element.addClass("owl-loading"),this.$stage=a("<"+this.settings.stageElement+' class="owl-stage"/>').wrap('<div class="owl-stage-outer">'),this.$element.append(this.$stage.parent()),this.replace(this.$element.children().not(this.$stage.parent())),this._width=this.$element.width(),this.refresh(),this.$element.removeClass("owl-loading").addClass("owl-loaded"),this.eventsCall(),this.internalEvents(),this.addTriggerableEvents(),this.trigger("initialized")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){b>=a&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),delete e.responsive,e.responsiveClass&&this.$element.attr("class",function(a,b){return b.replace(/\b owl-responsive-\S+/g,"")}).addClass("owl-responsive-"+d)):e=a.extend({},this.options),(null===this.settings||this._breakpoint!==d)&&(this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}}))},e.prototype.optionsLogic=function(){this.$element.toggleClass("owl-center",this.settings.center),this.settings.loop&&this._items.length<this.settings.items&&(this.settings.loop=!1),this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.settings.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};c>b;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={}},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){if(0===this._items.length)return!1;(new Date).getTime();this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$stage.addClass("owl-refresh"),this.update(),this.$stage.removeClass("owl-refresh"),this.state.orientation=b.orientation,this.watchVisibility(),this.trigger("refreshed")},e.prototype.eventsCall=function(){this.e._onDragStart=a.proxy(function(a){this.onDragStart(a)},this),this.e._onDragMove=a.proxy(function(a){this.onDragMove(a)},this),this.e._onDragEnd=a.proxy(function(a){this.onDragEnd(a)},this),this.e._onResize=a.proxy(function(a){this.onResize(a)},this),this.e._transitionEnd=a.proxy(function(a){this.transitionEnd(a)},this),this.e._preventClick=a.proxy(function(a){this.preventClick(a)},this)},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this.e._onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return this._items.length?this._width===this.$element.width()?!1:this.trigger("resize").isDefaultPrevented()?!1:(this._width=this.$element.width(),this.invalidate("width"),this.refresh(),void this.trigger("resized")):!1},e.prototype.eventsRouter=function(a){var b=a.type;"mousedown"===b||"touchstart"===b?this.onDragStart(a):"mousemove"===b||"touchmove"===b?this.onDragMove(a):"mouseup"===b||"touchend"===b?this.onDragEnd(a):"touchcancel"===b&&this.onDragEnd(a)},e.prototype.internalEvents=function(){var c=(k(),l());this.settings.mouseDrag?(this.$stage.on("mousedown",a.proxy(function(a){this.eventsRouter(a)},this)),this.$stage.on("dragstart",function(){return!1}),this.$stage.get(0).onselectstart=function(){return!1}):this.$element.addClass("owl-text-select-on"),this.settings.touchDrag&&!c&&this.$stage.on("touchstart touchcancel",a.proxy(function(a){this.eventsRouter(a)},this)),this.transitionEndVendor&&this.on(this.$stage.get(0),this.transitionEndVendor,this.e._transitionEnd,!1),this.settings.responsive!==!1&&this.on(b,"resize",a.proxy(this.onThrottledResize,this))},e.prototype.onDragStart=function(d){var e,g,h,i;if(e=d.originalEvent||d||b.event,3===e.which||this.state.isTouch)return!1;if("mousedown"===e.type&&this.$stage.addClass("owl-grab"),this.trigger("drag"),this.drag.startTime=(new Date).getTime(),this.speed(0),this.state.isTouch=!0,this.state.isScrolling=!1,this.state.isSwiping=!1,this.drag.distance=0,g=f(e).x,h=f(e).y,this.drag.offsetX=this.$stage.position().left,this.drag.offsetY=this.$stage.position().top,this.settings.rtl&&(this.drag.offsetX=this.$stage.position().left+this.$stage.width()-this.width()+this.settings.margin),this.state.inMotion&&this.support3d)i=this.getTransformProperty(),this.drag.offsetX=i,this.animate(i),this.state.inMotion=!0;else if(this.state.inMotion&&!this.support3d)return this.state.inMotion=!1,!1;this.drag.startX=g-this.drag.offsetX,this.drag.startY=h-this.drag.offsetY,this.drag.start=g-this.drag.startX,this.drag.targetEl=e.target||e.srcElement,this.drag.updatedX=this.drag.start,("IMG"===this.drag.targetEl.tagName||"A"===this.drag.targetEl.tagName)&&(this.drag.targetEl.draggable=!1),a(c).on("mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents",a.proxy(function(a){this.eventsRouter(a)},this))},e.prototype.onDragMove=function(a){var c,e,g,h,i,j;this.state.isTouch&&(this.state.isScrolling||(c=a.originalEvent||a||b.event,e=f(c).x,g=f(c).y,this.drag.currentX=e-this.drag.startX,this.drag.currentY=g-this.drag.startY,this.drag.distance=this.drag.currentX-this.drag.offsetX,this.drag.distance<0?this.state.direction=this.settings.rtl?"right":"left":this.drag.distance>0&&(this.state.direction=this.settings.rtl?"left":"right"),this.settings.loop?this.op(this.drag.currentX,">",this.coordinates(this.minimum()))&&"right"===this.state.direction?this.drag.currentX-=(this.settings.center&&this.coordinates(0))-this.coordinates(this._items.length):this.op(this.drag.currentX,"<",this.coordinates(this.maximum()))&&"left"===this.state.direction&&(this.drag.currentX+=(this.settings.center&&this.coordinates(0))-this.coordinates(this._items.length)):(h=this.coordinates(this.settings.rtl?this.maximum():this.minimum()),i=this.coordinates(this.settings.rtl?this.minimum():this.maximum()),j=this.settings.pullDrag?this.drag.distance/5:0,this.drag.currentX=Math.max(Math.min(this.drag.currentX,h+j),i+j)),(this.drag.distance>8||this.drag.distance<-8)&&(c.preventDefault!==d?c.preventDefault():c.returnValue=!1,this.state.isSwiping=!0),this.drag.updatedX=this.drag.currentX,(this.drag.currentY>16||this.drag.currentY<-16)&&this.state.isSwiping===!1&&(this.state.isScrolling=!0,this.drag.updatedX=this.drag.start),this.animate(this.drag.updatedX)))},e.prototype.onDragEnd=function(b){var d,e,f;if(this.state.isTouch){if("mouseup"===b.type&&this.$stage.removeClass("owl-grab"),this.trigger("dragged"),this.drag.targetEl.removeAttribute("draggable"),this.state.isTouch=!1,this.state.isScrolling=!1,this.state.isSwiping=!1,0===this.drag.distance&&this.state.inMotion!==!0)return this.state.inMotion=!1,!1;this.drag.endTime=(new Date).getTime(),d=this.drag.endTime-this.drag.startTime,e=Math.abs(this.drag.distance),(e>3||d>300)&&this.removeClick(this.drag.targetEl),f=this.closest(this.drag.updatedX),this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(f),this.invalidate("position"),this.update(),this.settings.pullDrag||this.drag.updatedX!==this.coordinates(f)||this.transitionEnd(),this.drag.distance=0,a(c).off(".owl.dragEvents")}},e.prototype.removeClick=function(c){this.drag.targetEl=c,a(c).on("click.preventClick",this.e._preventClick),b.setTimeout(function(){a(c).off("click.preventClick")},300)},e.prototype.preventClick=function(b){b.preventDefault?b.preventDefault():b.returnValue=!1,b.stopPropagation&&b.stopPropagation(),a(b.target).off("click.preventClick")},e.prototype.getTransformProperty=function(){var a,c;return a=b.getComputedStyle(this.$stage.get(0),null).getPropertyValue(this.vendorName+"transform"),a=a.replace(/matrix(3d)?\(|\)/g,"").split(","),c=16===a.length,c!==!0?a[4]:a[12]},e.prototype.closest=function(b){var c=-1,d=30,e=this.width(),f=this.coordinates();return this.settings.freeDrag||a.each(f,a.proxy(function(a,g){return b>g-d&&g+d>b?c=a:this.op(b,"<",g)&&this.op(b,">",f[a+1]||g-e)&&(c="left"===this.state.direction?a+1:a),-1===c},this)),this.settings.loop||(this.op(b,">",f[this.minimum()])?c=b=this.minimum():this.op(b,"<",f[this.maximum()])&&(c=b=this.maximum())),c},e.prototype.animate=function(b){this.trigger("translate"),this.state.inMotion=this.speed()>0,this.support3d?this.$stage.css({transform:"translate3d("+b+"px,0px, 0px)",transition:this.speed()/1e3+"s"}):this.state.isTouch?this.$stage.css({left:b+"px"}):this.$stage.animate({left:b},this.speed()/1e3,this.settings.fallbackEasing,a.proxy(function(){this.state.inMotion&&this.transitionEnd()},this))},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(a){this._invalidated[a]=!0},e.prototype.reset=function(a){a=this.normalize(a),a!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(b,c){var e=c?this._items.length:this._items.length+this._clones.length;return!a.isNumeric(b)||1>e?d:b=this._clones.length?(b%e+e)%e:Math.max(this.minimum(c),Math.min(this.maximum(c),b))},e.prototype.relative=function(a){return a=this.normalize(a),a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=0,f=this.settings;if(a)return this._items.length-1;if(!f.loop&&f.center)b=this._items.length-1;else if(f.loop||f.center)if(f.loop||f.center)b=this._items.length+f.items;else{if(!f.autoWidth&&!f.merge)throw"Can not detect maximum absolute position.";for(revert=f.rtl?1:-1,c=this.$stage.width()-this.$element.width();(d=this.coordinates(e))&&!(d*revert>=c);)b=++e}else b=this._items.length-f.items;return b},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2===0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c=null;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[b-1]||0))/2*(this.settings.rtl?-1:1)):c=this._coordinates[b-1]||0,c)},e.prototype.duration=function(a,b,c){return Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(c,d){if(this.settings.loop){var e=c-this.relative(this.current()),f=this.current(),g=this.current(),h=this.current()+e,i=0>g-h?!0:!1,j=this._clones.length+this._items.length;h<this.settings.items&&i===!1?(f=g+this._items.length,this.reset(f)):h>=j-this.settings.items&&i===!0&&(f=g-this._items.length,this.reset(f)),b.clearTimeout(this.e._goToLoop),this.e._goToLoop=b.setTimeout(a.proxy(function(){this.speed(this.duration(this.current(),f+e,d)),this.current(f+e),this.update()},this),30)}else this.speed(this.duration(this.current(),c,d)),this.current(c),this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.transitionEnd=function(a){return a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0))?!1:(this.state.inMotion=!1,void this.trigger("translated"))},e.prototype.viewport=function(){var d;if(this.options.responsiveBaseElement!==b)d=a(this.options.responsiveBaseElement).width();else if(b.innerWidth)d=b.innerWidth;else{if(!c.documentElement||!c.documentElement.clientWidth)throw"Can not detect viewport width.";d=c.documentElement.clientWidth}return d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)},this)),this.reset(a.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(a,b){b=b===d?this._items.length:this.normalize(b,!0),this.trigger("add",{content:a,position:b}),0===this._items.length||b===this._items.length?(this.$stage.append(a),this._items.push(a),this._mergers.push(1*a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)):(this._items[b].before(a),this._items.splice(b,0,a),this._mergers.splice(b,0,1*a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)),this.invalidate("items"),this.trigger("added",{content:a,position:b})},e.prototype.remove=function(a){a=this.normalize(a,!0),a!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.addTriggerableEvents=function(){var b=a.proxy(function(b,c){return a.proxy(function(a){a.relatedTarget!==this&&(this.suppress([c]),b.apply(this,[].slice.call(arguments,1)),this.release([c]))},this)},this);a.each({next:this.next,prev:this.prev,to:this.to,destroy:this.destroy,refresh:this.refresh,replace:this.replace,add:this.add,remove:this.remove},a.proxy(function(a,c){this.$element.on(a+".owl.carousel",b(c,a+".owl.carousel"))},this))},e.prototype.watchVisibility=function(){function c(a){return a.offsetWidth>0&&a.offsetHeight>0}function d(){c(this.$element.get(0))&&(this.$element.removeClass("owl-hidden"),this.refresh(),b.clearInterval(this.e._checkVisibile))}c(this.$element.get(0))||(this.$element.addClass("owl-hidden"),b.clearInterval(this.e._checkVisibile),this.e._checkVisibile=b.setInterval(a.proxy(d,this),500))},e.prototype.preloadAutoWidthImages=function(b){var c,d,e,f;c=0,d=this,b.each(function(g,h){e=a(h),f=new Image,f.onload=function(){c++,e.attr("src",f.src),e.css("opacity",1),c>=b.length&&(d.state.imagesLoaded=!0,d.initialize())},f.src=e.attr("src")||e.attr("data-src")||e.attr("data-src-retina")})},e.prototype.destroy=function(){this.$element.hasClass(this.settings.themeClass)&&this.$element.removeClass(this.settings.themeClass),this.settings.responsive!==!1&&a(b).off("resize.owl.carousel"),this.transitionEndVendor&&this.off(this.$stage.get(0),this.transitionEndVendor,this.e._transitionEnd);for(var d in this._plugins)this._plugins[d].destroy();(this.settings.mouseDrag||this.settings.touchDrag)&&(this.$stage.off("mousedown touchstart touchcancel"),a(c).off(".owl.dragEvents"),this.$stage.get(0).onselectstart=function(){},this.$stage.off("dragstart",function(){return!1})),this.$element.off(".owl"),this.$stage.children(".cloned").remove(),this.e=null,this.$element.removeData("owlCarousel"),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.unwrap()},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:c>a;case">":return d?c>a:a>c;case">=":return d?c>=a:a>=c;case"<=":return d?a>=c:c>=a}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d){var e={item:{count:this._items.length,index:this.current()}},f=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),g=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},e,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(g)}),this.$element.trigger(g),this.settings&&"function"==typeof this.settings[f]&&this.settings[f].apply(this,g)),g},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.browserSupport=function(){if(this.support3d=j(),this.support3d){this.transformVendor=i();var a=["transitionend","webkitTransitionEnd","transitionend","oTransitionEnd"];this.transitionEndVendor=a[h()],this.vendorName=this.transformVendor.replace(/Transform/i,""),this.vendorName=""!==this.vendorName?"-"+this.vendorName.toLowerCase()+"-":""}this.state.orientation=b.orientation},a.fn.owlCarousel=function(b){return this.each(function(){a(this).data("owlCarousel")||a(this).data("owlCarousel",new e(this,b))})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b){var c=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type))for(var c=this._core.settings,d=c.center&&Math.ceil(c.items/2)||c.items,e=c.center&&-1*d||0,f=(b.property&&b.property.value||this._core.current())+e,g=this._core.clones().length,h=a.proxy(function(a,b){this.load(b)},this);e++<d;)this.load(g/2+this._core.relative(f)),g&&a.each(this._core.clones(this._core.relative(f++)),h)},this)},this._core.options=a.extend({},c.Defaults,this._core.options),this._core.$element.on(this._handlers)};c.Defaults={lazyLoad:!1},c.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":"url("+g+")",opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},c.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=c}(window.Zepto||window.jQuery,window,document),function(a){var b=function(c){this._core=c,this._handlers={"initialized.owl.carousel":a.proxy(function(){this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){this._core.settings.autoHeight&&"position"==a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass)===this._core.$stage.children().eq(this._core.current())&&this.update()},this)},this._core.options=a.extend({},b.Defaults,this._core.options),this._core.$element.on(this._handlers)};b.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},b.prototype.update=function(){this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass)},b.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=b}(window.Zepto||window.jQuery,window,document),function(a,b,c){var d=function(b){this._core=b,this._videos={},this._playing=null,this._fullscreen=!1,this._handlers={"resize.owl.carousel":a.proxy(function(a){this._core.settings.video&&!this.isInFullScreen()&&a.preventDefault()},this),"refresh.owl.carousel changed.owl.carousel":a.proxy(function(){this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))},this)},this._core.options=a.extend({},d.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};d.Defaults={video:!1,videoHeight:!1,videoWidth:!1},d.prototype.fetch=function(a,b){var c=a.attr("data-vimeo-id")?"vimeo":"youtube",d=a.attr("data-vimeo-id")||a.attr("data-youtube-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else{if(!(d[3].indexOf("vimeo")>-1))throw new Error("Video URL not supported.");c="vimeo"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},d.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?'style="width:'+c.width+"px;height:"+c.height+'px;"':"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(a){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?'<div class="owl-video-tn '+j+'" '+i+'="'+a+'"></div>':'<div class="owl-video-tn" style="opacity:1;background-image:url('+a+')"></div>',b.after(d),b.after(e)};return b.wrap('<div class="owl-video-wrapper"'+g+"></div>"),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length?(l(h.attr(i)),h.remove(),!1):void("youtube"===c.type?(f="http://img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type&&a.ajax({type:"GET",url:"http://vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}))},d.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null},d.prototype.play=function(b){this._core.trigger("play",null,"video"),this._playing&&this.stop();var c,d,e=a(b.target||b.srcElement),f=e.closest("."+this._core.settings.itemClass),g=this._videos[f.attr("data-video")],h=g.width||"100%",i=g.height||this._core.$stage.height();"youtube"===g.type?c='<iframe width="'+h+'" height="'+i+'" src="http://www.youtube.com/embed/'+g.id+"?autoplay=1&v="+g.id+'" frameborder="0" allowfullscreen></iframe>':"vimeo"===g.type&&(c='<iframe src="http://player.vimeo.com/video/'+g.id+'?autoplay=1" width="'+h+'" height="'+i+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'),f.addClass("owl-video-playing"),this._playing=f,d=a('<div style="height:'+i+"px; width:"+h+'px" class="owl-video-frame">'+c+"</div>"),e.after(d)},d.prototype.isInFullScreen=function(){var d=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return d&&a(d).parent().hasClass("owl-video-frame")&&(this._core.speed(0),this._fullscreen=!0),d&&this._fullscreen&&this._playing?!1:this._fullscreen?(this._fullscreen=!1,!1):this._playing&&this._core.state.orientation!==b.orientation?(this._core.state.orientation=b.orientation,!1):!0},d.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=d}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){this.swapping="translated"==a.type},this),"translate.owl.carousel":a.proxy(function(){this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&this.core.support3d){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",c)),f&&e.addClass("animated owl-animated-in").addClass(f).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",c))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.transitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c){var d=function(b){this.core=b,this.core.options=a.extend({},d.Defaults,this.core.options),this.handlers={"translated.owl.carousel refreshed.owl.carousel":a.proxy(function(){this.autoplay()
},this),"play.owl.autoplay":a.proxy(function(a,b,c){this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(){this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this.core.settings.autoplayHoverPause&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this.core.settings.autoplayHoverPause&&this.autoplay()},this)},this.core.$element.on(this.handlers)};d.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},d.prototype.autoplay=function(){this.core.settings.autoplay&&!this.core.state.videoPlay?(b.clearInterval(this.interval),this.interval=b.setInterval(a.proxy(function(){this.play()},this),this.core.settings.autoplayTimeout)):b.clearInterval(this.interval)},d.prototype.play=function(){return c.hidden===!0||this.core.state.isTouch||this.core.state.isScrolling||this.core.state.isSwiping||this.core.state.inMotion?void 0:this.core.settings.autoplay===!1?void b.clearInterval(this.interval):void this.core.next(this.core.settings.autoplaySpeed)},d.prototype.stop=function(){b.clearInterval(this.interval)},d.prototype.pause=function(){b.clearInterval(this.interval)},d.prototype.destroy=function(){var a,c;b.clearInterval(this.interval);for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=d}(window.Zepto||window.jQuery,window,document),function(a){"use strict";var b=function(c){this._core=c,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){this._core.settings.dotsData&&this._templates.push(a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))},this),"add.owl.carousel":a.proxy(function(b){this._core.settings.dotsData&&this._templates.splice(b.position,0,a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))},this),"remove.owl.carousel prepared.owl.carousel":a.proxy(function(a){this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"change.owl.carousel":a.proxy(function(a){if("position"==a.property.name&&!this._core.state.revert&&!this._core.settings.loop&&this._core.settings.navRewind){var b=this._core.current(),c=this._core.maximum(),d=this._core.minimum();a.data=a.property.value>c?b>=c?d:c:a.property.value<d?c:a.property.value}},this),"changed.owl.carousel":a.proxy(function(a){"position"==a.property.name&&this.draw()},this),"refreshed.owl.carousel":a.proxy(function(){this._initialized||(this.initialize(),this._initialized=!0),this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation")},this)},this._core.options=a.extend({},b.Defaults,this._core.options),this.$element.on(this._handlers)};b.Defaults={nav:!1,navRewind:!0,navText:["prev","next"],navSpeed:!1,navElement:"div",navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotData:!1,dotsSpeed:!1,dotsContainer:!1,controlsClass:"owl-controls"},b.prototype.initialize=function(){var b,c,d=this._core.settings;d.dotsData||(this._templates=[a("<div>").addClass(d.dotClass).append(a("<span>")).prop("outerHTML")]),d.navContainer&&d.dotsContainer||(this._controls.$container=a("<div>").addClass(d.controlsClass).appendTo(this.$element)),this._controls.$indicators=d.dotsContainer?a(d.dotsContainer):a("<div>").hide().addClass(d.dotsClass).appendTo(this._controls.$container),this._controls.$indicators.on("click","div",a.proxy(function(b){var c=a(b.target).parent().is(this._controls.$indicators)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(c,d.dotsSpeed)},this)),b=d.navContainer?a(d.navContainer):a("<div>").addClass(d.navContainerClass).prependTo(this._controls.$container),this._controls.$next=a("<"+d.navElement+">"),this._controls.$previous=this._controls.$next.clone(),this._controls.$previous.addClass(d.navClass[0]).html(d.navText[0]).hide().prependTo(b).on("click",a.proxy(function(){this.prev(d.navSpeed)},this)),this._controls.$next.addClass(d.navClass[1]).html(d.navText[1]).hide().appendTo(b).on("click",a.proxy(function(){this.next(d.navSpeed)},this));for(c in this._overrides)this._core[c]=a.proxy(this[c],this)},b.prototype.destroy=function(){var a,b,c,d;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},b.prototype.update=function(){var a,b,c,d=this._core.settings,e=this._core.clones().length/2,f=e+this._core.items().length,g=d.center||d.autoWidth||d.dotData?1:d.dotsEach||d.items;if("page"!==d.slideBy&&(d.slideBy=Math.min(d.slideBy,d.items)),d.dots||"page"==d.slideBy)for(this._pages=[],a=e,b=0,c=0;f>a;a++)(b>=g||0===b)&&(this._pages.push({start:a-e,end:a-e+g-1}),b=0,++c),b+=this._core.mergers(this._core.relative(a))},b.prototype.draw=function(){var b,c,d="",e=this._core.settings,f=(this._core.$stage.children(),this._core.relative(this._core.current()));if(!e.nav||e.loop||e.navRewind||(this._controls.$previous.toggleClass("disabled",0>=f),this._controls.$next.toggleClass("disabled",f>=this._core.maximum())),this._controls.$previous.toggle(e.nav),this._controls.$next.toggle(e.nav),e.dots){if(b=this._pages.length-this._controls.$indicators.children().length,e.dotData&&0!==b){for(c=0;c<this._controls.$indicators.children().length;c++)d+=this._templates[this._core.relative(c)];this._controls.$indicators.html(d)}else b>0?(d=new Array(b+1).join(this._templates[0]),this._controls.$indicators.append(d)):0>b&&this._controls.$indicators.children().slice(b).remove();this._controls.$indicators.find(".active").removeClass("active"),this._controls.$indicators.children().eq(a.inArray(this.current(),this._pages)).addClass("active")}this._controls.$indicators.toggle(e.dots)},b.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotData?1:c.dotsEach||c.items)}},b.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,function(a){return a.start<=b&&a.end>=b}).pop()},b.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},b.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},b.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},b.prototype.to=function(b,c,d){var e;d?a.proxy(this._overrides.to,this._core)(b,c):(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c))},a.fn.owlCarousel.Constructor.Plugins.Navigation=b}(window.Zepto||window.jQuery,window,document),function(a,b){"use strict";var c=function(d){this._core=d,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(){"URLHash"==this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){var c=a(b.content).find("[data-hash]").andSelf("[data-hash]").attr("data-hash");this._hashes[c]=b.content},this)},this._core.options=a.extend({},c.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(){var a=b.location.hash.substring(1),c=this._core.$stage.children(),d=this._hashes[a]&&c.index(this._hashes[a])||0;return a?void this._core.to(d,!1,!0):!1},this))};c.Defaults={URLhashListener:!1},c.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=c}(window.Zepto||window.jQuery,window,document);





/*
 * jQuery FlexSlider v2.7.0
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */!function($){var e=!0;$.flexslider=function(t,a){var n=$(t);void 0===a.rtl&&"rtl"==$("html").attr("dir")&&(a.rtl=!0),n.vars=$.extend({},$.flexslider.defaults,a);var i=n.vars.namespace,r=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,s=("ontouchstart"in window||r||window.DocumentTouch&&document instanceof DocumentTouch)&&n.vars.touch,o="click touchend MSPointerUp keyup",l="",c,d="vertical"===n.vars.direction,u=n.vars.reverse,v=n.vars.itemWidth>0,p="fade"===n.vars.animation,m=""!==n.vars.asNavFor,f={};$.data(t,"flexslider",n),f={init:function(){n.animating=!1,n.currentSlide=parseInt(n.vars.startAt?n.vars.startAt:0,10),isNaN(n.currentSlide)&&(n.currentSlide=0),n.animatingTo=n.currentSlide,n.atEnd=0===n.currentSlide||n.currentSlide===n.last,n.containerSelector=n.vars.selector.substr(0,n.vars.selector.search(" ")),n.slides=$(n.vars.selector,n),n.container=$(n.containerSelector,n),n.count=n.slides.length,n.syncExists=$(n.vars.sync).length>0,"slide"===n.vars.animation&&(n.vars.animation="swing"),n.prop=d?"top":n.vars.rtl?"marginRight":"marginLeft",n.args={},n.manualPause=!1,n.stopped=!1,n.started=!1,n.startTimeout=null,n.transitions=!n.vars.video&&!p&&n.vars.useCSS&&function(){var e=document.createElement("div"),t=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var a in t)if(void 0!==e.style[t[a]])return n.pfx=t[a].replace("Perspective","").toLowerCase(),n.prop="-"+n.pfx+"-transform",!0;return!1}(),n.ensureAnimationEnd="",""!==n.vars.controlsContainer&&(n.controlsContainer=$(n.vars.controlsContainer).length>0&&$(n.vars.controlsContainer)),""!==n.vars.manualControls&&(n.manualControls=$(n.vars.manualControls).length>0&&$(n.vars.manualControls)),""!==n.vars.customDirectionNav&&(n.customDirectionNav=2===$(n.vars.customDirectionNav).length&&$(n.vars.customDirectionNav)),n.vars.randomize&&(n.slides.sort(function(){return Math.round(Math.random())-.5}),n.container.empty().append(n.slides)),n.doMath(),n.setup("init"),n.vars.controlNav&&f.controlNav.setup(),n.vars.directionNav&&f.directionNav.setup(),n.vars.keyboard&&(1===$(n.containerSelector).length||n.vars.multipleKeyboard)&&$(document).bind("keyup",function(e){var t=e.keyCode;if(!n.animating&&(39===t||37===t)){var a=n.vars.rtl?37===t?n.getTarget("next"):39===t&&n.getTarget("prev"):39===t?n.getTarget("next"):37===t&&n.getTarget("prev");n.flexAnimate(a,n.vars.pauseOnAction)}}),n.vars.mousewheel&&n.bind("mousewheel",function(e,t,a,i){e.preventDefault();var r=t<0?n.getTarget("next"):n.getTarget("prev");n.flexAnimate(r,n.vars.pauseOnAction)}),n.vars.pausePlay&&f.pausePlay.setup(),n.vars.slideshow&&n.vars.pauseInvisible&&f.pauseInvisible.init(),n.vars.slideshow&&(n.vars.pauseOnHover&&n.hover(function(){n.manualPlay||n.manualPause||n.pause()},function(){n.manualPause||n.manualPlay||n.stopped||n.play()}),n.vars.pauseInvisible&&f.pauseInvisible.isHidden()||(n.vars.initDelay>0?n.startTimeout=setTimeout(n.play,n.vars.initDelay):n.play())),m&&f.asNav.setup(),s&&n.vars.touch&&f.touch(),(!p||p&&n.vars.smoothHeight)&&$(window).bind("resize orientationchange focus",f.resize),n.find("img").attr("draggable","false"),setTimeout(function(){n.vars.start(n)},200)},asNav:{setup:function(){n.asNav=!0,n.animatingTo=Math.floor(n.currentSlide/n.move),n.currentItem=n.currentSlide,n.slides.removeClass(i+"active-slide").eq(n.currentItem).addClass(i+"active-slide"),r?(t._slider=n,n.slides.each(function(){var e=this;e._gesture=new MSGesture,e._gesture.target=e,e.addEventListener("MSPointerDown",function(e){e.preventDefault(),e.currentTarget._gesture&&e.currentTarget._gesture.addPointer(e.pointerId)},!1),e.addEventListener("MSGestureTap",function(e){e.preventDefault();var t=$(this),a=t.index();$(n.vars.asNavFor).data("flexslider").animating||t.hasClass("active")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})})):n.slides.on(o,function(e){e.preventDefault();var t=$(this),a=t.index(),r;r=n.vars.rtl?-1*(t.offset().right-$(n).scrollLeft()):t.offset().left-$(n).scrollLeft(),r<=0&&t.hasClass(i+"active-slide")?n.flexAnimate(n.getTarget("prev"),!0):$(n.vars.asNavFor).data("flexslider").animating||t.hasClass(i+"active-slide")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){n.manualControls?f.controlNav.setupManual():f.controlNav.setupPaging()},setupPaging:function(){var e="thumbnails"===n.vars.controlNav?"control-thumbs":"control-paging",t=1,a,r;if(n.controlNavScaffold=$('<ol class="'+i+"control-nav "+i+e+'"></ol>'),n.pagingCount>1)for(var s=0;s<n.pagingCount;s++){r=n.slides.eq(s),void 0===r.attr("data-thumb-alt")&&r.attr("data-thumb-alt","");var c=""!==r.attr("data-thumb-alt")?c=' alt="'+r.attr("data-thumb-alt")+'"':"";if(a="thumbnails"===n.vars.controlNav?'<img src="'+r.attr("data-thumb")+'"'+c+"/>":'<a href="#">'+t+"</a>","thumbnails"===n.vars.controlNav&&!0===n.vars.thumbCaptions){var d=r.attr("data-thumbcaption");""!==d&&void 0!==d&&(a+='<span class="'+i+'caption">'+d+"</span>")}n.controlNavScaffold.append("<li>"+a+"</li>"),t++}n.controlsContainer?$(n.controlsContainer).append(n.controlNavScaffold):n.append(n.controlNavScaffold),f.controlNav.set(),f.controlNav.active(),n.controlNavScaffold.delegate("a, img",o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(n.direction=a>n.currentSlide?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},setupManual:function(){n.controlNav=n.manualControls,f.controlNav.active(),n.controlNav.bind(o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(a>n.currentSlide?n.direction="next":n.direction="prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},set:function(){var e="thumbnails"===n.vars.controlNav?"img":"a";n.controlNav=$("."+i+"control-nav li "+e,n.controlsContainer?n.controlsContainer:n)},active:function(){n.controlNav.removeClass(i+"active").eq(n.animatingTo).addClass(i+"active")},update:function(e,t){n.pagingCount>1&&"add"===e?n.controlNavScaffold.append($('<li><a href="#">'+n.count+"</a></li>")):1===n.pagingCount?n.controlNavScaffold.find("li").remove():n.controlNav.eq(t).closest("li").remove(),f.controlNav.set(),n.pagingCount>1&&n.pagingCount!==n.controlNav.length?n.update(t,e):f.controlNav.active()}},directionNav:{setup:function(){var e=$('<ul class="'+i+'direction-nav"><li class="'+i+'nav-prev"><a class="'+i+'prev" href="#">'+n.vars.prevText+'</a></li><li class="'+i+'nav-next"><a class="'+i+'next" href="#">'+n.vars.nextText+"</a></li></ul>");n.customDirectionNav?n.directionNav=n.customDirectionNav:n.controlsContainer?($(n.controlsContainer).append(e),n.directionNav=$("."+i+"direction-nav li a",n.controlsContainer)):(n.append(e),n.directionNav=$("."+i+"direction-nav li a",n)),f.directionNav.update(),n.directionNav.bind(o,function(e){e.preventDefault();var t;""!==l&&l!==e.type||(t=$(this).hasClass(i+"next")?n.getTarget("next"):n.getTarget("prev"),n.flexAnimate(t,n.vars.pauseOnAction)),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(){var e=i+"disabled";1===n.pagingCount?n.directionNav.addClass(e).attr("tabindex","-1"):n.vars.animationLoop?n.directionNav.removeClass(e).removeAttr("tabindex"):0===n.animatingTo?n.directionNav.removeClass(e).filter("."+i+"prev").addClass(e).attr("tabindex","-1"):n.animatingTo===n.last?n.directionNav.removeClass(e).filter("."+i+"next").addClass(e).attr("tabindex","-1"):n.directionNav.removeClass(e).removeAttr("tabindex")}},pausePlay:{setup:function(){var e=$('<div class="'+i+'pauseplay"><a href="#"></a></div>');n.controlsContainer?(n.controlsContainer.append(e),n.pausePlay=$("."+i+"pauseplay a",n.controlsContainer)):(n.append(e),n.pausePlay=$("."+i+"pauseplay a",n)),f.pausePlay.update(n.vars.slideshow?i+"pause":i+"play"),n.pausePlay.bind(o,function(e){e.preventDefault(),""!==l&&l!==e.type||($(this).hasClass(i+"pause")?(n.manualPause=!0,n.manualPlay=!1,n.pause()):(n.manualPause=!1,n.manualPlay=!0,n.play())),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(e){"play"===e?n.pausePlay.removeClass(i+"pause").addClass(i+"play").html(n.vars.playText):n.pausePlay.removeClass(i+"play").addClass(i+"pause").html(n.vars.pauseText)}},touch:function(){function e(e){e.stopPropagation(),n.animating?e.preventDefault():(n.pause(),t._gesture.addPointer(e.pointerId),T=0,c=d?n.h:n.w,f=Number(new Date),l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c)}function a(e){e.stopPropagation();var a=e.target._slider;if(a){var n=-e.translationX,i=-e.translationY;if(T+=d?i:n,m=(a.vars.rtl?-1:1)*T,x=d?Math.abs(T)<Math.abs(-n):Math.abs(T)<Math.abs(-i),e.detail===e.MSGESTURE_FLAG_INERTIA)return void setImmediate(function(){t._gesture.stop()});(!x||Number(new Date)-f>500)&&(e.preventDefault(),!p&&a.transitions&&(a.vars.animationLoop||(m=T/(0===a.currentSlide&&T<0||a.currentSlide===a.last&&T>0?Math.abs(T)/c+2:1)),a.setProps(l+m,"setTouch")))}}function i(e){e.stopPropagation();var t=e.target._slider;if(t){if(t.animatingTo===t.currentSlide&&!x&&null!==m){var a=u?-m:m,n=a>0?t.getTarget("next"):t.getTarget("prev");t.canAdvance(n)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?t.flexAnimate(n,t.vars.pauseOnAction):p||t.flexAnimate(t.currentSlide,t.vars.pauseOnAction,!0)}s=null,o=null,m=null,l=null,T=0}}var s,o,l,c,m,f,g,h,S,x=!1,y=0,b=0,T=0;r?(t.style.msTouchAction="none",t._gesture=new MSGesture,t._gesture.target=t,t.addEventListener("MSPointerDown",e,!1),t._slider=n,t.addEventListener("MSGestureChange",a,!1),t.addEventListener("MSGestureEnd",i,!1)):(g=function(e){n.animating?e.preventDefault():(window.navigator.msPointerEnabled||1===e.touches.length)&&(n.pause(),c=d?n.h:n.w,f=Number(new Date),y=e.touches[0].pageX,b=e.touches[0].pageY,l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c,s=d?b:y,o=d?y:b,t.addEventListener("touchmove",h,!1),t.addEventListener("touchend",S,!1))},h=function(e){y=e.touches[0].pageX,b=e.touches[0].pageY,m=d?s-b:(n.vars.rtl?-1:1)*(s-y),x=d?Math.abs(m)<Math.abs(y-o):Math.abs(m)<Math.abs(b-o);var t=500;(!x||Number(new Date)-f>500)&&(e.preventDefault(),!p&&n.transitions&&(n.vars.animationLoop||(m/=0===n.currentSlide&&m<0||n.currentSlide===n.last&&m>0?Math.abs(m)/c+2:1),n.setProps(l+m,"setTouch")))},S=function(e){if(t.removeEventListener("touchmove",h,!1),n.animatingTo===n.currentSlide&&!x&&null!==m){var a=u?-m:m,i=a>0?n.getTarget("next"):n.getTarget("prev");n.canAdvance(i)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?n.flexAnimate(i,n.vars.pauseOnAction):p||n.flexAnimate(n.currentSlide,n.vars.pauseOnAction,!0)}t.removeEventListener("touchend",S,!1),s=null,o=null,m=null,l=null},t.addEventListener("touchstart",g,!1))},resize:function(){!n.animating&&n.is(":visible")&&(v||n.doMath(),p?f.smoothHeight():v?(n.slides.width(n.computedW),n.update(n.pagingCount),n.setProps()):d?(n.viewport.height(n.h),n.setProps(n.h,"setTotal")):(n.vars.smoothHeight&&f.smoothHeight(),n.newSlides.width(n.computedW),n.setProps(n.computedW,"setTotal")))},smoothHeight:function(e){if(!d||p){var t=p?n:n.viewport;e?t.animate({height:n.slides.eq(n.animatingTo).innerHeight()},e):t.innerHeight(n.slides.eq(n.animatingTo).innerHeight())}},sync:function(e){var t=$(n.vars.sync).data("flexslider"),a=n.animatingTo;switch(e){case"animate":t.flexAnimate(a,n.vars.pauseOnAction,!1,!0);break;case"play":t.playing||t.asNav||t.play();break;case"pause":t.pause();break}},uniqueID:function(e){return e.filter("[id]").add(e.find("[id]")).each(function(){var e=$(this);e.attr("id",e.attr("id")+"_clone")}),e},pauseInvisible:{visProp:null,init:function(){var e=f.pauseInvisible.getHiddenProp();if(e){var t=e.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(t,function(){f.pauseInvisible.isHidden()?n.startTimeout?clearTimeout(n.startTimeout):n.pause():n.started?n.play():n.vars.initDelay>0?setTimeout(n.play,n.vars.initDelay):n.play()})}},isHidden:function(){var e=f.pauseInvisible.getHiddenProp();return!!e&&document[e]},getHiddenProp:function(){var e=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var t=0;t<e.length;t++)if(e[t]+"Hidden"in document)return e[t]+"Hidden";return null}},setToClearWatchedEvent:function(){clearTimeout(c),c=setTimeout(function(){l=""},3e3)}},n.flexAnimate=function(e,t,a,r,o){if(n.vars.animationLoop||e===n.currentSlide||(n.direction=e>n.currentSlide?"next":"prev"),m&&1===n.pagingCount&&(n.direction=n.currentItem<e?"next":"prev"),!n.animating&&(n.canAdvance(e,o)||a)&&n.is(":visible")){if(m&&r){var l=$(n.vars.asNavFor).data("flexslider");if(n.atEnd=0===e||e===n.count-1,l.flexAnimate(e,!0,!1,!0,o),n.direction=n.currentItem<e?"next":"prev",l.direction=n.direction,Math.ceil((e+1)/n.visible)-1===n.currentSlide||0===e)return n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),!1;n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),e=Math.floor(e/n.visible)}if(n.animating=!0,n.animatingTo=e,t&&n.pause(),n.vars.before(n),n.syncExists&&!o&&f.sync("animate"),n.vars.controlNav&&f.controlNav.active(),v||n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),n.atEnd=0===e||e===n.last,n.vars.directionNav&&f.directionNav.update(),e===n.last&&(n.vars.end(n),n.vars.animationLoop||n.pause()),p)s?(n.slides.eq(n.currentSlide).css({opacity:0,zIndex:1}),n.slides.eq(e).css({opacity:1,zIndex:2}),n.wrapup(c)):(n.slides.eq(n.currentSlide).css({zIndex:1}).animate({opacity:0},n.vars.animationSpeed,n.vars.easing),n.slides.eq(e).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing,n.wrapup));else{var c=d?n.slides.filter(":first").height():n.computedW,g,h,S;v?(g=n.vars.itemMargin,S=(n.itemW+g)*n.move*n.animatingTo,h=S>n.limit&&1!==n.visible?n.limit:S):h=0===n.currentSlide&&e===n.count-1&&n.vars.animationLoop&&"next"!==n.direction?u?(n.count+n.cloneOffset)*c:0:n.currentSlide===n.last&&0===e&&n.vars.animationLoop&&"prev"!==n.direction?u?0:(n.count+1)*c:u?(n.count-1-e+n.cloneOffset)*c:(e+n.cloneOffset)*c,n.setProps(h,"",n.vars.animationSpeed),n.transitions?(n.vars.animationLoop&&n.atEnd||(n.animating=!1,n.currentSlide=n.animatingTo),n.container.unbind("webkitTransitionEnd transitionend"),n.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(n.ensureAnimationEnd),n.wrapup(c)}),clearTimeout(n.ensureAnimationEnd),n.ensureAnimationEnd=setTimeout(function(){n.wrapup(c)},n.vars.animationSpeed+100)):n.container.animate(n.args,n.vars.animationSpeed,n.vars.easing,function(){n.wrapup(c)})}n.vars.smoothHeight&&f.smoothHeight(n.vars.animationSpeed)}},n.wrapup=function(e){p||v||(0===n.currentSlide&&n.animatingTo===n.last&&n.vars.animationLoop?n.setProps(e,"jumpEnd"):n.currentSlide===n.last&&0===n.animatingTo&&n.vars.animationLoop&&n.setProps(e,"jumpStart")),n.animating=!1,n.currentSlide=n.animatingTo,n.vars.after(n)},n.animateSlides=function(){!n.animating&&e&&n.flexAnimate(n.getTarget("next"))},n.pause=function(){clearInterval(n.animatedSlides),n.animatedSlides=null,n.playing=!1,n.vars.pausePlay&&f.pausePlay.update("play"),n.syncExists&&f.sync("pause")},n.play=function(){n.playing&&clearInterval(n.animatedSlides),n.animatedSlides=n.animatedSlides||setInterval(n.animateSlides,n.vars.slideshowSpeed),n.started=n.playing=!0,n.vars.pausePlay&&f.pausePlay.update("pause"),n.syncExists&&f.sync("play")},n.stop=function(){n.pause(),n.stopped=!0},n.canAdvance=function(e,t){var a=m?n.pagingCount-1:n.last;return!!t||(!(!m||n.currentItem!==n.count-1||0!==e||"prev"!==n.direction)||(!m||0!==n.currentItem||e!==n.pagingCount-1||"next"===n.direction)&&(!(e===n.currentSlide&&!m)&&(!!n.vars.animationLoop||(!n.atEnd||0!==n.currentSlide||e!==a||"next"===n.direction)&&(!n.atEnd||n.currentSlide!==a||0!==e||"next"!==n.direction))))},n.getTarget=function(e){return n.direction=e,"next"===e?n.currentSlide===n.last?0:n.currentSlide+1:0===n.currentSlide?n.last:n.currentSlide-1},n.setProps=function(e,t,a){var i=function(){var a=e||(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo;return function(){if(v)return"setTouch"===t?e:u&&n.animatingTo===n.last?0:u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:n.animatingTo===n.last?n.limit:a;switch(t){case"setTotal":return u?(n.count-1-n.currentSlide+n.cloneOffset)*e:(n.currentSlide+n.cloneOffset)*e;case"setTouch":return e;case"jumpEnd":return u?e:n.count*e;case"jumpStart":return u?n.count*e:e;default:return e}}()*(n.vars.rtl?1:-1)+"px"}();n.transitions&&(i=d?"translate3d(0,"+i+",0)":"translate3d("+(n.vars.rtl?-1:1)*parseInt(i)+"px,0,0)",a=void 0!==a?a/1e3+"s":"0s",n.container.css("-"+n.pfx+"-transition-duration",a),n.container.css("transition-duration",a)),n.args[n.prop]=i,(n.transitions||void 0===a)&&n.container.css(n.args),n.container.css("transform",i)},n.setup=function(e){if(p)n.vars.rtl?n.slides.css({width:"100%",float:"right",marginLeft:"-100%",position:"relative"}):n.slides.css({width:"100%",float:"left",marginRight:"-100%",position:"relative"}),"init"===e&&(s?n.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+n.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(n.currentSlide).css({opacity:1,zIndex:2}):0==n.vars.fadeFirstSlide?n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).css({opacity:1}):n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing)),n.vars.smoothHeight&&f.smoothHeight();else{var t,a;"init"===e&&(n.viewport=$('<div class="'+i+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(n).append(n.container),n.cloneCount=0,n.cloneOffset=0,u&&(a=$.makeArray(n.slides).reverse(),n.slides=$(a),n.container.empty().append(n.slides))),n.vars.animationLoop&&!v&&(n.cloneCount=2,n.cloneOffset=1,"init"!==e&&n.container.find(".clone").remove(),n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden","true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden","true"))),n.newSlides=$(n.vars.selector,n),t=u?n.count-1-n.currentSlide+n.cloneOffset:n.currentSlide+n.cloneOffset,d&&!v?(n.container.height(200*(n.count+n.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){n.newSlides.css({display:"block"}),n.doMath(),n.viewport.height(n.h),n.setProps(t*n.h,"init")},"init"===e?100:0)):(n.container.width(200*(n.count+n.cloneCount)+"%"),n.setProps(t*n.computedW,"init"),setTimeout(function(){n.doMath(),n.vars.rtl,n.newSlides.css({width:n.computedW,marginRight:n.computedM,float:"left",display:"block"}),n.vars.smoothHeight&&f.smoothHeight()},"init"===e?100:0))}v||n.slides.removeClass(i+"active-slide").eq(n.currentSlide).addClass(i+"active-slide"),n.vars.init(n)},n.doMath=function(){var e=n.slides.first(),t=n.vars.itemMargin,a=n.vars.minItems,i=n.vars.maxItems;n.w=void 0===n.viewport?n.width():n.viewport.width(),n.h=e.height(),n.boxPadding=e.outerWidth()-e.width(),v?(n.itemT=n.vars.itemWidth+t,n.itemM=t,n.minW=a?a*n.itemT:n.w,n.maxW=i?i*n.itemT-t:n.w,n.itemW=n.minW>n.w?(n.w-t*(a-1))/a:n.maxW<n.w?(n.w-t*(i-1))/i:n.vars.itemWidth>n.w?n.w:n.vars.itemWidth,n.visible=Math.floor(n.w/n.itemW),n.move=n.vars.move>0&&n.vars.move<n.visible?n.vars.move:n.visible,n.pagingCount=Math.ceil((n.count-n.visible)/n.move+1),n.last=n.pagingCount-1,n.limit=1===n.pagingCount?0:n.vars.itemWidth>n.w?n.itemW*(n.count-1)+t*(n.count-1):(n.itemW+t)*n.count-n.w-t):(n.itemW=n.w,n.itemM=t,n.pagingCount=n.count,n.last=n.count-1),n.computedW=n.itemW-n.boxPadding,n.computedM=n.itemM},n.update=function(e,t){n.doMath(),v||(e<n.currentSlide?n.currentSlide+=1:e<=n.currentSlide&&0!==e&&(n.currentSlide-=1),n.animatingTo=n.currentSlide),n.vars.controlNav&&!n.manualControls&&("add"===t&&!v||n.pagingCount>n.controlNav.length?f.controlNav.update("add"):("remove"===t&&!v||n.pagingCount<n.controlNav.length)&&(v&&n.currentSlide>n.last&&(n.currentSlide-=1,n.animatingTo-=1),f.controlNav.update("remove",n.last))),n.vars.directionNav&&f.directionNav.update()},n.addSlide=function(e,t){var a=$(e);n.count+=1,n.last=n.count-1,d&&u?void 0!==t?n.slides.eq(n.count-t).after(a):n.container.prepend(a):void 0!==t?n.slides.eq(t).before(a):n.container.append(a),n.update(t,"add"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.added(n)},n.removeSlide=function(e){var t=isNaN(e)?n.slides.index($(e)):e;n.count-=1,n.last=n.count-1,isNaN(e)?$(e,n.slides).remove():d&&u?n.slides.eq(n.last).remove():n.slides.eq(e).remove(),n.doMath(),n.update(t,"remove"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.removed(n)},f.init()},$(window).blur(function(t){e=!1}).focus(function(t){e=!0}),$.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,fadeFirstSlide:!0,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",customDirectionNav:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){},rtl:!1},$.fn.flexslider=function(e){if(void 0===e&&(e={}),"object"==typeof e)return this.each(function(){var t=$(this),a=e.selector?e.selector:".slides > li",n=t.find(a);1===n.length&&!1===e.allowOneSlide||0===n.length?(n.fadeIn(400),e.start&&e.start(t)):void 0===t.data("flexslider")&&new $.flexslider(this,e)});var t=$(this).data("flexslider");switch(e){case"play":t.play();break;case"pause":t.pause();break;case"stop":t.stop();break;case"next":t.flexAnimate(t.getTarget("next"),!0);break;case"prev":case"previous":t.flexAnimate(t.getTarget("prev"),!0);break;default:"number"==typeof e&&t.flexAnimate(e,!0)}}}(jQuery);

  

/*
 * jQuery Shorten plugin 1.1.0
 *
 * Copyright (c) 2014 Viral Patel
 * http://viralpatel.net
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
*/

(function($) {
    $.fn.shorten = function(settings) {
        "use strict";

        var config = {
            showChars: 100,
            minHideChars: 10,
            ellipsesText: "...",
            moreText: "more",
            lessText: "less",
            theHref: "javascript://nop/",
          	activateClass: "morelink",
          	allcontentClass: "allcontent",
          	contentID: "",
          	allContentHeader: "",
            onLess: function() {},
            onMore: function() {},
            errMsg: null,
            force: false
        };

        if (settings) {
            $.extend(config, settings);
        }

        if ($(this).data('jquery.shorten') && !config.force) {
            return false;
        }
        $(this).data('jquery.shorten', true);

        $(document).off("click", '.morelink');

        $(document).on({
            click: function() {

                var $this = $(this);
                if ($this.hasClass('less')) {
                    $this.removeClass('less');
                    $this.html(config.moreText);
                    $this.parent().prev().animate({'height':'0'+'%'}, function () { $this.parent().prev().prev().show(); }).hide('fast', function() {
                        config.onLess();
                      });

                } else {
                    $this.addClass('less');
                    $this.html(config.lessText);
                    $this.parent().prev().animate({'height':'100'+'%'}, function () { $this.parent().prev().prev().hide(); }).show('fast', function() {
                        config.onMore();
                      });
                }
                return false;
            }
        }, '.morelink');

        return this.each(function() {
            var $this = $(this);

            var content = $this.html();
            var contentlen = $this.text().length;
            if (contentlen > config.showChars + config.minHideChars) {
                var c = content.substr(0, config.showChars);
                if (c.indexOf('<') >= 0) // If there's HTML don't want to cut it
                {
                    var inTag = false; // I'm in a tag?
                    var bag = ''; // Put the characters to be shown here
                    var countChars = 0; // Current bag size
                    var openTags = []; // Stack for opened tags, so I can close them later
                    var tagName = null;

                    for (var i = 0, r = 0; r <= config.showChars; i++) {
                        if (content[i] == '<' && !inTag) {
                            inTag = true;

                            // This could be "tag" or "/tag"
                            tagName = content.substring(i + 1, content.indexOf('>', i));

                            // If its a closing tag
                            if (tagName[0] == '/') {


                                if (tagName != '/' + openTags[0]) {
                                    config.errMsg = 'ERROR en HTML: the top of the stack should be the tag that closes';
                                } else {
                                    openTags.shift(); // Pops the last tag from the open tag stack (the tag is closed in the retult HTML!)
                                }

                            } else {
                                // There are some nasty tags that don't have a close tag like <br/>
                                if (tagName.toLowerCase() != 'br') {
                                    openTags.unshift(tagName); // Add to start the name of the tag that opens
                                }
                            }
                        }
                        if (inTag && content[i] == '>') {
                            inTag = false;
                        }

                        if (inTag) { bag += content.charAt(i); } // Add tag name chars to the result
                        else {
                            r++;
                            if (countChars <= config.showChars) {
                                bag += content.charAt(i); // Fix to ie 7 not allowing you to reference string characters using the []
                                countChars++;
                            } else // Now I have the characters needed
                            {
                                if (openTags.length > 0) // I have unclosed tags
                                {
                                    //console.log('They were open tags');
                                    //console.log(openTags);
                                    for (j = 0; j < openTags.length; j++) {
                                        //console.log('Cierro tag ' + openTags[j]);
                                        bag += '</' + openTags[j] + '>'; // Close all tags that were opened

                                        // You could shift the tag from the stack to check if you end with an empty stack, that means you have closed all open tags
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    c = $('<div/>').html(bag + '<span class="ellip">' + config.ellipsesText + '</span>').html();
                }else{
                    c+=config.ellipsesText;
                }
				
                var html = '<div class="shortcontent">' + c +
                    '</div><div id="' + config.contentID + '" class="' + config.allcontentClass + '">' + config.allContentHeader + content +
                    '</div><span><a href="' + config.theHref + '" class="' + config.activateClass + '">' + config.moreText + '</a></span>';

                $this.html(html);
                $this.find(".allcontent").hide(); // Hide all text
                $('.shortcontent p:last', $this).css('margin-bottom', 0); //Remove bottom margin on last paragraph as it's likely shortened
            }
        });

    };

})(jQuery);




/*! jQuery Validation Plugin - v1.15.0 - 2/24/2016
 * http://jqueryvalidation.org/
 * Copyright (c) 2016 Jörn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.settings.submitHandler&&(c.submitButton=b.target),a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.settings.submitHandler?(c.submitButton&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),e=c.settings.submitHandler.call(c,c.currentForm,b),c.submitButton&&d.remove(),void 0!==e?e:!1):!0}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){if(this.length){var d,e,f,g,h,i,j=this[0];if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(b,c){i[c]=f[c],delete f[c],"required"===c&&a(j).removeAttr("aria-required")}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g),a(j).attr("aria-required","true")),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}}),a.extend(a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){var c=a(b).val();return null!==c&&!!a.trim(""+c)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||-1!==a.inArray(c.keyCode,d)||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date ( ISO ).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}."),step:a.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){var c=a.data(this.form,"validator"),d="on"+b.type.replace(/^validate/,""),e=c.settings;e[d]&&!a(this).is(e.ignore)&&e[d].call(c,this,b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){d[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable]",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler),a(this.currentForm).find("[required], [data-rule-required], .required").attr("aria-required","true")},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=h&&g.check(e)))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)a[b]&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0]),d in c||!b.objectLength(a(this).rules())?!1:(c[d]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type;return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=b.hasAttribute("contenteditable")?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f=a(b).rules(),g=a.map(f,function(a,b){return b}).length,h=!1,i=this.elementValue(b);if("function"==typeof f.normalizer){if(i=f.normalizer.call(b,i),"string"!=typeof i)throw new TypeError("The normalizer should return a string value.");delete f.normalizer}for(d in f){e={method:d,parameters:f[d]};try{if(c=a.validator.methods[d].call(this,i,b,e.parameters),"dependency-mismatch"===c&&1===g){h=!0;continue}if(h=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(j){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",j),j instanceof TypeError&&(j.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),j}}if(!h)return this.objectLength(f)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement(d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return a.replace(/([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return this.dependTypes[typeof a]?this.dependTypes[typeof a](a,b):!0},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a[c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0!==e.param?e.param:!0:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(d,e){b[d]=a.isFunction(e)&&"normalizer"!==d?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||d>=e},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||c>=a},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e=a(c).attr("type"),f="Step attribute on input type "+e+" is not supported.",g=["text","number","range"],h=new RegExp("\\b"+e+"\\b"),i=e&&!h.test(g.join());if(i)throw new Error(f);return this.optional(c)||b%d===0},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var b,c={};a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)})});





/**
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.2
 */
;(function(f){"use strict";"function"===typeof define&&define.amd?define(["jquery"],f):"undefined"!==typeof module&&module.exports?module.exports=f(require("jquery")):f(jQuery)})(function($){"use strict";function n(a){return!a.nodeName||-1!==$.inArray(a.nodeName.toLowerCase(),["iframe","#document","html","body"])}function h(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}var p=$.scrollTo=function(a,d,b){return $(window).scrollTo(a,d,b)};p.defaults={axis:"xy",duration:0,limit:!0};$.fn.scrollTo=function(a,d,b){"object"=== typeof d&&(b=d,d=0);"function"===typeof b&&(b={onAfter:b});"max"===a&&(a=9E9);b=$.extend({},p.defaults,b);d=d||b.duration;var u=b.queue&&1<b.axis.length;u&&(d/=2);b.offset=h(b.offset);b.over=h(b.over);return this.each(function(){function k(a){var k=$.extend({},b,{queue:!0,duration:d,complete:a&&function(){a.call(q,e,b)}});r.animate(f,k)}if(null!==a){var l=n(this),q=l?this.contentWindow||window:this,r=$(q),e=a,f={},t;switch(typeof e){case "number":case "string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)){e= h(e);break}e=l?$(e):$(e,q);case "object":if(e.length===0)return;if(e.is||e.style)t=(e=$(e)).offset()}var v=$.isFunction(b.offset)&&b.offset(q,e)||b.offset;$.each(b.axis.split(""),function(a,c){var d="x"===c?"Left":"Top",m=d.toLowerCase(),g="scroll"+d,h=r[g](),n=p.max(q,c);t?(f[g]=t[m]+(l?0:h-r.offset()[m]),b.margin&&(f[g]-=parseInt(e.css("margin"+d),10)||0,f[g]-=parseInt(e.css("border"+d+"Width"),10)||0),f[g]+=v[m]||0,b.over[m]&&(f[g]+=e["x"===c?"width":"height"]()*b.over[m])):(d=e[m],f[g]=d.slice&& "%"===d.slice(-1)?parseFloat(d)/100*n:d);b.limit&&/^\d+$/.test(f[g])&&(f[g]=0>=f[g]?0:Math.min(f[g],n));!a&&1<b.axis.length&&(h===f[g]?f={}:u&&(k(b.onAfterFirst),f={}))});k(b.onAfter)}})};p.max=function(a,d){var b="x"===d?"Width":"Height",h="scroll"+b;if(!n(a))return a[h]-$(a)[b.toLowerCase()]();var b="client"+b,k=a.ownerDocument||a.document,l=k.documentElement,k=k.body;return Math.max(l[h],k[h])-Math.min(l[b],k[b])};$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(a){return $(a.elem)[a.prop]()}, set:function(a){var d=this.get(a);if(a.options.interrupt&&a._last&&a._last!==d)return $(a.elem).stop();var b=Math.round(a.now);d!==b&&($(a.elem)[a.prop](b),a._last=this.get(a))}};return p});




// Magnific Popup v1.1.0 by Dmitry Semenov
// http://bit.ly/magnific-popup#build=inline+image+ajax+gallery+retina+imagezoom
(function(a){typeof define=="function"&&define.amd?define(["jquery"],a):typeof exports=="object"?a(require("jquery")):a(window.jQuery||window.Zepto)})(function(a){var b="Close",c="BeforeClose",d="AfterClose",e="BeforeAppend",f="MarkupParse",g="Open",h="Change",i="mfp",j="."+i,k="mfp-ready",l="mfp-removing",m="mfp-prevent-close",n,o=function(){},p=!!window.jQuery,q,r=a(window),s,t,u,v,w=function(a,b){n.ev.on(i+a+j,b)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(b,c){n.ev.triggerHandler(i+b,c),n.st.callbacks&&(b=b.charAt(0).toLowerCase()+b.slice(1),n.st.callbacks[b]&&n.st.callbacks[b].apply(n,a.isArray(c)?c:[c]))},z=function(b){if(b!==v||!n.currTemplate.closeBtn)n.currTemplate.closeBtn=a(n.st.closeMarkup.replace("%title%",n.st.tClose)),v=b;return n.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(n=new o,n.init(),a.magnificPopup.instance=n)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(a.transition!==undefined)return!0;while(b.length)if(b.pop()+"Transition"in a)return!0;return!1};o.prototype={constructor:o,init:function(){var b=navigator.appVersion;n.isLowIE=n.isIE8=document.all&&!document.addEventListener,n.isAndroid=/android/gi.test(b),n.isIOS=/iphone|ipad|ipod/gi.test(b),n.supportsTransition=B(),n.probablyMobile=n.isAndroid||n.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),s=a(document),n.popupsCache={}},open:function(b){var c;if(b.isObj===!1){n.items=b.items.toArray(),n.index=0;var d=b.items,e;for(c=0;c<d.length;c++){e=d[c],e.parsed&&(e=e.el[0]);if(e===b.el[0]){n.index=c;break}}}else n.items=a.isArray(b.items)?b.items:[b.items],n.index=b.index||0;if(n.isOpen){n.updateItemHTML();return}n.types=[],u="",b.mainEl&&b.mainEl.length?n.ev=b.mainEl.eq(0):n.ev=s,b.key?(n.popupsCache[b.key]||(n.popupsCache[b.key]={}),n.currTemplate=n.popupsCache[b.key]):n.currTemplate={},n.st=a.extend(!0,{},a.magnificPopup.defaults,b),n.fixedContentPos=n.st.fixedContentPos==="auto"?!n.probablyMobile:n.st.fixedContentPos,n.st.modal&&(n.st.closeOnContentClick=!1,n.st.closeOnBgClick=!1,n.st.showCloseBtn=!1,n.st.enableEscapeKey=!1),n.bgOverlay||(n.bgOverlay=x("bg").on("click"+j,function(){n.close()}),n.wrap=x("wrap").attr("tabindex",-1).on("click"+j,function(a){n._checkIfClose(a.target)&&n.close()}),n.container=x("container",n.wrap)),n.contentContainer=x("content"),n.st.preloader&&(n.preloader=x("preloader",n.container,n.st.tLoading));var h=a.magnificPopup.modules;for(c=0;c<h.length;c++){var i=h[c];i=i.charAt(0).toUpperCase()+i.slice(1),n["init"+i].call(n)}y("BeforeOpen"),n.st.showCloseBtn&&(n.st.closeBtnInside?(w(f,function(a,b,c,d){c.close_replaceWith=z(d.type)}),u+=" mfp-close-btn-in"):n.wrap.append(z())),n.st.alignTop&&(u+=" mfp-align-top"),n.fixedContentPos?n.wrap.css({overflow:n.st.overflowY,overflowX:"hidden",overflowY:n.st.overflowY}):n.wrap.css({top:r.scrollTop(),position:"absolute"}),(n.st.fixedBgPos===!1||n.st.fixedBgPos==="auto"&&!n.fixedContentPos)&&n.bgOverlay.css({height:s.height(),position:"absolute"}),n.st.enableEscapeKey&&s.on("keyup"+j,function(a){a.keyCode===27&&n.close()}),r.on("resize"+j,function(){n.updateSize()}),n.st.closeOnContentClick||(u+=" mfp-auto-cursor"),u&&n.wrap.addClass(u);var l=n.wH=r.height(),m={};if(n.fixedContentPos&&n._hasScrollBar(l)){var o=n._getScrollbarSize();o&&(m.marginRight=o)}n.fixedContentPos&&(n.isIE7?a("body, html").css("overflow","hidden"):m.overflow="hidden");var p=n.st.mainClass;return n.isIE7&&(p+=" mfp-ie7"),p&&n._addClassToMFP(p),n.updateItemHTML(),y("BuildControls"),a("html").css(m),n.bgOverlay.add(n.wrap).prependTo(n.st.prependTo||a(document.body)),n._lastFocusedEl=document.activeElement,setTimeout(function(){n.content?(n._addClassToMFP(k),n._setFocus()):n.bgOverlay.addClass(k),s.on("focusin"+j,n._onFocusIn)},16),n.isOpen=!0,n.updateSize(l),y(g),b},close:function(){if(!n.isOpen)return;y(c),n.isOpen=!1,n.st.removalDelay&&!n.isLowIE&&n.supportsTransition?(n._addClassToMFP(l),setTimeout(function(){n._close()},n.st.removalDelay)):n._close()},_close:function(){y(b);var c=l+" "+k+" ";n.bgOverlay.detach(),n.wrap.detach(),n.container.empty(),n.st.mainClass&&(c+=n.st.mainClass+" "),n._removeClassFromMFP(c);if(n.fixedContentPos){var e={marginRight:""};n.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}s.off("keyup"+j+" focusin"+j),n.ev.off(j),n.wrap.attr("class","mfp-wrap").removeAttr("style"),n.bgOverlay.attr("class","mfp-bg"),n.container.attr("class","mfp-container"),n.st.showCloseBtn&&(!n.st.closeBtnInside||n.currTemplate[n.currItem.type]===!0)&&n.currTemplate.closeBtn&&n.currTemplate.closeBtn.detach(),n.st.autoFocusLast&&n._lastFocusedEl&&a(n._lastFocusedEl).focus(),n.currItem=null,n.content=null,n.currTemplate=null,n.prevHeight=0,y(d)},updateSize:function(a){if(n.isIOS){var b=document.documentElement.clientWidth/window.innerWidth,c=window.innerHeight*b;n.wrap.css("height",c),n.wH=c}else n.wH=a||r.height();n.fixedContentPos||n.wrap.css("height",n.wH),y("Resize")},updateItemHTML:function(){var b=n.items[n.index];n.contentContainer.detach(),n.content&&n.content.detach(),b.parsed||(b=n.parseEl(n.index));var c=b.type;y("BeforeChange",[n.currItem?n.currItem.type:"",c]),n.currItem=b;if(!n.currTemplate[c]){var d=n.st[c]?n.st[c].markup:!1;y("FirstMarkupParse",d),d?n.currTemplate[c]=a(d):n.currTemplate[c]=!0}t&&t!==b.type&&n.container.removeClass("mfp-"+t+"-holder");var e=n["get"+c.charAt(0).toUpperCase()+c.slice(1)](b,n.currTemplate[c]);n.appendContent(e,c),b.preloaded=!0,y(h,b),t=b.type,n.container.prepend(n.contentContainer),y("AfterChange")},appendContent:function(a,b){n.content=a,a?n.st.showCloseBtn&&n.st.closeBtnInside&&n.currTemplate[b]===!0?n.content.find(".mfp-close").length||n.content.append(z()):n.content=a:n.content="",y(e),n.container.addClass("mfp-"+b+"-holder"),n.contentContainer.append(n.content)},parseEl:function(b){var c=n.items[b],d;c.tagName?c={el:a(c)}:(d=c.type,c={data:c,src:c.src});if(c.el){var e=n.types;for(var f=0;f<e.length;f++)if(c.el.hasClass("mfp-"+e[f])){d=e[f];break}c.src=c.el.attr("data-mfp-src"),c.src||(c.src=c.el.attr("href"))}return c.type=d||n.st.type||"inline",c.index=b,c.parsed=!0,n.items[b]=c,y("ElementParse",c),n.items[b]},addGroup:function(a,b){var c=function(c){c.mfpEl=this,n._openClick(c,a,b)};b||(b={});var d="click.magnificPopup";b.mainEl=a,b.items?(b.isObj=!0,a.off(d).on(d,c)):(b.isObj=!1,b.delegate?a.off(d).on(d,b.delegate,c):(b.items=a,a.off(d).on(d,c)))},_openClick:function(b,c,d){var e=d.midClick!==undefined?d.midClick:a.magnificPopup.defaults.midClick;if(!e&&(b.which===2||b.ctrlKey||b.metaKey||b.altKey||b.shiftKey))return;var f=d.disableOn!==undefined?d.disableOn:a.magnificPopup.defaults.disableOn;if(f)if(a.isFunction(f)){if(!f.call(n))return!0}else if(r.width()<f)return!0;b.type&&(b.preventDefault(),n.isOpen&&b.stopPropagation()),d.el=a(b.mfpEl),d.delegate&&(d.items=c.find(d.delegate)),n.open(d)},updateStatus:function(a,b){if(n.preloader){q!==a&&n.container.removeClass("mfp-s-"+q),!b&&a==="loading"&&(b=n.st.tLoading);var c={status:a,text:b};y("UpdateStatus",c),a=c.status,b=c.text,n.preloader.html(b),n.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),n.container.addClass("mfp-s-"+a),q=a}},_checkIfClose:function(b){if(a(b).hasClass(m))return;var c=n.st.closeOnContentClick,d=n.st.closeOnBgClick;if(c&&d)return!0;if(!n.content||a(b).hasClass("mfp-close")||n.preloader&&b===n.preloader[0])return!0;if(b!==n.content[0]&&!a.contains(n.content[0],b)){if(d&&a.contains(document,b))return!0}else if(c)return!0;return!1},_addClassToMFP:function(a){n.bgOverlay.addClass(a),n.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),n.wrap.removeClass(a)},_hasScrollBar:function(a){return(n.isIE7?s.height():document.body.scrollHeight)>(a||r.height())},_setFocus:function(){(n.st.focus?n.content.find(n.st.focus).eq(0):n.wrap).focus()},_onFocusIn:function(b){if(b.target!==n.wrap[0]&&!a.contains(n.wrap[0],b.target))return n._setFocus(),!1},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(f,[b,c,d]),a.each(c,function(c,d){if(d===undefined||d===!1)return!0;e=c.split("_");if(e.length>1){var f=b.find(j+"-"+e[0]);if(f.length>0){var g=e[1];g==="replaceWith"?f[0]!==d[0]&&f.replaceWith(d):g==="img"?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(j+"-"+c).html(d)})},_getScrollbarSize:function(){if(n.scrollbarSize===undefined){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),n.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return n.scrollbarSize}},a.magnificPopup={instance:null,proto:o.prototype,modules:[],open:function(b,c){return A(),b?b=a.extend(!0,{},b):b={},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(b){A();var c=a(this);if(typeof b=="string")if(b==="open"){var d,e=p?c.data("magnificPopup"):c[0].magnificPopup,f=parseInt(arguments[1],10)||0;e.items?d=e.items[f]:(d=c,e.delegate&&(d=d.find(e.delegate)),d=d.eq(f)),n._openClick({mfpEl:d},c,e)}else n.isOpen&&n[b].apply(n,Array.prototype.slice.call(arguments,1));else b=a.extend(!0,{},b),p?c.data("magnificPopup",b):c[0].magnificPopup=b,n.addGroup(c,b);return c};var C="inline",D,E,F,G=function(){F&&(E.after(F.addClass(D)).detach(),F=null)};a.magnificPopup.registerModule(C,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){n.types.push(C),w(b+"."+C,function(){G()})},getInline:function(b,c){G();if(b.src){var d=n.st.inline,e=a(b.src);if(e.length){var f=e[0].parentNode;f&&f.tagName&&(E||(D=d.hiddenClass,E=x(D),D="mfp-"+D),F=e.after(E).detach().removeClass(D)),n.updateStatus("ready")}else n.updateStatus("error",d.tNotFound),e=a("<div>");return b.inlineElement=e,e}return n.updateStatus("ready"),n._parseMarkup(c,{},b),c}}});var H="ajax",I,J=function(){I&&a(document.body).removeClass(I)},K=function(){J(),n.req&&n.req.abort()};a.magnificPopup.registerModule(H,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){n.types.push(H),I=n.st.ajax.cursor,w(b+"."+H,K),w("BeforeChange."+H,K)},getAjax:function(b){I&&a(document.body).addClass(I),n.updateStatus("loading");var c=a.extend({url:b.src,success:function(c,d,e){var f={data:c,xhr:e};y("ParseAjax",f),n.appendContent(a(f.data),H),b.finished=!0,J(),n._setFocus(),setTimeout(function(){n.wrap.addClass(k)},16),n.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),b.finished=b.loadError=!0,n.updateStatus("error",n.st.ajax.tError.replace("%url%",b.src))}},n.st.ajax.settings);return n.req=a.ajax(c),""}}});var L,M=function(b){if(b.data&&b.data.title!==undefined)return b.data.title;var c=n.st.image.titleSrc;if(c){if(a.isFunction(c))return c.call(n,b);if(b.el)return b.el.attr(c)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=n.st.image,d=".image";n.types.push("image"),w(g+d,function(){n.currItem.type==="image"&&c.cursor&&a(document.body).addClass(c.cursor)}),w(b+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),r.off("resize"+j)}),w("Resize"+d,n.resizeImage),n.isLowIE&&w("AfterChange",n.resizeImage)},resizeImage:function(){var a=n.currItem;if(!a||!a.img)return;if(n.st.image.verticalFit){var b=0;n.isLowIE&&(b=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",n.wH-b)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(n.content&&n.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var b=0,c=a.img[0],d=function(e){L&&clearInterval(L),L=setInterval(function(){if(c.naturalWidth>0){n._onImageHasSize(a);return}b>200&&clearInterval(L),b++,b===3?d(10):b===40?d(50):b===100&&d(500)},e)};d(1)},getImage:function(b,c){var d=0,e=function(){b&&(b.img[0].complete?(b.img.off(".mfploader"),b===n.currItem&&(n._onImageHasSize(b),n.updateStatus("ready")),b.hasSize=!0,b.loaded=!0,y("ImageLoadComplete")):(d++,d<200?setTimeout(e,100):f()))},f=function(){b&&(b.img.off(".mfploader"),b===n.currItem&&(n._onImageHasSize(b),n.updateStatus("error",g.tError.replace("%url%",b.src))),b.hasSize=!0,b.loaded=!0,b.loadError=!0)},g=n.st.image,h=c.find(".mfp-img");if(h.length){var i=document.createElement("img");i.className="mfp-img",b.el&&b.el.find("img").length&&(i.alt=b.el.find("img").attr("alt")),b.img=a(i).on("load.mfploader",e).on("error.mfploader",f),i.src=b.src,h.is("img")&&(b.img=b.img.clone()),i=b.img[0],i.naturalWidth>0?b.hasSize=!0:i.width||(b.hasSize=!1)}return n._parseMarkup(c,{title:M(b),img_replaceWith:b.img},b),n.resizeImage(),b.hasSize?(L&&clearInterval(L),b.loadError?(c.addClass("mfp-loading"),n.updateStatus("error",g.tError.replace("%url%",b.src))):(c.removeClass("mfp-loading"),n.updateStatus("ready")),c):(n.updateStatus("loading"),b.loading=!0,b.hasSize||(b.imgHidden=!0,c.addClass("mfp-loading"),n.findImageSize(b)),c)}}});var N,O=function(){return N===undefined&&(N=document.createElement("p").style.MozTransform!==undefined),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a=n.st.zoom,d=".zoom",e;if(!a.enabled||!n.supportsTransition)return;var f=a.duration,g=function(b){var c=b.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+a.duration/1e3+"s "+a.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,c.css(e),c},h=function(){n.content.css("visibility","visible")},i,j;w("BuildControls"+d,function(){if(n._allowZoom()){clearTimeout(i),n.content.css("visibility","hidden"),e=n._getItemToZoom();if(!e){h();return}j=g(e),j.css(n._getOffset()),n.wrap.append(j),i=setTimeout(function(){j.css(n._getOffset(!0)),i=setTimeout(function(){h(),setTimeout(function(){j.remove(),e=j=null,y("ZoomAnimationEnded")},16)},f)},16)}}),w(c+d,function(){if(n._allowZoom()){clearTimeout(i),n.st.removalDelay=f;if(!e){e=n._getItemToZoom();if(!e)return;j=g(e)}j.css(n._getOffset(!0)),n.wrap.append(j),n.content.css("visibility","hidden"),setTimeout(function(){j.css(n._getOffset())},16)}}),w(b+d,function(){n._allowZoom()&&(h(),j&&j.remove(),e=null)})},_allowZoom:function(){return n.currItem.type==="image"},_getItemToZoom:function(){return n.currItem.hasSize?n.currItem.img:!1},_getOffset:function(b){var c;b?c=n.currItem.img:c=n.st.zoom.opener(n.currItem.el||n.currItem);var d=c.offset(),e=parseInt(c.css("padding-top"),10),f=parseInt(c.css("padding-bottom"),10);d.top-=a(window).scrollTop()-e;var g={width:c.width(),height:(p?c.innerHeight():c[0].offsetHeight)-f-e};return O()?g["-moz-transform"]=g.transform="translate("+d.left+"px,"+d.top+"px)":(g.left=d.left,g.top=d.top),g}}});var P=function(a){var b=n.items.length;return a>b-1?a-b:a<0?b+a:a},Q=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=n.st.gallery,d=".mfp-gallery";n.direction=!0;if(!c||!c.enabled)return!1;u+=" mfp-gallery",w(g+d,function(){c.navigateByImgClick&&n.wrap.on("click"+d,".mfp-img",function(){if(n.items.length>1)return n.next(),!1}),s.on("keydown"+d,function(a){a.keyCode===37?n.prev():a.keyCode===39&&n.next()})}),w("UpdateStatus"+d,function(a,b){b.text&&(b.text=Q(b.text,n.currItem.index,n.items.length))}),w(f+d,function(a,b,d,e){var f=n.items.length;d.counter=f>1?Q(c.tCounter,e.index,f):""}),w("BuildControls"+d,function(){if(n.items.length>1&&c.arrows&&!n.arrowLeft){var b=c.arrowMarkup,d=n.arrowLeft=a(b.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(m),e=n.arrowRight=a(b.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(m);d.click(function(){n.prev()}),e.click(function(){n.next()}),n.container.append(d.add(e))}}),w(h+d,function(){n._preloadTimeout&&clearTimeout(n._preloadTimeout),n._preloadTimeout=setTimeout(function(){n.preloadNearbyImages(),n._preloadTimeout=null},16)}),w(b+d,function(){s.off(d),n.wrap.off("click"+d),n.arrowRight=n.arrowLeft=null})},next:function(){n.direction=!0,n.index=P(n.index+1),n.updateItemHTML()},prev:function(){n.direction=!1,n.index=P(n.index-1),n.updateItemHTML()},goTo:function(a){n.direction=a>=n.index,n.index=a,n.updateItemHTML()},preloadNearbyImages:function(){var a=n.st.gallery.preload,b=Math.min(a[0],n.items.length),c=Math.min(a[1],n.items.length),d;for(d=1;d<=(n.direction?c:b);d++)n._preloadItem(n.index+d);for(d=1;d<=(n.direction?b:c);d++)n._preloadItem(n.index-d)},_preloadItem:function(b){b=P(b);if(n.items[b].preloaded)return;var c=n.items[b];c.parsed||(c=n.parseEl(b)),y("LazyLoad",c),c.type==="image"&&(c.img=a('<img class="mfp-img" />').on("load.mfploader",function(){c.hasSize=!0}).on("error.mfploader",function(){c.hasSize=!0,c.loadError=!0,y("LazyLoadError",c)}).attr("src",c.src)),c.preloaded=!0}}});var R="retina";a.magnificPopup.registerModule(R,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=n.st.retina,b=a.ratio;b=isNaN(b)?b():b,b>1&&(w("ImageHasSize."+R,function(a,c){c.img.css({"max-width":c.img[0].naturalWidth/b,width:"100%"})}),w("ElementParse."+R,function(c,d){d.src=a.replaceSrc(d,b)}))}}}}),A()})


$.fn.extend({
    list2Columns: function(numCols) {
        var listItems = $(this).find('li'); /* get the list data */
        var listHeader = $(this);
        var numListItems = listItems.length;
        var numItemsPerCol = Math.ceil(numListItems / numCols); /* divide by the number of columns requires */
        var currentColNum = 1, currentItemNumber = 1, returnHtml = '', i = 0;

        /* append the columns */
        for (i=1;i<=numCols;i++) {
            $(this).parent().append('<ul class="column list-column-' + i + '"></ul>');
        }

        /* append the items to the columns */
        $.each(listItems, function (i, v)
        {    
            if (currentItemNumber <= numItemsPerCol){
                currentItemNumber ++;
            } else {
                currentItemNumber = 1;
                currentColNum ++;
            }
            $('.list-column-'+currentColNum).append(v);
        });
        $(this).remove();
    }
});




/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;f<g;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&m<10&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),Math.abs(b)>1?c:d}var f=[],g=[],h={precision:100,elapse:!1,defer:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.options.defer===!1&&this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&b<0?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});









/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


            var isoCountries = [
                { id: 'AF', text: 'Afghanistan'},
                { id: 'AX', text: 'Aland Islands'},
                { id: 'AL', text: 'Albania'},
                { id: 'DZ', text: 'Algeria'},
                { id: 'AS', text: 'American Samoa'},
                { id: 'AD', text: 'Andorra'},
                { id: 'AO', text: 'Angola'},
                { id: 'AI', text: 'Anguilla'},
                { id: 'AQ', text: 'Antarctica'},
                { id: 'AG', text: 'Antigua And Barbuda'},
                { id: 'AR', text: 'Argentina'},
                { id: 'AM', text: 'Armenia'},
                { id: 'AW', text: 'Aruba'},
                { id: 'AU', text: 'Australia'},
                { id: 'AT', text: 'Austria'},
                { id: 'AZ', text: 'Azerbaijan'},
                { id: 'BS', text: 'Bahamas'},
                { id: 'BH', text: 'Bahrain'},
                { id: 'BD', text: 'Bangladesh'},
                { id: 'BB', text: 'Barbados'},
                { id: 'BY', text: 'Belarus'},
                { id: 'BE', text: 'Belgium'},
                { id: 'BZ', text: 'Belize'},
                { id: 'BJ', text: 'Benin'},
                { id: 'BM', text: 'Bermuda'},
                { id: 'BT', text: 'Bhutan'},
                { id: 'BO', text: 'Bolivia'},
                { id: 'BA', text: 'Bosnia And Herzegovina'},
                { id: 'BW', text: 'Botswana'},
                { id: 'BV', text: 'Bouvet Island'},
                { id: 'BR', text: 'Brazil'},
                { id: 'IO', text: 'British Indian Ocean Territory'},
                { id: 'BN', text: 'Brunei Darussalam'},
                { id: 'BG', text: 'Bulgaria'},
                { id: 'BF', text: 'Burkina Faso'},
                { id: 'BI', text: 'Burundi'},
                { id: 'KH', text: 'Cambodia'},
                { id: 'CM', text: 'Cameroon'},
                { id: 'CA', text: 'Canada'},
                { id: 'CV', text: 'Cape Verde'},
                { id: 'KY', text: 'Cayman Islands'},
                { id: 'CF', text: 'Central African Republic'},
                { id: 'TD', text: 'Chad'},
                { id: 'CL', text: 'Chile'},
                { id: 'CN', text: 'China'},
                { id: 'CX', text: 'Christmas Island'},
                { id: 'CC', text: 'Cocos (Keeling) Islands'},
                { id: 'CO', text: 'Colombia'},
                { id: 'KM', text: 'Comoros'},
                { id: 'CG', text: 'Congo'},
                { id: 'CD', text: 'Congo}, Democratic Republic'},
                { id: 'CK', text: 'Cook Islands'},
                { id: 'CR', text: 'Costa Rica'},
                { id: 'CI', text: 'Cote D\'Ivoire'},
                { id: 'HR', text: 'Croatia'},
                { id: 'CU', text: 'Cuba'},
                { id: 'CY', text: 'Cyprus'},
                { id: 'CZ', text: 'Czech Republic'},
                { id: 'DK', text: 'Denmark'},
                { id: 'DJ', text: 'Djibouti'},
                { id: 'DM', text: 'Dominica'},
                { id: 'DO', text: 'Dominican Republic'},
                { id: 'EC', text: 'Ecuador'},
                { id: 'EG', text: 'Egypt'},
                { id: 'SV', text: 'El Salvador'},
                { id: 'GQ', text: 'Equatorial Guinea'},
                { id: 'ER', text: 'Eritrea'},
                { id: 'EE', text: 'Estonia'},
                { id: 'ET', text: 'Ethiopia'},
                { id: 'FK', text: 'Falkland Islands (Malvinas)'},
                { id: 'FO', text: 'Faroe Islands'},
                { id: 'FJ', text: 'Fiji'},
                { id: 'FI', text: 'Finland'},
                { id: 'FR', text: 'France'},
                { id: 'GF', text: 'French Guiana'},
                { id: 'PF', text: 'French Polynesia'},
                { id: 'TF', text: 'French Southern Territories'},
                { id: 'GA', text: 'Gabon'},
                { id: 'GM', text: 'Gambia'},
                { id: 'GE', text: 'Georgia'},
                { id: 'DE', text: 'Germany'},
                { id: 'GH', text: 'Ghana'},
                { id: 'GI', text: 'Gibraltar'},
                { id: 'GR', text: 'Greece'},
                { id: 'GL', text: 'Greenland'},
                { id: 'GD', text: 'Grenada'},
                { id: 'GP', text: 'Guadeloupe'},
                { id: 'GU', text: 'Guam'},
                { id: 'GT', text: 'Guatemala'},
                { id: 'GG', text: 'Guernsey'},
                { id: 'GN', text: 'Guinea'},
                { id: 'GW', text: 'Guinea-Bissau'},
                { id: 'GY', text: 'Guyana'},
                { id: 'HT', text: 'Haiti'},
                { id: 'HM', text: 'Heard Island & Mcdonald Islands'},
                { id: 'VA', text: 'Holy See (Vatican City State)'},
                { id: 'HN', text: 'Honduras'},
                { id: 'HK', text: 'Hong Kong'},
                { id: 'HU', text: 'Hungary'},
                { id: 'IS', text: 'Iceland'},
                { id: 'IN', text: 'India'},
                { id: 'ID', text: 'Indonesia'},
                { id: 'IR', text: 'Iran}, Islamic Republic Of'},
                { id: 'IQ', text: 'Iraq'},
                { id: 'IE', text: 'Ireland'},
                { id: 'IM', text: 'Isle Of Man'},
                { id: 'IL', text: 'Israel'},
                { id: 'IT', text: 'Italy'},
                { id: 'JM', text: 'Jamaica'},
                { id: 'JP', text: 'Japan'},
                { id: 'JE', text: 'Jersey'},
                { id: 'JO', text: 'Jordan'},
                { id: 'KZ', text: 'Kazakhstan'},
                { id: 'KE', text: 'Kenya'},
                { id: 'KI', text: 'Kiribati'},
                { id: 'KR', text: 'Korea'},
                { id: 'KW', text: 'Kuwait'},
                { id: 'KG', text: 'Kyrgyzstan'},
                { id: 'LA', text: 'Lao People\'s Democratic Republic'},
                { id: 'LV', text: 'Latvia'},
                { id: 'LB', text: 'Lebanon'},
                { id: 'LS', text: 'Lesotho'},
                { id: 'LR', text: 'Liberia'},
                { id: 'LY', text: 'Libyan Arab Jamahiriya'},
                { id: 'LI', text: 'Liechtenstein'},
                { id: 'LT', text: 'Lithuania'},
                { id: 'LU', text: 'Luxembourg'},
                { id: 'MO', text: 'Macao'},
                { id: 'MK', text: 'Macedonia'},
                { id: 'MG', text: 'Madagascar'},
                { id: 'MW', text: 'Malawi'},
                { id: 'MY', text: 'Malaysia'},
                { id: 'MV', text: 'Maldives'},
                { id: 'ML', text: 'Mali'},
                { id: 'MT', text: 'Malta'},
                { id: 'MH', text: 'Marshall Islands'},
                { id: 'MQ', text: 'Martinique'},
                { id: 'MR', text: 'Mauritania'},
                { id: 'MU', text: 'Mauritius'},
                { id: 'YT', text: 'Mayotte'},
                { id: 'MX', text: 'Mexico'},
                { id: 'FM', text: 'Micronesia}, Federated States Of'},
                { id: 'MD', text: 'Moldova'},
                { id: 'MC', text: 'Monaco'},
                { id: 'MN', text: 'Mongolia'},
                { id: 'ME', text: 'Montenegro'},
                { id: 'MS', text: 'Montserrat'},
                { id: 'MA', text: 'Morocco'},
                { id: 'MZ', text: 'Mozambique'},
                { id: 'MM', text: 'Myanmar'},
                { id: 'NA', text: 'Namibia'},
                { id: 'NR', text: 'Nauru'},
                { id: 'NP', text: 'Nepal'},
                { id: 'NL', text: 'Netherlands'},
                { id: 'AN', text: 'Netherlands Antilles'},
                { id: 'NC', text: 'New Caledonia'},
                { id: 'NZ', text: 'New Zealand'},
                { id: 'NI', text: 'Nicaragua'},
                { id: 'NE', text: 'Niger'},
                { id: 'NG', text: 'Nigeria'},
                { id: 'NU', text: 'Niue'},
                { id: 'NF', text: 'Norfolk Island'},
                { id: 'MP', text: 'Northern Mariana Islands'},
                { id: 'NO', text: 'Norway'},
                { id: 'OM', text: 'Oman'},
                { id: 'PK', text: 'Pakistan'},
                { id: 'PW', text: 'Palau'},
                { id: 'PS', text: 'Palestinian Territory}, Occupied'},
                { id: 'PA', text: 'Panama'},
                { id: 'PG', text: 'Papua New Guinea'},
                { id: 'PY', text: 'Paraguay'},
                { id: 'PE', text: 'Peru'},
                { id: 'PH', text: 'Philippines'},
                { id: 'PN', text: 'Pitcairn'},
                { id: 'PL', text: 'Poland'},
                { id: 'PT', text: 'Portugal'},
                { id: 'PR', text: 'Puerto Rico'},
                { id: 'QA', text: 'Qatar'},
                { id: 'RE', text: 'Reunion'},
                { id: 'RO', text: 'Romania'},
                { id: 'RU', text: 'Russian Federation'},
                { id: 'RW', text: 'Rwanda'},
                { id: 'BL', text: 'Saint Barthelemy'},
                { id: 'SH', text: 'Saint Helena'},
                { id: 'KN', text: 'Saint Kitts And Nevis'},
                { id: 'LC', text: 'Saint Lucia'},
                { id: 'MF', text: 'Saint Martin'},
                { id: 'PM', text: 'Saint Pierre And Miquelon'},
                { id: 'VC', text: 'Saint Vincent And Grenadines'},
                { id: 'WS', text: 'Samoa'},
                { id: 'SM', text: 'San Marino'},
                { id: 'ST', text: 'Sao Tome And Principe'},
                { id: 'SA', text: 'Saudi Arabia'},
                { id: 'SN', text: 'Senegal'},
                { id: 'RS', text: 'Serbia'},
                { id: 'SC', text: 'Seychelles'},
                { id: 'SL', text: 'Sierra Leone'},
                { id: 'SG', text: 'Singapore'},
                { id: 'SK', text: 'Slovakia'},
                { id: 'SI', text: 'Slovenia'},
                { id: 'SB', text: 'Solomon Islands'},
                { id: 'SO', text: 'Somalia'},
                { id: 'ZA', text: 'South Africa'},
                { id: 'GS', text: 'South Georgia And Sandwich Isl.'},
                { id: 'ES', text: 'Spain'},
                { id: 'LK', text: 'Sri Lanka'},
                { id: 'SD', text: 'Sudan'},
                { id: 'SR', text: 'Suriname'},
                { id: 'SJ', text: 'Svalbard And Jan Mayen'},
                { id: 'SZ', text: 'Swaziland'},
                { id: 'SE', text: 'Sweden'},
                { id: 'CH', text: 'Switzerland'},
                { id: 'SY', text: 'Syrian Arab Republic'},
                { id: 'TW', text: 'Taiwan'},
                { id: 'TJ', text: 'Tajikistan'},
                { id: 'TZ', text: 'Tanzania'},
                { id: 'TH', text: 'Thailand'},
                { id: 'TL', text: 'Timor-Leste'},
                { id: 'TG', text: 'Togo'},
                { id: 'TK', text: 'Tokelau'},
                { id: 'TO', text: 'Tonga'},
                { id: 'TT', text: 'Trinidad And Tobago'},
                { id: 'TN', text: 'Tunisia'},
                { id: 'TR', text: 'Turkey'},
                { id: 'TM', text: 'Turkmenistan'},
                { id: 'TC', text: 'Turks And Caicos Islands'},
                { id: 'TV', text: 'Tuvalu'},
                { id: 'UG', text: 'Uganda'},
                { id: 'UA', text: 'Ukraine'},
                { id: 'AE', text: 'United Arab Emirates'},
                { id: 'GB', text: 'United Kingdom'},
                { id: 'US', text: 'United States'},
                { id: 'UM', text: 'United States Outlying Islands'},
                { id: 'UY', text: 'Uruguay'},
                { id: 'UZ', text: 'Uzbekistan'},
                { id: 'VU', text: 'Vanuatu'},
                { id: 'VE', text: 'Venezuela'},
                { id: 'VN', text: 'Viet Nam'},
                { id: 'VG', text: 'Virgin Islands}, British'},
                { id: 'VI', text: 'Virgin Islands}, U.S.'},
                { id: 'WF', text: 'Wallis And Futuna'},
                { id: 'EH', text: 'Western Sahara'},
                { id: 'YE', text: 'Yemen'},
                { id: 'ZM', text: 'Zambia'},
                { id: 'ZW', text: 'Zimbabwe'}
            ];

	var at, 
    cityMap, 
    countryMap,
    geocoder, 
    marker, 
    
    city_marker1, 
    
    city_marker2, 
    
    city_marker3, 
    
    city_marker4, 
    
    city_marker5, 
    
    city_marker6, 
    
    city_marker7, 
    
    city_marker8, 
    
    layer,
	init;


  var instance = $.fn.deviceDetector;
  var device_message = 'You are using ' + instance.getBrowserName() +' on ' + instance.getOsName();
  $('#save_device').val(device_message);

  $(document).ready(function(){
  
    
		$('.lazy').Lazy();
    
  		/** scroll class for top bar **/
    
        $(window).scroll(function() {    
            var scroll = $(window).scrollTop();
			var head_height	= $('.site-header__wrapper').height();
            if (scroll >= head_height) {
                $('.site-header__wrapper').addClass("darkHeader");
            } else {
                $('.site-header__wrapper').removeClass("darkHeader");
            }
        });
    	if($('.zoomme').length){
          
			$('.zoomme').each(function(i, e) {
            	var big_image = $(this).attr('large');
                $(this).zoom({
                    url: big_image, 
                    callback: function(){
                        $(this).addClass('haszoom');
                    }
                });

			});
    	}
    
  

        //console.log(instance.getInfo());

        if ($('#preview_mode').length){

        }
        else {
            var pixel_instance = $.fn.deviceDetector;
            //console.log('You are using ' + pixel_instance.getBrowserName() +' on ' + pixel_instance.getOsName());

              if($('#thumbnail_mode').length){
                    var thedevice = $('#thumbnail_mode').data('device');
                    if(thedevice == 'mobile'){
                        cityFixedWidth = 1000;
                    }
              } else if (pixel_instance.isMobile()) {
                //console.log('isMobile');
                var dpi = 75;
                Object.defineProperty(window, 'devicePixelRatio', {
                get: function() {return dpi / 96}
                }); 
            }
        }
  
  
    
    	$('#tidio-chat-button-mobile').css('z-index',999);
  

        var map_marker_selector = '.mapboxgl-marker';
        var $map_text_container = $('#map_text_inner');

        //Setters

        var set_ocean_color = '#theImage';
        var set_land_color = '#theImageInner';
        var set_font_stack = '#map_text_inner';

        var set_text_1_content = '#line_1';
        var set_text_2_content = '#line_2';
        var set_text_3_content = '#line_3';

        var set_contentLayout = '#for_contentLayout';
        var set_textboxLayout = '#for_textboxLayout';
  		var set_map_css_class = '#for_map_css_class';


        //Savers
         var save_color_scheme = '#save_color_scheme';
         var color_scheme_selector_part = 'map_colorScheme_'; 
         var save_font_stack = '#save_font_stack';
         var save_frame_color = '#save_frame_color';
         var save_text_1_content = '#save_text_1_content';
         var save_text_2_content = '#save_text_2_content';
         var save_text_3_content = '#save_text_3_content';
         var save_marker_lat = '#save_marker_lat';
         var save_marker_lng = '#save_marker_lng';
         var save_marker_latlng = '#save_marker_latlng';
         var save_marker_addr = '#save_marker_addr';
         var save_marker_icon = '#save_marker_icon';
         var save_contentLayout = '#save_contentLayout';
         var save_textBoxLayout = '#save_textBoxLayout';
         var save_design_url = '#save_design_url';
         var save_orientation = '#save_orientation';
    	 var save_map_markers = '#save_map_markers';
    	 var save_minimap = '#save_minimap';


         var save_map_zoom = '#save_map_zoom';
         var save_map_lat = '#save_map_lat';
         var save_map_lng = '#save_map_lng';
  		 var save_map_city = '#save_map_city';
  		 var save_iso_code = '#save_iso_code';


        //for custom stuff (unused at the moment) -------------------------
        var save_ocean_color = '#save_ocean_color';
        var save_land_color = '#save_land_color';
        var save_marker_color = '#save_marker_color';
        var save_text_1_font_family = '#save_1_font_family_value';
        var save_text_2_font_family = '#save_1_font_family_value';
        var save_text_3_font_family = '#save_1_font_family_value';

        var save_text_1_font_color = '#save_1_font_color_value';
        var save_text_2_font_color = '#save_2_font_color_value';
        var save_text_3_font_color = '#save_3_font_color_value';

        //for custom stuff (unused at the moment) -------------------------
        var set_text_1_font_family = '#set_1_font_family_value';
        var set_text_2_font_family = '#set_2_font_family_value';
        var set_text_3_font_family = '#set_3_font_family_value';       
        var set_text_1_font_color = '#set_1_font_color_value';
        var set_text_2_font_color = '#set_2_font_color_value';
        var set_text_3_font_color = '#set_3_font_color_value';


        //var save_textbg_color = $('#save_textbg_color');
        //var save_textbg_opacity = $('#save_textbg_opacity');

        var set_textbg_color = '#set_textbg_color';
        //set_textbg_opacity = $('#set_textbg_opacity');
  
  
  
  
  
    	/* -------------------------------------------------------- */
		/* ---------------------- DATA STORAGE AND DEFAULTS-------- */
		/* -------------------------------------------------------- */ 
  
  
  
        function save_data_from_url(){ 
		   
           var fontStack = $.urlParam('fontStack');
           var frameColor = $.urlParam('frameColor');
           var line1 = $.urlParam('line1');
           var line2 = $.urlParam('line2');
           var line3 = $.urlParam('line3');
           var mapLat = $.urlParam('mapLat');
           var mapLng = $.urlParam('mapLng');
           var mapZoom = $.urlParam('mapZoom');
           var markerLat = mapLat;
           var markerLng = mapLng;
           var iso_code = $.urlParam('iso');
           var miniMap = $.urlParam('miniMap');
          
           var orientation = $.urlParam('orientation');
           var mapMarkers = $.urlParam('mapMarkers');
          
          
           var markerAddr = $.urlParam('markerAddr');
           var markerIcon = $.urlParam('markerIcon');
           var contentLayout = $.urlParam('layout');
           var colorScheme = $.urlParam('colorScheme');	
           var textBoxLayout = $.urlParam('textBoxLayout');
           var framingOptions = $.urlParam('framingOptions');

           if (line1 != null ) {
              line1 = decodeURIComponent(line1);
              $(save_text_1_content).val(line1);
              //	console.log(line1);
           }
           if (line2 != null ) {
              line2 = decodeURIComponent(line2);
              $(save_text_2_content).val(line2);
           }
           if (line3 != null ) {
              line3 = decodeURIComponent(line3);
              $(save_text_3_content).val(line3);
           } 
           if (markerAddr != null ) {
              markerAddr = decodeURIComponent(markerAddr);
              $(save_marker_addr).val(markerAddr);
           }
           if (fontStack != null){
             //alert(fontStack);
              $(save_font_stack).val(fontStack);
           }
           if (frameColor != null){
              $(save_frame_color).val(frameColor);
           }
           if (framingOptions != null){
              framingOptions = framingOptions.replace(/-/g, ' ');
              $('[name="frame-options"] option[value="'+framingOptions+'"]').prop('selected',true).change();
           }
          
           if (markerLat != null){
              $(save_map_lat).val(mapLat); //$(save_marker_lat).val(mapLat);
           }
           if (markerLng != null){
              $(save_map_lng).val(mapLng); //$(save_marker_lng).val(mapLng);
           }
           if (mapLat != null){
              $(save_map_lat).val(mapLat);
              $(save_marker_lat).val(mapLat);
              //alert('mapLat = ' + mapLat);
           }
           if (mapLng != null){
              $(save_map_lng).val(mapLng);
              $(save_marker_lng).val(mapLng);
              //alert('mapLng = ' + mapLng);
           }
           if (iso_code != null){
              $(save_iso_code).val(iso_code);
              //alert('mapLng = ' + mapLng);
           }
           if (mapZoom != null){
              $(save_map_zoom).val(mapZoom);
              //alert('mapZoom = ' + mapZoom);
           }
           if (miniMap != null){
              $(save_minimap).val(miniMap);
           }
          
           var tempmarker = null;
           if ((markerLat != null) && (markerLng != null)){
              var marker_latlng = convertDMS(markerLat,markerLng);
              $(save_marker_latlng).val(marker_latlng);
              tempmarker = get_marker_icon();
           }
           if (markerIcon != null){
              $(save_marker_icon).val(markerIcon);
           }
           else if (tempmarker != null ) {
              $(save_marker_icon).val(tempmarker);
           }
           if (markerAddr != null){
              $(save_marker_addr).val(markerAddr);
           }
           if (contentLayout != null){
              $(save_contentLayout).val(contentLayout);
           }
          
           if (orientation != null){
              $(save_orientation).val(orientation);
           }
           if (mapMarkers != null){
             	//alert(mapMarkers);
           		if(mapMarkers.indexOf('|') > -1){
                	mapMarkers = clean_hexcolor_value(mapMarkers);
                    $(save_map_markers).val(mapMarkers);
                }
           }
           if (colorScheme != null){
           		if(colorScheme.indexOf('custom||') > -1){
                  	if($('#map_colorScheme_custom').length) {
                    	$('#map_colorScheme_custom').attr('data-colorparams',colorScheme);
                      	process_custom_color_url_param();
                      	colorScheme = 'custom';
                  	}
               }
               var fixed_colorscheme = decodeURI(colorScheme);
               fixed_colorscheme = fixed_colorscheme.replace('+','-').replace(' ','-');
               $(save_color_scheme).val(fixed_colorscheme);
               //alert(colorScheme);
               //console.log('----------fixed_colorscheme---------- fixed_colorscheme = '+ fixed_colorscheme);
               //console.log('----------  $(save_color_scheme).val(fixed_colorscheme);------ = '+   $(save_color_scheme).val());
           }
           if (textBoxLayout != null){
              $(save_textBoxLayout).val(textBoxLayout);
           }
           set_default_values($('#cityDropdown'));

        }

        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results==null){
               return null;
            }
            else{
               return decodeURI(results[1]) || null;
            }
        }
 	 	// get set and save stuff from url END -----------
  
  



        function initialise(){
            //alert('initialise');
            //if ($('#map_canvas').length){
             // alert('#map_canvas');
                init = true;
                save_data_from_url(); //sets map obj's and related funcs
                var columnHeight = $('.featured-slider').outerHeight( true );
                var columnwidth = $('.featured-slider').outerWidth( true ) * 0.6;
                //$('.actual-map-wrap').css('width',columnwidth+'px');
                $('.featured-slider__cover').css('height',columnHeight+'px');
                //set_default_radio('color-scheme');
                //set_default_radio('marker-radio');
                get_selected_fonts();
                //get_and_set_color_scheme();
                setPaperSize();
                init_accordion_section();
                check_marker();
                set_display_sizes();
                set_frame_color_func();
          
                 var random = Math.floor(Math.random() * 1000); 
              	$('#save_design_timestamp').val(Date.now()+'-'+random);


            //}
        }

        // Block non-numeric chars.
        $(document).on('keyup', '.numeric-only', function (event) {
          
  			try{
                var val = this.value;
                val = val.replace(/([^0-9\.])/g, '');
                val = val.replace(/([\.].*)[\.]/g, '$1');
                if (val == '') {
                    val = 0;
                }
                else {             
                  var xval = parseFloat(val);
                  if (xval < 0) {
                    val = 0;
                  }
                }
                this.value = val;
          	} catch (err_numericonly) {
              	console.log('Error: '+err_numericonly.message);
      		}
          
        });
    
		$("body").on("click", ".fine-tune-zoom-toggle", function(event){
			$(this).hide();
    		$('.fine-tune-zoom-form').slideDown(300);
		});
    
		$("body").on("click", ".fine-tune-zoom-reset", function(event){
          	$('.update-zoom-input').val(cityMap.getZoom());
		});
    
    	$("body").on("click", ".update-new-zoom", function(event){
  			try {
                var $inputObj = $('.update-zoom-input');
                if($inputObj.val().length != 0 ){
                  	var newzoom = $inputObj.val();
                    cityMap.setZoom(newzoom);
                  	save_zoom(newzoom);
                }
          	} catch (err_updatenewzoom) {
              	console.log('Error: '+err_updatenewzoom.message);
      		}
		});
    	
    

        function set_default_radio(inputname){
  			try{
                var $thisObj;
                if($('input[name='+inputname+']:checked')){

                    $thisObj = $('input[name='+inputname+']:checked');
                    //alert('found checked | '+$thisObj.val());

                }
                else if ($('input[name='+inputname+']:first')){
                    $thisObj = $('input[name='+inputname+']:first');
                      //alert('set checked | '+$thisObj.val());
                    $thisObj.prop("checked", true); 
                }
          	} catch (err_set_default_radio) {
            	console.log('Error: '+err_set_default_radio.message);
      		}
        }
    
        // get set and save stuff from url -----------
        function set_default_values($dropdownObj){
          //defaults from dropdownobj
           var canuse_cd_data = false;
           if (($(save_map_lat).val() == "" ) && ($(save_map_lat).val() == "" )) {
              canuse_cd_data = true;
           }
          
          var cdminimap,cdorientation,cdiso,cdmapzoom,cdmaplng,cdmaplat,cdcolorscheme,cdcontentlayout,cdtextboxlayout,cdtext1,cdtext2,cdtext3,cdfontstack,cdframecolor,cdlat,cdlng,cdmarkericon,cdmarkeraddr,cdmarkerlat,cdmarkerlng,cdcontentlat,cdcontentlng;
          //stores for the data we will be using
          var using_minimap,using_orientation,using_iso,using_mapzoom,using_maplng,using_maplat,using_colorscheme,using_contentlayout,using_textboxlayout,using_text1,using_text2,using_text3,using_fontstack,using_framecolor,using_markericon,using_markeraddr,using_markerlat,using_markerlng;

		  $dropdownObj = typeof $dropdownObj !== 'undefined' ? $dropdownObj : $('#cityDropdown');
          var $thisObj = $dropdownObj;
          
          cdorientation = 'portrait';
          cdminimap = 'yes';
		  
          //process lat lng
          cdmaplat = $thisObj.data('lat');
          cdmaplng = $thisObj.data('lng');
          cdmapzoom = $thisObj.data('zoom');
          
          //console.log('#########' + $thisObj.attr('id') + 'cdlat = ' + cdlat + '| cdlng = ' + cdlng + '###################');

          cdmarkerlat = cdmaplat; //$thisObj.data('markerlat');
          cdmarkerlng = cdmaplng; //$thisObj.data('markerlng');

          cdfontstack = $('#fontDropdown').val();
          
          //get colorscheme
          if ($thisObj.is('[data-colorscheme]')) {
           
          	cdcolorscheme = decodeURI($thisObj.data('colorscheme'));
            //console.log('----------cdcolorscheme---------- data-colorscheme = '+ cdcolorscheme);
          }
          else {
            
          	cdcolorscheme = $('input[name=color-scheme]:checked').val();
            
          }
          cdcolorscheme = decodeURI(cdcolorscheme);
          //alert('cdcolorscheme = '+ cdcolorscheme);
          //get layout
          if ($thisObj.is('[data-layout]')) {
            
          	cdcontentlayout = decodeURI($thisObj.data('layout'));
            //console.log('cdcontentlayout data-layout = '+cdcontentlayout);
          }
          else {
            
          	cdcontentlayout = 'modern_light_fade';
            
          }
          //console.log('cdcontentlayout = '+cdcontentlayout);
		  if ($(save_contentLayout).val() != "" ) {
				using_contentlayout = $(save_contentLayout).val();
		  }
		  else{
              using_contentlayout = cdcontentlayout;
              
		  }
		  $(save_contentLayout).val(using_contentlayout);
		  //console.log('save_contentLayout = '+using_contentlayout);
          
          
          

          if (cdmarkerlat != '' && cdmarkerlng != '' ){
              cdcontentlat = cdmarkerlat;
              cdcontentlng = cdmarkerlng;
          }
          else{
              cdcontentlat = cdlat;
              cdcontentlng = cdlng;
          }

          //default line 1 from settings
          cdtext1 = $thisObj.data('line1');
          /**
          if (cdtext1 == ''){

              var names = ['Eliza & Noah','Jacob & Maggie','Sabina & Adam','Ashland & Matthew','Collin & Juliana','Josiah & Juliana','Ben & Madeleine','Adam & Annika','Charlotte & James','Hannah & Christian'];
              cdtext1 = names[Math.floor(Math.random()*names.length)];
              cdtext1 = cdtext1.toUpperCase();

          }**/
          //cdtext1 = 'YOUR TEXT HERE';

          //default line 2 from settings
          cdtext2 = $thisObj.data('line2');
          if (cdtext2 == ''){
              cdtext2 = convertDMS(cdcontentlat,cdcontentlng);	 
          }

          //default line 3 from settings
          cdtext3 = $thisObj.data('line3');
          if (cdtext3 == ''){
              var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];
              var today = new Date();

              var date = today.getDate()+' '+monthNames[today.getMonth()]+' '+today.getFullYear();
              cdtext3 = 'Married, '+date;
          }
          cdtext3 = '';

          //default color scheme 

          cdframecolor = $('#frameColors').val();

          var cdtype = 'cd';

           if ($(save_orientation).val() != "" ) {
              using_orientation = $(save_orientation).val();
           }
           else{
              using_orientation = cdorientation;
           }
           set_orientation_from_saved();
          
           if ($(save_minimap).val() != "" ) {
              using_minimap = $(save_minimap).val();
           }
           else{
              using_minimap = cdminimap;
           }
           set_minimap_visibility_from_saved();
          
           // ------------ LINE 1 ----------------
		   if(canuse_cd_data == true){
               if ($(save_text_1_content).val() != "" ) {
                  using_text1 = $(save_text_1_content).val();
               }
               else{
                    using_text1 = cdtext1;
               }
           }
           else {
				using_text1 = $(save_text_1_content).val();
           }
          
           // ------------ LINE 2 ----------------       
		   if(canuse_cd_data == true){
               if ($(save_text_2_content).val() != "" ) {
                  using_text2 = $(save_text_2_content).val();
               }
               else{
                  using_text2 = cdtext2;

               }
           }
           else {
				using_text2 = $(save_text_2_content).val();
           }
          
           // ------------ LINE 3 ---------------- 
		   if(canuse_cd_data == true){
               if ($(save_text_3_content).val() != "" ) {
                  using_text3 = $(save_text_3_content).val();
               }
               else{
                  using_text3 = cdtext3;

               }
           }
           else {
				using_text3 = $(save_text_3_content).val();
           }

           if ($(save_font_stack).val() != "" ) {
              using_fontstack = $(save_font_stack).val();
           }
           else{
              using_fontstack = cdfontstack;
           }

           if ($(save_frame_color).val() != "" ) {
              using_framecolor = $(save_frame_color).val();
           }
           else{
              using_framecolor = '';
           }
          
           if ($(save_color_scheme).val() != "" ) {
              using_colorscheme = $(save_color_scheme).val();
			  //console.log('---------------using SAVE color scheme = "'+using_colorscheme+'"');
           }
           else{
               if (($(save_map_lat).val() != "" ) || ($(save_map_lng).val() != "" )){
			   		using_colorscheme = $('input[name=color-scheme]:checked').val();
               }
               else {
              		using_colorscheme = cdcolorscheme;
               }
             //console.log('---------------using CD color scheme = "'+using_colorscheme+'"');
           }
           using_colorscheme = decodeURI(using_colorscheme);
           using_colorscheme = handleize_string(using_colorscheme);
          	$("input[name='color-scheme'][value='" + using_colorscheme + "']").prop('checked', true);
           //console.log('---------------using_colorscheme = "'+using_colorscheme+'"');
		   $(save_color_scheme).val(using_colorscheme);
          
          
           if ($(save_map_lat).val() != "" ) {
              //alert('$(save_map_lat has value');
              using_maplat = $(save_map_lat).val();
           }
           else{
              //alert('save_map_lat has no value');
              using_maplat = cdmaplat;
           }
          
           if ($(save_map_lng).val() != "" ) {
              using_maplng = $(save_map_lng).val();
           }
           else{
              using_maplng = cdmaplng;
           }
          
           if ($(save_map_zoom).val() != "" ) {
              //alert('save_map_zoom has no value');
              using_mapzoom = $(save_map_zoom).val();
           }
           else{
              using_mapzoom = cdmapzoom;
           }
          
           $('.update-zoom-input').val(using_mapzoom);
          
           set_text(using_text1,using_text2,using_text3);
          	//need to run these first so obj is set
          	save_lat_lng_zoom(using_maplat,using_maplng,using_mapzoom);
          	
		    setCityMap();
            getCountryFromLatLng(using_maplat,using_maplng);
         
			/**
           if ($(save_marker_addr).val() != "" ) {
              using_markeraddr = $(save_marker_addr).val();
           }
           else{
              using_markeraddr = cdmarkeraddr; 
           }

           if ($(save_marker_lat).val() != "" ) {
              using_markerlat = $(save_map_lat).val(); //$(save_marker_lat).val();
           }
           else{
              using_markerlat = cdmarkerlat;
           }
           if ($(save_marker_lng).val() != "" ) {
              using_markerlng = $(save_map_lng).val(); //$(save_marker_lng).val();
           }
           else{
              using_markerlng = cdmarkerlng;
           }
           **/
           if ($(save_marker_icon).val() != "" ) {
              using_markericon = $(save_marker_icon).val();
           }
           else{
              using_markericon = cdmarkericon;
           }
          
           //user defined map markers
          
           set_content_layout_from_saved();
          
           if ($(save_textBoxLayout).val() != "" ) {
              using_textboxlayout = $(save_textBoxLayout).val();
           }
           else{
               
              using_textboxlayout = cdtextboxlayout;
           }

           // alert(using_fontstack);

            //set font
            using_fontstack = handleize_string(using_fontstack);
            //alert("$('#font-" + using_fontstack + ").prop('selected',true).change()");
            if($('#font-'+ using_fontstack).length){
              $('#font-'+ using_fontstack).prop('selected',true).change();
            }

            //set marker icon
            using_markericon = handleize_string(using_markericon);
            if($('#marker-'+ using_markericon).length){
              $('#marker-'+ using_markericon).prop('checked',true).change();
            }
            using_colorscheme = handleize_string(using_colorscheme);
            if($('#'+color_scheme_selector_part + using_colorscheme).length){
              $('#'+color_scheme_selector_part + using_colorscheme).prop('checked',true).change();
            }
          
          
            //set_thumb_map(using_markerlng,using_markerlat,using_markeraddr);
          	getCountryFromLatLng(using_maplat,using_maplng);
          	
            set_frame_color_func(using_framecolor);
            build_url();
           	show_hide_text_labels();
          	setPaperSize();
            setTimeout(function(){
            	resize_and_centermap();
              
              	var $colorSchemeObj = $("input[name='color-scheme'][value='" + using_colorscheme + "']");
                $('body').attr('color-scheme', $colorSchemeObj.val());
                var minimapland = $thisObj.data('land');
                //setmap_style_item('land', 'fill-color', minimapland);
                $('body').attr('color-scheme', $('input[name=color-scheme]:checked').val());
              
            }, 500);
          

        }
    
        function show_hide_text_labels(){
          
          
            try {
              
              
                var hide_wrap = true;
                // ------------ LINE 1 ----------------   
                if ($(save_text_1_content).val() != "" ) {
                    $('.line-1').removeClass('hide-me');
                    hide_wrap = false;
                }
                else{
                    $('.line-1').addClass('hide-me');
                }
                // ------------ LINE 2 ----------------       
                if ($(save_text_2_content).val() != "" ) {
                    $('.line-2').removeClass('hide-me');
                    hide_wrap = false;
                }
                else{
                    $('.line-2').addClass('hide-me');
                }
                // ------------ LINE 3 ----------------  
                if ($(save_text_3_content).val() != "" ) {
                    $('.line-3').removeClass('hide-me');
                    hide_wrap = false;
                }
                else{
                    $('.line-3').addClass('hide-me');
                }


                if (hide_wrap == true) {
                    $('.map-frame-text-inner').addClass('hide-me');
                }
                else{
                    $('.map-frame-text-inner').removeClass('hide-me');
                }
              
              

            } catch (err_show_hide_text_labels) {
              	//console.log(err_show_hide_text_labels.message);
            }
          
        }
  

        function build_url(pathname){
          	  var thepathname = typeof pathname !== 'undefined' ? pathname : window.location.pathname;
           	  //console.log('pathname = '+ thepathname + ' | window.location.pathname = ' + window.location.pathname);
              //if(init == true){

             // }
              //else {
              setTimeout(function(){

                 //data	
                 var color_scheme = $('#save_color_scheme').val();
                 if(color_scheme == 'custom'){
                   	if($('#map_colorScheme_custom').attr('data-colorparams').indexOf('custom||') > -1){
						color_scheme = $('#map_colorScheme_custom').attr('data-colorparams');
                    }
                 }
                 var font_stack = $('#save_font_stack').val();
                 var frame_color = $('#save_frame_color').val();
                 var text_1_content = $('#save_text_1_content').val();
                 var text_2_content = $('#save_text_2_content').val();
                 var text_3_content = $('#save_text_3_content').val();
                
                 var map_lat = $('#save_map_lat').val();
                 var map_lng = $('#save_map_lng').val();
                 var map_zoom = $('#save_map_zoom').val();
                 var map_markers = $('#save_map_markers').val();
                 map_markers = clean_hexcolor_value(map_markers);
                 var marker_lat = $('#save_marker_lat').val();
                 var marker_lng = $('#save_marker_lng').val();
                 var marker_addr = $('#save_marker_addr').val();
                 var marker_icon = $('#save_marker_icon').val();
                 var contentLayout = $('#save_contentLayout').val();
                 var textBoxLayout = $('#save_textBoxLayout').val();
                 var currentVariant = $('[name="id"]').val();
                 var framingOptions = $('[name="frame-options"]').val();
                
                 var orientation = $('#save_orientation').val();
                
                 var minimap = $('#save_minimap').val();
                  //alert(currentVariant);



                 if (text_1_content != '' ) {
                    text_1_content = encodeURIComponent(text_1_content);
                 }

                 if (text_2_content != '' ) {
                    text_2_content = encodeURIComponent(text_2_content);
                 }

                 if (text_3_content != '' ) {
                    text_3_content = encodeURIComponent(text_3_content);
                 } 

                 if (marker_addr != '' ) {
                    marker_addr = encodeURIComponent(marker_addr);
                 }
                 var framingOptionsParam = '';
                 if($('[name="frame-options"]').length){
                     if (framingOptions != '') {
                     	framingOptionsParam = 'framingOptions='+framingOptions.replace(/\s/g, '-');
                     }
                 }
                
                 var urlOrientation = 'orientation=' + orientation;
                
                 var urlMinimap = 'miniMap=' + minimap;

                 //params
                 var colorScheme = 'colorScheme=' + color_scheme;
                 var fontStack = 'fontStack=' + font_stack;
                 
                 var frameColor = 'frameColor=' + frame_color;
                 if($('#frameColors').prop( "disabled")){
                 	frameColor = '';
                 };
                 var line1 = 'line1=' + text_1_content;
                 var line2 = 'line2=' + text_2_content;
                 var line3 = 'line3=' + text_3_content;
                
                 var mapLat = 'mapLat=' + map_lat;
                 var mapLng = 'mapLng=' + map_lng;
                 var mapZoom = 'mapZoom=' + map_zoom;
                 /** not needed for city map
                 var markerLat = 'markerLat=' + marker_lat;
                 var markerLng = 'markerLng=' + marker_lng;
                 **/
                 var mapMarkers = '';
                 if(map_markers != ''){
					mapMarkers = '&mapMarkers=' + map_markers;
                 }
                 var screen_res = $(window).width() + "x" + $(window).height();
                     
                 $('#save_map_browser_resolution').val(screen_res);
                 $('#save_map_user_agent').val(navigator.userAgent);
                	
                 //var markerAddr = 'markerAddr=' + marker_addr;
                 //var markerIcon = 'markerIcon=' + marker_icon;
                
                 var contentLayout = 'layout=' + contentLayout;
                 var textBoxLayout = ''; //'textBoxLayout=' + textBoxLayout;
                 var variantId = 'variant=' + currentVariant;
                 var view = '';
                 if (window.location.href.indexOf('view=') > 0){
                 	view = 'view=' + $.urlParam('view') + '&';
                 }
                 var user_params = '&' + urlMinimap + '&' + contentLayout + '&' + textBoxLayout + '&' + urlOrientation + '&' + mapZoom + mapMarkers + '&' + colorScheme + '&' + fontStack + '&' + line1 + '&' + line2 + '&' + line3 + '&' + mapLat + '&' + mapLng + '&' + frameColor+ '&' + framingOptionsParam;
                 var r = window.location.protocol + '//' + window.location.host + thepathname + "?" + view + variantId + user_params;
                 var saved_url = $(save_design_url).val();
                 //alert('about to update url');
                 $('[name="return_to"]').val(thepathname + "?" + view + variantId + user_params);
                 if(r == saved_url){
                  	
                 }
                 else {
                   	//console.log('url changed'); 
                	$(save_design_url).val(r);
                   if (history.replaceState) {
                          window.history.replaceState({
                            path: r
                          }, "", r)
                   }
                   
                 }
                 if ($('#preview_mode').length){
                 }
                else {
                  var preview_url = 'https://mapsoftheworld.io' + thepathname + "?" + view + variantId + user_params;
                   var preview_design_url = preview_url.replace('?','?view=citymap-thumbnail-preview&');
                   $('#save_previewDesignUrl').val(preview_url);
                   //console.log('build = '+preview_url);
                   preview_image(preview_url);
                   check_for_minimum_inputs();
                   update_button_price();
                  
                }
              }, 10);
              //}
        }
  
  
    	/* -------------------------------------------------------- */
		/* ---------------------- DATA STORAGE AND DEFAULTS END --- */
		/* -------------------------------------------------------- */ 

          function radio_button_tmpl(id,checked,value,name,count) {
              var val_arr = value.split(':');
              var title = val_arr[0];
              var clean_title;
              var val_text = val_arr[1];
              var cm_arr = val_text.split('(');
              var cm_text = '('+cm_arr[1];
              var inches_text = cm_arr[0].toLowerCase();
              var inches_arr = inches_text.split('x');
              var disable_options = '';
              if (title.indexOf('Size A') > -1) {
					clean_title = title.replace('Size','');
                	
              }
              else {
              		clean_title = inches_arr[0].replace('inches', '').replace(/\s/g, '') + "' x " + inches_arr[1].replace('inches', '').replace(/\s/g, '');
                	clean_title = clean_title+'"';
              }
              var radio_button_tmpl = "<div class='grid__item one-third'>" +
                  "<input " + disable_options + " class='size-radio-item' id='" + id + "' " + checked + " value='" + value + "' name='size-radio' type='radio' />" +
                  "<label for='" + id + "' option='" + count + "' class='image-radio-button' style=''>" +
                      "<div class=/size-wrap/>"+
                          "<div class='size-item'>" + clean_title + "<span>" + cm_text + "</span></div>" +
                      "</div>" +
                  "</label>" +
              "</div>";
              return radio_button_tmpl;
          }

          setTimeout(function(){
              $("#size option").each(function(i, e) {
                  var count = i++;
                  var theval = $(this).val();
                  var the_id = theval.replace(/\s/g, '-').replace(':','').replace('(','').replace(')','')  + '_size-radio_' + i;
                  var checked = '';
                  if($(this).is(':selected')) {
                      checked	 = 'checked';
                  }
                  var the_html = radio_button_tmpl(the_id, checked, theval, 'size-radio', count);
                  if (the_id.indexOf('Size-A') > -1) {
					$(the_html).appendTo("#a");
                  }
                  else {
                  	$(the_html).appendTo("#r");
                  }

              });
              $('#size-select-group').hide();
          }, 1000);

          $("body").on("change", ".size-radio-item", function(){
              var theval = $(this).val();
              $("#size").val(theval);
              $("#size").change();
              hide_not_available_options($(this));
              
          });
          $("body").on("Option Unavailable", ".size-radio-item", function(){
              var theval = $(this).val();
              $("#size").val(theval);
              $("#size").change();
              hide_not_available_options();
              
          });
          $(window).on( "Option Unavailable", function() {
            	//alert('Option Unavailable');
          	//hide_not_available_options();
          });
   
          function hide_not_available_options(){
            	var $selectedObj = $('[name="id"] option:selected');
          		$('[name="frame-options"]').find('option').each(function() {
          			$(this).prop('disabled',false);
          		});
          		if($selectedObj.is('[data-disable1]')) {
          			var disable_title1 = $selectedObj.data('disable1');
                  	//console.log('####### disable_title1 = ' + disable_title1);
          			if($('select [value="' + disable_title1 + '"]').length){
          				$('select [value="' + disable_title1 + '"]').prop('disabled',true);	
          			}
          		}
          		if($selectedObj.is('[data-disable2]')) {
          			var disable_title2 = $selectedObj.data('disable2');
                  	//console.log('####### disable_title2 = ' + disable_title2);
          			if($('select [value="' + disable_title2 + '"]').length){
          				$('select [value="' + disable_title2 + '"]').prop('disabled',true);	
          			}
          		}

          }
  
  		  /** ---------------------- COUNTRY MAP -------------------------**/
          function setCityFromTag(tag) {
          		try{
						var ptag_tag = tag
                        var currentAjaxRequest = null;
                        var searchterm = ptag_tag.replace(/[\s]+/g, '* ') + "*";
                        searchterm = searchterm.replace(/[\*]+/g, '*');
                        if (searchterm == "") {
                            searchterm = "*";
                        }
                        var searchtags = '%20AND%20tag:'+ptag_tag;
                        // What's the search URL?
                        var searchURL = '/search?type=product&q=' + searchterm + searchtags;
                        // Killing any Ajax request that's currently being processed.
                        if (currentAjaxRequest != null) currentAjaxRequest.abort();
                        // Pulling results.
                      	//alert(searchURL + '&view=new-country-data');
                        currentAjaxRequest = $.getJSON(searchURL + '&view=city-data', function(data) {
                            // If we have no results.
                            if(data.results_count > 0) {
                              $.each(data.results, function(index, item) {
                                //alert(item.title);
                                var line1 = item.title.toUpperCase();
                                var line2 = item.subtitle.toUpperCase();
                                save_lat_lng_zoom(item.map_lat,item.map_lng,item.zoom,item.title);
								set_text(line1,line2); 
                                //window.location.href = item.url;
                                /**
                                var cityDropdown = '<input new id="cityDropdown" name="cityDropdown" type="hidden" ' +
                                'product="' + item.url  + '" data-line1="' + item.title + '" data-line2="' + item.subtitle + '" ' +
                                'data-lat="' + item.map_lat + '" data-lng="' + item.map_lng + '" data-abbr="' + item.iso + '" ' +
                                'data-zoom="' + item.zoom + '" />';
  								$( "#cityDropdown" ).replaceWith( cityDropdown );
                                console.log('update city data store' );
                                
                                //build_url(item.url);
                                **/
                                setCityMap();
                                return;
                              });
                            }
                            else{
								setCityMap();
                            }
                       }).fail(function() {
                  			//console.log( "error" );
                          	setCityMap();
                	   });	 
          		} catch (err_setCountryFromISO) {
      			}
          }
          function setCountryFromISO(iso) {
          		try{
                  	console.log('----------------- setCountryFromISO -----------');
                  	iso = typeof iso !== 'undefined' ? iso : $('#countryDropdown').data('abbr');
                  	var current_iso  = $('#countryDropdown').data('abbr');
                  	current_iso = current_iso.toLowerCase();
                  	iso = iso.toLowerCase();
                  	var maptype = 'countrymap';
                    if (iso.indexOf('us-') > -1){
                      	if (iso == 'us-hi'){
                          	maptype = 'statemap';
                        }
                        else {
							iso = 'us';
                        }
                     	console.log('line 2874 ' + iso + '==' + current_iso);
                    } else if (iso.indexOf('-') > -1){
						var isoarr = iso.split('-');
                      	iso = isoarr[0];
                    }
                  	if (iso == current_iso) {
                      	console.log(iso + ' == current_iso ' + current_iso);
                      	setMiniMMap();
                      	$('#countryDropdown').data('abbr',iso);
                      	$('.mini-map-wrap').show();
                    }
                  	else {
                      	$('#countryDropdown').data('abbr',iso);
						var iso_tag = 'iso_'+iso;
                        var currentAjaxRequest = null;
                        var searchterm = iso.replace(/[\s]+/g, '* ') + "*";
                        searchterm = searchterm.replace(/[\*]+/g, '*');
                        if (searchterm == "") {
                            searchterm = "*";
                        }
                      	console.log('iso_tag = ' + iso_tag + ' | maptype = ' + maptype);
                        var searchtags = '%20AND%20tag:'+iso_tag+'%20AND%20tag:'+maptype;
                        // What's the search URL?
                        var searchURL = '/search?type=product&q=' + searchterm + searchtags;
                        // Killing any Ajax request that's currently being processed.
                        if (currentAjaxRequest != null) currentAjaxRequest.abort();
                        // Pulling results.
                      	//alert(searchURL + '&view=new-country-data');
                      	console.log('searchURL = ' + searchURL);
                        currentAjaxRequest = $.getJSON(searchURL + '&view=new-country-data', function(data) {
                            // If we have no results.
                          	console.log('----------------- setCountryFromISO AJAX -----------');
                          	console.log('data.results_count = ' + data.results_count);
                            if(data.results_count > 0) {
                              $.each(data.results, function(index, item) {
                                //alert(item.title);
                                var countryDropdown = '<input new id="countryDropdown" name="countryDropdown" type="hidden" ' +
                                'product="' + item.url  + '" value="' + item.title + '" ' +
                                'data-lat="' + item.bb_lat + '" data-lng="' + item.bb_lng + '" data-abbr="' + item.iso + '" data-mstyle="' + item.mstyle + '" ' +
                                'data-zoom="' + item.zoom + '" />';
                                console.log(countryDropdown);
  								$( "#countryDropdown" ).replaceWith( countryDropdown );
                                setMiniMMap();
                                $('.mini-map-wrap').show();
                                //setPaperSize();
                                return;
                              });
                            } 
                            else {
								$('.mini-map-wrap').hide();
                            }
                          	console.log('----------------- setCountryFromISO AJAX END -----------');
                       }).fail(function(xhr, textStatus, errorThrown) {
                            console.log('----------------- setCountryFromISO error ----------' );
                          	$('.mini-map-wrap').hide();
                            console.log(xhr.statusText);
                            console.log(textStatus);
                            console.log(errorThrown);
                          	console.log( "setCountryFromISO error" );
                          	console.log('----------------- setCountryFromISO error END ----------' );
                	   });	 
                  	}
          		} catch (err_setCountryFromISO) {
      			}
            	console.log('----------------- setCountryFromISO END -----------');
          }
  
          function getCountryFromLatLng(lat,lng){
            	try{
                    //mapbox uses lng lat
                    var at = 'pk.eyJ1IjoiY2hlcmlzaGVkbG9jYXRpb25zIiwiYSI6ImNqZHQzMjY5ajB6Y2oyeHBja2w3OG1jaWUifQ.1ADcEgkY7VANSGkPgsw4tA';
                    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + lng + '%2C' + lat + '.json?access_token=' + at +'&types=region';
					//var url1 = 'http://ws.geonames.org/countryCodeJSON?lat=' + lat + '&lng=' + lng + '&username=mapsoftheworld';
                  	//console.log('url = ' + url1);

                    var jqxhr = $.getJSON( url, function(response) {
                        console.log( "success" );
                      
                        //console.log(response.features[0]);
                      	console.log(response);
                       	//console.log('response.features[0] = ' + response.features[0]);
                      	
                        if(response.features[0] !== undefined ){ 
                            if (response.features[0].properties.short_code !== undefined || response.features[0].properties.short_code !== null) {
								
                                var countryname = '';
                                //alert(response.features[0].properties.short_code);
                                if (response.features[0].properties.short_code === undefined || response.features[0].properties.short_code === null) {
                                    countryname = response.features[0].place_name;
                                }
                                if (response.features[0].properties["short_code"] === undefined) {
									
                                  	var iso = response.features[0].properties.short_code;
                                }
                                else {
									var iso = response.features[0].properties["short_code"];
                                }
                              
                              
                              
                              
                              	//var iso_backup = response.features[0].context[0].short_code;
                              	console.log('getCountryFromLatLng iso = ' + iso);
                              	if (iso != undefined){
                                  	setCountryFromISO(iso);
                                }
                                else {
                                  
                                   if (response.features[0].context[0].short_code !== undefined ){
                            			var iso = response.features[0].context[0].short_code;
                                     	console.log('3032 iso = ' + iso);
                                		setCountryFromISO(iso);
                            		}
                                  	else {
										$('.mini-map-wrap').hide();
                                    }
                                }
                                
                            }
                            else {
                             	$('.mini-map-wrap').hide();
                                return false;
                            }
                        }
                        else{
							//$('.mini-map-wrap').hide();
                        }
                    })
                    .fail(function() {
                      $('.mini-map-wrap').hide();
                      //console.log( "error" );
                    });
          		} catch (err_getCountryFromLatLng) {
                  	//console.log(err_getCountryFromLatLng.message);
      			}
          }
  
  		  //getCountryFromLatLng('-26.4', '153.06667');
  
  
          // from : http://qnimate.com/javascript-limit-function-call-rate/

          function debounce(func, wait, immediate) {
              var timeout;
              return function() {
                  var context = this,
                      args = arguments;
                  var later = function() {
                      timeout = null;
                      if (!immediate) func.apply(context, args);
                  };
                  var callNow = immediate && !timeout;
                  clearTimeout(timeout);
                  timeout = setTimeout(later, wait);
                  if (callNow) func.apply(context, args);
              };
          };
          function save_zoom(zoom){
              $(save_map_zoom).val(zoom);
              build_url();
          }
          function save_lat_lng_zoom(lat,lng,zoom,addr){
              var theaddr = typeof addr !== 'undefined' ? addr : '';
              $(save_map_zoom).val(zoom);
              $(save_map_lat).val(lat);
              $(save_map_lng).val(lng);
              $('.update-zoom-input').val(zoom);
              $(save_marker_lat).val(lat);
              $(save_marker_lng).val(lng);
              $(save_marker_addr).val(theaddr);
              if ((lat != null) && (lng != null)){
                  var marker_latlng = convertDMS(lat,lng);
                  $(save_marker_latlng).val(marker_latlng);
                  console.log('FUNC save_lat_lng_zoom = ' + marker_latlng);
                  $('.latlng-me').html(marker_latlng);
                  setMiniMapColor();
                  if($('#add_lat_lng').is(':checked')){
                      $(set_text_2_content).val(marker_latlng);
                      if($($(set_text_2_content).attr('data-linkedinput')).length){
                          $($(set_text_2_content).attr('data-linkedinput')).html(marker_latlng);
                          $(save_text_2_content).val(marker_latlng);
                          show_hide_text_labels();
                      }
                  }
                
                
              }
              //set_latlng_subtitle();
              build_url();
            
            
          }
          var save_map_stage_instant = debounce(function(){
             var lat = cityMap.getBounds().getCenter().lat;
             var lng = cityMap.getBounds().getCenter().lng;
             var zoom = cityMap.getZoom();
             save_lat_lng_zoom(lat,lng,zoom);
          }, 500);
          var fix_mini_map_country = debounce(function(){
             var lat = cityMap.getBounds().getCenter().lat;
             var lng = cityMap.getBounds().getCenter().lng;
             getCountryFromLatLng(lat,lng);
          }, 4000);
  
        function setCityMap(){
            if( $('#citymap_canvas').length){
            if (typeof cityMap === 'object') {
				changeCity();
              	
            }
            else {
            if ( $('#currentCountry').length && $('#currentCountry').attr('data-iso') != '' ) {  
            $('#citymap_canvas').html('');
            $('#geocoder').html('');
            //var map_css_class = $('#map_css_class').val();
            var selectedObj = $('#cityDropdown');
            var currentCountryObj = $('#currentCountry');
            var getCountry = selectedObj.val();
            var countryAbbr = currentCountryObj.data('iso'); //$('#countryDropdown').attr('abbr'); 
            var getlat = $(save_map_lat).val();
            var getlng = $(save_map_lng).val();
            var defaultcityzoom = 11.5;
            var getzoom = getZoom(selectedObj);
              
            //map styling 
            var css,mapstyle;
			var $thisObj = $('input[name=color-scheme]:checked');
            css = $thisObj.data('css-class');
            mapstyle = $thisObj.data('mapstyle');
            $(set_map_css_class).attr('class','').addClass(css);
 			// preserveDrawingBuffer: true,
            //console.log('######### setCityMap ' + selectedObj.attr('id') + 'getlat = ' + getlat + '| getlng = ' + getlng + '###################');
            at = 'pk.eyJ1IjoiY2hlcmlzaGVkbG9jYXRpb25zIiwiYSI6ImNqZHQzMjY5ajB6Y2oyeHBja2w3OG1jaWUifQ.1ADcEgkY7VANSGkPgsw4tA';
            mapboxgl.accessToken = at;
            cityMap = new mapboxgl.Map({
                container: 'citymap_canvas',
              	style: 'mapbox://styles/cherishedlocations/'+mapstyle,
                center: [getlng, getlat],
                zoom: getzoom,
                interactive: true,
              	attributionControl: false
            });             	

            // Add zoom and rotation controls to the map.
			var nav = new mapboxgl.NavigationControl();
			cityMap.addControl(nav, 'top-left'); 
              
    		cityMap.addControl(new mapboxgl.AttributionControl({
        		compact: true
    		})); 
              
            //cityMap.addControl(new mapboxgl.ScaleControl());
              
            var lastZoomCityMap = cityMap.getZoom();

            cityMap.on('zoom', function(e) {
              //console.log('########## zoom ###############');
              const currentZoomCityMap = cityMap.getZoom();
              if (currentZoomCityMap > lastZoomCityMap) {
                cityMap.resize();
              } else {
                cityMap.resize();
              }
              save_map_stage_instant();
              fix_mini_map_country();
              lastZoomCityMap = currentZoomCityMap;
            });
            cityMap.on('click', function(e) {
                //console.log('########## click ###############');
                cityMap.resize();
              	save_map_stage_instant();
              	fix_mini_map_country();
            });  
            cityMap.on('drag', function(e) {
                //console.log('########## drag ###############');
                cityMap.resize();
             	save_map_stage_instant();
              	fix_mini_map_country();

            });
            // create a HTML element for each feature
            
            var el1 = document.createElement('div');
              el1.className = 'marker1';
            
            var el2 = document.createElement('div');
              el2.className = 'marker2';
            
            var el3 = document.createElement('div');
              el3.className = 'marker3';
            
            var el4 = document.createElement('div');
              el4.className = 'marker4';
            
            var el5 = document.createElement('div');
              el5.className = 'marker5';
            
            var el6 = document.createElement('div');
              el6.className = 'marker6';
            
            var el7 = document.createElement('div');
              el7.className = 'marker7';
            
            var el8 = document.createElement('div');
              el8.className = 'marker8';
            

            // After the map style has loaded on the page, add a source layer and default
            // styling for a single point.
            cityMap.on('load', function() {
             	//move controls
				//$('#citymap_canvas .mapboxgl-control-container .mapboxgl-ctrl-top-left').appendTo('.map-frame');
              	$('body').addClass('loaded');
				$('#theMapFrame').append('<input type="hidden" id="map_loaded" />');
              	// make a marker for each feature to add later
              	
              	city_marker1 = new mapboxgl.Marker(el1,{
                    draggable: true
                });
              	
              	city_marker2 = new mapboxgl.Marker(el2,{
                    draggable: true
                });
              	
              	city_marker3 = new mapboxgl.Marker(el3,{
                    draggable: true
                });
              	
              	city_marker4 = new mapboxgl.Marker(el4,{
                    draggable: true
                });
              	
              	city_marker5 = new mapboxgl.Marker(el5,{
                    draggable: true
                });
              	
              	city_marker6 = new mapboxgl.Marker(el6,{
                    draggable: true
                });
              	
              	city_marker7 = new mapboxgl.Marker(el7,{
                    draggable: true
                });
              	
              	city_marker8 = new mapboxgl.Marker(el8,{
                    draggable: true
                });
              	
              
                
                city_marker1.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker2.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker3.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker4.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker5.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker6.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker7.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
                city_marker8.on('dragend', function(e) {
                   console.log('########## drag ###############');
                    onMarkerDragEnd();

                });
                
              
              
                if ($(save_map_markers).val() != "" ) {
                	process_custom_markers_url_param();
                }
              
              	//city_marker1.setLngLat([getlng, getlat]).addTo(cityMap);
				
                //map.loadImage('https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Cat_silhouette.svg/400px-Cat_silhouette.svg.png', function(error, image) {
                    //if (error) throw error;

                    //map.addImage('cat', image);
					/**
                    map.addSource('single-point', {
                        "type": "geojson",
                        "data": {
                            "type": "FeatureCollection",
                            "features": []
                        }
                    });

                    map.addLayer({
                        "id": "point",
                        "source": "single-point",
                        "type": "symbol",
                        "layout": {
                            "icon-image": "simple-house",
                            "icon-size": 0.1
                        }
                    });
                    **/
                    if(init == true){
						
                        //if(set_marker_from_url()){

                        //}
                        //else{
                            //place_marker_from_saved();
                            //set_marker_icon();
                        //}
                      	build_url();
                        init = false;
                      	
                    }
					/**
                    geocoder.on('result', function(ev) {
                        
                        var markerHtml = $('.marker-radio:checked').parents('div').find('.svg-icon-wrap').html();
                        //alert(markerHtml);
                        marker.remove();
                        // create a HTML element for each feature
                        var el = $('<div>').addClass('marker');

                        //place_marker(getlng,getlat);


                        set_latlng_subtitle();
                        setTimeout(function(){
                            check_marker();
                        }, 1000);
                        //alert(ev.result.geometry.coordinates);
                        var markerLngLat = ev.result.geometry.coordinates;
                        var markerLng = '';
                        var markerLat = '';

                        //var markerLngLatArr = markerLngLat.split(',');
                        if (markerLngLat.length >= 2){
                            markerLng = markerLngLat[0];
                            markerLat = markerLngLat[1];
                            place_marker(markerLng,markerLat);
                        }
                        
                    });
                    **/
              		

                //});
              
              	setPaperSize();
            });
            cityMap.on('style.load', function () {
                console.log('---------  style.load ------------');
            	function stylewaiting() {
                  	console.log('---------  style.load Func ------------');
                    if (!cityMap.isStyleLoaded()) {
                      console.log('--------- style.NOT loaded ------------');
                      setTimeout(function() {
                        stylewaiting();
                      }, 50);
                    } else {
                      console.log('--------- style.IS loaded ------------');
                      $('body').append('<div id="url2png-cheese" class="citymapready"></div>');
                      preview_image($('#save_previewDesignUrl').val());
                      update_map_colors_from_dialog();
                      triggerResize();
                    }
              	};
              	stylewaiting();
            });
            //document.getElementById('geocoder').appendChild(geocoder.onAdd(map));


          }
          }
            }

        }
        function setMiniMapColor(){
    		/**
  			if (typeof countryMap === 'object') {
                        var $thisObj = $('input[name=color-scheme]:checked');
                        var minimapland;
                        minimapland = $thisObj.data('land');
                        setmap_style_item('land', 'fill-color', minimapland);
                		$('body').attr('color-scheme',$thisObj.val());
              			console.log('setMiniMapColor ' + minimapland);
            }
            **/
  
		}           
        
        
		$('body').bind('setMiniMMap', function(){
    		setMiniMMap();
		});
                    
                    
        function setMiniMMap(){
            if( $('#countrymap_canvas').length){
            if (typeof countryMap === 'object') {
				changeCountry();
              	setMiniMapColor();
              
            }
            else {
            if ( $('#currentCountry').length && $('#currentCountry').attr('data-iso') != '' ) {  
            $('#countrymap_canvas').html('');
            $('#geocoder').html('');
            //var map_css_class = $('#map_css_class').val();
            var selectedObj = $('#countryDropdown');
            var currentCountryObj = $('#currentCountry');
            var getCountry = selectedObj.val();
            var countryAbbr = currentCountryObj.data('iso'); //$('#countryDropdown').attr('abbr'); 
            var getlat = selectedObj.data('lat');
            var getlng = selectedObj.data('lng');
            var getmstyle = selectedObj.data('mstyle');
            var getzoom = getZoom(selectedObj);
			$('#countrymap_container').attr('iso',countryAbbr);
              //	preserveDrawingBuffer: true,
            at = 'pk.eyJ1IjoiY2hlcmlzaGVkbG9jYXRpb25zIiwiYSI6ImNqZHQzMjY5ajB6Y2oyeHBja2w3OG1jaWUifQ.1ADcEgkY7VANSGkPgsw4tA';
            mapboxgl.accessToken = at;

            countryMap = new mapboxgl.Map({
                container: 'countrymap_canvas',
              
                style: 'mapbox://styles/cherishedlocations/'+getmstyle,
                center: [getlng, getlat],
                zoom: getzoom,
                interactive: false
            });

            // create a HTML element for each feature
            var el = document.createElement('div');
            el.className = 'marker';

            // make a marker for each feature and add to the map
            marker = new mapboxgl.Marker(el);

            countryMap.scrollZoom.disable();

            geocoder = new MapboxGeocoder({
                accessToken: at,
              limit: 10,
                // limit results to Country
                country: countryAbbr
            });

            // After the map style has loaded on the page, add a source layer and default
            // styling for a single point.
            countryMap.on('load', function() {

              	$('body').addClass('loaded');
				$('#theMapFrame').append('<input type="hidden" id="map_loaded" />');
              
              
                setMiniMapColor();

                //map.loadImage('https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Cat_silhouette.svg/400px-Cat_silhouette.svg.png', function(error, image) {
                    //if (error) throw error;

                    //map.addImage('cat', image);
					/**
                    countryMap.addSource('single-point', {
                        "type": "geojson",
                        "data": {
                            "type": "FeatureCollection",
                            "features": []
                        }
                    });

                    countryMap.addLayer({
                        "id": "point",
                        "source": "single-point",
                        "type": "symbol",
                        "layout": {
                            "icon-image": "simple-house",
                            "icon-size": 0.1
                        }
                    });
                    **/
                    if(init == true){
                      
                      
                        //set land color 
                        setMiniMapColor();
                        //setmap_style_item('land', 'fill-outline-color', minimapland); 

                        place_marker_from_saved();
                        set_marker_icon_func();

                      	build_url();
                        init = false;
                      	
                    }

                    geocoder.on('result', function(ev) {
                        /**
                        var markerHtml = $('.marker-radio:checked').parents('div').find('.svg-icon-wrap').html();
                        //alert(markerHtml);
                        marker.remove();
                        // create a HTML element for each feature
                        var el = $('<div>').addClass('marker');

                        //place_marker(getlng,getlat);


                        set_latlng_subtitle();
                        setTimeout(function(){
                            check_marker();
                        }, 1000);
                        //alert(ev.result.geometry.coordinates);
                        var markerLngLat = ev.result.geometry.coordinates;
                        var markerLng = '';
                        var markerLat = '';

                        //var markerLngLatArr = markerLngLat.split(',');
                        if (markerLngLat.length >= 2){
                            markerLng = markerLngLat[0];
                            markerLat = markerLngLat[1];
                            place_marker(markerLng,markerLat);
                        }
                        **/
                    });

                //});
              
              	countryMap.resize();
            });
            countryMap.on('style.load', function () {
              	//console.log('countryMap.on style.load');
              setMiniMapColor();
            });
            //document.getElementById('geocoder').appendChild(geocoder.onAdd(map));


              }
              else{
				console.log('countryMap falied country check');
              }
            }
            }

        }
  
  
  
        if ($('#theMapFrame').length){
            setTimeout(function(){
                //alert('theMapFrame');
                initialise();
            }, 50);
          
            function triggerResize(){
      			var windowWidth = $(window).innerWidth();
                //if(windowWidth > 768 ){
                	$(window).trigger('resize');
                //}
            }
          	$('.main-content__wrapper').click(function(e){
                setTimeout(function(){
                    triggerResize();
                }, 400);
            	
            })
            //setInterval(function(){
      			//triggerResize();
            //}, 4000);
        }
        if($('#country_code_array').length) {
            var country_code_array = JSON.parse("[" + $('#country_code_array').val().replace(/"/g, "").replace(/'/g, '"') + "]");
        }
  
  
  
    
  		/** ---------------------- COUNTRY MAP END -------------------------**/
    
		// disable button if no more results to load
   
        if ($('#collection-slider').length > 0) {
            var Len = $('#collection-slider li').length;
            var Len;
          	var swipe = true;
          	var controlNav = true;
          	var slideshow = true;
            var animationLoop = true;
            if(Len >1){
              swipe = true;
              controlNav = true;
              slideshow = true;
              animationLoop = true;
            }
            else{
              swipe = false;
              controlNav = false;
              slideshow = false;
              animationLoop = false;
            }
            $('#collection-slider').flexslider({
                slideshow: slideshow,
                animationLoop: animationLoop,
                animation: "slide",              //String: Select your animation type, "fade" or "slide"
                smoothHeight: true,
                controlNav: controlNav,
                touch:swipe,
                after: function(slide) {
                    //console.log(slider....);
                }

            });
        }
    
    
    
		if ($('.js-lazyYT').length){
			$('.js-lazyYT').lazyYT('AIzaSyCawA87g_pgTbSNPhiWAemy-mFKszJGl4M');
            $("body").on("click", ".video-action", function(event){
				$(this).parents('.video-outer-wrap').toggleClass('video-playing');
                //alert($(this).parents('.video-slide-inner').find('.ytp-thumbnail').attr('class') + 'found');
                $(this).parents('.video-outer-wrap').find('.ytp-thumbnail').trigger('click');
                return false;
        	});
                      
		}
    

    
    
    
    	//var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
        function isMobile() {
        	var check = false;
        	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(    hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)    0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac    (er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v    )w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-    d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(    m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac(     |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(    k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-|     |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(    ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(    07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(    c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(    gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-    v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))    check = true})(navigator.userAgent||navigator.vendor||window.opera);
        	return check; 
        }
    
       $(".marker-autocomp-form .autocomplete").focus(function(){
         	var width = $(window).innerWidth();
         	console.log('------------ about to check isMobile ------------ ');
         	if(isMobile()){
              	console.log('------------ isMobile ------------ ');
              	var type = 'search-and-go-autocomplete';
              	var target_focusSelector = '#market_autocomplete';
              	if ($(this).is("[search_and_update]")){
              		type = 'local-autocomplete';
                  	var target_focusSelector = '#local_autocomplete';
                }
              	if ($(this).is("[search_and_latlng]")){
              		type = 'marker-autocomplete';
                  	var target_focusSelector = '#marker_autocomplete';
                }
              	//alert($(".marker-autocomp-wrap .animate").length);
            	$('body').removeClass('marker-autocomplete').removeClass('search-and-go-autocomplete').removeClass('local-autocomplete').removeClass('autocomplete-open').addClass('autocomplete-open').addClass(type);
              	$(".marker-autocomp-wrap .animate").each(function() {
            		$(this).addClass('animated');
            	});
              	//$(target_focusSelector).find('[type="search"]').focus();
              	//$('body').scrollTop('0px');
				//$(this).parents('.marker-autocomp-wrap ').removeClass('autocomplete-active').addClass('autocomplete-active');
            }

        });

        
    /**
    .blur(function(){
            if(!isMobile()){
               close_autocomplete();
            }
        });
        **/
    
    	
    
    	$(document).on("click", "[href='#places-autocomplete']", function(e) {
        	var type = 'search-and-go-autocomplete';
          	$('body').removeClass('search-and-go-autocomplete').removeClass('local-autocomplete').removeClass('autocomplete-open').addClass('autocomplete-open').addClass(type);
            $(".marker-autocomp-wrap .animate").each(function() {
            	$(this).addClass('animated');
            });
		  	//$(this).parents('.marker-autocomp-wrap ').removeClass('autocomplete-active').addClass('autocomplete-active');
          	e.preventDefault();
		});  
    
    	$(document).on("click", ".close-autocomp", function(e) {
          	close_autocomplete();
		}); 
  
    
    
    
	var $window = $( window ),
	$body = $( 'body' ),
	$document = $( document ),
	spring = {
		headerFloatingHeight : 60,
	};
    if($('.flag-mell').length){
      	
        
        for (var key in isoCountries) {
            if (isoCountries.hasOwnProperty(key)) {
              if($( '[country="'+isoCountries[key].text+'"]' ).length){
                var iso_code = isoCountries[key].id.toLowerCase();
                $( '[country="'+isoCountries[key].text+'"]' ).prepend('<span class="flag-icon flag-icon-'+ iso_code + '"></span')
                
              }
              //alert(isoCountries[key].id);
              //alert(isoCountries[key].text);
            }
		}
    }

		/* =======================================
		 * WOW JS
		 * =======================================
		 */
		var wow = new WOW({
			mobile : false,
			offset : 60,
		});
		wow.init();
    
    	//$('.parallax-background').dParallax();
    
    
    
    function matched_height(){
        // get test settings
        var byRow = $('body').find('.match-by-row');
		
        // apply matchHeight to each item container's items
        $('.matched-height-container').each(function() {
          	
            $(this).children('.matched-height-item').matchHeight({
                byRow: byRow
            });
        });
    }
    matched_height();
    
    
    
    function truncate_content_block(){
      try {
        if ($('.truncate-me').length) {
            $('.truncate-me').each(function() {
              	var activatelink = 'magnify';
            	var chars = $(this).attr('data-max-characters');
              	chars = parseInt(chars, 10);
                $(this).shorten({
                	showChars: chars,
                    moreText: 'read more',
                  	theHref: '#mfp_popup',
                  	allcontentClass: 'allcontent rte',
                  	activateClass: activatelink,
                    lessText: 'read less'
                });
              
            });
        }
      } catch (err_truncate_content_block) {
      }
    }
  
  	truncate_content_block();
    
    
	$(document).on("click", ".view-content-popup .magnify", function(e) {
		try {
        e.preventDefault();
      	var parentObj = $(this).parents('.view-content-popup');
		var clonedHTML = parentObj.html();
      	var popupContent = parentObj.parents('.grid__item').find('.popup-content').html().replace('##popupcontent##',clonedHTML);
      	//alert(clonedHTML);
		$(this).magnificPopup({
			closeOnContentClick: true,
            items: {
              src: $('<div class="white-popup-block">' + popupContent + '</div>'),
              type: 'inline'
            },
          	src: clonedHTML,
			closeBtnInside: true
		}).magnificPopup('open');
      } catch (contentpopupmagnify) {
      }
	}); 
    
    
	$(document).on("click", ".change-country-btn", function(e) {

	});
    
    
    
    
    
    
    
    
   /** ------------- product tabs ---------------- **/
    
    if($('ul.tabs').length){
       
		$('ul.tabs').each(function(){
      		var active, content, links = $(this).find('a');
      		active = links.first().addClass('active');
      		content = $(active.attr('href'));
      		links.not(':first').each(function () {
        		$($(this).attr('href')).hide();
      		});
      		$(this).find('a').click(function(e){
                active.removeClass('active');
                content.hide();
                active = $(this);
                content = $($(this).attr('href'));
                active.addClass('active');
                content.show();
                return false;
      		});
    	});
	}
    
   /** ------------- product tabs END ---------------- **/  
    
   
    
    
    
    
   /** ------------- country picker ---------------- **/
    
	function formatCountry (country) {
    	 if (!country.id) { return country.text; }
         var $country = $(
                '<span class="flag-icon flag-icon-'+ country.id.toLowerCase() +'"></span>' +
                '<span class="flag-text">'+ country.text+"</span>"
		);
		return $country;
	};
            
	//Assuming you have a select element with name country
	// e.g. <select name="name"></select>
  
          
	$("[name='country']").on('select2:select', function (e) {
		var data = e.params.data;
		if (data.id){
        	var isoid = data.id.toLowerCase()
           	var supported_country_selector = '#country-'+isoid;
            var country_term = data.text + ' ' +  isoid;
            var marker_params = '';
            search_and_go(country_term, marker_params);
		}
	});
    
   /** ------------- country picker END ---------------- **/
    
    
    $(window).resize(function() {
      	matched_height();
      	setSize();
      	//height_fix();
      	//open_all_accordion_section();
    }); 
    
    
    
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    
    var term = "*";
    
    $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();    
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      term = $(this).val();
      var termlength = term.length;
      var searchterm = term.replace(/[\s]+/g, '* ') + "*";
      searchterm = searchterm.replace(/[\*]+/g, '*');
      if (searchterm == "") {
          searchterm = "*";
      }
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + searchterm;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (termlength > 1 && term != $(this).attr('data-old-term')) {
        
        
        
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=city-data', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function(index, item) {
              var link = $('<a></a>').attr('href', item.url);
              link.append('<span class="flag-icon flag-icon-'+item.iso+'"></span>');
              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 10) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
    
    
	/* -------------------------------------------------------- */
	/* ---------------------- currency select ----------------- */
	/* -------------------------------------------------------- */

	$('.search-type-checkbox').on('change', function() {
      	console.log('------------------- search-type-checkbox ------------------------');
	});
                                  
    
	$('.shopify-currency-form select').on('change', function() {
      	console.log($(this).val());
  		$(this).parents('form').submit();
	});
    
	/* -------------------------------------------------------- */
	/* -------------------- currency select END --------------- */
	/* -------------------------------------------------------- */
    
    
	/* -------------------------------------------------------- */
	/* ---------------------- login form ---------------------- */
	/* -------------------------------------------------------- */
  
  
  
  
        $('.cd-form').each(function(key, form) {
        	$(form).validate({
            	onkeyup: false
        	});
      	});
  
  		try {
  		$( ".password-field" ).rules( "add", {
        	required: true,
            minlength: 8,
            mypassword: true
		});
        } catch (err_passwordfield_rules) {}

  
  		try {
  		$.validator.addMethod('mypassword', function(value, element) {
        	return this.optional(element) || (value.match(/[a-zA-Z]/) && value.match(/[0-9]/));
    	},
    	'Password must contain at least one numeric and one alphabetic character.');
        } catch (err_validator_addMethod) {}
  

		//open modal
		/**
		mainNav.on('click', function(event){
			$(event.target).is(mainNav) && mainNav.children('ul').toggleClass('is-visible');
		});
		**/
		//open sign-up form
		$('body').on("click",'.cd-signup',function(event) {
			event.preventDefault();
			signup_selected($('#cdswitcher'));
		});
		//open login-form form
		$('body').on("click",'.cd-signin',function(event) {
			event.preventDefault();
          	//console.log($(this));
			login_selected($('#cdswitcher'));
		});
		//close modal !! but only cd-user-modal not static-cd-user-modal
      	$('body').on('click', '.cd-user-modal', function(event) {
          	var this_formModal = $(this);
			if( $(event.target).is(this_formModal) || $(event.target).is('.cd-close-form') ) {
				this_formModal.removeClass('is-visible');
			}	
		});
		//close modal when clicking the esc keyboard button
		$(document).keyup(function(event){
	    	if(event.which=='27'){
          		try {
	    			formModal.removeClass('is-visible');
          		} catch (errfm1) { }
			}
	    });
        
		//switch from a tab to another
  		$('body').on('click', '.contact-methods-chat-popup', function(event) {
          	try {
          	Tawk_API.toggle();
            } catch (chatpopuperrfm1) { 
            
            }
		});

		//switch from a tab to another
  		$('body').on('click', '.cd-switcher', function(event) {
          	var thisObj = $(this);
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = $(this),
			tabLogin = thisObj.children('li').eq(0).children('a'),
			tabSignup = thisObj.children('li').eq(1).children('a'),
			mainNav = $('.main-nav'); 
          
			event.preventDefault();
			( $(event.target).is( tabLogin ) ) ? login_selected(thisObj) : signup_selected(thisObj);
		});
    
    
  		$('body').on('click', '.site-header__section--button', function(event) {
          	//triggerResize();
		});

		//hide or show password
 		$('body').on('click', '.hide-password', function(event) {
			var togglePass = $(this),
			passwordField = togglePass.prev('input');
          
          	var formModal = togglePass.parents('.usermodal'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formLogin = formModal.find('#cd-login'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
			mainNav = $('.main-nav'); 
          
			
			( 'password' == passwordField.attr('type') ) ? passwordField.attr('type', 'text') : passwordField.attr('type', 'password');
			( 'Hide' == togglePass.text() ) ? togglePass.text('Show') : togglePass.text('Hide');
			//focus and move cursor to the end of input field
			passwordField.putCursorAtEnd();
		});

		//show forgot-password form 
  		$('body').on('click', '.cd-form-forgot-pw', function(event) {
			event.preventDefault();
			forgot_password_selected($(this));
		});

		//back to login from the forgot-password form
  		$('body').on('click', '.cd-form-back-to-login', function(event) {
			event.preventDefault();
			login_selected($(this));
		});

		function login_selected(thisObj){
			/**mainNav.children('ul').removeClass('is-visible');**/
          	var formModal = thisObj.parents('.usermodal');
            var cdswitcher = formModal.find('.cd-switcher');
            var resetPassword = formModal.find('#cd-reset-password-submit');
			var formLogin = formModal.find('#cd-login');
			var formSignup = formModal.find('#cd-signup');
			var formForgotPassword = formModal.find('#cd-reset-password');
			var formModalTab = formModal.find('.cd-switcher');
			var tabLogin = formModalTab.children('li').eq(0).children('a');
			var tabSignup = formModalTab.children('li').eq(1).children('a');      
          
			//console.log('----login_selected---------');
			formModal.addClass('is-visible');
          
			formLogin.addClass('is-selected');
          	cdswitcher.addClass('is-selected');
          	resetPassword.removeClass('is-selected');
			formSignup.removeClass('is-selected');
			formForgotPassword.removeClass('is-selected');
			tabLogin.addClass('selected');
			tabSignup.removeClass('selected');
		}

		function signup_selected(thisObj){
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
                
			mainNav = $('.main-nav'); 
          
			/**mainNav.children('ul').removeClass('is-visible');**/
			//console.log('signup_selected');
          	cdswitcher.addClass('is-selected');
			formModal.addClass('is-visible');
          	resetPassword.removeClass('is-selected');
			formLogin.removeClass('is-selected');
			formSignup.addClass('is-selected');
			formForgotPassword.removeClass('is-selected');
			tabLogin.removeClass('selected');
			tabSignup.addClass('selected');
		}

		function forgot_password_selected(thisObj){
          	//console.log('--------- forgot pw -----');
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
                
			mainNav = $('.main-nav'); 
          
			formLogin.removeClass('is-selected');
          	cdswitcher.addClass('is-selected');
          	resetPassword.removeClass('is-selected');
			formSignup.removeClass('is-selected');
			formForgotPassword.addClass('is-selected');
		}

		//REMOVE THIS - it's just to show error messages 
  		/**
		formLogin.find('input[type="submit"]').on('click', function(event){
			event.preventDefault();
			formLogin.find('input[type="email"]').toggleClass('has-error').next('span').toggleClass('is-visible');
		});
		formSignup.find('input[type="submit"]').on('click', function(event){
			event.preventDefault();
			formSignup.find('input[type="email"]').toggleClass('has-error').next('span').toggleClass('is-visible');
		});
        **/


		//IE9 placeholder fallback
		//credits http://www.hagenburger.net/BLOG/HTML5-Input-Placeholder-Fix-With-jQuery.html
		/**
		if(!Modernizr.input.placeholder){
			$('[placeholder]').focus(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
			  	}
			}).blur(function() {
			 	var input = $(this);
			  	if (input.val() == '' || input.val() == input.attr('placeholder')) {
					input.val(input.attr('placeholder'));
			  	}
			}).blur();
			$('[placeholder]').parents('form').submit(function() {
			  	$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
				 		input.val('');
					}
			  	})
			});
		}
		**/
  

        $('body').on('change', '#customer-heade-nav', function(event) {
            //console.log('change type selector----------------');
            if ($(this).val() != '') {
                location.href = $(this).val();
            }
        }); 
  
  
		/* -------------------------------------------------------- */
		/* ---------------------- login form END ------------------ */
		/* -------------------------------------------------------- */  
    
    
	setTimeout(function(){
      
      
    	$("head link[rel='stylesheet']").last().after("<link rel='stylesheet' href='//mapsoftheworld.io/cdn/shop/t/77/assets/fonts.css?v=160501534986905909901701081081' type='text/css' media='screen'>");
        $("head link[rel='stylesheet']").last().after("<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Lato|Lobster|Montserrat|Muli|Open+Sans|Oxygen|PT+Sans|Pacifico|Raleway|Roboto|Source+Sans+Pro' type='text/css' media='screen'>");
        $("head link[rel='stylesheet']").last().after("<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Crimson+Text|Libre+Baskerville|Lora|Merriweather|Noto+Serif|PT+Serif|Playfair+Display|Source+Serif+Pro|Vollkorn' type='text/css' media='screen'>");
 
      
	}, 1000);
    
   
 
    

 

    
   /** ------------------ FIX 100vh on mobile --------------- **/ 
    
    
    
    function height_fix(){
      	//console.log('----------------------- height_fix -----------------------');
      	var windowWidth = $(window).innerWidth();
  		var viewportHeight = $(window).innerHeight();
      
      	var productContentWrap = $('.product-content-wrap').innerHeight();
      	var productHeaderHeight = $('#productpage_head').innerHeight();
      	var productOuterHeight = $('#for_productCoverBackground').innerHeight();
      	var productInnerHeight = $('#for_contentlayout').innerHeight();
      	var buyButtonInnerHeight = $('#product_preview_buttons .buy-button-wrap').innerHeight();
      	var editButtonInnerHeight = $('#product_preview_buttons .show-customise-options').innerHeight(); 
      	var editbuttonFix = 0;
      	var productOffset = 0;
      	var buttonsHeight = 0;
      
        //console.log('productHeaderHeight = '+ productHeaderHeight);
      	//productOuterHeight = productOuterHeight - productHeaderHeight;
      
      	productOffset = (productOuterHeight - productInnerHeight) / 2;
      	//console.log('productOffset = '+ productOffset);
      
      	productOuterHeight = productOuterHeight - productOffset;
      	//console.log('productOuterHeight = '+ productOuterHeight);
      
      	buttonsHeight = buyButtonInnerHeight + editButtonInnerHeight;
        //console.log('buttons height = '+ buttonsHeight + ' ('+buyButtonInnerHeight+' + '+editButtonInnerHeight+')');
      
      	editbuttonFix = productContentWrap - (buttonsHeight + productOuterHeight);
		//console.log('remaining height = '+ editbuttonFix);
      	editbuttonFix = editbuttonFix / 2;
      
      	$('#product_preview_buttons .show-customise-options').css('margin-bottom',editbuttonFix+'px');
      
		$('.viewheight-fix').each(function() {
                var offset = 0;
                if(windowWidth < 769 ){
                    if ($(this).is("[data-mobile-heightoffset]")){
                        offset = parseInt($(this).data('mobile-heightoffset'), 10);
                    }
                    viewportHeight = viewportHeight - offset;
                }
                else{
                  	//alert('auto');
                    if ($(this).is("[data-heightoffset]")){
                        offset = $(this).data('heightoffset');
                        if (offset == 'auto'){
                      
							viewportHeight = 'auto';
                        }
                        else {
                          	offset = parseInt(offset, 10);
                            viewportHeight = 'calc(100vh - ' + offset + 'px)';
                        }
                    }
                }
                $(this).css({ height: viewportHeight });

		});
      	//console.log('----------------------- height_fix END -----------------------');
      
	}
    
    height_fix();
    



		/* -------------------------------------------------------- */
		/* ---------------------- FRAMES AND SIZING --------------- */
		/* -------------------------------------------------------- */  

	var realWidth = '';

	var realHeight = '';
	var window_scale = 1;
	var window_zoomscale = 1;
    function setPaperSize(force_zoom){
		var size = 'size 4';
		var $preview_mode = false;
		if ($('#preview_mode').length) {
			$preview_mode = $('#preview_mode');
		}
		if($('#size').length){
			var sizeArr = [];
			sizeArr = $('#size').val().split(':');
            sizeArr[0] = typeof sizeArr[0] !== 'undefined' ? sizeArr[0] : 'size 1';
           	size = sizeArr[0].trim().toLowerCase();
		}
      	//console.log('#### size = ' + size +' -----');
		var container_selector = '.featured-slider__cover-background';
		if($('#measurement_container').length){
			if ($('#measurement_container').val() != ''){
                  container_selector = $('#measurement_container').val();
			}
		}
      	var orientation = get_orientation();
		var windowWidth = (Math.round(( parseFloat($(container_selector).innerWidth()) * 100))/100);
		var windowHeight = (Math.round(( parseFloat($(container_selector).innerHeight()) * 100))/100);
		var bufferh = 100;
      	console.log('#2623 windowHeight = ' + windowHeight+' *******************');
		var bufferw = 60;
		if (windowWidth < 800) {
              bufferh = 20;
              bufferw = 20;
		}
      	if(orientation == 'landscape'){
          
            bufferw = 80;
          	bufferh = 80;
            if (windowWidth < 800) {
                  bufferh = 30;
                  bufferw = 30;
            }
          
			windowWidth = windowWidth * 0.8;
			windowHeight =  windowHeight * 0.8;
          //console.log('#2642 windowHeight = ' + windowHeight+' **');
          
        }
        if($('#thumbnail_mode').length){
        	bufferh = 0;
            bufferw = 0;
        }
		if ($preview_mode.length) {
			if ((typeof $preview_mode.data('bufferh') !== 'undefined') && (typeof $preview_mode.data('bufferw') !== 'undefined')){
				bufferh = $preview_mode.data('bufferh');
              	bufferw = $preview_mode.data('bufferw');
			}
		}
		windowWidth = windowWidth - bufferw;
		windowHeight = windowHeight - bufferh;
      	//console.log('#2653 windowHeight = ' + windowHeight+' (bufferh = '+bufferh+') **');
          var paperWidth, 
          hasMount,
          hasFrame,
          paperHeight, 
          woodWidth,
          mountWidth, 
          woodWidth2,
          mountWidth2, 
          mountOffset,
          mountOffset2,
          mountMargin,
          mountMargin2,
          mapWidth,
          mapHeight,
          mapHeightPercent,
          fontSize,
          outerFrameWidth,
          outerFrameHeight,
          scaleWidth,
          scaleHeight,
          scale,
          borderWidth,
          borderWidth2,
          borderMargin,
          borderMargin2,
          countentLayout,
          outerFrameWidth2,
          outerFrameHeight2,
          imageInnerWidth,
          imageInnerHeight,
          imageInnerMargin,
          printonlyWidth,
          printonlyHeight,
          framedwithoutmountWidth,
          framedwithoutmountHeight,
          framedwithmountWidth,
          framedwithmountHeight;

          var mmpx_scale = 3.7795275590551;
      	  var mmpx_scale_orig = mmpx_scale;
      	  var mmpx_increase = 1;
          hasMount = set_mount();
      	  hasFrame = set_frame();
          countentLayout = get_countentLayout();
          fontSize = 28;
          woodWidth = 20;
          mountMargin = woodWidth * 0.80;
		switch(size) {     
              case 'size 1':
                  paperWidth  = (Math.round(( parseFloat(279.4) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(355.6) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(33.1) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(3307) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(4200) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(3307) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(4200) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(2625) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(3525) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 24.5;
                  borderWidth = 1.9;
                  borderMargin = 8;
                  woodWidth = 18;
              	  mountMargin = woodWidth * 0.65;
            
                  break;
            
              case 'size 2':
                  paperWidth  = (Math.round(( parseFloat(406.4) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(508) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(4800) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(6000) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(4875) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(6075) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(3676) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(4876) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 36.5;
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size 3':
                  paperWidth  = (Math.round(( parseFloat(457.2) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(609.6) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(5401) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(7201) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(5401) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(7201) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(4276) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(6076) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 42.5;
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size 4':
                  paperWidth  = (Math.round(( parseFloat(508) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(711.2) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(6000) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(8400) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(6000) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(8400) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(4876) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(7276) * 100))/100);
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 44;
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size 5':
                  paperWidth  = (Math.round(( parseFloat(609.6) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(914.4) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(7200) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(10800) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(7275) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(10875) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(6075) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(9675) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 60;
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size 6':
                  paperWidth  = (Math.round(( parseFloat(711.2) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(1016) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(8475) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(12075) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(8475) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(12075) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(7276) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(10876) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = 69;
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size a0':
                  paperWidth  = (Math.round(( parseFloat(840.74) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(1188.72) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(9900) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(14100) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(9900) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(14100) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(9900) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(14100) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(75) * 100))/100);
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size a1':
                  paperWidth  = (Math.round(( parseFloat(594.36) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(840.74) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(7021) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(9931) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(7021) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(9931) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(7021) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(9931) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(54) * 100))/100);
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size a2':
                  paperWidth  = (Math.round(( parseFloat(419.1) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(594.36) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(4960) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(7015) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(4960) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(7015) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(4960) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(7015) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(40.5) * 100))/100);
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size a3':
                  paperWidth  = (Math.round(( parseFloat(297.18) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(419.1) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(3511) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(4951) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(3511) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(4951) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(3511) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(4951) * 100))/100); 
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(27) * 100))/100);
                  borderWidth = 2.5;
                  borderMargin = 8;
            
                  break;
              case 'size a4':
                  paperWidth  = (Math.round(( parseFloat(210.82) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(297.18) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(38.1) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(2491) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(3511) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(2491) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(3511) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(2491) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(3511) * 100))/100);
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(19) * 100))/100);
                  borderWidth = 1.5;
                  borderMargin = 4;
            	  mountMargin = woodWidth * 0.55;
                  break;
              
              default:
                  paperWidth  = (Math.round(( parseFloat(508) * 100))/100);
                  paperHeight = (Math.round(( parseFloat(711.2) * 100))/100);
                  mountWidth  = (Math.round(( parseFloat(50.8) * 100))/100);
              
                  printonlyWidth  = (Math.round(( parseFloat(6000) * 100))/100);
                  printonlyHeight = (Math.round(( parseFloat(8400) * 100))/100);
                  framedwithoutmountWidth  = (Math.round(( parseFloat(6000) * 100))/100);
                  framedwithoutmountHeight = (Math.round(( parseFloat(8400) * 100))/100);
                  framedwithmountWidth  = (Math.round(( parseFloat(4876) * 100))/100);
                  framedwithmountHeight = (Math.round(( parseFloat(7276) * 100))/100);
              
                  mapHeightPercent  = (Math.round(( parseFloat(0) * 100))/100);
                  fontSize = (Math.round(( parseFloat(27) * 100))/100);
                  borderWidth = 2.5;
                  borderMargin = 8;    
            
                  break;
         
		}
      	//console.log('#2761 size = ' + size+' mountWidth = ' + mountWidth);
        
        if (size.split(' ')[1].toLowerCase().startsWith('a')){
        $('#frame-options').addClass('disabled');
          } else {
        $('#frame-options').removeClass('disabled');
        }
      
      	var frameObj = $('#theMapFrame');
      	var frameInnerObj = $('#theMapInner');
      	var mountObj = $('#theMount');
      	var paperObj = $('#thePaper');
      	var imageObj = $('#theImage');
      	var imageInnerObj = $('#theImageInner');
      	var countryMapObj = $('#countrymap_canvas');
      	var cityMapObj = $('#citymap_canvas');
      	var countrymap_container = '#countrymap_container'; 
      
      	var store_paperWidth = paperWidth;
        var store_paperHeight = paperHeight;
      	//console.log('orientation =' + orientation);
      	if(orientation == 'landscape'){
            paperWidth = store_paperHeight;
            paperHeight = store_paperWidth;
          	fontSize = fontSize * 0.8;
          /**
          	if ($preview_mode.length) {
            
            }
          else {
            fontSize = fontSize * 0.8;
          }
          **/
          console.log('ratio 1: '+paperWidth/paperHeight);
        }
      	
        if ($preview_mode.length) {
          
          console.log('ratio 2: '+paperWidth/paperHeight);
          	
          	if (typeof $preview_mode.data('mountproduction') !== 'undefined'){
				/**
              	// fix mount for production
              	var productionpaperWidth = paperWidth - ( mountWidth * 2 );
              	var productionpaperHeight = paperHeight - ( mountWidth * 2 );
              	var productionfontscale = productionpaperWidth / paperWidth;
              	//adjust the font size
              	fontSize = fontSize * productionfontscale;
              	fontSize = (Math.round(( parseFloat(fontSize) * 100))/100);
              	hasMount = 'nomount';
              	// minus mount with from design for production
              	paperWidth = productionpaperWidth;
                paperHeight = productionpaperHeight;
**/
              
              	hasMount = 'nomount';
            }
          console.log('ratio 3: '+paperWidth/paperHeight);
        }
        

		var saveWoodWidth = woodWidth;
      
        if ($preview_mode.length) {
                    console.log('ratio 4: '+paperWidth/paperHeight);
        	if ((typeof $preview_mode.data('paperwidth') !== 'undefined') && (typeof $preview_mode.data('paperheight') !== 'undefined')){
               
                 paperWidth = (Math.round(( parseFloat($preview_mode.data('paperwidth')) * 100))/100);
                 paperHeight = (Math.round(( parseFloat($preview_mode.data('paperheight')) * 100))/100);
              	 //console.log('paperWidth '+paperWidth+' | paperHeight '+paperHeight);
                 if (typeof $preview_mode.data('paperwidth') !== 'undefined') {
                 	//fontSize = (Math.round(( parseFloat($preview_mode.data('fontsize')) * 100))/100);
                 }
        	}
        	if (typeof $preview_mode.data('woodwidth') !== 'undefined'){
               //console.log('woodwidth = '+$preview_mode.data('woodwidth'));
                 woodWidth = (Math.round(( parseFloat($preview_mode.data('woodwidth')) * 100))/100);
              	//console.log('woodwidth = '+woodWidth);
              	 mountMargin = woodWidth;
              	//console.log('mountMargin = '+mountMargin);
        	}
            console.log('ratio 5: '+paperWidth/paperHeight);
          
        } 
      
      
      
          if ($preview_mode.length) {
                      console.log('ratio 6: '+paperWidth/paperHeight);
              if (typeof $preview_mode.data('mmpx') !== 'undefined'){
                //console.log('#2822 mmpx undefined');
                
                	mmpx_scale = Number($preview_mode.data('mmpx'));
                	mmpx_increase = mmpx_scale / mmpx_scale_orig;
                	fontSize = fontSize * mmpx_increase;
                	//console.log('mmpx condition ---- fontSize = ' + fontSize + ' | mmpx_scale = ' + mmpx_scale + ' | mmpx_increase = '+mmpx_increase);
                
              }
              console.log('ratio 7: '+paperWidth/paperHeight);
          }
      
      
        if ($preview_mode.length) {
                    console.log('ratio 8: '+paperWidth/paperHeight);
          	if (typeof $preview_mode.data('noframe') !== 'undefined') {
				hasFrame = 'noframe';
           		woodWidth = 0;
            }
          	if (typeof $preview_mode.data('nomount') !== 'undefined') {
           		hasMount = 'nomount';
           		borderMargin = 0;
           		mountMargin = 0;
            }
                    console.log('ratio 9: '+paperWidth/paperHeight);
        }
      

		//console.log( 'paperWidth = ' + paperWidth + 'mm | paperHeight = ' + paperHeight + 'mm |  mountWidth = ' + mountWidth + 'mm |  woodWidth = ' +  woodWidth + 'mm');    
      
        paperWidth  = (Math.round(( (paperWidth * mmpx_scale) * 100))/100);
        paperHeight = (Math.round(( (paperHeight * mmpx_scale) * 100))/100);
        woodWidth   = (Math.round(( (woodWidth * mmpx_scale) * 100))/100);
        mountWidth  = (Math.round(( (mountWidth * mmpx_scale) * 100))/100);
        mountMargin = (Math.round(( (mountMargin * mmpx_scale) * 100))/100);
        saveWoodWidth = (Math.round(( (saveWoodWidth * mmpx_scale) * 100))/100);
      
      	//console.log('#2854 mountWidth = ' + mountWidth+' mmpx_scale = ' + mmpx_scale);
      
      
		if ($preview_mode.length) {
			if ((typeof $preview_mode.data('forcewidth') !== 'undefined') && (typeof $preview_mode.data('forceheight') !== 'undefined')) {
                //console.log('#2822 mmpx undefined');
                        console.log('ratio 10: '+paperWidth/paperHeight);
                mmpx_scale_orig = mmpx_scale;

				var mmpx_scale = Number($preview_mode.data('forcewidth')) / paperWidth;

                paperWidth  = (Math.round(( ($preview_mode.data('forcewidth')) * 100))/100);
                paperHeight = (Math.round(( ($preview_mode.data('forceheight')) * 100))/100);
                var store_paperWidth = paperWidth;
                var store_paperHeight = paperHeight;
                //console.log('orientation =' + orientation);
                if(orientation == 'landscape'){
                    paperWidth = store_paperHeight;
                    paperHeight = store_paperWidth;

                }
              
              
              
                woodWidth   = (Math.round(( (woodWidth * mmpx_scale) * 100))/100);
                mountWidth  = (Math.round(( (mountWidth * mmpx_scale) * 100))/100);
                mountMargin = (Math.round(( (mountMargin * mmpx_scale) * 100))/100);
                saveWoodWidth = (Math.round(( (saveWoodWidth * mmpx_scale) * 100))/100);
              
                	fontSize = fontSize * mmpx_scale;
              
                          console.log('ratio 11: '+paperWidth/paperHeight);
			}
		}
      
        if ($preview_mode.length) {
          
            if (typeof $preview_mode.data('marginoveride') !== 'undefined'){
              
                mountMargin = 0;

            }
        } 
      
      
        mountOffset = mountWidth - mountMargin;
      
        if (hasMount == 'nomount'){
         	$('#theMount').hide();
        }
      	else{
        	$('#theMount').show();
      	}
        if (countentLayout == 'border'){
        	borderWidth = borderWidth * mmpx_scale;
       		borderMargin = borderMargin * mmpx_scale;
          	borderWidth2 = borderWidth * 2;
          	borderMargin2 = borderMargin * 2;
        }
        else{
        	borderWidth = 0;
       		borderMargin = 0;
          	borderWidth2 = 0;
          	borderMargin2 = 0;
        }
      	//console.log('paperWidth '+paperWidth+' | paperHeight '+paperHeight);
      	woodWidth2 = woodWidth * 2;
      	mountWidth2 = mountWidth * 2;
      	//alert(woodWidth2);
      
     	//console.log('#2879 woodWidth2 = ' + woodWidth2+' mountWidth2 = ' + mountWidth2);    
      
        outerFrameWidth = (Math.round(( (paperWidth + woodWidth2) * 100))/100);
      	var outerFrameWidthThin = (Math.round(( (paperWidth + woodWidth2 + mountWidth2) * 100))/100);
      	outerFrameHeight = (Math.round(( (paperHeight + woodWidth2) * 100))/100);
		var outerFrameHeightThin = (Math.round(( (paperHeight + woodWidth2 + mountWidth2) * 100))/100);
      
      	//console.log( 'PAGE: windowWidth = ' + windowWidth + 'px | windowHeight = ' + windowHeight + 'px');   
      	//console.log( 'PRODUCT: outerFrameWidth = ' + outerFrameWidth + 'px | outerFrameHeight = ' + outerFrameHeight + 'px');       
      	//console.log('#2885 outerFrameHeight = ' + outerFrameHeight+' outerFrameWidth = ' + outerFrameWidth);
      	//console.log('#2885 outerFrameHeightThin = ' + outerFrameHeightThin+' outerFrameWidthThin = ' + outerFrameWidthThin);

      	        scaleWidth  = (Math.floor(( (windowWidth / outerFrameWidth) * 1000))/1000); 
      	var scaleWidthThin  = (Math.floor(( (windowWidth / outerFrameWidthThin) * 1000))/1000);
      	        scaleHeight = (Math.floor(( (windowHeight / outerFrameHeight) * 1000))/1000);
      	var scaleHeightThin = (Math.floor(( (windowHeight / outerFrameHeightThin) * 1000))/1000); 
        //console.log('#2885 windowHeight = ' + windowHeight+' outerFrameHeightThin = ' + outerFrameHeightThin+' **');
      
      
      	scale = 1;
      	var scaleThin = 1;

      	var testheight = paperHeight;
      
        //console.log('#2911 scaleHeightThin = ' + scaleHeightThin+' scaleWidthThin = ' + scaleWidthThin+' **');
      
        //caculate scale
        if (scaleHeight > scaleWidth){
			scale = scaleWidth;
        }
        else {
			scale = scaleHeight;	
        }
      	//fix scale for preview viwes
        if ($preview_mode.length) {
                    console.log('ratio 12: '+paperWidth/paperHeight);
          	if ((typeof $preview_mode.data('scale') !== 'undefined') && ($preview_mode.data('scale') == 'none')){
              
            	scale = 1;
              
            }
            else{
				scale = $preview_mode.data('scale');

            }
                    console.log('ratio 13: '+paperWidth/paperHeight);
        }

      	//console.log('#2913 scaleHeight = ' + scaleHeight+' scaleWidth = ' + scaleWidth+' **');
      
      	//Thinner scale to adjust font when image has mount
        if (scaleHeightThin > scaleWidthThin){
			scaleThin = scaleWidthThin;
        }
        else {
			scaleThin = scaleHeightThin;	
        }
      
      
      	//fix scale for thumbnail viwe
        if($('#thumbnail_mode').length){
          	if ($('#thumbnail_mode').is("[data-scale]")){
                if($('#thumbnail_mode').data('scale') == 'auto'){
				
                }
              	else {
          			scale = $('#thumbnail_mode').data('scale');
                }
            }
          	else {
            	scale = 0.4;
          	}
        }   
      
      
      	//console.log('#2920 scaleThin = ' + scaleThin);
        //if (scale >= 1) { scale = 1; }
      
           if (hasFrame == 'noframe'){
             woodWidth = 0;
             woodWidth2 = 0;
          }
      	
      
        //console.log( 'Scale: scaleWidth = ' + scaleWidth + ' |  scaleHeight = ' +  scaleHeight + ' | SCALE = ' +  scale);  
      	//var cityFixedWidth = paperWidth;
      	//var cityFixedHeight = paperHeight;
      
      	var paperWidth_woodWidth2 = (paperWidth + woodWidth2);
        var paperHeight_woodWidth2 = (paperHeight + woodWidth2);
      	frameObj.data('width', paperWidth_woodWidth2).data("height", paperHeight_woodWidth2);
      
      
        paperWidth =  (Math.round(( (paperWidth * scale) * 100))/100);
        paperHeight =  (Math.round(( (paperHeight * scale) * 100))/100);
        woodWidth =  (Math.round(( (woodWidth * scale) * 100))/100);
        mountWidth = (Math.round(( (mountWidth * scale) * 100))/100);
      	woodWidth2 =  (Math.round(( (woodWidth2 * scale) * 100))/100);
      	mountWidth2 =  (Math.round(( (mountWidth2 * scale) * 100))/100);
      
      	saveWoodWidth = (Math.round(( (saveWoodWidth * scale) * 100))/100);
      
        mountOffset = (Math.round(( (mountOffset * scale) * 100))/100);
        mountMargin = (Math.round(( (mountMargin * scale) * 100))/100);

        outerFrameWidth2 = (Math.round(( (paperWidth + woodWidth2) * 100))/100);
      	outerFrameHeight2 = (Math.round(( (paperHeight + woodWidth2) * 100))/100);
      
       	borderWidth = (Math.round(( (borderWidth * scale) * 100))/100);
       	borderMargin = (Math.round(( (borderMargin * scale) * 100))/100);
        borderWidth2 = (Math.round(( (borderWidth2 * scale) * 100))/100);
        borderMargin2 = (Math.round(( (borderMargin2 * scale) * 100))/100);
      
           if (hasFrame == 'noframe'){
              woodWidth = 0;
              woodWidth2 = 0;
          }
      
      
      	var newtestheight = paperHeight;
      
      	//console.log( 'New PRODUCT: outerFrameWidth2 = ' + outerFrameWidth2 + 'px | outerFrameHeight2 = ' + outerFrameHeight2 + 'px');   
      
      	mountOffset2 = mountOffset * 2;
      	mountMargin2 = mountMargin * 2;
     
      	//console.log('#2975 fontSize = ' + fontSize + ' scale = '+ scale); 
      	if (hasMount == 'nomount'){
           
            imageInnerWidth = paperWidth - mountMargin2;
            imageInnerHeight = paperHeight - mountMargin2;
            imageInnerMargin = 0;
          	//console.log('scale = ' + scale);
            fontSize = fontSize * scale;
      	}
      	else{
            imageInnerWidth = paperWidth - mountWidth2;
            imageInnerHeight = paperHeight - mountWidth2;
            imageInnerMargin = mountOffset;
          	//console.log('scaleThin = ' + scaleThin);
          	fontSize = fontSize * scaleThin;
            //console.log('#2992 fontSize = ' + fontSize + '| scaleThin = '+scaleThin); 
      	}
      	paperObj.css('font-size',fontSize+'px');

      	//frameObj.attr('class','').addClass('size-'+size);
      	var using_mountWidth = mountWidth;
      	var using_mountWidth2 = using_mountWidth * 2;
      
		if ($preview_mode.length) {
                    console.log('ratio 14: '+paperWidth/paperHeight);
              if (typeof $preview_mode.data('fakemountwidth') !== 'undefined'){
              	var fakemountwidth = Number($preview_mode.data('fakemountwidth'));
				fakemountwidth = fakemountwidth * mmpx_increase;
                using_mountWidth = fakemountwidth;
                using_mountWidth2 = fakemountwidth * 2;
                paperWidth = paperWidth + using_mountWidth2;
                paperHeight = paperHeight + using_mountWidth2;
                imageInnerWidth =  paperWidth - using_mountWidth2;
                imageInnerHeight = paperHeight - using_mountWidth2;
                imageInnerMargin = using_mountWidth;
              }
          
          console.log('ratio 15: '+paperWidth/paperHeight);
		}
      
      	var imageObjWidth = paperWidth - mountMargin2;
      	var imageObjHeight = paperHeight - mountMargin2;
      
      	//fix scale for thumbnail viwe
        if($('#thumbnail_mode').length){
          	var htmlwidth = paperWidth + woodWidth2;
          	var htmlheight = paperHeight + woodWidth2;
            if ($('#thumbnail_mode').is("[data-outerwidth]") && $('#thumbnail_mode').is("[data-outerheight]") ){
          		htmlwidth = $('#thumbnail_mode').data('outerwidth');
          		htmlheight = $('#thumbnail_mode').data('outerheight');	
            }
          	$('html').css({"width": (htmlwidth), "height": (htmlheight)});
        } 
      	frameObj.css({"width": (paperWidth + woodWidth2), "height": (paperHeight + woodWidth2)});
      	frameInnerObj.css({"width": paperWidth, "height": paperHeight,"margin": woodWidth});
      	paperObj.css({"width": paperWidth, "height": paperHeight});
     	imageObj.css({"width": imageObjWidth, "height": imageObjHeight,"margin": mountMargin});
      	mountObj.css({"width": imageInnerWidth, "height": imageInnerHeight,"margin": using_mountWidth});
      
      	//make adjustments to image inner for borders etc
      	imageInnerWidth = imageInnerWidth - borderMargin2;
      	imageInnerHeight = imageInnerHeight - borderMargin2;
      	imageInnerMargin = imageInnerMargin + borderMargin;

      	imageInnerObj.css({"width": ( imageInnerWidth ), "height": ( imageInnerHeight ),"margin": imageInnerMargin});
      
      	if (countentLayout == 'border'){
          
          	imageInnerObj.css({"border-color": "#ffffff", "border-width":borderWidth+"px", "border-style":"solid"});

        }
      	else{
          
        	imageInnerObj.css({"border-color": "#ffffff", "border-width":"0px", "border-style":"solid"});

      	}
      
      	//alert(scale);
      	//alert(fontSize);

      
      	//history.pushState({url: url}, title, url);
      	//current height width ratio
      
      
      	/** -------------------------------- set map size -------------------------------- **/
      
      
      
      	var countryFixedWidth = 500;
      	var countryFixedHeight = countryFixedWidth;
      
      
      	var countrymap_container_width = (Math.round(( parseFloat($(countrymap_container).innerWidth()) * 100))/100);
      	var countrymap_container_height = (Math.round(( parseFloat($(countrymap_container).innerHeight()) * 100))/100);
      
      	var countryMapScale = countrymap_container_width / countryFixedWidth;
     
      
      
        var aspectRatio = imageObjHeight / imageObjWidth;
      	var cityFixedWidth = 1600;
      
      	if(orientation == 'landscape'){
          	cityFixedWidth = 2000;
                        if ($preview_mode.length) {
							//cityFixedWidth = 4000;
        				}
        }
      
        if ($preview_mode.length) {
          	console.log('ratio 17: '+paperWidth/paperHeight);
          	if (typeof $preview_mode.data('fullcanvas') !== 'undefined'){
          		//alert('mmpx_increase = '+mmpx_increase);
              	/** nick **/
              	if ($preview_mode.data('fixedwidth') == 'auto'){
					cityFixedWidth = imageObjWidth;
                }
                else {
					cityFixedWidth = $preview_mode.data('fixedwidth');
                }
               
            }
          console.log('ratio 18: '+paperWidth/paperHeight);

        }
      
  		var pixel_instance_set_paper = $.fn.deviceDetector;
  		//console.log('You are using ' + pixel_instance.getBrowserName() +' on ' + pixel_instance.getOsName());
      
      	if(windowWidth < 769 ){
          
          if($('#thumbnail_mode').length){
          		var thedevice = $('#thumbnail_mode').data('device');
                if(thedevice == 'mobile'){
					cityFixedWidth = 1000;  
                }
          } else if (pixel_instance_set_paper.isMobile()) {
        		cityFixedWidth = 1000;  
          }
        }
      	var cityFixedHeight = Math.round(cityFixedWidth * aspectRatio);
        var cityMapScale  = (Math.floor(( (   (imageObjWidth - borderWidth2) / cityFixedWidth  ) * 1000))/1000);
      	var scaleorzoom = 'scale';
      	if(windowWidth < 769 ){
    		var ua = navigator.userAgent;
			/**
    		if (/Android/i.test(ua)) {

              	if(/Chrome/i.test(ua)){
                  	//scaleorzoom = 'zoom';
                  	
                  	cityFixedHeight = Math.round(2300 * aspectRatio);
                  	cityFixedWidth = cityFixedHeight;
                    cityMapScale  = (Math.floor(( (   (imageObjHeight - borderWidth2) / cityFixedHeight  ) * 1000))/1000);
                    
              	}
         	}
            **/
        }

        if ($preview_mode.length) {
          console.log('cityMapScale: '+cityMapScale);
          	if ((typeof $preview_mode.data('scale') !== 'undefined') && ($preview_mode.data('scale') == 'none')){
              /** nick **/
              if ($preview_mode.data('fixedwidth') == 'auto'){
                  	var cityFixedWidth = imageObjWidth;
              		var cityFixedHeight = imageObjHeight;
              }
              
            }
          console.log('ratio 20: '+paperWidth/paperHeight);
        }
      
      
      	var adjustedmapHeightPercent = 1;
		/**
      	if (mapHeightPercent > 0) {
          	adjustedmapHeightPercent = mapHeightPercent + 100;
          	adjustedmapHeightPercent = adjustedmapHeightPercent / 100;
          	fixedHeight = fixedHeight * adjustedmapHeightPercent;
        }**/
      

      	countryMapObj.css({"width": countryFixedWidth, "height": countryFixedHeight });
        // city map height
      	cityMapObj.css({"width": cityFixedWidth, "height": cityFixedHeight });
      	//console.log(aspectRatio);
      
      
      	var countryOffsetFixedWidth = countrymap_container_width - countryFixedWidth;
      	countryOffsetFixedWidth = countryOffsetFixedWidth / 2;
      	var cityOffsetFixedWidth = (imageObjWidth - borderWidth2) - cityFixedWidth;
      	cityOffsetFixedWidth = cityOffsetFixedWidth / 2;
        
      	var countryOffsetFixedHeight = countryOffsetFixedWidth;
      	var cityOffsetFixedHeight = (imageObjHeight - borderWidth2) - cityFixedHeight;
      	cityOffsetFixedHeight = cityOffsetFixedHeight / 2;
      
      
      	/** ------ reposition controls ------------**/
      	var $controlsObj = $('.mapboxgl-ctrl-top-left');
      	var countryMapScaleReversed = 1 * countryMapScale;
        if(countryMapScaleReversed < 2){
			countryMapScaleReversed = 2;
        }
      	var additionalControlsOffset = 0;
      	var currentOffset = saveWoodWidth + (mountMargin2 * 2);
      	var additionalControlsOffset = currentOffset;
      
      	$controlsObj.css('transform','scale(' + countryMapScaleReversed + ')');
      	if (hasMount != 'nomount'){
      		additionalControlsOffset = mountMargin2 * countryMapScaleReversed;
          	additionalControlsOffset = currentOffset + additionalControlsOffset;
        }
      	//console.log('imageInnerMargin = ' + imageInnerMargin);
		$controlsObj.css('left','calc(5% + ' + imageInnerMargin + 'px');
		$controlsObj.css('top','calc(5% + ' + imageInnerMargin + 'px');
      	
      	
      	$('#countrymap_canvas').css({"left": countryOffsetFixedWidth + "px", "right": countryOffsetFixedWidth + "px", "top": countryOffsetFixedHeight + "px","bottom": countryOffsetFixedHeight + "px" });
        $('#countrymap_canvas').css({
            '-webkit-transform' : 'scale(' + countryMapScale + ')',
            '-moz-transform'    : 'scale(' + countryMapScale + ')',
            '-ms-transform'     : 'scale(' + countryMapScale + ')',
            '-o-transform'      : 'scale(' + countryMapScale + ')',
            'transform'         : 'scale(' + countryMapScale + ')'
        });
      	resize_map();
      	if (scaleorzoom == 'scale'){
          
          if (($preview_mode.length) && (typeof $preview_mode.data('fullcanvas') !== 'undefined')) {
            console.log('ratio 21: '+paperWidth/paperHeight);
            if ($preview_mode.data('fixedwidth') == 'auto'){
            	$('#citymap_canvas').css({

                'left': '0px', 'top': '0px'
                  });
            }
            else {
              $('#citymap_canvas').css({

                  'left': cityOffsetFixedWidth + 'px', 'top': cityOffsetFixedHeight + 'px',
                  '-webkit-transform' : 'scale(' + cityMapScale + ')',
                  '-moz-transform'    : 'scale(' + cityMapScale + ')',
                  '-ms-transform'     : 'scale(' + cityMapScale + ')',
                  '-o-transform'      : 'scale(' + cityMapScale + ')',
                  'transform'         : 'scale(' + cityMapScale + ')'
              });
            }
            console.log('ratio 22: '+paperWidth/paperHeight);
          }
          else{
            $('#citymap_canvas').css({

                'left': cityOffsetFixedWidth + 'px', 'top': cityOffsetFixedHeight + 'px',
                '-webkit-transform' : 'scale(' + cityMapScale + ')',
                '-moz-transform'    : 'scale(' + cityMapScale + ')',
                '-ms-transform'     : 'scale(' + cityMapScale + ')',
                '-o-transform'      : 'scale(' + cityMapScale + ')',
                'transform'         : 'scale(' + cityMapScale + ')'
            });
            
          }
      	}
        else if (scaleorzoom == 'zoom') {
          $('#citymap_canvas').css({
              'left':'0px', 'top': '0px',
              'zoom'              : cityMapScale,
              '-webkit-transform' : 'scale(1)',
              '-moz-transform'    : 'scale(1)',
              '-ms-transform'     : 'scale(1)',
              '-o-transform'      : 'scale(1)',
              'transform'         : 'scale(1)'
          });

        }
      	resize_map();
      	$('.horizontal-border-wrap').css('height',woodWidth);
        $('.vertical-border-wrap').css('width',woodWidth);
     	$('.bottom-left-fix').css('width',woodWidth).css('height',woodWidth);
      	height_fix();
        //refreshMapZoom(zoomscale);
      	 resize_map();
      	//box-shadow: 0px 0px 5px rgba(0,0,0,0.3) inset, 0 0 0 9999px rgba(255, 255, 255, 0.9);
	}
   
   
    
    
    function set_mount(){
      var mount,val;
      mount = 'nomount';
      $('#theMapInner').removeClass('hasmount');
      if ($('[name="frame-options"]')){
          val = $('[name="frame-options"]').val();
          //val = val.toLowerCase();
          if (val && val.indexOf("with Mount") >= 0){
              mount = 'hasmount'; 
              $('#theMapInner').addClass('hasmount');
          }
          //alert(mount);
      }
      return mount;
    }

    function set_frame(){
      var frame,val;
      frame = 'hasframe';
      $('#theMapInner').removeClass('hasframe');
      if ($('[name="frame-options"]')){
          val = $('[name="frame-options"]').val();
        //alert(val);
          //val = val.toLowerCase();
          if (val && val.indexOf("Unframed") >= 0){
              frame = 'noframe'; 

              $('#frameColors').prop( "disabled", true ).parents('.choices-wrap').hide();         	


          }
          else{
              $('#theMapInner').addClass('hasframe');
              $('#frameColors').prop( "disabled", false ).parents('.choices-wrap').show();
             
          }
          set_and_save_frame_color_func();

      }

      return frame;
    }
    
    
    $(document).on('change', '#size', function(event) {
      	fixVariant();
      	//console.log('change size start ' +$('#countryDropdown').val());
        setSize();
      	//console.log('change size end ' +$('#countryDropdown').val());
        set_display_sizes();
        build_url();
      	set_frame_product();
    });
    $(document).on('change', '[name="frame-options"]', function(event) {
          fixVariant();
          //var $thisObj = $(this);
          setPaperSize();
      	  set_display_sizes();
      	  build_url();
      	  set_frame_product();
    });
    
    function set_frame_product() {
      	if ($('[name="frame-options"]').length){
            var $selectedObj = $('[name="id"] option:selected');
            var $selectedFramingOptionObj = $('[name="frame-options"] option:selected');
            var framingOption = $selectedFramingOptionObj.val();
          	var frameSku = '';
            var size = $selectedObj.attr('data-size');
            var location = $selectedObj.attr('data-location');
          	var frame = $selectedFramingOptionObj.val();
          	var mount_variantid = '';
			var framing_variantid = '';
          	var dataselect = '[data-size="' + size + '"][data-location="' + location + '"][data-frame-options="' + frame + '"]';
          	var additionalvariantidArr = '';
          	var frameprice = "";
          	var regprice = $('[data-regular-price]').text();
          	var regprice_number = regprice.replace(/[^\d\.,]/g, '');
          	var beforesubmit = 'no';
          	console.log(dataselect);
            if (framingOption == 'Unframed without Mount') {
      			$('#mount_product_select option:selected').prop('selected', false);
      			$('#framing_product_select option:selected').prop('selected', false);
             	frameSku = '';
              	frameprice = '';
              	$('.framing-pricing-wrap').hide();
              	console.log('total_price-------------- '+ frameprice);
              
              	$('.framing-pricing-wrap').hide();
              	$('[data-regular-price]').show();
              	$('[data-regular-pricetotal]').hide();
              	$('[data-regular-pricetotal]').html('');
              	$('.product__totalprice').html($('[data-regular-price]').text());
            }
            else if (framingOption == 'Framed with Mount') {
              	framing_variantid = $('#framing_product_select ' + dataselect).prop('selected', true);
              	frameSku = $('#framing_product_select option:selected').attr('data-sku');
              	additionalvariantidArr = framing_variantid;
              	beforesubmit = 'yes';
              	frameprice = '<ul><li>Map poster <b>' + regprice + '</b></li><li>Framing service <b>' + $('#framing_product_select option:selected').attr('data-price') + '</b></li></ul>';
              	var frame_price_num = $('#framing_product_select option:selected').attr('data-price');
              	frame_price_num = parseFloat(frame_price_num.replace(/[^\d\.,]/g, ''));
              	var total_price = (parseFloat(regprice_number) + frame_price_num).toFixed(2);
              	console.log('total_price-------------- '+ total_price); 
              	var total_price_final = regprice.replace(regprice_number.toString(),total_price.toString());
              	$('[data-regular-price]').hide();
              	$('[data-regular-pricetotal]').show();
              	$('.framing-pricing-wrap').show();
              	$('[data-regular-pricetotal]').html(total_price_final);
              	$('[data-regular-pricetotal], .product__totalprice').html(total_price_final);
            } else if (framingOption == 'Framed without Mount') {
              	framing_variantid = $('#framing_product_select ' + dataselect).prop('selected', true);
              	frameSku = $('#framing_product_select option:selected').attr('data-sku');
              	additionalvariantidArr = framing_variantid;
              	beforesubmit = 'yes';
              	frameprice = '<ul><li>Map poster <b>' + regprice + '</b></li><li>Framing service <b>' + $('#framing_product_select option:selected').attr('data-price') + '</b></li></ul>';
              	var frame_price_num = $('#framing_product_select option:selected').attr('data-price');
              	frame_price_num = parseFloat(frame_price_num.replace(/[^\d\.,]/g, ''));
              	var total_price = (parseFloat(regprice_number) + frame_price_num).toFixed(2);
              	console.log('total_price-------------- '+ total_price); 
              	var total_price_final = regprice.replace(regprice_number.toString(),total_price.toString());
              	$('[data-update-price]').html(total_price_final);
              	$('[data-regular-price]').hide();
              	$('[data-regular-pricetotal]').show();
              	$('.framing-pricing-wrap').show();
              	$('[data-regular-pricetotal], .product__totalprice').html(total_price_final);
            }
            $('.framing-pricing-wrap').html(frameprice);
          	$('#save_frame_options').val(framingOption);
			$('#save_frame_sku').val(frameSku);
          	$('#save_additional_variantids').val(additionalvariantidArr).attr('data-beforesubmit',beforesubmit);
        }
    }
    set_frame_product();
    /** -------------------- add multiple items to cart -------------------- **/
    
    if($('#save_additional_variantids').length){
    	$('#productpage_form').submit(function(e) {

          	if($('[data-beforesubmit="yes"]').length) {
                e.preventDefault();
  				e.stopImmediatePropagation();
              	console.log('#productpage_form submit 1');
                $(".saving-screen").fadeIn(800);
              	var random = Math.floor(Math.random() * 1000); 
              	$('#save_design_timestamp').val(Date.now()+'-'+random);
                multipleVariantAddToCart($('#framing_service_products_wrap'));
            }
            else {
              	console.log('#productpage_form submit 2');
				//alert('submit');
            }
          	
		});
      	
    }
    
    function add_frame_then_submit () {
      
    }
    
    Shopify.queue = [];

    Shopify.moveAlong = function(callback) {
      	// If we still have requests in the queue, let's process the next one.
		if (Shopify.queue.length) {
                	console.log('moveAlong addItem');
        	var request = Shopify.queue.shift();
        	// pass the properties into addItem as well
        	Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
      	}
      	// If the queue is empty, we will redirect to the cart page.
      	else {
        	if(typeof callback === 'function'){
              console.log('moveAlong callback');
            	callback();
          	}
          	else {
              	console.log('moveAlong submit');
                $('#save_additional_variantids').attr('data-beforesubmit','no');
                $('#productpage_form').submit();
                $(".saving-screen").fadeOut(800);
        		//document.location.href = '/cart';
            }
      	}
    };

    // Create a new Shopify.addItem function that takes the 'properties' parameter
    Shopify.addItem = function(id, qty, properties, callback) {
      var params = {
          quantity: qty,
          id: id
      };
      if(properties != false){
          params.properties = properties;
      }
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: params,
          success: function(){
            if(typeof callback === 'function'){
              callback();
            }
          },
          error: function(){}
      });
    }

    function push_to_queue(variantID, quantity, properties) {
      	console.log('push_to_queue');
    	Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            properties: properties
    	});
    }
    
    var multipleVariantAddToCart = function(variantHolderObj) {
		try {
			var variants = [];
          	console.log('multipleVariantAddToCart');
            variantHolderObj.find('option:selected').each(function(){
              	console.log('multipleVariantAddToCart loop');
                var variant_id = parseInt($(this).val());
              	console.log('variant_id = '+variant_id);
              	var propertiesObject = new Object();
				propertiesObject['_timestamp'] = $('#save_design_timestamp').val();
              	
                if($(this).parents('#framing_product_select')){
					var using_framecolor = $(save_frame_color).val();
                  	propertiesObject['color'] = using_framecolor;
                }
              	var propertiesString = JSON.stringify(propertiesObject);
              	console.log(propertiesString)
                push_to_queue(variant_id, 1, propertiesObject);
            });
            // process the queue
    		Shopify.moveAlong();
		} catch (errf) {console.log("Error: "+errf.message);}
	};
    
    
    /** -------------------- add multiple items to cart -------------------- **/
    
    function set_framing_service_message () {
      /**
		$('.framing-service').each(function(){
            var tr, this_blockid, this_blockkey;
          	var numblocks = 0;
			var $block = $(this).parents('tr.cart-item');
          	var frameprice = $block.find('[data-cart-item-line-price]').html();
          	var frameoption = $block.find('[data-cart-item-variant-title]').text().trim()+"";
            var framecolor = $block.find('[data-cart-itempropname="color"] [data-cart-item-property-value]').text().trim()+"";
			var blockid = $block.find('[data-cart-itempropname="_timestamp"] [data-cart-item-property-value]').text().trim()+"";
			$('tr.cart-item').each(function(){
              	tr = $(this);
				this_blockid = $(this).find('[data-cart-itempropname="_timestamp"] [data-cart-item-property-value]').text().trim()+"";
				console.log('set_framing_service_message');
              	if (this_blockid == blockid) {
                	if (frameoption.indexOf('Framed without Mount') > -1) {
      					frameoption = 'Framed without Mount';
                    }
                    else if (frameoption.indexOf('Framed with Mount') > -1) {
      					frameoption = 'Framed width Mount';
                    } else {
						frameoption = 'Unframed without Mount';
                    }
                  	tr.find('.framing-service-message-wrap .framing-service-message').html('Framing service: '+frameoption+ ' | '+framecolor);
                  	tr.find('.framing-service-message-wrap .framing-service-price').html('+<b>' + frameprice + '</b>');
				}
			});
		});
        **/
    }
    
    /** -------------------- delete rraming from cart -------------------- **/
    
	$(document).on('click', 'a[data-cart-item-delete-motw]', function(event) {
		try {
			console.log("data-cart-item-delete-motw click");
                          $(".saving-screen").fadeIn(800);
          
            if ($(this).parents('tr.cart-item').length) { 
              cart_get();
              var block = $(this).parents('tr.cart-item');          
              cart_qty_change_q(block, 'del');
            }          
          
			/*var blockkeys = [];
			var data = {
	          "updates": {}
	        }
            var blocksstr = "";
            var tr, this_blockid, this_blockkey;
          	var numblocks = 0;
          	if ($(this).parents('tr.cart-item').length) {
              var block = $(this).parents('tr.cart-item');
              var blockid = block.find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";
              $('tr.cart-item').each(function(){
                  tr = $(this);
                  this_blockid = $(this).find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";                  
                  if (this_blockid == blockid) {
                      console.log("data-cart-item-delete-new blockid '"+this_blockid+"' vs '"+blockid+"'");
                      this_blockkey = tr.attr('data-cart-item-id-motw'); 
                      console.log("data-cart-item-delete-motw this_blockkey '"+this_blockkey+"'");
                      numblocks++;
                      data.updates[this_blockkey] = 0;
                      if (blocksstr.length > 0) {
                        blocksstr = blocksstr+"&";
                      }
                      blocksstr = blocksstr+"updates["+this_blockkey+"]="+quan;                    
                  }
              });
              console.log("data-cart-item-delete-motw num blockkeys "+numblocks);
              console.log(JSON.stringify(data));
              if (numblocks > 0) {
                var params = {
                  type: 'POST',
                  url: '/cart/update.js',
                  data: blocksstr,
                  success: function(line_item) { 
                    console.log("Success");                    
                    window.location.reload(true);                   
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log("Failure");
                  }
                };
                jQuery.ajax(params);
              }
            }*/
          
          	event.preventDefault();
		} catch (err_cart_delete_item) {console.log("ERROR: " +err_cart_delete_item.message);}
	});   
    
    Shopify.new_getCart = function(callback) {
        try {
      	$.getJSON('/cart.js', function (cart, textStatus) {
            if ((typeof callback) === 'function') {
              callback(cart);
            }
            else {
              /**Shopify.onCartUpdate(cart);**/
            }
      	});
      } catch (errf) {console.log("Error: "+errf.message);}
    };
    
    $(document).on('click', '.increment-quantity', function(event) {
      try {
        console.log("cart-item__qty-input increment..");
        if ($(this).parents('tr.cart-item').length) { 
          cart_get();
          var block = $(this).parents('tr.cart-item');
          $(".saving-screen").fadeIn(800);
          cart_qty_change_q(block, 'change');
        }
       } catch (err_cart_change_item_a) {console.log("ERROR: " +err_cart_change_item_a.message);}
    });
    $(document).on('click', '.decrement-quantity', function(event) {
      try {
        console.log("cart-item__qty-input decrement..");
        if ($(this).parents('tr.cart-item').length) {
          cart_get();
          var block = $(this).parents('tr.cart-item');
          $(".saving-screen").fadeIn(800);
          cart_qty_change_q(block, 'change');
        }
       } catch (err_cart_change_item_b) {console.log("ERROR: " +err_cart_change_item_b.message);}
    });
    function cart_get() {
      try {
      	var params = {
        	type: 'GET', url: '/cart.js', dataType: 'json', 
            success: function(cart) { 
              for (i in cart.items) {
                  console.log(cart.items[i].key+" x"+cart.items[i].quantity);								
              }
            },error: function(XMLHttpRequest, textStatus) {}
        };
        jQuery.ajax(params);
      } catch (err_cart_get) {console.log("ERROR: " +err_cart_get.message);}
    }
    function cart_qty_change_line(arr, n) {
      try {
        console.log("cart_qty_change_line "+n+")");
        console.log(arr);
        var r = 0;
        var match = false;
        for (key in arr) {
          r += 1;
          if (r == n) {
            match = true;
            console.log("cart_qty_change_line line '"+arr[key]['line']+"' q '"+arr[key]['q']+"'");
            var params = {
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  quantity: arr[key]['q'],
                  line: arr[key]['line']
            	},
                dataType: 'json',
                success: function(line_item) { 
                  console.log("Success");     
                  if (n > 1) {
                    console.log("cart_qty_change_line next..");
                    cart_qty_change_line(arr, n-1);
                  }
                  else {
                    console.log("cart_qty_change_line done");
                    window.location.reload(true);                      
                  }
                },
                error: function(XMLHttpRequest, textStatus) {
                    console.log("Failure");
                }
            };
            jQuery.ajax(params);
            
          }
        }
        /*if (match == false) {
          console.log("cart_qty_change_line done");
          //window.location.reload(true);          
        }*/
        
      } catch (cart_qty_change_line) {console.log("ERROR: " +cart_qty_change_line.message);}        
    }
    function cart_qty_change_q(block, qq) {
        try {
            console.log("cart-item__qty-input function");
          
            var params = {
                type: 'GET', url: '/cart.js', dataType: 'json', 
                success: function(cart) { 
                  
                  var keypos = [];

                  if (block.find('.cart-item__qty-input')) {
                              
                    var quan = block.find('.cart-item__qty-input').val();
                    if (qq == 'del') {
                      quan = '0';
                    }
                    console.log("cart-item__qty-input quantity '"+quan+"'");
                    if ((quan.match("[0-9]+")) && (quan.length > 0)) {
                      console.log("cart-item__qty-input quantity is number");
                      var blockkeys = [];
                      var blocksstr = "";
                      var tr, this_blockid, this_blockkey;
                      var numblocks = 0;
                      var blockid = block.find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";
                      console.log("cart-item__qty-input blockid '"+blockid+"'");
                      $('tr.cart-item').each(function(){
                          tr = $(this);
                          this_blockid = $(this).find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";                   
                          if (this_blockid == blockid) {
                              console.log("cart-item__qty-input blockid '"+this_blockid+"' vs '"+blockid+"'");
                              this_blockkey = tr.attr('data-cart-item-id-motw'); 
                              //console.log("cart-item__qty-input this_blockkey '"+this_blockkey+"'");
                              numblocks++; 
                              keypos[this_blockkey] = [];
                              keypos[this_blockkey]['q'] = quan;
                              console.log("### cart-item__qty-input "+this_blockkey+" x "+quan);                            
                          }
                      });

                      var keyitems = 0;
                      for (i in cart.items) {
                          keyitems += 1;
                          if (keypos[cart.items[i].key]) {
                            if (keypos[cart.items[i].key]['q']) {                           
                              keypos[cart.items[i].key]['line'] = keyitems;
                              console.log("### cart-item__qty-input "+keypos[cart.items[i].key]['line']+" x "+keypos[cart.items[i].key]['q']);
                            }
                          }
                      }                      
                      
                      console.log("cart-item__qty-input num blockkeys "+numblocks);
                      if (numblocks > 0) {
                          cart_qty_change_line(keypos, numblocks);
                      }
                    }
                    else {
                        console.log("cart-item__qty-input quantity NOT number");
                    }
                  }

                },error: function(XMLHttpRequest, textStatus) {}
            };
            jQuery.ajax(params); 
          
            event.preventDefault();
        } catch (err_cart_change2_item) {console.log("ERROR: " +err_cart_change2_item.message);}
    }
    function cart_qty_change(block) {
        try {
            /*console.log("cart-item__qty-input function");
          	if (block.find('.cart-item__qty-input')) {
                        $(".saving-screen").fadeIn(800);
              var quan = block.find('.cart-item__qty-input').val();
              console.log("cart-item__qty-input quantity '"+quan+"'");
              if ((quan.match("[0-9]+")) && (quan.length > 0)) {
                console.log("cart-item__qty-input quantity is number");
                var blockkeys = [];
                var data = {
                    "updates": {}
                }
                var blocksstr = "";
                var tr, this_blockid, this_blockkey;
                var numblocks = 0;
                var blockid = block.find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";
                console.log("cart-item__qty-input blockid '"+blockid+"'");
                $('tr.cart-item').each(function(){
                    tr = $(this);
                    this_blockid = $(this).find('[data-cart-itempropname-motw="_timestamp"] [data-cart-item-property-value-motw]').text().trim()+"";                   
                    if (this_blockid == blockid) {
                      	console.log("cart-item__qty-input blockid '"+this_blockid+"' vs '"+blockid+"'");
                        this_blockkey = tr.attr('data-cart-item-id-motw'); 
                        console.log("cart-item__qty-input this_blockkey '"+this_blockkey+"'");
                        numblocks++;
                        data.updates[this_blockkey] = parseInt(quan, 10);
                        if (blocksstr.length > 0) {
                          blocksstr = blocksstr+"&";
                        }
                      	blocksstr = blocksstr+"updates["+this_blockkey+"]="+quan;
                    }
                });
                console.log("cart-item__qty-input num blockkeys "+numblocks);
                console.log(JSON.stringify(data));
                if (numblocks > 0) {
                    var params = {
                        type: 'POST',
                        url: '/cart/update.js',
                        data: blocksstr,
                        success: function(line_item) { 
                            console.log("Success");
                          	cart_get();
                            //window.location.reload(true);                         
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            console.log("Failure");
                        }
                    };
                    jQuery.ajax(params);
                }
              }
              else {
                  console.log("cart-item__qty-input quantity NOT number");
              }
            }
            event.preventDefault();*/
        } catch (err_cart_change_item) {console.log("ERROR: " +err_cart_change_item.message);}
    }
    
    /** -------------------- delete rraming from cart END -------------------- **/

    $(document).on('change', '[name="id"]', function(event) {
          //build_url();
    });

    function set_display_sizes(){
      if($('[name="id"] option:selected').length){
          var width = $('[name="id"] option:selected').data('width');
          var height = $('[name="id"] option:selected').data('height');
          var orientation = get_orientation();
          //console.log('set_display_sizes | height ='+height+' | width = '+width);
          var store_width = width;
          var store_height = height;
          //console.log('orientation =' + orientation);
          if(orientation == 'landscape'){
              height = store_width;
              width = store_height;

          }
          $('.dimensions-size.right-size').html(height+' Inch');
          $('.dimensions-size.bottom-size').html(width+' Inch');
         
      }
    }


    function setSize(){
      if($('#size').length){
          var size = $('#size').val().replace(' x ','').replace(/[^A-Za-z]/g,'').toLowerCase();
          setPaperSize();
         
      }
    }
    
    
    $(document).arrive('[data-cart-item-line-price-motw]', function() {
      
      	update_cart_items();
      	/**
      	var $parentObj = $(this).parents('[data-cart-item]');
      
      	var image_url = $parentObj.find("li:contains('_Preview image:')").text().replace('_Preview image:','').trim();
        $( "li:contains('_Preview image:')").hide();
     	$parentObj.find('[data-cart-item-image]').attr('src',image_url);
      	var design_url = $parentObj.find("li:contains('_Design url:')").text().replace('_Design url:','').trim();
      	$( "li:contains('_Design url:')").hide();
      	$parentObj.find('[data-cart-item-href]').attr('href',design_url);
      
      	var variant_title = $parentObj.find('[data-cart-item-variant-title]').text();
      	var variant_title_arr = [];
      	variant_title_arr = variant_title.split('/');
      	$parentObj.find('[data-cart-item-variant-title]').html(variant_title_arr[0] + ' <br /> ' + variant_title_arr[1]);
      	
      	$('[data-cart-item-title]').replace(' - the editor');
      
        $parentObj.find('[data-cart-item-property-list] li').each(function() {
          	var li_contents = $(this).text();
          	var li_contents_arr = [];
          	li_contents_arr = li_contents.split(': ');
          	var li_contents_arr_clean = li_contents_arr[0];
          	li_contents_arr_clean = handleize_string(li_contents_arr_clean);
          	$(this).attr('data-cart-itempropname',li_contents_arr_clean);
		});
      
      	$( "li:contains('Marker icon:')").hide();
		$( "li:contains('MarkerlatLng:')").hide();
		$( "li:contains('Marker lat:')").hide();
		$( "li:contains('Marker lng:')").hide();
      	$( "li:contains('_Preview image:')").hide();
      	$( "li:contains('_Design url:')").hide();
        **/
    });

    $(document).arrive('#set_usercountry', function() {
       //console.log('#set_usercountry added');
        $('.letsdothis').trigger('change');
    });
    $(document).arrive('#tawkchat-container', function() {
        $('#tawkchat-container').attrchange({
        	trackValues: true, 
            callback: function (event) {
            	if (pixel_instance_color.isMobile()){
                    if($('#tawkchat-container').css("top") == '0px'){
                        $('#tawkchat-container').css('opacity','1');
                    }
                    else{
                        $('#tawkchat-container').css('opacity','0');
                    }
    			}
            }
        });
    });

    
			$('.BOLD-mc-picker').attrchange({
				trackValues: true, 
				callback: function (event) {
					var properties = $(this).attrchange('getProperties');						
					//console.log('Status: ' + properties.status + '. Attribute Name: ' + event.attributeName + ' Prev Value: ' + event.oldValue + ' New Value: ' + event.newValue);
                  	$('.letsdothis').trigger('change');
				}
			});
            
        
    
    
    
		/* -------------------------------------------------------- */
		/* ---------------------- FRAMES AND SIZING END ----------- */
		/* -------------------------------------------------------- */  
    
    
    
    
	/**
    $(document).on('change', '#countryDropdown', function(event) {
        console.log('#countryDropdown onchange - reading value = ' + $('#countryDropdown').val());   	
        setMap();
      	storeVariant();
        set_default_values();
    });
	**/
    var saved_country = $('#countryDropdown').val();
    var saved_font = $('#fontDropdown option:selected').val();
    var saved_borderstyle = $('input[name=map-layout]:checked', '#productpage_form').val()
    var saved_textareastyle = $('#textboxLayout option:selected').val();
    $(document).on('click', '#size', function(event) {
      	//storeVariant();
    });
    $(document).on('click', '[name="frame-options"]', function(event) {
		//storeVariant();
    });
    function storeVariant() {
      /**
        saved_country = $('#countryDropdown').val();
      	saved_font = $('#fontDropdown option:selected').val();
        saved_borderstyle = $('#contentLayout option:selected').val();
      	saved_textareastyle = $('#textboxLayout option:selected').val();
      	console.log('storeVariant country ' +saved_country);
        **/
    }
    function fixVariant() {
      	/**
        var country = saved_country;
        var font = saved_font;
        var borderstyle = saved_borderstyle;
        var textareastyle = saved_textareastyle;      
        //setTimeout(function(){
          console.log('fixVariant set country = ' +country+' ***************************');

          $('#countryDropdown option[value="'+country+'"]').attr('selected','selected').prop("selected", true);
          $('#countryDropdown option[value!="'+country+'"]').removeAttr('selected').prop("selected", false);
          
          $('#fontDropdown option[value="'+font+'"]').attr('selected','selected').prop("selected", true);
          $('#fontDropdown option[value!="'+font+'"]').removeAttr('selected').prop("selected", false);
          
          $('#contentLayout option[value="'+borderstyle+'"]').attr('selected','selected').prop("selected", true);
          $('#contentLayout option[value!="'+borderstyle+'"]').removeAttr('selected').prop("selected", false);

          $('#textboxLayout option[value="'+textareastyle+'"]').attr('selected','selected').prop("selected", true);
          $('#textboxLayout option[value!="'+textareastyle+'"]').removeAttr('selected').prop("selected", false);
          
          saved_country = country;
          saved_font = font;
          saved_borderstyle = borderstyle;
          saved_textareastyle = textareastyle;
          
          $('#countryDropdown').change();
          
      	//}, 500);
        **/
    }
  
  
var lastSavedUrl = '';
var global_time = 0;
var d = new Date();
var n = d.getTime();
var preview_in_progress = false;
var submit_after_save = false;  
var show_info_dialog = false;  
var show_upsell_dialog = false;  

function submit_after_save_check(){
  
	if(submit_after_save === true){
      
          preview_in_progress = false;
          submit_after_save = true;  
          show_info_dialog = false;  
          show_upsell_dialog = false;  
      
		//$('#productpage_form').submit();
		setTimeout(function(){
		}, 6000);
	}
	else{
		enable_cart_buttons();
	}
  
}

function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

function cleanUrlForSearch(url){
	url = replaceAll(url,'/','-ss-');
	url = replaceAll(url,'&','-aa-');
	url = replaceAll(url,'=','-ee-');
	url = replaceAll(url,'.','-pp-');
	url = replaceAll(url,':','-cc-');
	url = replaceAll(url,'?','-qq-');
	url = replaceAll(url,'%','-pc-');
  	return url;
}

function build_and_save_preview_image (){
	try {
    	/** Update quantity and price**/
		//freegift_check(cart,'swapvariant');
      
  	// check the device so we can add to the preview url
	var pixel_instance = $.fn.deviceDetector;
  	//console.log('You are using ' + pixel_instance.getBrowserName() +' on ' + pixel_instance.getOsName());
  	var device = 'desktop';
    if (pixel_instance.isMobile()){
		device = 'mobile';
    }
  	//find the width and height of the container
  	var container_selector = '.featured-slider__cover-background';
    if($('#measurement_container').val() != ''){
		container_selector = $('#measurement_container').val();
    }
	var windowWidth = Math.round(Math.round(( parseFloat($('#theMapFrame').data('width') * 0.4) * 100))/100);
	var windowHeight = Math.round(Math.round(( parseFloat($('#theMapFrame').data('height') * 0.4) * 100))/100);
  
  
  
  	//console.log('### '+ windowWidth + ' | '+windowHeight);
  	//var image_url = 'https://res.cloudinary.com/mapsoftheworld/image/upload/w_'+width+',h_'+height+',c_fill,g_center/bo_10px_solid_white/bo_1px_solid_gray/bo_13px_solid_rgb:000/placeholders/'+icon_name;
  	if($('#save_previewDesignUrl').length){
      	var image_url = $('#save_previewDesignUrl').val().replace('?','?view=citymap-thumbnail-preview&');
        var fetch_url = location.protocol + "//" + location.host + '/search?view=mappreview&q=';
      	//var agent = '&agent='+navigator.userAgent;
      	image_url = image_url+'&device='+device+'&dimensions=setwindow|width:'+windowWidth+'_height:'+windowHeight;
        image_url = cleanUrlForSearch(image_url);
     
        $.get( fetch_url+image_url, function( data ) {
            $('#save_previewImgUrl').val(data);
        });
  	}
    } catch (errf_build_and_save_preview_image) {console.log("Error: "+errf_build_and_save_preview_image.message);}
}
function preload_preview_image(){
	try {
        if($('#save_previewImgUrl').val() != ''){
            var myImage = new Image();
            myImage.name = "previewImg";
            myImage.src = $('#save_previewImgUrl').val();
        }
    } catch (errf_preload_preview_image) {console.log("Error: "+errf_preload_preview_image.message);}
}
var preview_image = debounce(function(url){
  	//alert(url);
  	try {
        preview_in_progress = false;
        submit_after_save_check();
        build_and_save_preview_image();
        /**
        if ($('#preview_mode').length){

        }
        else {
            console.log('preview_image START');
            if ($('#save_previewDesignUrl').length) {
                d = new Date();
                var function_time = d.getTime();
                var bwidth = 2000;
                var bheight = 5000;
                if (lastSavedUrl != url){
                    console.log('preview_image PASSED URL CHECK');
                    lastSavedUrl = url;
                    global_time = function_time;
                    preview_in_progress = true;
                  GrabzIt("NzA1YTkwYjRhMmNmNDlhNDhmM2Y0YmY0NWY4ZThhODc=").ConvertPage({
                        "target":"#theMapFrame",
                        "format":"jpg",
                        "hide":".mapboxgl-ctrl-top-left,#tidio-chat", 
                        "bwidth":bwidth, 
                        "bheight":bheight, 
                        "quality":"80",
                        "waitfor":".citymapready",
                        "onerror": function(id){
                            preview_on_finish(function_time,global_time,lastSavedUrl);                                                               
                        },
                        "onfinish": function(id){
                            preview_on_finish(function_time,global_time,lastSavedUrl); 
                        }
                    }).DataURI(preview_image_callback);    
                }
                else{
                    console.log('preview_image FAILED URL CHECK');
                }

            }
        }
        **/
  	} catch (errf_preview_image) {console.log("Error: "+errf_preview_image.message);}
}, 2000);

function preview_on_finish(function_time,global_time,url){
  
	if (function_time >= global_time){
		//console.log('preview_image PASSED TIME CHECK');
		preview_in_progress = false;
		lastSavedUrl = url;
		$('#save_previewDesignUrl').val(url);
		var timetaken = (d.getTime() - function_time) / 1000;
		//console.log( 'time taken = '+ timetaken);
		submit_after_save_check();
	}
	else {
		//console.log('preview_image DEAD REPLACED CALL');
		//Dead replaced call
		//disable_cart_buttons('Saving preview, please wait...');
	}  
  
  
}



function preview_image_callback(dataUri) {
    
	if($('#save_previewImgUrl').length){
      	//console.log('preview_image_callback START');
    	$('#save_previewImgUrl').val(dataUri);
      	upload_to_cloud(dataUri);
      	//$('#preview_image_test').attr('src',dataUri).show();
    }

} 
function upload_to_cloud(dataUri){
	var data = new FormData();
	data.append("upload_preset", "mqyu68qo");
	data.append("file", dataUri);
	data.append("api_key", "713814972582496");  
	const xhr = new XMLHttpRequest();
	xhr.open('POST', 'https://api.cloudinary.com/v1_1/mapsoftheworld/image/upload', false);
	xhr.send(data);
	delete data;
	const imageResponse = JSON.parse(xhr.responseText);
	//console.log(imageResponse);
	var imageurl = false;
	var imageerror = false;
	if (imageResponse.secure_url) {
		imageurl = imageResponse.secure_url;
      	var saveduri = $('#save_previewImgUrl').val();
        if(dataUri == saveduri){
          	//alert('about to replace = '+imageurl);
			$('#save_previewImgUrl').val(imageurl);
        }
    }
	else if (imageResponse.error.message) {  
		imageerror = imageResponse.error.message;
		//alert(imageerror);
	}
	else {
		imageerror = "An unknown error has occurred";
		//alert(imageerror);
	} 
  
}


function disable_cart_buttons(message){
  	$('.progress-message').find('.progress-message-inner').text('Saving preview, please wait...');
}

function enable_cart_buttons(){
  	$('.buy-button-wrap').removeClass('saving-mode');
  	$('.progress-message').hide().find('.progress-message-inner').text('');
}

$( 'button[form="productpage_form"]' ).on( "click", function( e ) {
   /**
    e.preventDefault();
  	preload_preview_image();
    var form = $(this);
    var preview_url = $('#save_previewDesignUrl').val();
  
	//Shopify.freegift_getCart(freegift_check_init_swap);
  
  	$('.progress-message').hide();
    if (show_info_dialog === true){
      	//alert('show_info_dialog');
      	open_magnific_popup('#are_you_sure_modal');
      	show_info_dialog = false;
      	submit_after_save = false;
      	return false;
    }
    else if (preview_in_progress === true){
      	//alert('preview_in_progress');
      	submit_after_save = true;
        $('.progress-message').show().find('.progress-message-inner').text('Saving map details, please wait...');
        return false;
    }
    else{
		//form.submit(); // submit bypassing the jQuery bound event
    }
    **/

});

function open_magnific_popup(selector){
	$.magnificPopup.open({
		items: {
        	src: selector,
		},
		type: 'inline'
	});
}

$(document).on('click', '.btn--loader', function(ev) {
	//ev.preventDefault();
  	$(this).addClass('btn--loader-active');
});

$(document).on('click', 'button[form]', function(ev) {
	var formId = $(this).attr('form'); $('#' + formId).submit(); 
});



function check_for_minimum_inputs(){
	var requires_popup = false;
	$('[data-advise-user]').each(function() {
        if ($(this).val() == ''){
            var text = $(this).data('advise-user');
            requires_popup = true;
            var textid = $(this).data('advise-id');
            $('#to_do_text ul').find('#'+textid).show();
        }
        if (requires_popup == true){
            show_info_dialog == true;
        }
        else{
            show_info_dialog == false;
        }
	});
}

$('.alert-user-button-blocker').magnificPopup({
	type: 'inline',
  	closeOnContentClick: true,
	modal: true
});
$('.alert-user-button-blocker').click(function (e) {
  	$('.buy-button-wrap').removeClass('ask-user-mode');
});
$(document).on('click', '.closePopup', function (e) {
        	e.preventDefault();
            $.magnificPopup.close();
});
  
  
  
//**dataURL to blob**
function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}

//**blob to dataURL**
function blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function(e) {callback(e.target.result);}
    a.readAsDataURL(blob);
}

/**
mapboxgl.accessToken = 'pk.eyXXX';
var previewmap = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/light-v9',
    minZoom: 4,
    maxZoom: 14,
    center: [-2.0, 53.3],
    preserveDrawingBuffer: true
});

previewmap.on('load', function () {
    var content = map.getCanvas().toDataURL();
    console.log(content)
});
**/
  
$(document).on('click', '.quicktest-run', function(event) {
	setTimeout(function(){
    	preview_image();
      //preview_image();
	}, 10);
});
  
 
  
function quicktest(){

  			/**
            cityMap.getCanvas().toBlob(function(blob) {
                blobToDataURL(blob, function(dataurl){
    				$('#preview_image_test').attr('src',dataurl).show();
				});
            });
            **/
  
  	/**
      var citycontent = cityMap.getCanvas().toDataURL("image/png");
  	  var countrycontent = countryMap.getCanvas().toDataURL("image/png");
  	  if($('#citymap_canvas_thumbnail').length){
        
    	$('#countrymap_canvas_thumbnail').attr('src',countrycontent);
    	$('#citymap_canvas_thumbnail').attr('src',citycontent);
        $('#theMapFrame').addClass('html2canvas-ready');
                    $('#preview_image_test').attr('src',citycontent).show();
                    
                    
                    
                    **/
        /**
        html2canvas(document.querySelector("#theMapFrame")).then(canvas => {
          	$('#theMapFrame').removeClass('html2canvas-ready');
        	var width = $('#theMapFrame').width();
          	var height = $('#theMapFrame').height();
        	canvas.id = "canvas_wrap_canvas";
           	$('#canvas_wrap').append( canvas );
            var thumbnailcontainer = document.querySelector('#canvas_wrap_canvas').toDataURL();
    		$('#save_previewImgUrl').val(thumbnailcontainer);
            $('#preview_image_test').attr('src',citycontent);
        });
      }
      
      **/
  /**
	var selectedObj = $('#cityDropdown');
	var getlat = $(save_map_lat).val();
	var getlng = $(save_map_lng).val();
	var defaultcityzoom = 11.5;
	var getzoom = getZoom(selectedObj);
	var $thisObj = $('input[name=color-scheme]:checked');
	mapstyle = $thisObj.data('mapstyle');
    mapboxgl.accessToken = 'pk.eyXXX';
    var previewmap = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/cherishedlocations/'+mapstyle,
        zoom: getzoom,
        interactive: false,
        attributionControl: false
        center: [getlng, getlat],
        preserveDrawingBuffer: true
    });
            //console.log('######### setCityMap ' + selectedObj.attr('id') + 'getlat = ' + getlat + '| getlng = ' + getlng + '###################');
            at = 'pk.eyJ1IjoiY2hlcmlzaGVkbG9jYXRpb25zIiwiYSI6ImNqZHQzMjY5ajB6Y2oyeHBja2w3OG1jaWUifQ.1ADcEgkY7VANSGkPgsw4tA';
            mapboxgl.accessToken = at;
            cityMap = new mapboxgl.Map({
                container: 'citymap_canvas',
              preserveDrawingBuffer: true,
              style: 'mapbox://styles/cherishedlocations/'+mapstyle,
                center: [getlng, getlat],
                zoom: getzoom,
                interactive: true,
              	attributionControl: false
            });
  
  
  GrabzIt("NzA1YTkwYjRhMmNmNDlhNDhmM2Y0YmY0NWY4ZThhODc=").ConvertPage({"target": "#theMapFrame", "hide": "#tidio-chat", "bheight": -1, "height": -1, "width": -1, "onfinish": function(id){
			alert('image done');
            }}).DataURI(preview_image_callback2);
            **/
  
  
}
  
  
  
  


  function update_button_price(){
    var current_price = $('.product__current-price').html();
	$('[data-update-price]').each(function() {
      	  // $(this).show();
      	  $(this).css('display', 'inline');
	});
  }

function get_preview_image(url,objid,bwidth,bheight,timestamp){
  
  	if($('#'+objid).length){
  		//console.log('bwidth = ' + bwidth + ' | bheight ' + bheight);
      	/**
		GrabzIt("NzA1YTkwYjRhMmNmNDlhNDhmM2Y0YmY0NWY4ZThhODc=").ConvertURL(url, {"format":"jpg","bwidth":bwidth, "bheight":bheight, "quality":"80", "delay":"3500", "onfinish": function(id){
        	//alert(id);
    	}}).AddTo(objid);
 		**/
    }
    
}

function needs_preview() {
  	/**
  	//alert($(".needs-preview").length);
  	if($(".needs-preview").length){
        $(".needs-preview").each(function() {
            var objid = $(this).attr('id');
          	var title = $(this).data('title');
          	var var_bwidth = Math.floor($(this).data('width') * 50);
          	var var_bheight = Math.floor($(this).data('height') * 50);
          	if (title.indexOf("small") !=-1) {
                var_bwidth = 703;
                var_bheight = 878;
			}
            else if (title.indexOf("medium") !=-1) {
                var_bwidth = 741; //741.143;
                var_bheight = 926; //925.929;
            }
            else if (title.indexOf("xlarge") !=-1) {
              var var_bwidth = 800;
              var var_bheight = 1000;
            }
            else if (title.indexOf("large") !=-1) {
              var var_bwidth = 593;
              var var_bheight = 818;
            }
          
       console.log('var_bwidth = ' + var_bwidth + ' | var_bheight ' + var_bheight);  

            var url = $(this).closest('a').attr('href') + '&view=simple-map-preview';

            get_preview_image(url,objid,var_bwidth,var_bheight,3444);
        });
  	}
    **/
}
  

needs_preview();

  
  
  //$(document).on('change', '.color-radio', function(event) {
    	//var $thisObj = $(this);
    	//get_and_set_color_scheme($thisObj);
  //});

  function handleize_string(string){
    if (string === undefined || string === null || string.length <= 0) {
		
      	return "";
    }
    else{
		return string.replace(/\&+/g, '-').replace(/\s+/g, '-').toLowerCase();
    }
  }

  function check_string(string){
    if (string === undefined || string === null || string.length <= 0) {
		
      	return false;
    }
    else{
		return string;
    }
  }

//------------ COLOR SCHEME ----------------------------------------


  $(document).on('change', '#frameColors', function(event) {
		use_frame_color();

  });

  function get_frame_color(){
      var frame_color = $('#frameColors').val();
	  return frame_color;
    
  }

  function save_frame_color_func(){
      var frame_color = get_frame_color();
	  $(save_frame_color).val(frame_color);
    
  }
    
  function set_and_save_frame_color_func(){
      var frame_color = '';
	  if($('#frameColors').prop( "disabled")){
        	frame_color = '';
	  }
      else {
	  		frame_color = $('#frameColors').val();
      };
	  $(save_frame_color).val(frame_color);
      var using_framecolor = handleize_string(frame_color);
      if($('#frame-color-'+ using_framecolor).length){
      	$('#frame-color-'+ using_framecolor).prop('selected',true).change();
      }
    	
    
  }

  function set_frame_color_func(framecolor){
      var using_framecolor = handleize_string(framecolor);
      if($('#frame-color-'+ using_framecolor).length){
      	$('#frame-color-'+ using_framecolor).prop('selected',true).change();
      }
    
  }

  function use_frame_color(){
      var selectedObj = $('#frameColors option:selected');
      var selectedclass = $('#frameColors option:selected').data('cssclass');
      var using_framecolor = handleize_string(selectedObj.val());
     // alert(selectedclass);
      $('#theMapFrame').attr('class',selectedclass);
      save_frame_color_func();
      build_url();
    
      if (selectedObj.is("[data-closeup]")){
			var closeup_src = selectedObj.data("closeup");
        	var closeup_HTML = '<a class="image-popup-fit-width" title="'+selectedObj.data('rawvalue')+' classic style frame" href="'+closeup_src+'"><i class="fa fa-info-circle" aria-hidden="true"></i> '+selectedObj.data('rawvalue')+' frame close up view</a>';
        	$('#frame_closeup').html(closeup_HTML);
           init_framePopup();

      }
    
  }

  function init_framePopup() {
	try {

		  $('.image-popup-fit-width').magnificPopup({
			  type: 'image',
			  closeOnContentClick: true,
			  image: {
				  verticalFit: false
			  }
		  });

	} catch (err_init_framePopup) {
	}
  }


  $(document).on('change', 'input[type=radio][name=color-scheme]', function(event) {
        //alert('change' + $(this).val());
		get_and_set_color_scheme();
		save_color_scheme_func($(this));
		build_url();
    	//update_map_colors_from_dialog($(this));

  });

  function get_and_set_color_scheme(){
    
    	var $thisObj = $('input[name=color-scheme]:checked');
    
    	/** Example 
    	id="map_colorScheme_standard" 
        data-css-class="map-style-1-1535323870171" 
        data-textcolor="" 
        data-textbg="" 
        data-textbgopacity="0.0" 
        data-accent="" 
        data-ocean="" 
        data-land="#ffffff" 
        class="color-radio" 
        name="color-scheme" 
        type="radio" 
        value="Standard" 
        **/
    	
    	/** var css,ocean,land,textbg,textbgopacity,marker,text1,text2,text3,accent,textcolor;
        land = $thisObj.data('land');
    	textbg = $thisObj.data('textbg');
    	textbgopacity = $thisObj.data('textbgopacity');
    	ocean = $thisObj.data('ocean');
		accent = $thisObj.data('accent');
    	textcolor = $thisObj.data('textcolor');*
    	marker = accent;
        text1 = textcolor;
        text2 = textcolor;
        text3 = textcolor;
        */
    
    	var css,minimapland,mapstyle;
    	css = $thisObj.data('css-class');
    	minimapland = $thisObj.data('land');
    	mapstyle = $thisObj.data('mapstyle');
    
    	
    	
		set_citymap_color_scheme_func(css,minimapland,mapstyle);
    	//set_full_color_scheme_func(ocean,land,textbg,marker,text1,text2,text3);
        setMiniMapColor();
  }
  
  function set_citymap_color_scheme_func(css,minimapland,mapstyle){
    
    	//set_marker_color_func(marker);
		setMiniMapColor();
        $(set_map_css_class).attr('class','').addClass(css);
    	$('body').attr('color-scheme', $('input[name=color-scheme]:checked').val());
        if (typeof cityMap === 'object') {
			cityMap.setStyle('mapbox://styles/cherishedlocations/' + mapstyle);
        }
    
    
        
    
  }
  
  
  function set_full_color_scheme_func(ocean,land,textbg,marker,text1,text2,text3){
    
    	set_marker_color_func(marker);
		set_land_color_func(land);
		set_ocean_color_func(ocean);
		set_text_1_color_func(text1);
    	set_text_2_color_func(text2);
		set_text_3_color_func(text3);
    
    	set_textbg_color_func(textbg);
    	//set_textbg_opacity(textbgopacity);
  }
  
  
  function save_color_scheme_func($thisObj){
     if (typeof($thisObj )==='undefined') $thisObj = $('input[name=color-scheme]:checked');
     var name = $thisObj.val();
  	 $(save_color_scheme).val(name);
  }

  function set_textbg_color_func(color){
  		//$(save_textbg_color).val(color);
		$(set_textbg_color).css('background-color',color);
  }

  function set_textbg_opacity(opacity){
  		//$(save_textbg_opacity).val(opacity);
		//$(set_textbg_opacity).css('opacity',opacity);
  }

  function set_ocean_color_func(color){
    /** not used int ehis version
	    $(set_ocean_color).css('background-color',color);
	**/
  }

  function set_marker_color_func(color){
      if($('.mapboxgl-marker svg').length){
         $('.mapboxgl-marker svg').css('fill',color);
          $('.mapboxgl-marker path').css('fill',color);
      }
	  //$(save_marker_color).val(color);
  }


  function set_text_1_color_func(color){
	    $(set_text_1_font_color).css('color',color);
    	//.val(color);
  }

  function set_text_2_color_func(color){
	    $(set_text_2_font_color).css('color',color);
    	//$(save_text_2_font_color).val(color);
  }

  function set_text_3_color_func(color){
    	//alert('set_text_3_color - '+color);
    	//alert($(set_text_3_font_color).attr('class'));
	    $(set_text_3_font_color).css('color',color);
    	//$(save_text_3_font_color).val(color);
  }
  
  
  
  
  
  /** ------------- NEW MARKERS ---------------**/
  
  
 
    function openMarkerPopup(number,type) {
      	$('#marker_picker_modal').attr('data-number',number);
      	//alert('openMarkerPopup '+number);
      	$('#marker_picker_modal').attr('data-type',type);
		$.magnificPopup.open({
			items: {
            	src: '#marker_picker_modal',
			},
            callbacks: {
              	open: function() {
                	$('html').attr('style','');
                  	$('body').removeClass('open-edit-drawer');
            	}
            },
			type: 'inline'
		});
    }
    function onMarkerDragEnd() {
    	try {
            var lngLat;
            
          	if (typeof city_marker1 === 'object') {
              if($('.marker1.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker1.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,1);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker2 === 'object') {
              if($('.marker2.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker2.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,2);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker3 === 'object') {
              if($('.marker3.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker3.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,3);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker4 === 'object') {
              if($('.marker4.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker4.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,4);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker5 === 'object') {
              if($('.marker5.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker5.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,5);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker6 === 'object') {
              if($('.marker6.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker6.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,6);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker7 === 'object') {
              if($('.marker7.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker7.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,7);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
          	if (typeof city_marker8 === 'object') {
              if($('.marker8.mapboxgl-marker').length){
					//set_user_marker_input_lnglat();
              		lngLat = city_marker8.getLngLat();
                  	set_user_marker_input_lnglat(lngLat.lng,lngLat.lat,8);
                  	console.log('6216 lngLat: ' + lngLat.lng + ' | ' + lngLat.lat);
                }
            	//console.log('lngLat: ' + lngLat.lng);
            }
            
		} catch (onDragEnd_errf) {
          	console.log("Error: "+onDragEnd_errf.message);
        } 
    }
    function fix_blank_address(address,lng,lat){
      	address = typeof address !== 'undefined' ? address : '';
        if(address == ''){
        	address = 'Longitude: ' + lng + ', Latitude: ' + lat;
		}
      	return address;
    }
    function fix_blank_iconname(name){
      	name = typeof name !== 'undefined' ? name : 'heart';
        if(name == ''){
        	name = 'heart';
		}
      	return name;
    }
    function stacktrace() {
      function st2(f) {
        var args = [];
        if (f) {
            for (var i = 0; i < f.arguments.length; i++) {
                args.push(f.arguments[i]);
            }
            var function_name = f.toString().split('(')[0].substring(9);
            return st2(f.caller) + function_name + '(' + args.join(', ') + ')' + "\n";
        } else {
            return "";
        }
      }
      return st2(arguments.callee.caller);
    }
    
    function adjustBrightness(col, amt) {

        var usePound = false;

        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }

        var R = parseInt(col.substring(0,2),16);
        var G = parseInt(col.substring(2,4),16);
        var B = parseInt(col.substring(4,6),16);

        // to make the colour less bright than the input
        // change the following three "+" symbols to "-"
        R = R + amt;
        G = G + amt;
        B = B + amt;

        if (R > 255) R = 255;
        else if (R < 0) R = 0;

        if (G > 255) G = 255;
        else if (G < 0) G = 0;

        if (B > 255) B = 255;
        else if (B < 0) B = 0;

        var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
        var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
        var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

        return (usePound?"#":"") + RR + GG + BB;

    }
    
    function set_user_marker_input_lnglat(lng,lat,rownumber,address){
      	address = typeof address !== 'undefined' ? address : '';
        address = fix_blank_address(address,lng,lat);
		var $inputObj = $('#custom-icon-data-'+rownumber);
      	var $rowObj = $('#custom-marker-'+rownumber);
      	var lat_lng_dms = convertDMS(lat,lng);
      	$rowObj.find('.marker-item-latlng').html(lat_lng_dms);
      	$rowObj.find('.marker-address').html(address);
      	$inputObj.attr('data-lat',lat);
      	$inputObj.attr('data-lng',lng);
      	build_custom_markers_url_param();
    }
    function get_user_marker_html(markername,number,hexcolor){
      	markername = typeof markername !== 'undefined' ? markername : 'star';
        var icon_html = $('#marker_picker_modal [name="marker-icon-radio"][value="'+markername+'"]').parents('.image-radio-item').find('.svg-icon-wrap').html();
      	var hexcolor = get_user_marker_hexcolor(number);
      	hexcolor = hexify_hexcolor(hexcolor);
        if (icon_html.indexOf('##fill##') > -1 ){
          	icon_html = icon_html.replace(/\##fill##/g,hexcolor);
        }
      	var darkerhexcolor = adjustBrightness(hexcolor,-85);
        if (icon_html.indexOf('##filldark##') > -1 ){
          	icon_html = icon_html.replace(/\##filldark##/g,darkerhexcolor);
        }
      	return icon_html;
    }
    function get_user_marker_name(number){
      	var $inputObj = $('#custom-icon-data-'+number);
        var markername = $inputObj.attr('data-name');
      	markername = typeof markername !== 'undefined' ? markername : 'star';
      	return markername;
    }
    function set_user_marker(number,markername){
      	var $inputObj = $('#custom-icon-data-'+number);
      	var $rowObj = $('#custom-marker-'+number);
      	var icon_html = get_user_marker_html(markername,number);
      	var hexcolor = get_user_marker_hexcolor(number);
      	hexcolor = hexify_hexcolor(hexcolor);
        if (icon_html.indexOf('##fill##') > -1 ){
          	icon_html = icon_html.replace(/\##fill##/g,hexcolor);
        }
      	var darkerhexcolor = adjustBrightness(hexcolor,-85);
        if (icon_html.indexOf('##filldark##') > -1 ){
          	icon_html = icon_html.replace(/\##filldark##/g,darkerhexcolor);
        }
      	$rowObj.find('.marker-item-svg-inner').html(icon_html);
      	$inputObj.attr('data-name',markername);
    }
    function get_user_marker_hexcolor(number){
      	try {
          	
            var $inputObj = $('#custom-icon-data-'+number);
            var $rowObj = $('#custom-marker-'+number);
            var hexcolor = $inputObj.attr('data-color');
            //console.log('number '+number+'| ' +hexcolor);
          	hexcolor = clean_hexcolor_value(hexcolor);
          	return hexcolor;
          
		} catch (hexcolor_errf) {
          	console.log("Error: "+hexcolor_errf.message);
        } 
    }
    function set_user_marker_color(number,hexcolor){
    	try {
          	hexcolor = typeof hexcolor !== 'undefined' ? hexcolor : 'ff001e';
            hexcolor = hexify_hexcolor(hexcolor);
          	//alert('----number '+number+' | hexcolor '+hexcolor+' ---');
            var $inputObj = $('#custom-icon-data-'+number);
            var $rowObj = $('#custom-marker-'+number);
            var markerClass = '.marker'+number;
          	//set_user_marker_color
            if($rowObj.length){
              	$rowObj.find('.color-point').css('background',hexcolor);
                $rowObj.find('.marker-item-svg-inner svg').css('fill',hexcolor);
                $rowObj.find('.marker-item-svg-inner path').css('fill',hexcolor);
            }
            if($(markerClass).length){
              	//console.log('-------found  color class '+hexcolor+' ---------');
              	setTimeout(function(){ 
                	$(markerClass).find('svg').css('fill',hexcolor);
                	$(markerClass).find('path').css('fill',hexcolor);
                }, 700);
            }
		} catch (set_marker_color_errf) {
          	console.log("Error: "+set_marker_color_errf.message);
        } 
    }
	function custom_marker_tmpl(number,markername,hexcolor,lng,lat,address){
      	markername = typeof markername !== 'undefined' ? markername : 'heart';
      	hexcolor = typeof hexcolor !== 'undefined' ? hexcolor : 'ff001e';
      	hexcolor = clean_hexcolor_value(hexcolor);
      	lng = typeof lng !== 'undefined' ? lng : '';
      	lat = typeof lat !== 'undefined' ? lat : '';
      	address = typeof address !== 'undefined' ? address : '';
        
		var custom_marker_row = '<div class="marker-item-row-inner">' +
                '<div class="marker-item-svg">'+
                    '<div data-svg-html class="marker-item-svg-inner"></div>'+
      			'</div><div class="color-point"></div><div class="marker-item-info-note">' +
                 	'<div data-number="' + number + '" class="marker-item-info-latlng-edit update-marker-popup cursor-pointer">Edit</div>' +
                '</div>' +
                '<div class="marker-item-latlng"></div>' +
                '<input type="hidden" data-number="' + number + '" class="marker-row-data" id="custom-icon-data-' + number + '" data-color="' + hexcolor + '" data-name="' + markername + '" data-lat="' + lat + '" data-lng="' + lat + '" />' +
        		'<div class="marker-address">' + address + '</div>' +
            	'<div data-number="' + number + '" class="cursor-hand remove-marker-row">×</div>'+
        '</div>';
      	return custom_marker_row;
    }
    function set_marker_popup(rownumber,type){
      	try {
            if(type == 'updatemarker'){
                var $inputObj = $('#custom-icon-data-'+rownumber);
                var $rowObj = $('#custom-marker-'+rownumber);
                var lat = $inputObj.attr('data-lat');
                var lng = $inputObj.attr('data-lng');
                var lnglat = convertDMS(lat,lng);
                var hexcolor = $inputObj.attr('data-color');
              	hexcolor = clean_hexcolor_value(hexcolor);
                var markername = $inputObj.attr('data-name');
                var markeraddress = $rowObj.find('.marker-address').html();
                markeraddress = fix_blank_address(markeraddress,lng,lat);
                var $modalObj = $('#marker_picker_modal');
                $modalObj.attr('data-number',rownumber);
                $('#marker_picker_modal').find('[name="marker-icon-radio"][value="'+markername+'"]').prop('checked',true).change();
              	$modalObj.find('.jscolor').val(hexcolor);
              	hexcolor = hexify_hexcolor(hexcolor);
              	$modalObj.find('.jscolor').css('background',hexcolor);
                build_latlng_sumamry(markeraddress,lng,lat);
            }
            else {
                build_latlng_sumamry('','','');
            }
		} catch (edit_marker_popuperrf) {
          	console.log("Error: " + edit_marker_popuperrf.message);
        } 
    }
    function build_marker_row(rownumber,markername,lng,lat,address,hexcolor,type){
      	try {
          	type = typeof type !== 'undefined' ? type : '';
          	hexcolor = clean_hexcolor_value(hexcolor);
            var row_html = custom_marker_tmpl(rownumber,markername,hexcolor,lng,lat,address);
            if(type == 'updatemarker'){
				$('#custom-marker-'+rownumber).html(row_html);
                set_user_marker(rownumber,markername);
                set_user_marker_color(rownumber,hexcolor);
            }
          	else {
              	var row_html_wrap = '<div id="custom-marker-' + rownumber + '" class="marker-item-row">' + row_html + '</div>';
                $('.marker-items').append(row_html_wrap);
                set_user_marker(rownumber,markername);
                set_user_marker_color(rownumber,hexcolor);
                $('#add_marker').attr('data-number',rownumber);
                rownumber = parseInt(rownumber);
                rownumber = rownumber + 1;
                $('#add_marker').show().attr('data-number',rownumber);
              if(rownumber <= 8) {

                    $('#add_marker').show();
                }
                else {

                  $('#add_marker').hide().attr('data-number',8);
                }
            }
		} catch (build_marker_row_errf) {
          	console.log("Error: " + build_marker_row_errf.message);
        } 
    }
    function clean_hexcolor_value(hexcolor){
    	try {
            hexcolor = hexcolor.replace(/[#]/g,'');
            return hexcolor;
		} catch (clean_hexcolor_value_errf) {
          	console.log("Error: clean_hexcolor_value " + clean_hexcolor_value_errf.message);
        } 
    }
    function hexify_hexcolor(hexcolor){
      	try {
            if(hexcolor.indexOf('#') > -1 ){
            }
            else {
                hexcolor = '#'+hexcolor;
            }
            return hexcolor;
		} catch (hexify_hexcolor_errf) {
          	console.log("Error: hexify_hexcolor " + hexify_hexcolor_errf.message);
        } 
    }
    function build_custom_markers_url_param() {
      	try {
            console.log('build_custom_markers_url_param');
            var $marker_rows_parentObj = $('.marker-items')
            var param = '';
            var param_item_sep = '||';
            var param_item = '';
            $('.marker-item-row').each(function( index, value ) {
                index = index + 1;
                if(index == 1){
                    param_item_sep = '';
                }
                else {
                    param_item_sep = '||';
                }
                var $inputObj = $('#custom-icon-data-'+index);
                var $rowObj = $('#custom-marker-'+index);
                var lat = $inputObj.attr('data-lat');
                var lng = $inputObj.attr('data-lng');
                console.log();
                var hexcolor = $inputObj.attr('data-color');
                console.log('6222 #custom-icon-data-' + index + '| hexcolor = '+ hexcolor+' | lat ' + lat + ' | lng ' + lng);
                hexcolor = clean_hexcolor_value(hexcolor);

                var markername = $inputObj.attr('data-name');

                var param_item = param_item_sep + 'icon_'+markername+'|lat_'+lat+'|lng_'+lng+'|color_'+hexcolor;
                param = param + param_item;
            });
            param = clean_hexcolor_value(param);
            $('#save_map_markers').val(param);
            build_url();
		} catch (build_custom_markers_url_param_errf) {
          	console.log("Error: build_custom_markers_url_param " + build_custom_markers_url_param_errf.message);
        } 
    }
    function process_custom_markers_url_param() {
      	try {
            if($('#save_map_markers').val() != ''){
                var param = $('#save_map_markers').val();

                if(	param.indexOf('icon_') > -1){
                     //exists 
                     var markers_arr = [];
                     markers_arr = param.split('||');
                     $.each( markers_arr, function( markernumber, marker ){
                        markernumber = markernumber + 1;
                        var markerdata_arr = [];
                        markerdata_arr = marker.split('|');
                        var lat = '';
                        var lng = '';
                        var markername = '';
                        var hexcolor = '';
                        var address = '';

                        $.each( markerdata_arr, function( index, markerdatavalue ){
                            var markerdatavalue_arr = [];
                            markerdatavalue_arr = markerdatavalue.split('_');
                            console.log('markerdatavalue_arr[0] '+markerdatavalue_arr[0]+' | markerdatavalue_arr[1] '+markerdatavalue_arr[1]);
                            if(markerdatavalue_arr[0] == 'lat'){
                                  lat = markerdatavalue_arr[1];
                            }
                            else if(markerdatavalue_arr[0] == 'lng'){
                                  lng = markerdatavalue_arr[1];
                            }
                            else if(markerdatavalue_arr[0] == 'icon'){
                                  markername = markerdatavalue_arr[1];
                            }
                            else if(markerdatavalue_arr[0] == 'color'){
                                  hexcolor = markerdatavalue_arr[1];
                                  hexcolor = clean_hexcolor_value(hexcolor);
                            }
                            else if(markerdatavalue_arr[0] == 'addr'){
                                  address = markerdatavalue_arr[1];
                            }
                        });
                        console.log('markernumber ' + markernumber +  ' | lng = ' + lng + ' | lat = ' + lat + ' | address = ' + address + ' | hexcolor = '+ hexcolor);
                        address = fix_blank_address(address,lng,lat);
                        build_marker_row(markernumber,markername,lng,lat,address,hexcolor,'');
                        addDragableMarker(cityMap,markernumber,lng,lat,address,hexcolor);
                     });
                }
                else {
                   //nope
                }
            }
		} catch (process_custom_markers_url_param_errf) {
          	console.log("Error: process_custom_markers_url_param " + process_custom_markers_url_param_errf.message);
        }  
    }
    
    function redo_row_numbers(){
      	try {
			$('.marker-item-row').each(function( index, value ) {
              	//index starts at zeo 
              	index = index + 1;
              	var $thisObj = $(this);
				$thisObj.attr('id','custom-marker-'+index);
              	$thisObj.find('.marker-row-data').attr('id','custom-icon-data-'+index);
                $thisObj.find('[data-number]').each(function() {
					var $thisObjNew = $(this);
					$thisObjNew.attr('data-number',index);
				});
			});
			
		} catch (redo_row_numbers_errf) {
          	console.log("Error: redo_row_numbers " + redo_row_numbers_errf.message);
        } 
    }
    function set_markers_from_rows(){
      	try {
          	
          	city_marker1.remove();
          	
          	city_marker2.remove();
          	
          	city_marker3.remove();
          	
          	city_marker4.remove();
          	
          	city_marker5.remove();
          	
          	city_marker6.remove();
          	
          	city_marker7.remove();
          	
          	city_marker8.remove();
          	
			$('.marker-item-row').each(function( index, value ) {
              	//index starts at zeo 
              	//if($('#custom-marker-'+index).length){
                  	
                    var dataObj = $(this).find('.marker-row-data');
                    var lat = dataObj.attr('data-lat');
                    var lng = dataObj.attr('data-lng');
                    var number = dataObj.attr('data-number');
                    var address = $(this).find('.marker-address').html();
              		var hexcolor = $(this).attr('data-color');
              		hexcolor = clean_hexcolor_value(hexcolor);
                  	console.log('6604 number ' + number + ' | lat '+lat+ ' | address ' + address);
                    addDragableMarker(cityMap,number,lng,lat,address,hexcolor);
              	//}
              	
			});
          	var rowcount = $('.marker-item-row').length;
            if(rowcount < 8) {
              	rowcount = rowcount+1;
              	$('#add_marker').show().attr('data-number',rowcount);
				$('#add_marker').show();
            }
            else {
              $('#add_marker').hide().attr('data-number',8);
            }
			
		} catch (set_markers_from_rows_errf) {
          	console.log("Error: set_markers_from_rows " + set_markers_from_rows_errf.message);
        } 
    }
    function delete_marker_row(number){
      	try {
        	$('#custom-marker-'+number).remove();
			redo_row_numbers(number);
          	set_markers_from_rows(number);
		} catch (delete_marker_row_errf) {
          	console.log("Error: delete_marker_row " + delete_marker_row_errf.message);
        } 
    }
    function addDragableMarker(mapObj,number,lng,lat,address,hexcolor){
      	try {
            mapObj = typeof mapObj !== 'undefined' ? mapObj : cityMap;
            console.log('addDragableMarker ' + number);
            //alert('lng = '+lng+' | lat = ' + lat);
            if ((lng != '') && (lat != '')){
            }
            else {
                var mapCenter = mapObj.getCenter();
                lng = mapCenter['lng'];
                lat = mapCenter['lat'];
            }
            var lng_lat = [lng, lat];
            // create a HTML element for each feature
            var $inputObj = $('#custom-icon-data-'+number);
            var $rowObj = $('#custom-marker-'+number);
            var markername = get_user_marker_name(number);
            hexcolor = clean_hexcolor_value(hexcolor);
            var icon_html = get_user_marker_html(markername,number,hexcolor);
            var $markerObj = '';
            var markerClass = '';
            console.log('number ' + number + ' | markername = '+markername);
            number = parseInt(number);
            switch(number) {
                
              	case 1:
                if (typeof city_marker1 === 'object') {
                      $markerObj = city_marker1;
                      markerClass = '.marker1';
                }
                break;
                
              	case 2:
                if (typeof city_marker2 === 'object') {
                      $markerObj = city_marker2;
                      markerClass = '.marker2';
                }
                break;
                
              	case 3:
                if (typeof city_marker3 === 'object') {
                      $markerObj = city_marker3;
                      markerClass = '.marker3';
                }
                break;
                
              	case 4:
                if (typeof city_marker4 === 'object') {
                      $markerObj = city_marker4;
                      markerClass = '.marker4';
                }
                break;
                
              	case 5:
                if (typeof city_marker5 === 'object') {
                      $markerObj = city_marker5;
                      markerClass = '.marker5';
                }
                break;
                
              	case 6:
                if (typeof city_marker6 === 'object') {
                      $markerObj = city_marker6;
                      markerClass = '.marker6';
                }
                break;
                
              	case 7:
                if (typeof city_marker7 === 'object') {
                      $markerObj = city_marker7;
                      markerClass = '.marker7';
                }
                break;
                
              	case 8:
                if (typeof city_marker8 === 'object') {
                      $markerObj = city_marker8;
                      markerClass = '.marker8';
                }
                break;
                
                default:
                  if (typeof city_marker1 === 'object') {
                      $markerObj = city_marker1;
                      markerClass = '.marker1';
                  }
            }
            $markerObj.remove();
            $markerObj.setLngLat(lng_lat).addTo(mapObj);
            $(markerClass).attr('data-icon',markername).html(icon_html);
            set_user_marker_input_lnglat(lng,lat,number,address);
            build_custom_markers_url_param();
		} catch (addDragableMarker_errf) {
          	console.log("Error: addDragableMarker " + addDragableMarker_errf.message);
        } 
    }
	$(document).on('click', '.set-the-marker', function (e) {
      	
      	var number = $('#marker_picker_modal').attr('data-number');
      	var type = $('#marker_picker_modal').attr('data-type');
      	var $selectedObj = $('#marker_picker_modal').find('.marker-radio:checked');
      	var hexcolor = $('#marker_picker_modal').find('.jscolor').val();
      	hexcolor = clean_hexcolor_value(hexcolor);
      	//alert('#marker_picker_modal = '+number);
      	var markername = fix_blank_iconname($selectedObj.val());
      	$.magnificPopup.close();
      	$('#marker_picker_modal').attr('data-number','');
      	var $selectedObj = $(this);
      	var $latlngParentObj = $('#marker_picker_modal .chosen-location-summary');
      	
      	var lat = '';
      	var lng = '';
      	var address = $latlngParentObj.find('.selected-address').html();
      	address = fix_blank_address(address,lng,lat);
        if(($latlngParentObj.find('.latlng').attr('data-lng') != '') && ($latlngParentObj.find('.latlng').attr('data-lat') != '')){
            lat = $latlngParentObj.find('.latlng').attr('data-lat');
            lng = $latlngParentObj.find('.latlng').attr('data-lng');;
            //alert('lng = '+lng+' | lat = ' + lat);
        }
        else {
        	var mapCenter = cityMap.getCenter();
            lng = mapCenter['lng'];
            lat = mapCenter['lat'];
        }
      	build_marker_row(number,markername,lng,lat,address,hexcolor,type);
		addDragableMarker(cityMap,number,lng,lat,address,hexcolor);
	});
    function build_latlng_sumamry(address,lng,lat){
      	
      	if ((lng != '') && (lat != '')){
            address = fix_blank_address(address,lng,lat);
          	$('#marker_picker_modal .chosen-location-summary .latlng').attr('data-lng',lng).attr('data-lat',lat).html(convertDMS(lat,lng));
            $('#marker_picker_modal').find('.selected-address').html(address);
            $('#marker_picker_modal').find('.chosen-location-summary').show();
          	$('#marker_picker_modal').find('.no-marker-location').hide();
      	}
        else{
          	$('#marker_picker_modal').find('.chosen-location-summary').hide();
            $('#marker_picker_modal').find('.no-marker-location').show();
            $('#marker_picker_modal .chosen-location-summary .latlng').attr('data-lng','').attr('data-lat','').html('');
            $('#marker_picker_modal').find('.selected-address').html('');
        }
    }
	$(document).on('click', '.remove-selected-address', function (e) {
      	
      	$('#marker_picker_modal .chosen-location-summary .latlng').attr('data-lng','').attr('data-lat','').html('');
      	$('#marker_picker_modal').find('.selected-address').html('');
      	$('#marker_picker_modal').find('.chosen-location-summary').hide();
                  $('#marker_picker_modal').find('.no-marker-location').show();
	});
	$(document).on('click', '#add_marker', function (e) {
		//place_marker(0,0,cityMap);
      	var number = $(this).attr('data-number');
      	//alert('#add_marker '+number);
      	var type = 'setmarker';
      	openMarkerPopup(number,type);
        set_marker_popup(number,type);
	});
	$(document).on('click', '.update-marker-popup', function (e) {
		//place_marker(0,0,cityMap);
      	var number = $(this).attr('data-number');
      	var type = 'updatemarker';
      	openMarkerPopup(number,type);
      	set_marker_popup(number,type);
	});
	$(document).on('click', '.remove-marker-row', function (e) {
		//place_marker(0,0,cityMap);
      	var number = $(this).attr('data-number');
      	delete_marker_row(number);
	});
    

  	/**
	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#username',
		modal: true
	});**/
    
    function openColorPopup(el) { // get the class name in arguments here
		$.magnificPopup.open({
			items: {
            	src: '#color_picker_modal',
			},
            callbacks: {
              	open: function() {
                	$('html').attr('style','');
                  	$('body').removeClass('open-edit-drawer');
            	}
            },
			type: 'inline'
		});
      

    }
	$('#color_picker_modal').drags({
      handle: '#color_picker_handle'
    });

    $(function () {
        $('.ajax-call').click(function (e) {
            openColorPopup(this.className);
        });
        $(document).on('click', '.closePopup', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    });
    
    
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
       	$('body').attr('data-popup','');
	});
    var pickTextColorBasedOnBgColorAdvanced_func = function(col) {
    	try {
              if (col <= 0.03928) {
                return col / 12.92;
              }
              return Math.pow((col + 0.055) / 1.055, 2.4);
		} catch (pickTextColorBasedOnBgColorAdvanced_func_errf) {
          	console.log("Error: pickTextColorBasedOnBgColorAdvanced_func_errf " + pickTextColorBasedOnBgColorAdvanced_func_errf.message);
        }      
    }
    function pickTextColorBasedOnBgColorAdvanced(bgColor, lightColor, darkColor) {
      	try {

            var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            var uicolors = [r / 255, g / 255, b / 255];
            var c = uicolors.map(pickTextColorBasedOnBgColorAdvanced_func);
            var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
            return (L > 0.179) ? darkColor : lightColor;
          
          
		} catch (pickTextColorBasedOnBgColorAdvanced_errf) {
          	console.log("Error: pickTextColorBasedOnBgColorAdvanced " + pickTextColorBasedOnBgColorAdvanced_errf.message);
        } 
    }
    
    function process_color_update($thisObj,color){
      
      	var layer_id = $thisObj.data('id');
      	var layer_property = $thisObj.data('property');
      	var hexcolor = color;
      	
      	hexcolor = hexify_hexcolor(hexcolor);
      	
      	//console.log('process_color_update ------');
      	//console.log('land color  = ' + $('#custom_land').val());
      	//console.log('layer_id = ' + layer_id + ' | layer_property = ' + layer_property + ' | hexcolor = ' + hexcolor);
      	//console.log('process_color_update END ------');
      	setmap_style_item(layer_id, layer_property, hexcolor, cityMap);
    }
    
    function update_custom_color_icon(){
      	var $svgObj = $('.custom-color-scheme-icon-svg');
      	var land_color = $('#custom_land').val();
      	var water_color = $('#custom_water').val();
        var road_color = $('#custom_roads').val();
      
      	var national_park_color = $('#custom_national_park').val();
      	var park_color = $('#custom_park').val();
      	var building_color = $('#custom_building').val();
      
      	var using_park = national_park_color;
      	$svgObj.find('#land').css('fill',land_color);
      	$svgObj.find('#water').css('fill',water_color);
      	$svgObj.find('#road').css('fill',road_color);
        if (national_park_color == land_color){
			using_park = park_color;
        }
      	$svgObj.find('#park').css('fill',using_park);
    }
    function build_custom_color_url_param() {
      	//console.log('build_custom_color_url_param');
      	var land_color = $('#custom_land').val();
      	var water_color = $('#custom_water').val();
        var road_color = $('#custom_roads').val();
      
      	var national_park_color = $('#custom_national_park').val();
      	var park_color = $('#custom_park').val();
      	var building_color = $('#custom_building').val();
      
      	if ($('#custom_national_park').parents('.table-column').find('.disable-feature:checked').length > 0) {
       		national_park_color = 'disabled';
        }
      	if ($('#custom_park').parents('.table-column').find('.disable-feature:checked').length > 0) {
       		park_color = 'disabled';
        }
      	if ($('#custom_building').parents('.table-column').find('.disable-feature:checked').length > 0) {
       		building_color = 'disabled';
        }
      	
      	var param = 'custom||land-'+land_color+'|water-'+water_color+'|roads-'+road_color+'|national_park-'+national_park_color+'|park-'+park_color+'|building-'+building_color;
      	var param = param.replace(/\#/g,"");
      	//console.log(param);
      	$('#map_colorScheme_custom').attr('data-colorparams',param);
      	build_url();
      
    }
    
    function process_custom_color_url_param() {
      	if($('#map_colorScheme_custom').is("[data-colorparams]")){
			var param = $('#map_colorScheme_custom').attr('data-colorparams');
          	if(	param.indexOf('custom||') > -1){
                 //exists 
                 var params_arr = [];
                 params_arr = param.split('||');
                 var values_arr = [];
                 values_arr = params_arr[1].split('|');
                 $.each( values_arr, function( index, value ){
                      //console.log('process_custom_color_url_param | '+value);
                      var rows_arr = [];
                      rows_arr = value.split('-');
                      if($('#custom_'+rows_arr[0]).length){
                          var $thisObj = $('#custom_'+rows_arr[0]);
                        
                          var hexcolor = rows_arr[1];
                          //console.log('process_custom_color_url_param - hexcolor | '+hexcolor);
                          if(hexcolor.indexOf('disabled') > -1){
                            	
                              $thisObj.parents('.table-column').find('.disable-feature').prop('checked',true).change();
                              hexcolor = $('#custom_land').val();
                          }
                          else {
                          		 $thisObj.parents('.table-column').find('.disable-feature').prop('checked',false).change();
                          }

                          hexcolor = hexify_hexcolor(hexcolor);
                        
                          var textcolor = pickTextColorBasedOnBgColorAdvanced(hexcolor, '#dddddd', '#222222');
                          $thisObj.css('background-color',hexcolor).css('color',textcolor);
						  $thisObj.val(hexcolor);
                          if($thisObj.siblings('.additional-field').length) {
                              $thisObj.siblings('.additional-field').each(function() {
                                  var $eachObj = $(this);
                                  $eachObj.val(hexcolor);
                              });
                          }
                      }
                 });
          	}
            else {
               //nope
            }
        }
    }

	var pixel_instance_color = $.fn.deviceDetector;
  	var device = 'desktop';
    if (pixel_instance_color.isMobile()){
		$('.jscolor').attr('readonly', 'readonly');
    }
    
    function inherit_land_color(){
		var hexcolor = $('#custom_land').val();
   		var text_color = $('#custom_land').css('color');
        //console.log($thisObj.attr('id') + ' == #custom_land');
		$('.disable-feature:checked').each(function() {
        	var $eachObj2 = $(this);
           	var $targetObj2 = $eachObj2.parents('.table-column').find('.jscolor');
          	if ($targetObj2.val() != hexcolor) {
                //console.log("$targetObj = " + $targetObj.data('id') + ' | hexcolor = '+ hexcolor);
                $targetObj2.val(hexcolor);
                $targetObj2.css({
                    backgroundColor: hexcolor,
                    color: text_color
                });
                process_color_update($targetObj2,hexcolor);
                $targetObj2.siblings('.additional-field').each(function() {
                   // console.log('------sibling item -----');
                    var $eachObj2 = $(this);
                    process_color_update($eachObj2,hexcolor);
                    //console.log('------siblings item END -----');
                });	
            }
		});
      	update_custom_color_icon();
    }
    
    function color_update($thisObj,color) {
      	if ($thisObj.parents('#color_picker_modal').length){
       	//update this one 
      	var hexcolor = color;
      	process_color_update($thisObj,hexcolor);
        $thisObj.siblings('.additional-field').each(function() {
          	var $eachObj = $(this);
          	process_color_update($eachObj,hexcolor);
        });
      	//console.log($thisObj.attr('id') + ' == custom_land');
      	//find_and_update_inherited_land_colors();
      
      	if($thisObj.attr('id') == 'custom_land' ){
         	// update land ticked children
          	inherit_land_color();
      	}
      	else if ($thisObj.parents('.table-column').find('.disable-feature').length) { //Has checkbox
            var $checkboxObj = $thisObj.parents('.table-column').find('.disable-feature');
            var hex_land_color = $('#custom_land').val();
            if (hexcolor == hex_land_color) { //Colour matches land colour
              //Tick its checkbox
              $checkboxObj.prop('checked',true);
            } else {
              //Untick its checkbox
              $checkboxObj.prop('checked',false);
            }
    	}
        update_custom_color_icon();
        build_custom_color_url_param();
        }
    }
	$('.disable-feature').on('change', function () { 
      	//var $targetObj = $(this).parents('.table-column').find('.jscolor');
        if ($(this).prop('checked')) {
           	inherit_land_color();
          	//$targetObj.prop('disabled',true);
        } else {
             //$targetObj.prop('disabled',false);
          	
        }
      	
    
    });
    
    
    
    function update_map_colors_from_dialog(){
      	var $thisObj = $('input[name=color-scheme]:checked');
      	if($thisObj.val() == 'custom') {
            $('#color_picker_modal .jscolor').each(function() {
                var hexcolor = $(this).val();
                color_update($(this),hexcolor);
            });
      	}
    }
    $('body').on('click', '.close-picker-btn', function(e) {
                e.preventDefault();
      	  $('.cp-color-picker').hide();
      		$(':focus').blur()
    });
    $('body').on('click', '.close-dialog-btn', function(e) {
      	 
          e.preventDefault();
       		$('.cp-color-picker').hide();
          $.magnificPopup.close();
      	$(':focus').blur()
    });
      
    $('body').on('click', '.open-colour-dialog', function() {
    	  openColorPopup('popup-modal');
      	  if($("input[name='color-scheme']").val() != 'custom'){
            	$('body').removeClass('open-edit-drawer');
          		$("input[name='color-scheme'][value='custom']").prop('checked', true).change();
      	  }
      	  $('.mfp-bg').hide();
      	  $('body').attr('data-popup','color-picker');
    });
    
    $('body').on('click', '.mobile-button-rewards', function() {
    	  $('.blp-call-to-action').trigger('click');
    });
    
   
    
    

	$(document).arrive('#jscolor_box', function(newElem) {
    	var $div = $(newElem);
        //alert('###ARRIVE  jscolor_box');  
	});
    
    
	var plugin = {};

	// shows memory fields
	plugin.memory = {
		customBG: '#222',
		margin: '4px -2px 0',
		doRender: 'div div',
		opacity: false,



		buildCallback: function($elm) {
			var colorInstance = this.color,
				colorPicker = this,
				random = function(n) {
					return Math.round(Math.random() * (n || 255));
				};


			var color_list_html = ''+
            '<div class="cp-memory">' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
			'<div></div>' +
            '</div>';
			$elm.prepend(color_list_html).on('click', '.cp-memory div', function(e) {
				var $this = $(this);

				if (this.className) {
					$this.parent().prepend($this.prev()).children().eq(0).
						css('background-color', '#' + colorInstance.colors.HEX);
				} else {
					colorInstance.setColor($this.css('background-color'));
					colorPicker.render();
				}
			}).find('.cp-memory div').each(function() {
				!this.className && $(this).css({background:
					'rgb(' + random() + ', ' + random() + ', ' + random() + ')'
				});
			});
			var color_button_html = ''+
            '<div class="cp-buttons">' +
			'<div class="close-picker-btn">Close</div>' +
			'<div class="close-dialog-btn">Back to design</div>' +
            '</div>';
          	$elm.append(color_button_html);
          
			this.$colorPatch = $elm.prepend('<div class="cp-disp">').find('.cp-disp');
			$('.color').on('click', function(e) {
				e.preventDefault && e.preventDefault();
			});
          
		},
		renderCallback: function($elm, toggled) {
			var colors = this.color.colors;
            var thecolor = colors.HEX;
            //console.log('### thecolor = ' + colors.HEX);
          	
            color_update($elm,'#' + colors.HEX);
			this.$colorPatch.css({
				backgroundColor: '#' + colors.HEX,
				color: colors.RGBLuminance > 0.22 ? '#222' : '#ddd'
			}).text(this.color.toString($elm._colorMode)); // $elm.val();
		}
	};

	$('.jscolor').colorPicker(
		plugin.memory
	);
   
    
    
    
  

//------------ COLOR SCHEME END  ----------------------------------------

//------------ FONTS ----------------------------------------------------

  $(document).on('change', '#fontDropdown', function(event) {
      //alert( this.value );
        save_font();
    	set_font_family();
      	storeVariant();
    	build_url();
  });


  function get_selected_fonts(){
  	if ($('#fontDropdown').length) {
    	var $thisObj = $('#fontDropdown');

    	var fontFamily,text1family,text2family,text3family;
 		var textClass = $thisObj.val().replace(/\s+/g, '-').toLowerCase();
        fontFamily = textClass;


    	set_font_family(fontFamily);
	}

  }





  function get_font(){
  	if ($('#fontDropdown').length) {
    	var $thisObj = $('#fontDropdown');
 		var textClass = $thisObj.val().replace(/\s+/g, '-').toLowerCase();
    	return textClass;
	}
    
  }


  function save_font(){
      var font = get_font();
	  $(save_font_stack).val(font)
    
  }

  function set_font_family(the_class){
    	var the_class = get_font();
	    $(set_font_stack).attr('class','').attr('class',the_class);
    	////$(save_font_stack).val(the_class);
  }


  function set_fonts(fontFamily){
		set_font_family(fontFamily);
  }

//------------ FONTS END -------------------------------------------------

//------------ MARKERS & THUMB ---------------------------------------------------

	
	//For now Markers will only be placed on the minimap

  $(document).on('change', '[name="marker-icon-radio"]', function(event) {
    /**
    //alert( this.value );
      set_marker_icon_func();
      save_marker_icon_func();
    	build_url();
        **/
  });

  function set_marker_icon_func(){
    	
    	var $thisObj = $('[name="marker-icon-radio"]:checked');
    	//alert($thisObj.attr('class'));
    	var marker_html = $thisObj.next('label').find('.svg-icon-wrap').html();
        var name = $thisObj.val();
    	//alert(name);
		$('#for_icon').attr('class','').addClass(name);
        if($(map_marker_selector).length){
          //alert(marker_html);
			$(map_marker_selector).html(marker_html);
          	set_marker_color_from_selected();
        }
  }

  function get_marker_icon(){
     var $thisObj = $('[name="marker-icon-radio"]:checked');
     var name = $thisObj.val();
  	 return name;
  }

  function save_marker_icon_func(){
     var name = get_marker_icon();
  	 $(save_marker_icon).val(name);
  }

  function set_marker_color_from_selected(){
    
    	var $thisObj = $('input[name=color-scheme]:checked');
		var color = $thisObj.data('accent');
   
      if($('.mapboxgl-marker svg').length){
          $('.mapboxgl-marker svg').css({ fill: color});
          $('.mapboxgl-marker path').css({ fill: color});
      }
  }

  function save_marker_details(lat,lng,addr){
    	var theaddr = typeof addr !== 'undefined' ? addr : '';
    	//console.log('save_marker_details lat '+ lat);
    	//console.log('save_marker_details lng '+ lng);
      $(save_marker_lat).val(lat);
      $(save_marker_lng).val(lng);
      $(save_marker_addr).val(theaddr);
    
	  if ((lat != null) && (lng != null)){
          var marker_latlng = convertDMS(lat,lng);
          $(save_marker_latlng).val(marker_latlng);
          //console.log('save_marker_details = ' + marker_latlng);

          $('.latlng-me').html(marker_latlng);
      }
    
      //var save_map_lat = $('#save_map_lat');
      //var save_map_lat = $('#save_map_lat');
    	//alert('lat = '+ lat + ' lng = '+lng);
  }

  function remove_marker(){
    	
      save_marker_details('','','');
    	marker.remove();
        if($('.marker.mapboxgl-marker').length){
          $('.marker.mapboxgl-marker').remove();

        }
    
      
    	check_marker();
  }

  function check_marker(){
    var markerLat = $(save_map_lat).val(); //$(save_marker_lat).val();	
    var markerLng = $(save_map_lng).val(); //$(save_marker_lng).val();
	if ((markerLat != '') && (markerLng != '')){
      
      	$('.thumb_canvasContainer').show();
      
    	$('.map-markers').removeClass('nomarker').addClass('hasmarker');  
          //alert('hasmarker');
	}
    else{
    	$('.map-markers').removeClass('hasmarker').addClass('nomarker');   
          //alert('nomarker');
    }

  }

  function set_marker_from_url(){

      var marker_lat = decodeURIComponent($.urlParam('mapLat')); //decodeURIComponent($.urlParam('markerLat'));
      var marker_lng = decodeURIComponent($.urlParam('mapLng')); //decodeURIComponent($.urlParam('markerLng'));
      var marker_addr = decodeURIComponent($.urlParam('markerAddr'));
      if(marker_lat != null && marker_lng != null){
          place_marker(marker_lng,marker_lat);
          //console.log('set_marker_from_url about to set_thumb_map');
          set_thumb_map(marker_lng,marker_lat,marker_addr);
          //save_marker_details(marker_lat,marker_lng,marker_addr);
          return true;
      }
      else{
          return false; 
      }

  }

  function set_thumb_map_from_saved(){
      var lat = $(save_map_lat).val(); //$(save_marker_lat).val();
      var lng = $(save_map_lng).val(); //$(save_marker_lng).val();
      var addr = $(save_marker_addr).val();
      //console.log('set_thumb_map_from_saved about to set_thumb_map');
      set_thumb_map(lng,lat,addr);
  }

  function set_thumb_map(lng,lat,address){
      if($('.thumb_canvasContainer').length){
          if (typeof mapThumb === 'object') {
              if(markerThumb){
                  markerThumb.setMap(null);
              }
              if (check_string(lng) && check_string(lat) && check_string(address)){
                  //alert('set_thumb_map_lng ='+lng);
                  //console.log('set_thumb_map_lat ='+lat);
                  var location = new google.maps.LatLng(lat,lng);
                  markerThumb = new google.maps.Marker({
                  map: mapThumb,
                  position: location
                  });
                  mapThumb.setCenter(location);
                      
                	//alert('show_thumb');
                      $('.choices-wrap .marker-autocomp-form').hide();
                      $('.thumbaddress-loc').html(address);
                      $('.thumbaddress-lnglat').html(convertDMS(lat,lng));
                	$('.thumb_canvasContainer').show();
              }
              else {
              }
          }
      }
  }
  
  function place_marker_from_saved(){
	  /** this is only for mini map for now**/
      var lat = $(save_map_lat).val(); //$(save_marker_lat).val();
      var lng = $(save_map_lng).val(); //$(save_marker_lng).val();
      place_marker(lng,lat)
  }


  function place_marker(lng,lat,mapObj){
    /** this is only for mini map for now**/
	mapObj = typeof mapObj !== 'undefined' ? mapObj : countryMap;
    lng = typeof lng !== 'undefined' ? lng : $(save_map_lng).val();
    lat = typeof lat !== 'undefined' ? lat : $(save_map_lat).val();
    if (typeof marker === 'object') {
          //marker lat lng
          var lat_lng = [lng, lat];
          //country lat lng 
          var selectedObj = $('#countryDropdown');
          var countrylat = selectedObj.data('lat');
          var countrylng = selectedObj.data('lng');
      	  var mapzoom = getZoom($('#countryDropdown')); 

          //console.log('place_marker_lat '+lat);
          //console.log('place_marker_lng '+lng);
          //save_marker_details(lat,lng,addr);
      
          var short_latlng = convertDMS(lat,lng);
      	  //console.log('place_marker = ' + short_latlng);
          $('.latlng-me').html(short_latlng);

          var markerHtml = $('[name="marker-icon-radio"]:checked').parents('div').find('.svg-icon-wrap').html();
          //alert($('[name="marker-icon-radio"]:checked').val());
          marker.remove();  
          marker.setLngLat(lat_lng).addTo(mapObj);
          $('.marker').html(markerHtml);
          set_marker_color_from_selected();
          countryMap.jumpTo({ 
              center: [countrylng, countrylat],
              zoom: mapzoom
          }); 
          check_marker();
    }
  }

//------------ MARKERS END -----------------------------------------------

//------------ USER TEXT ---------------------------------------------------

  $(document).on('input', '.update-from-me', function(event) {
      var $thisObj = $(this);
      
      if($($thisObj.attr('data-linkedinput')).length){
        //alert($(this).val());
          $($thisObj.attr('data-linkedinput')).html($(this).val());
          $($thisObj.attr('data-savetext')).val($(this).val()); 
          build_url();
        	
      }
      if($thisObj.attr('id') == 'line_2'){
		$('#add_lat_lng').prop('checked', false);
      }
      show_hide_text_labels();

  });

  $(document).on('change', '#add_lat_lng', function(event) {
      //alert( this.value );
      set_latlng_subtitle();
  });


  function set_latlng_subtitle(){
    var subtitle,lat,lng,markerlat,markerlng,contentlat,contentlng;
    var $thisObj = $('#cityDropdown');
    if($('#add_lat_lng').is(':checked')){
    
    	
    
		
    	subtitle = $thisObj.data('line2');
      	var mapCenter = cityMap.getCenter();
        lng = mapCenter['lng'];
        lat = mapCenter['lat'];
      
      	//markerlat = $(save_map_lat).val(); //$(save_marker_lat).val();
    	//markerlng = $(save_map_lat).val(); //$(save_marker_lng).val();
    	/**
        if (markerlat != '' && markerlng != '' ){
            contentlat = markerlat;
            contentlng = markerlng;
        }
        else{
            contentlat = lat;
            contentlng = lng;
        }**/
        contentlat = lat;
        contentlng = lng;
     	subtitle = convertDMS(contentlat,contentlng);	
      
      	//console.log('subtitle contentlat = '+contentlat);
        //console.log('subtitle contentlng = '+contentlng);
    
		$(set_text_2_content).val(subtitle);
        // alert($(set_text_2_content).val().length);
        if($($(set_text_2_content).attr('data-linkedinput')).length){

            $($(set_text_2_content).attr('data-linkedinput')).html(subtitle);
            $(save_text_2_content).val(subtitle);
          	show_hide_text_labels();
          	
         
        }
  	}
    build_url();
  }

    function toDegreesMinutesAndSeconds(coordinate) {
        var absolute = Math.abs(coordinate);
        var degrees = Math.floor(absolute);
        var minutesNotTruncated = (absolute - degrees) * 60;
        var minutes = Math.floor(minutesNotTruncated);
        var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

        return degrees + "." + minutes;
    }

    function convertDMS(lat, lng) {
      	//console.log('convert in lat '+lat);
      	//console.log('convert in lng '+lng);
        var latitude = toDegreesMinutesAndSeconds(lat);
        var latitudeCardinal = Math.sign(lat) >= 0 ? "N" : "S";

        var longitude = toDegreesMinutesAndSeconds(lng);
        var longitudeCardinal = Math.sign(lng) >= 0 ? "E" : "W";
      	//console.log('convert out lat '+latitude);
      	//console.log('convert out lng '+longitude);
        return latitude + "°" + latitudeCardinal + " / " + longitude + "°" + longitudeCardinal;
      	//return lat.toFixed(2)+"&deg;"+latitudeCardinal+ " / " + lng.toFixed(2)+"&deg;"+longitudeCardinal;
    }

//------------ USER TEXT END -----------------------------------------------

//-------------  CART MODS -----------------------------------------



$('.product-quantity').each(function() {
	decrement_disable($(this));
});
      
//cart_item_quantity_change
      
$(function() {
      	update_cart_items();
      	//set_framing_service_message();
	$(document).arrive('.data-cart-item-motw', function() {
      	update_cart_items();
      	//set_framing_service_message();
	});
  
	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#username',
		modal: true
	});
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
});
      
function cart_prop_itemplate(first,last) {
  	try {
        var first_downcase = first.toLowerCase();
        var colorclass = '';
        var colorvalue = '';
        if (first_downcase.indexOf('color scheme') > -1) {
            colorclass = 'color-scheme cart-item__property';
            colorvalue = last.toLowerCase().replace(/\s/g, '-');
            colorclass = colorclass + ' ' + colorvalue;
          	console.log('-------- cart_prop_itemplate -------');
          	console.log('-------- ' + colorclass + ' ' + colorvalue + ' -------');
        }
      	
      	var first_final = first.replace('/_/g','');
      	var last_final = last;
        if(last_final.indexOf('http') > -1){
			
        }
        else {
			last_final.replace('/_/g','');
        }
        var html = '<li data-cart-itempropname-motw="'+first+'" class="cart-property-motw '+ colorclass +'" data-cart-item-property-motw>';
        html += '<span class="hulkapps_option_name" data-cart-item-property-name-motw>'+first_final+':';
        html += '</span>';
        if (first_downcase.indexOf('preview image') > -1) {
          	console.log('first_downcase = '+first_downcase);
        	html += '<span class="hulkapps_option_value" data-cart-item-property-value-motw data-cart-item-preview-image-motw>'+last_final;
          	html += '</span>';
        } else if ((last.indexOf('/uploads/') > -1) || (last.indexOf('.jpg') > -1) || (last.indexOf('.png') > -1) || (last.indexOf('.jpeg') > -1) || (last.indexOf('svg') > -1)){
            if (last.indexOf('_|_') > -1) {
                var propertyVal = last.split('_|_');
                var swatchVal = propertyVal[0].replace('http://','').replace('&amp;amp;amp;', '&amp;amp;').replace('&amp;amp;lt;', '<').replace('&amp;amp;gt;', '>');
                var swatchImage = propertyVal[1];
                html += '<span class="hulkapps_option_value " style="cursor: pointer;" data-cart-item-property-value-motw >';
                html += '<div style="width:35px;height:35px;background-image:url('+swatchImage+');background-size:cover;background-position: center center;" title="" data-placement="top" data-original-title="<div style=\'padding:5px 0px; text-align:center;width:170px;\'><div class=\'swatch_tooltip_title\'>'+swatchVal+'</div><div class=\'swatch_tooltip_data\' style=\'width:100%;height:150px;background-image:url('+swatchImage+');background-size:cover;background-position: center center;\'></div></div>" data-html="true" data-toggle="tooltip">';
                html += '</div>';
                html += '</span>';
            } else {
              html += '<span class="hulkapps_option_value" data-cart-item-property-value-motw >';
              html += '<a class="lightbox" href="' + last + '">Uploaded File';
              html += '</a>';
              html += '</span>';
            }
        } else {
          html += '<span class="hulkapps_option_value" data-cart-item-property-value-motw >'+last_final.replace('&amp;amp;amp;', '&amp;amp;').replace('&amp;amp;lt;', '<').replace('&amp;amp;gt;', '>')+'';
          html += '</span>';
        }
        html += '</li>'; 
        return html;
  	} catch (cart_prop_itemplate_errf) {
      	console.log("Error: " + cart_prop_itemplate_errf.message);
  	}
}
      
      
function update_cart_items(){
  	console.log('----- update_cart_items ----');
  	try {
        //$('[data-cart-item-property]').hide();
        // ----------- adjust properties
        $('.cart-item').each(function(){
            var $itemObj = $(this);
          	var hrefclass = $itemObj.find('[data-cart-item-href-motw]').attr('href');
          	var hrefclassArr = hrefclass.split('?');
          	var design_url = $itemObj.find('[data-cart-itempropname-motw="_Design url"] [data-cart-item-property-value-motw]').text();
          	hrefclass = hrefclassArr[0].replace('https://mapsoftheworld.io','').replace('/products/','');
          	$itemObj.addClass(hrefclass);
            if(hrefclass == 'framing-service') {
				$itemObj.find('.cart-item__meta').attr('colspan','2');
            }
            $itemObj.find('[data-cart-item-property-motw]').each(function(){
                var $propertyObj = $(this);
                var propertyText = $propertyObj.text();
                if(propertyText.indexOf(': ') > -1) {
                  
					propertyText = propertyText.replace(/\s/g, ' ').trim();
                    var ptdc = propertyText.toLowerCase();
                  	console.log('ptdc = ' + ptdc);
                  	var proceed = false;
                  	if (ptdc.indexOf('preview image') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('color scheme') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('font') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('map zoom') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('minimap') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('map lat') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('map lng') > -1) {
                    	proceed = true;
                    } else if (ptdc.indexOf('line 1') > -1) {
                      	proceed = true;
                    } else if (ptdc.indexOf('line 2') > -1) {
                      	proceed = true;
                    } else if (ptdc.indexOf('line 3') > -1) {
                      	proceed = true;
                    } else if (ptdc.indexOf('layout') > -1) {
                      	proceed = true;
                    } else if (ptdc.indexOf('Frame option') > -1) {
                      	proceed = true;
                    }
                  
                  	if (proceed == true) {
                        console.log('----- propertyText ----');
                      	var propertyTextArr = propertyText.split(': ');
                        var first = propertyTextArr[0];
                        var last = propertyTextArr[1];
                        var html = cart_prop_itemplate(first,last);
                        if (html != null) {
                            console.log('first = ' + first);
                            console.log('last = ' + last);
                            $propertyObj.replaceWith(html).show();
                          	design_url = $itemObj.find('[data-cart-itempropname-motw="_Design url"] [data-cart-item-property-value-motw]').text();
                          	var previewimage = $itemObj.find('[data-cart-item-preview-image-motw]').text();
                          	console.log('---------- previewimage --------');
                          	console.log(previewimage);
                          	console.log('---------- previewimage END --------');
                          	$itemObj.find('.needs_design_link').attr('href',design_url);
                          	$itemObj.find('[data-cart-item-image-motw]').attr('src',previewimage).removeClass('hide');
                        }
                    }
                    else {
						$propertyObj.hide();
                    }
                }
            });
        });
      	//set_framing_service_message();
    } catch (update_cart_items_errf) {
      console.log("Error: "+update_cart_items_errf.message);
    }
}

/*============================================================================
  GET cart.js returns the cart in JSON.
==============================================================================*/
Shopify.cartadjust_getCart = function(callback) {
	try {
//console.log('cartadjust_getCart');
  	$.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      /**Shopify.onCartUpdate(cart);**/
    }
  });
  } catch (errf) {console.log("Error: "+errf.message);}
};

var cartadjust_init = function(cart) {
	try {
      	console.log('cartadjust_init');
      	if($('[data-cart-item-id-motw]').length){
            /** Update quantity and price**/
            Shopify.cart = cart;
            //console.log('cart.item_count = ' + cart.item_count);
            var properties = false;
            Shopify.free_gift_added = false;

            if (cart.item_count >= 1){
                //console.log(cart.items);
                var row = 0;
                $.each( cart.items, function( key, value ) {
                    //row++;
                    //console.log( value.variant_options[0] );
                    //alert(value.sku + '==' + Shopify.free_gift_sizesku);
                    var key = value.key;
                    if (value.properties['_Preview image'] != ''){
                      //console.log('Preview image: '+value.properties['Preview image']);
                        var preview_image = value.properties['_Preview image'];
                        $('[data-cart-item-id-motw="'+key+'"]').find('[data-cart-item-image-motw]').removeClass('hide').attr('src',preview_image);
                    }
                    if (value.properties['_Design url'] != ''){
                      //console.log('Design url: '+value.properties['Design url']);
                        var preview_link = value.properties['_Design url'];
                        $('[data-cart-item-id-motw="'+key+'"]').find('[data-cart-item-href-motw]').removeClass('hide').attr('href',preview_link);
                    }
                }); 
            }
      	}
    } catch (errf) {console.log("Error: "+errf.message);}
};

$('.money').attrchange({
	trackValues: true, 
	callback: function (event) {
      	//console.log('attrchange');
      	Shopify.cartadjust_getCart(cartadjust_init);
		//var properties = $(this).attrchange('getProperties');						
		//console.log('Status: ' + properties.status + '. Attribute Name: ' + event.attributeName + ' Prev Value: ' + event.oldValue + ' New Value: ' + event.newValue);
        
	}
});



Shopify.cartadjust_getCart(cartadjust_init);



$(window).on("cart_update_done", function() {

 	update_cart_items();
	setTimeout(function(){
		update_cart_items();
	}, 4000);
});

function decrement_disable(parentObj){

	if ( parentObj.length ) {
		var currentObj = parentObj.find('.cart-item__qty-input');
		var currentQty = parseInt(currentObj.val());
      
        // make decrement disabled at 1
        if (currentQty == 1) {
          	parentObj.find(".decrement-quantity").attr("disabled", "disabled");
        }

        // remove disabled attribute on subtract
        if (currentQty > 1) {
          	parentObj.find(".decrement-quantity").removeAttr("disabled");
        }
      
	}
  
}

$(".product-quantity button").on("click", function(ev) {
  var parentObj = $(this).parents('.product-quantity');
  var currentObj = parentObj.find('.cart-item__qty-input');
  var currentQty = currentObj.val();
  var qtyDirection = $(this).data("direction");
  var newQty = 0;
  
  if (qtyDirection == "1") {
    newQty = parseInt(currentQty) + 1;
  }
  else if (qtyDirection == "-1") {
    newQty = parseInt(currentQty) - 1;
  }

  // make decrement disabled at 1
	decrement_disable(parentObj);
  
  if (newQty > 0) {
    newQty = newQty.toString();
    currentObj.val(newQty);
  }
  else {
    currentObj.val("1");
  }
  currentObj.trigger("input");
});




//-------------  CART MODS END -----------------------------------------

//------------ LAYOUT -----------------------------------------------

	$(document).on('change', 'input[type=radio][name=map-layout]', function(event) {
      //alert( this.value );
        set_content_layout();
      	//storeVariant();
    });
    
    
    
   /** -------------- set orientation ------------- **/
   
   
    function get_orientation() {
      	var the_value = $('#save_orientation').val();
      	//console.log('get_orientation =' + the_value);
        if (the_value != ''){
			the_value = the_value.toLowerCase();
        }
      	else {
            the_value = 'portrait';
      	}
      	return the_value;
      
    }
    
    function save_orientation_func(value) {
      	value = typeof value !== 'undefined' ? value : 'portrait';
        if (value != ''){
			value = value.toLowerCase();
        }
      	$('#save_orientation').val(value);
      
    }
    
    function set_orientation_class(value) {
      	value = typeof value !== 'undefined' ? value : 'portrait';
        if (value != ''){
			value = value.toLowerCase();
        }
      	if($('#map_orientation_'+value).length){
          	$('#for_contentlayout').attr('orientation',value);
      	}
      
    }
    
    function set_orientation_radio(value) {
      	value = typeof value !== 'undefined' ? value : 'portrait';
        if (value != ''){
			value = value.toLowerCase();
        }
      	if($('#map_orientation_'+value).length){
        	$('#map_orientation_'+value).prop('checked',true);
      	}
      
    }
    
    function set_orientation_from_saved() {
		var saved_value = $('#save_orientation').val();
      	set_orientation_radio(saved_value);
      	set_orientation_class(saved_value);
      	set_display_sizes();
    }
    
	$(document).on('change', 'input[type=radio][name=map-orientation]', function(event) {
     	
      	var selected_value = $(this).val();
      	save_orientation_func(selected_value);
        set_orientation_class(selected_value);
      	set_display_sizes();
      	setPaperSize();
      	build_url();
      	//storeVariant();
    });
    
   /** -------------- set orientation END ------------- **/
   
   /** -------------- set minimap_visibility ------------- **/
   
   
    function get_minimap_visibility() {
      	var the_value = $('#save_minimap').val();
      	//console.log('get_minimap =' + the_value);
        if (the_value != ''){
			the_value = the_value.toLowerCase();
        }
      	else {
            the_value = 'yes';
      	}
      	return the_value;
      
    }
    
    function save_minimap_visibility_func(value) {
      	value = typeof value !== 'undefined' ? value : 'yes';
        if (value != ''){
			value = value.toLowerCase();
        }
      	$('#save_minimap').val(value);
      
    }
    
    function set_minimap_visibility_class(value) {
      	value = typeof value !== 'undefined' ? value : 'yes';
        if (value != ''){
			value = value.toLowerCase();
        }
      	if($('#minmap_toggle').length){
          	$('#for_contentlayout').attr('minimap',value);
      	}
      
    }
    
    function set_minimap_visibility_radio(value) {
      	value = typeof value !== 'undefined' ? value : 'yes';
        if (value != ''){
			value = value.toLowerCase();
        }
      	if($('#minmap_toggle').length){
          
          	if(value == 'no'){
				$('#minmap_toggle').prop('checked',false);
            }
            else{
                $('#minmap_toggle').prop('checked',true);
            }
      	}
      
    }
    
    function set_minimap_visibility_from_saved() {
		var saved_value = $('#save_minimap').val();
      	set_minimap_visibility_radio(saved_value);
      	set_minimap_visibility_class(saved_value);
      	set_display_sizes();
    }
    
	$(document).on('change', 'input[type=checkbox][name=minimap]', function(event) {
     	
      	var selected_value = 'yes';
        if($(this).prop('checked')){
			selected_value = 'yes';
        }
        else{
			selected_value = 'no';
        }
      	//alert(selected_value);
      	save_minimap_visibility_func(selected_value);
        set_minimap_visibility_class(selected_value);
      	set_display_sizes();
      	setPaperSize();
      	build_url();
      	//storeVariant();
    });
    
   /** -------------- set minimap_visibility END ------------- **/
    
    

    function get_countentLayout(){

      var $thisObj = $('input[type=radio][name=map-layout]:checked');
          var selectedval = $thisObj.val();
          //alert(selectedval);
          return selectedval;
    }

    function save_content_layout(){

		var selectedclass = get_countentLayout();
      	if($('#'+selectedclass+'-config-options').find('.scheme-config-item:checked').length){
            $('#'+selectedclass+'-config-options').find('.scheme-config-item:checked').each(function() {
            	selectedclass = selectedclass + '_' + $(this).val();
            });
      	}
   		$('#save_contentLayout').val(selectedclass);
      	build_url();

    }
    
    function set_content_layout_from_string(saved_value) {
		var saved_value_arr = [];
      	var layout = '';
      
      	//console.log('set_content_layout_from_saved "' + saved_value+'"');
      	//alert('saved_value = ' + saved_value);
      	saved_value_arr = saved_value.split('_');
      	jQuery.each(saved_value_arr, function(index, item) {
          	//alert('index = ' + index);
            if(index == 0){
				layout = item;
              	var layout_id = 'map_layout_' + layout.toLowerCase();
                if($('#'+layout_id).length){
                	$('#'+layout_id).prop('checked',true).change();
           
                }
              
            }
            else{
              	var idselector = layout + '-' + item;
              	var idselector = idselector.toLowerCase();
              	//console.log('------------layout = ' + layout + ' | idselector = ' + idselector);
				$('#'+idselector).prop('checked',true).change();
            }
    		// do something with `item` (or `this` is also `item` if you like)
		});
      	set_content_layout();
    }
  
    function set_content_layout_from_saved() {
		var saved_value = $('#save_contentLayout').val();
		set_content_layout_from_string(saved_value);
    }
  
    function set_only_content_layout(){

          var selectedclass = get_countentLayout();
          $('#productpage_wrap').attr('class','').attr('class',selectedclass);
      	  save_content_layout();

    }

    function set_content_layout(){

          var selectedclass = get_countentLayout();
          $('#productpage_wrap').attr('class','').attr('class',selectedclass);
      	  save_content_layout();
      	  setPaperSize();
          resize_map();

    }

  
    $(document).on('change', '#textboxLayout', function(event) {
      //alert( this.value );
        set_textbox_layout();
      	//storeVariant();
    });
  
    $(document).on('change', '.scheme-config-item', function(event) {
        //alert( this.value );
        set_layout_config();
      	save_content_layout();
      	//storeVariant();
    });
  
    function set_layout_config() {
      	var objForClass = $('#thePaper');
      	//modern
      
      var modern_color = $('[name="modern-color"]:checked').val();
      modern_color = 'modern-' + modern_color;
      var modern_fade = $('[name="modern-fade"]:checked').val();
      modern_fade = 'modern-' + modern_fade;
        //label
      var label_color = $('[name="label-color"]:checked').val();
      label_color = 'label-' + label_color;
      var label_position = $('[name="label-position"]:checked').val();
      label_position = 'label-' + label_position;
      	//classic
      var classic_color = $('[name="classic-color"]:checked').val();
      classic_color = 'classic-' + classic_color;
      var classic_position = $('[name="classic-align"]:checked').val();
      classic_position = 'classic-' + classic_position;
      var classic_text = $('[name="classic-text"]:checked').val();
      classic_text = 'classic-' + classic_text;
      
      
      	objForClass.attr('class','');
      	
      	objForClass.addClass(modern_color);
        objForClass.addClass(modern_fade);
        objForClass.addClass(label_color);
        objForClass.addClass(label_position);
        objForClass.addClass(classic_color);
        objForClass.addClass(classic_position);
        objForClass.addClass(classic_text);

    }

    function get_textbox_layout(){

          var $thisObj = $('#textboxLayout');
          var selectedval = $thisObj.val();
          //alert(selectedval);
          return selectedval;

    }

    function save_textbox_layout(){

		var selectedclass = get_textbox_layout();
   		$(save_textBoxLayout).val(selectedclass);
      	build_url();

    }


    function set_textbox_layout(){

		var selectedclass = get_textbox_layout();
		$('#for_textboxlayout').attr('class','').addClass(selectedclass);
      	$textBoxLayout.val(selectedclass);
      	save_textbox_layout();
        setPaperSize();
		resize_map();

    }

//------------ LAYOUT END -------------------------------------------


	function resize_map(){
      
    	if (typeof cityMap === 'object') {
            cityMap.resize();
    	}
    	if (typeof countryMap === 'object') {
            countryMap.resize();
    	}
	}
  
	function resize_and_centermap(){
      
    	if (typeof cityMap === 'object') {
          	var getlat = $(save_map_lat).val();
			var getlng = $(save_map_lng).val();
			var getzoom = $(save_map_zoom).val();
            cityMap.flyTo({center:[$(save_map_lng).val(), $(save_map_lat).val()]});
          	cityMap.resize();
    	}
    	if (typeof countryMap === 'object') {
            countryMap.resize();
    	}
	}


    function reset_autocomplete(){
          $('.thumb_canvasContainer').hide();
      	 //alert('hide thumb');
          $('.marker-autocomp-form').show();
          $('.marker-autocomp-form input').val('');
    }

    $(document).on('click', '.geocoder-icon-close', function(event) {
        //alert( this.value );
        remove_marker();
    });
    $(document).on('click', '.remove-marker-btn', function(event) {
        //alert( this.value );
      reset_autocomplete();
        remove_marker();
    });


    $(document).on('click', '.show-customise-options', function(event) {
         $('body').toggleClass('open-edit-drawer');

    });
  
    $(document).on('click', '.open-edit-drawer .featured-slider__cover-background', function(event) {
         $('body').toggleClass('open-edit-drawer');

    });
  

    $(document).on('click', '.add-address-toggle', function(event) {
         $('.no-address-toggle').toggleClass('hide-me');

    });

    $(document).on('click', '.take-me-to', function(ev) {
       
        
        var target = $(this).attr('href');
        if (!$('body').hasClass('open-edit-drawer')) {
            $('body').addClass('open-edit-drawer');
        }
      	$('body').scrollTo(target);
        close_accordion_section();
        $('.map-choices-title[href="'+target+'"').trigger('click');
      	$.magnificPopup.close();
      	ev.preventDefault();

    });


	function init_accordion_section() {
      	close_accordion_section();
    	$('.map-choices-title[href="#mapchoicessection-1"').trigger('click');
	}
	function close_accordion_section() {
      	var windowWidth = (Math.round(( parseFloat($(window).innerWidth()) * 100))/100);
      	var windowHeight = (Math.round(( parseFloat($(window).innerHeight()) * 100))/100);
        if (windowWidth < 8000) {
            $('.map-choices-section').removeClass('active');
          	$('.map-choices-section-wrap .map-choices-wrap').slideUp(300, function() {
    			$(this).removeClass('open');
				triggerResize();
			}); 
		}
        else{
			//open_all_accordion_section();
        }
      	triggerResize();
	}
    
	$( ".map-choices-title" ).on( "open:section", function( event ) {

      	var wrapperObj = $(this).parents('.map-choices-section');
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
        if(wrapperObj.is('.active')) {

        }else {
        	close_accordion_section();
            // Add active class to section title
            wrapperObj.addClass('active');
            // Open up the hidden content panel
            $('.map-choices-section-wrap ' + currentAttrValue).slideDown(300, function() {
    			$(this).addClass('open');
               	triggerResize();
            });
		}

    });
    
    
	$('.map-choices-title').click(function(e) {
      
      	var wrapperObj = $(this).parents('.map-choices-section');
      	var windowWidth = (Math.round(( parseFloat($(window).innerWidth()) * 100))/100);
      	var windowHeight = (Math.round(( parseFloat($(window).innerHeight()) * 100))/100);
      	if (windowWidth < 8000) {
            // Grab current anchor value
            var currentAttrValue = $(this).attr('href');
            if(wrapperObj.is('.active')) {
                close_accordion_section();
            }else {
                close_accordion_section();
                // Add active class to section title
                wrapperObj.addClass('active');
                // Open up the hidden content panel
              	$('.map-choices-section-wrap ' + currentAttrValue).slideDown(300, function() {
    				$(this).addClass('open');
                  	triggerResize();
               	});
            }
        }
        else{
			//open_all_accordion_section();
        }
      	triggerResize();
		e.preventDefault();
	});


  function set_land_color_func(hexcolor){
      if($('.mapboxgl-map').length){
          if (typeof(hexcolor )==='undefined') hexcolor = '#ffffff';
          //setmap_style_item('land', 'fill-color', hexcolor);
          //setmap_style_item('land', 'fill-outline-color', hexcolor);
      }
  }

  function setmap_style_item(layer, property,hexcolor,mapObj){

  	  mapObj = typeof mapObj !== 'undefined' ? mapObj : countryMap;
    
      if (typeof mapObj === 'object') {
      if($('.mapboxgl-map').length){
          if (typeof(hexcolor )==='undefined') hexcolor = '#ffffff';
          if (typeof(property)==='undefined') property = 'fill-color';
          if (typeof(layer)==='undefined') layer = 'land';
          var land_rgba = hexToRgb(hexcolor);
          var layers = mapObj.getStyle().layers;
        	//console.log('setmap_style_item | property ' + property + ' | land_rgba '+land_rgba);
          mapObj.setPaintProperty(layer, property, land_rgba);
          //mapObj.setPaintProperty('land', 'fill-color', 'rgba(0, 0, 0,0.17)');
      }
      }
  }

  function hexToRgb(hex, alpha) {
     hex   = hex.replace('#', '');
     var r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
     var g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
     var b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
     if ( alpha ) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
     }
     else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
     }
  }


  $(document).on('click', '#add_country_submit', function(event) {
    
      please_add_country();
    
  });


function please_add_country(){
  
    //tidioChatApi.messageFromVisitor('Message from visitor!');
	var name = $('#no_country_form_name').val();
  	var email = $('#no_country_form_email').val();
  	//alert('name '+name+ ' | email '+ email);
    document.tidioIdentify = {
        distinct_id: email, // Unique user ID in your system
        email: email, // User email
        name: name // Visitor name

    };
  	var thisurl = window.location.href;
  	var message = 'Hi, please add a map for this page '+thisurl + ' /n Thanks - '+name +', '+email;
    
    tidioChatApi.messageFromVisitor(message);
}


	//alert(supported_country_selector);


function changeCountry(){
  //check this one
  	
    //var map_css_class = $('#map_css_class').val();
  	var selectedObj = $('#countryDropdown');
	var getCountry = selectedObj.val();
	var countryAbbr = selectedObj.data('abbr'); //$('#countryDropdown').attr('abbr'); 
	var getlat = selectedObj.data('lat');
	var getlng = selectedObj.data('lng');
  	var getmstyle = selectedObj.data('mstyle');
	var getzoom = selectedObj.data('zoom');
  	//var map_css_class = selectedObj.data('map_class');
  	console.log('changeCountry = ' + getCountry);
  	$('#countrymap_container').attr('iso',countryAbbr);
  	console.log('countryAbbr = ' + countryAbbr);
  	//console.log();
  	
	if (typeof countryMap === 'object') {
        countryMap.setStyle('mapbox://styles/cherishedlocations/' + getmstyle);
        countryMap.jumpTo({ 
          center: [getlng, getlat],
          zoom: getzoom
        });
	}
  
    place_marker_from_saved();
  	setMiniMapColor();
}
  
function changeCity(){
  //check this one
    //var map_css_class = $('#map_css_class').val()
	var line1 = $(save_text_1_content).val();
  	var line2 = $(save_text_2_content).val();
	var countryISO = $(save_iso_code).val(); 
	var getlat = $(save_map_lat).val();
	var getlng = $(save_map_lng).val();
	var getzoom = $(save_map_zoom).val();
  	//var map_css_class = selectedObj.data('map_class');
  	//console.log('changeCity = ' + line1);
	if (typeof cityMap === 'object') {
        cityMap.jumpTo({ 
          center: [getlng, getlat],
          zoom: getzoom
        });
      	cityMap.resize();
	}
}

function getSize(){
  	var thesize = 'small';
	if ($('#size').length) {
            thesize = $('#size').val().replace(' x ','').replace(/[^A-Za-z]/g,'').toLowerCase();
	}
  	return thesize;
  	
}

function getZoom($dropdownObj){
  	var mapzoom,selectedObj,size;

  	$dropdownObj = typeof $dropdownObj !== 'undefined' ? $dropdownObj : $('#countryDropdown');
  
  	if ($dropdownObj.length){
      	if ($dropdownObj.attr('id') == "countryDropdown" ){
          	selectedObj = $dropdownObj;
          	mapzoom = selectedObj.data('zoom');
          	/**
            console.log('############# getZoom first | '+ $dropdownObj.attr('id') + ' ' + $dropdownObj.length);
            selectedObj = $dropdownObj;
            var size = getSize();
            console.log('############# size '+ size + '###############');
            switch(size) {     
                case 'small':
                    mapzoom = selectedObj.data('zoom');
                    break;
                case 'medium':
                    mapzoom = selectedObj.data('zoom_medium');
                    break;
                case 'large':
                    mapzoom = selectedObj.data('zoom_large');
                    break;
                case 'xlarge':
                    mapzoom = selectedObj.data('zoom_xlarge');
                    break;

                default:
                    mapzoom = selectedObj.data('zoom');
                    break;
            }**/
          
        }
        else {
          	//alert('$(save_map_zoom).val() = ' + $(save_map_zoom).val());
			mapzoom = $(save_map_zoom).val();
        }
		
    }
  	//alert(mapzoom);
  	//console.log('######### mapzoom =' + mapzoom +' #########');
  	//console.log('getZoom last ' + $dropdownObj.val());
  	return mapzoom;
}

function refreshMapZoom(zoom,mapObj,$dropdownObj){
  
  mapObj = typeof mapObj !== 'undefined' ? mapObj : countryMap;
  $dropdownObj = typeof $dropdownObj !== 'undefined' ? $dropdownObj : $('#countryDropdown');
  zoom = typeof zoom !== 'undefined' ? zoom : getZoom($dropdownObj);
  
  if (typeof mapObj === 'object') {
      //console.log('refreshMapZoom first ' + $dropdownObj.val());
        if (typeof zoom !== 'undefined'){
            zoom = zoom;
        }
        else{
            zoom = getZoom($dropdownObj);
        }
        //alert(zoom);
        //console.log('refreshMapZoom second ' + $dropdownObj.val());
          var selectedObj = $dropdownObj;
          //console.log('refreshMapZoom ' + selectedObj.val());
          var getlat = selectedObj.data('lat');
          var getlng = selectedObj.data('lng');
        //console.log('refreshMapZoom third ' + $dropdownObj.val());

          mapObj.jumpTo({ 
              center: [getlng, getlat],
              zoom: zoom
          }); 
        //console.log('refreshMapZoom fourth ' + $dropdownObj.val());
        mapObj.resize();
        //console.log('refreshMapZoom last ' + $dropdownObj.val());
  }
}

  $(document).on('click', '.zoom_map', function(event) {
    var zoomlevel = $('#map_zoom').val();
    refreshMapZoom(zoomlevel)
  });


/*---------------- thumb for marker ------------------ */

var mapThumb, markerThumb, layerThumb;

initializeThumb();
function initializeThumb() {
  if($('#thumb_canvas').length){
  //alert('initializeThumb');
	var location = new google.maps.LatLng(0, 3)
	mapThumb = new google.maps.Map(document.getElementById('thumb_canvas'), {
		mapTypeId: google.maps.MapTypeId.ROADMAP, //ROADMAP
		center: location,
		zoom: 10,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		disableDefaultUI: true,
		draggable: false,
		scaleControl: false,
		scrollwheel: false,
			           styles: [
				{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"featureType": "landscape",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"featureType": "road",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"featureType": "administrative",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"featureType": "poi",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"featureType": "administrative",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				"elementType": "labels",
				"stylers": [
				  { "visibility": "on" }
				]
				},{
				}
			]
		});
  }
	setData();
	//setAutocomplete('ca');refreshMapZoom
	//$('#countryDropdown').trigger('change');
}



        function close_autocomplete(){
          	$('body').removeClass('marker-autocomplete').removeClass('search-and-go-autocomplete').removeClass('local-autocomplete').removeClass('autocomplete-open');
              	
            $(".marker-autocomp-form .animated").each(function() {
            	$(this).removeClass('animated').addClass('animate');
          	});
        }

function set_text(line1,line2,line3){
	line1 = typeof line1 !== 'undefined' ? line1 : null;
  	line2 = typeof line2 !== 'undefined' ? line2 : null;
  	line3 = typeof line3 !== 'undefined' ? line3 : null;
	if (line1 != null ) {
 		line1 = decodeURIComponent(line1);
		$(save_text_1_content).val(line1);
        $(set_text_1_content).val(line1);
      
        if($($(set_text_1_content).attr('data-linkedinput')).length) {
            $($(set_text_1_content).attr('data-linkedinput')).html(line1);
        }
	}
	if (line2 != null ) {
		line2 = decodeURIComponent(line2);
		$(save_text_2_content).val(line2);
      	$(set_text_2_content).val(line2);
      
        if($($(set_text_2_content).attr('data-linkedinput')).length) {
            $($(set_text_2_content).attr('data-linkedinput')).html(line2);
        }
	}
	if (line3 != null ) {
		line3 = decodeURIComponent(line3);
		$(save_text_3_content).val(line3);
      	$(set_text_3_content).val(line3);
      
        if($($(set_text_3_content).attr('data-linkedinput')).length) {
            $($(set_text_3_content).attr('data-linkedinput')).html(line3);
        }
	}
    show_hide_text_labels();
}
 
$(document).on('change', '[data-linkwith]', function(event) {
  	var type = $(this).attr('data-linkwith');
  	$('[data-linkwith="' + type + '"]').prop('checked',true);
  	console.log();
  	change_autocomplete_types();
});
function placeToAddress(place){
  
	try {
        var address = {};
      	console.log(place);
      	console.log(place.address_components);
        place.address_components.forEach(function(c) {
            switch(c.types[0]){
                case 'street_number':
                    address.StreetNumber = c;
                    break;
                case 'route':
                    address.StreetName = c;
                    break;
                case 'neighborhood': 
                	address.Neighborhood = c;
                	break;
              	case 'locality':    // North Hollywood or Los Angeles?
                    address.City = c;
                    break;
                case 'administrative_area_level_1':     //  Note some countries don't have states
                    address.State = c;
                    break;
                case 'postal_code':
                    address.Zip = c;
                    break;
                case 'country':
                    address.Country = c;
                    break;
            }
        });

        console.log(address);
      	return address;
      
    } catch (errf_placeToAddress) {
      	console.log("Error: "+errf_placeToAddress.message);
    }
}


function setAutocomplete(eleid) {
  	if (typeof google === 'object' && typeof google.maps === 'object') {
        var countryAbbr = '';
        var countryRestrict = '';//{'country': countryAbbr}; //us //au //uk
      //alert('#'+eleid);
        if ($('#'+eleid).is("[data-useiso]")){
            countryAbbr = $('#'+eleid).data('useiso');
            countryRestrict = {'country': countryAbbr}; //us //au //uk
        }
        else{
            countryRestrict = {'country': []}; //us //au //uk
        }
      	var searchtypes = '(cities)';
      	var $parentObj = $('#'+eleid).parents('.marker-autocomp-wrap');
      
      	if($parentObj.find('.search-type-checkbox:checked').length) {
          	
      		searchtypes = $parentObj.find('.search-type-checkbox:checked').val();
          	console.log('8297 searchtypes = ' +searchtypes);
      	}
      	else if ($('#'+eleid).is("[data-types]")){
            if($('#'+eleid).attr('data-types') != ''){
				searchtypes = $('#'+eleid).attr('data-types');
              	console.log('8302 searchtypes = ' +searchtypes);
            }
        }
      
      	searchtypes = searchtypes.toLowerCase();
		console.log('8308 setAutocomplete = ' +searchtypes);
      	if(searchtypes == 'all'){
            window[eleid] = new google.maps.places.Autocomplete((	
            document.getElementById(eleid)), { 
                componentRestrictions: countryRestrict 
            });
      	}
        else {
            window[eleid] = new google.maps.places.Autocomplete((	
            document.getElementById(eleid)), { 
                types: [searchtypes],
                componentRestrictions: countryRestrict 
            });
        }
        google.maps.event.addListener(window[eleid], 'place_changed', function() {
            var place = window[eleid].getPlace();
            if (!place.geometry) {
                  // User entered the name of a Place that was not suggested and
                  // pressed the Enter key, or the Place Details request failed.
                  window.alert("No details available for input: '" + place.name + "', Please choose and address from autocomplete!");
                  return;
            }
			placeToAddress(place);
            var lat = place.geometry.location.lat();
            var lng = place.geometry.location.lng();
            var address = place.formatted_address;
            var placename = place.name;
            close_autocomplete();
            var place_tag = 'gplaceid_'+place.place_id; 
          	var $addressObj = placeToAddress(place);
         
          	var line1 = placename.toUpperCase();
            if ($addressObj.StreetName !== undefined) {
            	line1 = $addressObj.StreetName.long_name.toUpperCase();
            } else if ($addressObj.City !== undefined) { 
            	line1 = $addressObj.City.long_name.toUpperCase();
            } else if($addressObj.Neighborhood !== undefined) { 
            	line1 = $addressObj.Neighborhood.long_name.toUpperCase();
            }
            var line2 = getCountryName(place.address_components).toUpperCase();
          	var country_iso = getCountryIso(place.address_components).toLowerCase();
          	console.log('country_iso = '+country_iso);
            if(country_iso == "us" || country_iso == "gb" || country_iso == "au"){

                if ($addressObj.State !== undefined) {
                    line2 = $addressObj.State.long_name.toUpperCase();
                    if (line2 == 'HAWAII') {
                        if($addressObj.Neighborhood !== undefined) {
                           line2 = $addressObj.Neighborhood.long_name.toUpperCase() + ', ' + line2;
                        }
                    }
                }
                if (line1 == line2){
                    line2 = getCountryName(place.address_components).toUpperCase();
                }
            }
          
            if ($('#'+eleid).is("[search_and_go]")){
              		//console.log('search_and_go');
                    //var country_term = getCountry(place.address_components); 
                    //if ($addressObj.City.long_name) {
						//line1 = line1.long_name;
                   // }
                    var search_term = line1;

                    //&markerAddr='+encodeURIComponent(address);
                    var marker_params = 'line1=' + line1 + '&line2=' + line2 + '&mapLat='+lat+'&mapLng='+lng;
              		//alert('marker_params = '+ marker_params);
                    search_and_go(search_term,place_tag,marker_params);
            }
            else if ($('#'+eleid).is("[search_and_update]")){
              	//console.log('search_and_update');
              
                var thezoom = 11.5;
                //console.log('PlaceID: '+place.place_id);

                 save_lat_lng_zoom(lat,lng,thezoom,placename);

                set_text(line1,line2);

                build_url('/products/custom-map-poster');     

                getCountryFromLatLng(lat,lng);
                setCityFromTag(place_tag);
            }
            else if ($('#'+eleid).is("[search_and_latlng]")){
              	//console.log('search_and_update');
              	build_latlng_sumamry(address,lng,lat);

            }
            else{
              	//console.log('search_and_update else');
                place_marker(lng,lat);
               //console.log('setAutocomplete place_changed about to set_thumb_map');
                set_thumb_map(lng,lat,address);
                save_marker_details(lat,lng,address);
              	save_map_stage_instant();
                build_url();

                //console.log(address);
            }
          	$('html').attr('style','');
            $('body').removeClass('open-edit-drawer');
          	$('#'+eleid).val('');
        });
    }
}


function getCountry(addrComponents) {
    for (var i = 0; i < addrComponents.length; i++) {
        if (addrComponents[i].types[0] == "country") {
            return addrComponents[i].long_name + ' ' + addrComponents[i].short_name.toLowerCase();
        }
        if (addrComponents[i].types.length == 2) {
            if (addrComponents[i].types[0] == "political") {
                return addrComponents[i].long_name + ' ' + addrComponents[i].short_name.toLowerCase();
            }
        }
    }
    return false;
}
function getCountryName(addrComponents) {
    for (var i = 0; i < addrComponents.length; i++) {
        if (addrComponents[i].types[0] == "country") {
            return addrComponents[i].long_name;
        }
        if (addrComponents[i].types.length == 2) {
            if (addrComponents[i].types[0] == "political") {
                return addrComponents[i].long_name;
            }
        }
    }
    return false;
}
function getCountryIso(addrComponents) {
    for (var i = 0; i < addrComponents.length; i++) {
        if (addrComponents[i].types[0] == "country") {
            return addrComponents[i].short_name.toLowerCase();
        }
        if (addrComponents[i].types.length == 2) {
            if (addrComponents[i].types[0] == "political") {
                return addrComponents[i].short_name.toLowerCase();
            }
        }
    }
    return false;
}

function search_and_go(term,tag,marker_params,handle){
	marker_params = typeof marker_params !== 'undefined' ? marker_params : '';
	handle = typeof handle !== 'undefined' ? handle : 'custom-map-poster';
	var currentAjaxRequest = null;
	var searchterm = term.replace(/[\s]+/g, '* ') + "*";
	searchterm = searchterm.replace(/[\*]+/g, '*');
	if (searchterm == "") {
		searchterm = "*";
	}
  	var searchtags = '%20AND%20tag:'+tag+'%20AND%20tag:citymap';
	// What's the search URL?
	var searchURL = '/search?type=product&q=' + searchterm + searchtags;
	// Killing any Ajax request that's currently being processed.
	if (currentAjaxRequest != null) currentAjaxRequest.abort();
	// Pulling results.
  	// some defaults
  	var editor_url = 'custom-map-poster';
  	var current_iso = 'GB';
    var color_and_layout = '&layout=modern_dark_fade&colorScheme=Minimal'; 
  	//var user_params = '&' + urlMinimap + '&' + contentLayout + '&' + textBoxLayout + '&' + urlOrientation + '&' + mapZoom + '&' + colorScheme + '&' + fontStack + '&' + frameColor + '&' + line1 + '&' + line2 + '&' + line3 + '&' + mapLat + '&' + mapLng + '&' + markerAddr + '&' + markerIcon;
    if(($('body').is("[usercountry]")) && ($('body').attr('usercountry') != '')){
		current_iso = $('body').attr('usercountry');
    }
  	/**
    if($('#editpage-'+current_iso).length){
		editor_url = $('#editpage-'+current_iso).data('handle');
    }
    **/
	currentAjaxRequest = $.getJSON(searchURL + '&view=city-data', function(data) {
		// If we have no results.
      	//alert(data.results_count);
      	if(data.results_count == 0) {
            window.location.href = '/products/'+editor_url+'?'+marker_params+color_and_layout;
			return;
   		} else {
            // If we have results.
            $.each(data.results, function(index, item) {
              //alert('zoom = ' + item.zoom + ' |  item.layout = ' + item.layout + ' | colorScheme = ' + item.color_scheme + ' item.title = ' +item.title + ' |  item.subtitle = '+item.subtitle + 'item.map_lat = '+item.map_lat + ' | item.map_lng = ' + item.map_lng);
              if((item.color_scheme != '') && (item.layout != '')) {
              		color_and_layout = '&layout=' + item.layout + '&colorScheme=' + item.color_scheme;
              }
              if((item.title != '') && (item.subtitle != '') && (item.map_lat != '') && (item.map_lng != '') && (item.zoom != '')) {
					marker_params = '&line1=' + item.title + '&line2=' + item.subtitle + '&mapLat=' + item.map_lat + '&mapLng=' + item.map_lng + '&mapZoom=' + item.zoom;
              }
              //alert('/products/'+handle+'?'+marker_params+color_and_layout);
              window.location.href = '/products/'+handle+'?'+marker_params+color_and_layout;
			  return;
            });
    	}        
	});
}

function set_up_all_autocompletes(){
	var acInputs = document.getElementsByClassName("autocomplete");
	for (var i = 0; i < acInputs.length; i++) {
		setAutocomplete(acInputs[i].id);
	}
  	
}

function setData(){

	if('zzzz'  == ''){
		alert('Please select a country first!');
		return false;
	}
	
	refreshMapThumb();

	//map.setZoom(parseFloat(getzoom));

	//var location = new google.maps.LatLng(getlat, getlng);
	//map.setCenter(location);
	set_up_all_autocompletes();
}

function change_autocomplete_types(){

  	var acInputs = document.getElementsByClassName("autocomplete");
	for (var i = 0; i < acInputs.length; i++) {
		var id = acInputs[i].id;
      	var $idObj = $('#'+id);
		var $autocompObj = window[id];
   		var $parentObj = $('#'+id).parents('.marker-autocomp-wrap');
      	var searchtypes = '(cities)';
        if($parentObj.find('.search-type-checkbox:checked').length) {
            searchtypes = $parentObj.find('.search-type-checkbox:checked').val();
            console.log('8297 searchtypes = ' +searchtypes);
        }
        else if ($idObj.is("[data-types]")){
            if($idObj.attr('data-types') != ''){
                searchtypes = $(this).attr('data-types');
                console.log('8302 searchtypes = ' + searchtypes);
            }
        }
      	searchtypes = searchtypes.toLowerCase();
        if (searchtypes == 'all'){
			searchtypes = [];
        }
        $autocompObj.setTypes(searchtypes); 
	}
}

function refreshMapThumb() {
	if(markerThumb){
		markerThumb.setMap(null);
	}
	if(layerThumb){
		layerThumb.setMap(null);
	}
	$('#userAddress').val('');
}

/* ------------------- END thumb for marker------------- */

/** ------------------- free gift cart check ------------------- **/


/** ------------------- free gift cart check END ------------------- **/

});



